(function() {
'use strict';

    angular
        .module('app', ['ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'toastr', 'ngFileUpload', 'textAngular', 'angular-cookie-law', '720kb.datepicker', 'ngDialog', 'angucomplete-alt', 'jw.tooltip', 'fullPage.js'])
      .config(function($httpProvider) {
        $httpProvider.defaults.xsrfCookieName = 'csrftoken';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
      });
})();

(function () {
'use strict';

	angular
		.module('app')
		.service('PaginationService', PaginationService);

	function PaginationService () {
		var paginationData = {};
			paginationData.currentPage = 1;
			paginationData.pageSize = 10;

		return {
			getter: function () {
				return paginationData;
			},
			setter: function (value) {
				paginationData = value;
			}
		};
	}

})();
(function () {
'use strict';

	angular
		.module('app')
		.controller('PaginationController', PaginationController);

	function PaginationController ($scope, PaginationService) {
		
		$scope.$watch(function () {return PaginationService.getter(); }, function (newVal, oldVal) {
			if(newVal != null) {
				$scope.currentPage = newVal.currentPage;
				$scope.pageSize = newVal.pageSize;
			}
		});

		$scope.pageNumber = function (value) {
			PaginationService.setter({currentPage: value, pageSize: $scope.pageSize});
		}

		$scope.changePage = function (value) {
			if(value > $scope.howManyPages()) {
				PaginationService.setter({currentPage: $scope.howManyPages(), pageSize: $scope.pageSize});
			}
			if(value < 1) {
				PaginationService.setter({currentPage: 1, pageSize: $scope.pageSize});
			}
			if(value >= 1 && value <= $scope.howManyPages()) {
				PaginationService.setter({currentPage: value, pageSize: $scope.pageSize});
			}
		}

		$scope.changeHowManyElements = function (whichElement, howManyToDisplay) {
			$('.display b').removeClass('active');
            $('.display b[data-id="' + whichElement + '"]').addClass('active');

			PaginationService.setter({currentPage: 1, pageSize: howManyToDisplay});
		}

		$scope.nextOrPrevPage = function (option) {
			if(option == 'prev') {
				PaginationService.setter({currentPage: $scope.currentPage-1, pageSize: $scope.pageSize});
			}
			if(option == 'next') {
				PaginationService.setter({currentPage: $scope.currentPage+1, pageSize: $scope.pageSize});
			}
		}

		$scope.howManyPages = function () {
			return Math.ceil($scope.countElements / $scope.pageSize);
		}
	}

})();
(function() {
'use strict';

	angular
		.module('app')
		.factory('WorkOffersService', WorkOffersService);

	function WorkOffersService($http) {
		var offer = {};

		offer.create = function (data) {
			return $http.post('/api/v1/jobs/', data);
		}

		offer.read = function (currPage, pageSiz) {
			var nextPage = currPage + 1,
				pageSize = pageSiz;

			return $http.get('/api/v1/jobs/?page=' + nextPage + '&page_size=' + pageSize);
		}	

		offer.readAll = function () {
			return $http.get('/api/v1/jobs/');
		}

		offer.readOne = function (id) {
			return $http.get('/api/v1/jobs/' + id + '/');
		}

		offer.update = function (id, value) {
			return $http.put('/api/v1/jobs/' + id + '/', value);
		}

		offer.delete = function (id) {
			return $http.delete('/api/v1/jobs/' + id);
		}
		
		return offer;
	}

})();
(function() {
'use strict';

  angular
    .module('app')
    .config(workoffersRouterConfig);

  function workoffersRouterConfig($stateProvider) {
    $stateProvider
      .state('website.workoffers', {
          url: '/oferty-pracy',
          templateUrl: 'app/partials/workoffers/workoffers.html',
          controller: 'WorkOffersController'
      })
      .state('preview.workoffers', {
          url: '/oferty-pracy',
          templateUrl: 'app/partials/workoffers/workoffers.preview.html',
          controller: 'WorkOffersPreviewController'
      })
      .state('dashboard.workoffers', {
          url: '/oferty-pracy',
          templateUrl: 'app/partials/workoffers/workoffers.cms.html',
          controller: 'WorkOffersCmsController'
      })
      .state('dashboard.addworkoffers', {
          url: '/dodaj-oferte-pracy',
          templateUrl: 'app/partials/workoffers/addworkoffer.cms.html',
          controller: 'AddWorkOfferController'
      });
  }
})();

(function () {
'use strict';

	angular
		.module('app')
		.controller('WorkOffersPreviewController', WorkOffersPreviewController);

	function WorkOffersPreviewController($scope, WorkOffersService) {

		$scope.previewData = window.pastDataToNewWindow;

		WorkOffersService.readAll()
	        .success(function (response) {
	            $scope.jobsFromBackend = response.results;
	        });

        $scope.date = new Date();

	}

})();
(function() {
    'use strict';
    
     angular
        .module('app')
        .controller("WorkOffersController", WorkOffersController);

        function WorkOffersController($scope, WorkOffersService, $window) {

            $scope.currentPage = 0;
            $scope.pageSize = 10;
            $scope.showNoResults = false;

            $scope.$watch('[currentPage, pageSize]', function() {

                $scope.jobsFromBackend = {};
                $scope.jobsFromBackend.dataLoaded = false;

                WorkOffersService.read($scope.currentPage, $scope.pageSize)
                    .success(function (response) {
                        $scope.jobsFromBackend = response.results;
                        $scope.howManyPostsAre = response.count;
                        $scope.jobsFromBackend.dataLoaded = true;

                        
                        if(response.results.length < 1) {
                            $scope.showNoResults = true;
                        } else {
                            $scope.showNoResults = false;
                        }
                    });
            });

            $scope.openLink = function (link) {
                $window.open(link, '_blank');
            }

            $scope.numberOfPages = function() {
                return Math.ceil($scope.howManyPostsAre / $scope.pageSize);
            }
            
            $scope.howManyNewsAreDisplayed = function(howMany, id) {
                $('.display b').removeClass('active');
                $('.display b[data-id="' + id + '"]').addClass('active');
                $scope.pageSize = howMany;
                $scope.currentPage = 0;
            }
                    
        }
})();
(function(){
	'use strict';

	angular
		.module('app')
		.controller('WorkOffersCmsController', WorkOffersCmsController);

		function WorkOffersCmsController($scope, $state, $window, WorkOffersService, Upload, toastr) {
            
            $scope.currentPage = 0;
            $scope.pageSize = 10;

            $scope.publishedOptions = [
                { name: 'Opublikuj', value: true },
                { name: 'Szkic', value: false }
            ];

            $scope.$watch('[currentPage, pageSize]', function() {

                WorkOffersService.read($scope.currentPage, $scope.pageSize)
                    .success(function (response) {
                        $scope.jobsFromBackend = response.results;
                        $scope.howManyPostsAre = response.count;
                    });
            });

            $scope.upload = function (file) {
                Upload.upload({
                    url: '/api/v1/documents/',
                    data: {
                        file: file,
                        'title': $scope.file.name
                    }
                }).then(function (response) {
                    $scope.fileId = response.data.id;
                    $('.preload-file')
                        .css('display', 'none')
                        .css('width', '0px');
                    toastr.success("Plik został poprawnie wgrany."); 
                }, function(resp) {
                    toastr.error(resp.data.file[0]);
                }, function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    $('.preload-file')
                        .css('display', 'block')
                        .css('width', progressPercentage + '%');
                });
            }

            $scope.editOffer = function () {
                var data = {
                    title: $scope.value.title,
                    documents: [ $scope.fileId ],
                    add_to_news: $scope.value.addToNews,
                    published: $scope.value.published
                }

                WorkOffersService.update($scope.offerId, data) 
                    .success(function (response) {
                        $state.reload();
                        toastr.success('Uaktualniono.');
                    })
                    .error(function (response) {
                        for(var key in response) {
                            var value = response[key];

                            try {
                                value.forEach(function (element, index, array) {
                                    toastr.error(value[index]);
                                });
                            }

                            catch(err) {
                                toastr.error(response.detail);
                            }
                        }
                    });
            }

            $scope.deleteElement = function (id) {
                WorkOffersService.delete(id)
                    .success(function(response) {
                        $state.reload();
                        toastr.success("Pomyślnie usunięto.");
                    });
            }

            $scope.showEditPopup = function(options, id) {
                if (options === true) {
                    $scope.displayEditPopup = true;
                    
                    WorkOffersService.readOne(id)
                    .success(function(response) {
                        if(response.documents[0].title){
                            $scope.actualFile = response.documents[0].title;
                            $scope.fileId = response.documents[0].id;
                        }
                        $scope.offerId = response.id;
                        $scope.value.title = response.title;
                        $scope.value.addToNews = response.add_to_news;
                        $scope.value.published = response.published;
                    });
                } else {
                    $scope.displayEditPopup = false;
                }
                $scope.elementId = id;
            }

            $scope.numberOfPages = function () {
                return Math.ceil($scope.howManyPostsAre / $scope.pageSize);
            }
            
            $scope.howManyNewsAreDisplayed = function (howMany, id) {
                $('.display b').removeClass('active');
                $('.display b[data-id="' + id + '"]').addClass('active');
                $scope.pageSize = howMany;
                $scope.currentPage = 0;
            }

            $scope.showDeletePopup = function (options, id) {
                if (options === true) {
                    $scope.displayDeletePopup = true;
                } else {
                    $scope.displayDeletePopup = false;
                }
                $scope.elementId = id;
            }

            $scope.openPreview = function (link) {
                var previewData = {
                    title: $scope.value.title  
                }   

                $window.open(link, '_blank').pastDataToNewWindow = previewData;
            }
            
		}
})();
(function() {
	'use strict';

	angular
		.module('app')
		.controller('AddWorkOfferController', AddWorkOfferController);

	function AddWorkOfferController($scope, $location, $window, Upload, WorkOffersService, toastr) {

		$scope.published = 'True';

		$scope.upload = function (file) {
	        Upload.upload({
	            url: '/api/v1/documents/',
	            data: {
	               file: file,
	               'title': $scope.file.name
	            }
	        }).then(function (response) {
	            $scope.documentId = response.data.id;
	            $('.preload-file')
                    .css('display', 'none')
                    .css('width', '0px');
                toastr.success("Plik został poprawnie wgrany."); 
	        }, function(resp) {
	           toastr.error(resp.data.file[0]);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                $('.preload-file')
                    .css('display', 'block')
                    .css('width', progressPercentage + '%');
            });
	    }

	    $scope.addToNews = true;

		$scope.addWorkOffer = function(offer) {

			$scope.offer = {};

			var data = {
	       		title: $scope.offerTitle,
	       		documents: [ $scope.documentId ],
			   	in_news: $scope.addToNews,
			   	published: $scope.published
			}

			WorkOffersService.create(data)
				.success(function (response) {
					$location.path('/panel-administracyjny53335/oferty-pracy');
					toastr.success('Dodano.');
				})
				.error(function () {
                    toastr.error("Wypełnij wszystkie pola.");
                });
		}

		$scope.openPreview = function (link) {
            var previewData = {
                title: $scope.offerTitle  
            }   

            $window.open(link, '_blank').pastDataToNewWindow = previewData;
        }
		
	}

})();
(function () {
'use strict';

	angular
		.module('app')
		.factory('UsersService', UsersService);

	function UsersService ($http) {
		var user = {};

		user.create = function (value) {
			return $http.post('/api/v1/auth/registration/', value);
		}

		user.read = function (page, pageSiz) {
			var nextPage = page + 1,
				pageSize = pageSiz;
			
			return $http.get('/api/v1/auth/users/?page=' + nextPage + '&page_size=' + pageSize);
		}

		user.readAll = function () {
			return $http.get('/api/v1/auth/users/?page_size=' + 1000);
		}

		user.readOne = function (id) {
			return $http.get('/api/v1/auth/users/' + id + '/');
		}

		user.readMe = function () {
			return $http.get('/api/v1/auth/user/');
		}

		user.changePermissions = function (id, value) {
			var data = {
				permissions: value
			}

			return $http.post('/api/v1/auth/users/' + id + '/change_permissions/', data);
		}

		user.readPagePermissions = function (id) {
			return $http.get('/api/v1/auth/users/' + id + '/page_permissions');
		}

		user.changePagePermissions = function (id, value) {
			return $http.put('/api/v1/auth/users/' + id + '/page_permissions/', value);
		}
		
		user.activate = function (data) {
			return $http.post('/api/v1/auth/registration/verify-email/', data);
		}

		user.sendNewPassword = function (data) {
			return $http.post('/api/v1/auth/password/reset/', data);
		}

		user.changePassword = function (data) {
			return $http.post('/api/v1/auth/password/reset/confirm/', data);
		}

		user.delete = function (id) {
			return $http.delete('/api/v1/auth/users/' + id + '/');
		}

		return user;
	}

})();
(function () {
'use strict';

	angular
		.module('app')
		.config(usersRouterConfig);

	function usersRouterConfig ($stateProvider) {
		$stateProvider
	        .state('dashboard.users', {
                url: '/uzytkownicy',
                templateUrl: 'app/partials/users/users.cms.html',
                controller: 'UsersController',
                controllerAs: 'usrctrl'
	        });
	}

})();
(function() {
    "use strict";
    angular.module("app").controller("UsersController", UsersController);

    function UsersController(
        $scope,
        UsersService,
        UserLogsService,
        $location,
        $state,
        toastr
    ) {
        $scope.currentPage = 0;
        $scope.pageSize = 10;

        $scope.$watch("[currentPage, pageSize]", function() {
            UsersService.read($scope.currentPage, $scope.pageSize).success(
                function(response) {
                    $scope.usersFromBackend = response.results;
                    $scope.howManyPostsAre = response.count;
                }
            );
        });

        $scope.sendNewPassword = function(value) {
            var data = {
                email: value
            };

            UsersService.sendNewPassword(data).success(function(response) {
                toastr.success("Nowe hasło zostało wysłane.");
            });
        };

        $scope.addUser = function(value) {
            var data = {
                email: $scope.value.email,
                first_name: $scope.value.first_name,
                last_name: $scope.value.last_name
            };

            UsersService.create(data).success(function(response) {
                toastr.success("Dodano nowego użytkownika.");
                $state.reload();

                UsersService.read($scope.currentPage, $scope.pageSize).success(
                    function(response) {
                        $scope.usersFromBackend = response.results;
                        $scope.howManyPostsAre = response.count;
                    }
                );
            });
        };

        $scope.showPermissionWindow = function(options, id) {
            if (options === true) {
                $scope.displayPermissionsPopup = true;

                UsersService.readOne(id).success(function(response) {
                    function findPermission(permissionName) {
                        for (var i = 0; i < response.permissions.length; i++) {
                            if (permissionName == response.permissions[i]) {
                                return i;
                            }
                        }
                    }

                    // idealne miejsce

                    response.permissions[
                        findPermission("perfect_place.manage_my_perfect_place")
                    ]
                        ? ($scope.manageMyPerfectPlace = true)
                        : ($scope.manageMyPerfectPlace = false);
                    response.permissions[
                        findPermission("perfect_place.manage_all_perfect_place")
                    ]
                        ? ($scope.manageAllPerfectPlace = true)
                        : ($scope.manageAllPerfectPlace = false);

                    // dla mieszkańców

                    response.permissions[findPermission("news.manage_my_news")]
                        ? ($scope.manageMyNews = true)
                        : ($scope.manageMyNews = false);
                    response.permissions[findPermission("news.manage_all_news")]
                        ? ($scope.manageAllNews = true)
                        : ($scope.manageAllNews = false);

                    response.permissions[
                        findPermission("culture.manage_my_culture")
                    ]
                        ? ($scope.manageMyCulture = true)
                        : ($scope.manageMyCulture = false);
                    response.permissions[
                        findPermission("culture.manage_all_culture")
                    ]
                        ? ($scope.manageAllCulture = true)
                        : ($scope.manageAllCulture = false);

                    response.permissions[
                        findPermission("informations.manage_my_information")
                    ]
                        ? ($scope.manageMyInformations = true)
                        : ($scope.manageMyInformations = false);
                    response.permissions[
                        findPermission("informations.manage_all_information")
                    ]
                        ? ($scope.manageAllInformations = true)
                        : ($scope.manageAllInformations = false);

                    response.permissions[
                        findPermission("funding.manage_my_funding")
                    ]
                        ? ($scope.manageMyFunding = true)
                        : ($scope.manageMyFunding = false);
                    response.permissions[
                        findPermission("funding.manage_all_funding")
                    ]
                        ? ($scope.manageAllFunding = true)
                        : ($scope.manageAllFunding = false);

                    response.permissions[
                        findPermission("residential_construction.manage_my_residential_construction")
                        ]
                        ? ($scope.manageMyResidentialConstruction = true)
                        : ($scope.manageMyResidentialConstruction = false);
                    response.permissions[
                        findPermission("residential_construction.manage_all_residential_construction")
                        ]
                        ? ($scope.manageAllResidentialConstruction = true)
                        : ($scope.manageAllResidentialConstruction = false);

                    // współpraca

                    response.permissions[findPermission("rent.manage_my_rent")]
                        ? ($scope.manageMyRent = true)
                        : ($scope.manageMyRent = false);
                    response.permissions[findPermission("rent.manage_all_rent")]
                        ? ($scope.manageAllRent = true)
                        : ($scope.manageAllRent = false);

                    response.permissions[
                        findPermission("jobs_documents.manage_my_jobdocument")
                    ]
                        ? ($scope.manageMyJobs = true)
                        : ($scope.manageMyJobs = false);
                    response.permissions[
                        findPermission("jobs_documents.manage_all_jobdocument")
                    ]
                        ? ($scope.manageAllJobs = true)
                        : ($scope.manageAllJobs = false);

                    response.permissions[
                        findPermission("tenders.manage_my_tender")
                    ]
                        ? ($scope.manageMyTenders = true)
                        : ($scope.manageMyTenders = false);
                    response.permissions[
                        findPermission("tenders.manage_all_tender")
                    ]
                        ? ($scope.manageAllTenders = true)
                        : ($scope.manageAllTenders = false);

                    response.permissions[
                        findPermission("advertisers.manage_my_advertisments")
                    ]
                        ? ($scope.manageMyAdv = true)
                        : ($scope.manageMyAdv = false);
                    response.permissions[
                        findPermission("advertisers.manage_all_advertisments")
                    ]
                        ? ($scope.manageAllAdv = true)
                        : ($scope.manageAllAdv = false);

                    // o nas

                    response.permissions[
                        findPermission("press.manage_my_press")
                    ]
                        ? ($scope.manageMyPress = true)
                        : ($scope.manageMyPress = false);
                    response.permissions[
                        findPermission("press.manage_all_press")
                    ]
                        ? ($scope.manageAllPress = true)
                        : ($scope.manageAllPress = false);

                    // lokalizacje

                    response.permissions[
                        findPermission("localizations.manage_my_localizations")
                    ]
                        ? ($scope.manageMyLocalizations = true)
                        : ($scope.manageMyLocalizations = false);
                    response.permissions[
                        findPermission("localizations.manage_all_localizations")
                    ]
                        ? ($scope.manageAllLocalizations = true)
                        : ($scope.manageAllLocalizations = false);

                    response.permissions[findPermission("pages.manage_my_page")]
                        ? ($scope.manageMyPages = true)
                        : ($scope.manageMyPages = false);
                    response.permissions[
                        findPermission("pages.manage_all_page")
                    ]
                        ? ($scope.manageAllPages = true)
                        : ($scope.manageAllPages = false);
                });

                UsersService.readPagePermissions(id).success(function(
                    response
                ) {
                    function findPermission(permissionName) {
                        for (var i = 0; i < response.length; i++) {
                            if (permissionName == response[i]) {
                                return i;
                            }
                        }
                    }
                    response[findPermission("wynajem")]
                        ? ($scope.managePageWynajem = true)
                        : ($scope.managePageWynajem = false);
                    response[findPermission("adv")]
                        ? ($scope.managePageAdv = true)
                        : ($scope.managePageAdv = false);
                    response[findPermission("big-picture")]
                        ? ($scope.managePageBigPicture = true)
                        : ($scope.managePageBigPicture = false);
                    response[findPermission("management")]
                        ? ($scope.managePageManagement = true)
                        : ($scope.managePageManagement = false);
                    response[findPermission("historia")]
                        ? ($scope.managePageHistory = true)
                        : ($scope.managePageHistory = false);
                    response[findPermission("eco")]
                        ? ($scope.managePageEco = true)
                        : ($scope.managePageEco = false);
                    response[findPermission("kontakt")]
                        ? ($scope.managePageContact = true)
                        : ($scope.managePageContact = false);
                    response[findPermission("dofinansowanie")]
                        ? ($scope.managePageFunding = true)
                        : ($scope.managePageFunding = false);
                    response[findPermission("budownictwo-mieszkaniowe")]
                        ? ($scope.managePageResidentialConstruction = true)
                        : ($scope.managePageResidentialConstruction = false);
                });
            } else {
                $scope.displayPermissionsPopup = false;
                $state.reload();
            }
            $scope.elementId = id;
        };

        $scope.sendNewPermissions = function(id) {
            var data = [];
            var pageData = [];

            // idealne miejsce

            if ($scope.manageMyPerfectPlace == true) {
                data.push("perfect_place.manage_my_perfect_place");
            }
            if ($scope.manageAllPerfectPlace == true) {
                data.push("perfect_place.manage_all_perfect_place");
            }

            // dla mieszkańców

            if ($scope.manageMyNews == true) {
                data.push("news.manage_my_news");
            }
            if ($scope.manageAllNews == true) {
                data.push("news.manage_all_news");
            }

            if ($scope.manageMyCulture == true) {
                data.push("culture.manage_my_culture");
            }
            if ($scope.manageAllCulture == true) {
                data.push("culture.manage_all_culture");
            }

            if ($scope.manageMyInformations == true) {
                data.push("informations.manage_my_information");
            }
            if ($scope.manageAllInformations == true) {
                data.push("informations.manage_all_information");
            }

            if ($scope.manageMyFunding == true) {
                data.push("funding.manage_my_funding");
            }
            if ($scope.manageAllFunding == true) {
                data.push("funding.manage_all_funding");
            }

            if ($scope.manageMyResidentialConstruction == true) {
                data.push("residential_construction.manage_my_residential_construction");
            }
            if ($scope.manageAllResidentialConstruction == true) {
                data.push("residential_construction.manage_all_residential_construction");
            }

            // współpraca

            if ($scope.manageMyRent == true) {
                data.push("rent.manage_my_rent");
            }
            if ($scope.manageAllRent == true) {
                data.push("rent.manage_all_rent");
            }

            if ($scope.manageMyTenders == true) {
                data.push("tenders.manage_my_tender");
            }
            if ($scope.manageAllTenders == true) {
                data.push("tenders.manage_all_tender");
            }

            if ($scope.manageMyAdv == true) {
                data.push("advertisers.manage_my_advertisments");
            }
            if ($scope.manageAllAdv == true) {
                data.push("advertisers.manage_all_advertisments");
            }

            if ($scope.manageMyJobs == true) {
                data.push("jobs_documents.manage_my_jobdocument");
            }
            if ($scope.manageAllJobs == true) {
                data.push("jobs_documents.manage_all_jobdocument");
            }

            // o nas

            if ($scope.manageMyPress == true) {
                data.push("press.manage_my_press");
            }
            if ($scope.manageAllPress == true) {
                data.push("press.manage_all_press");
            }

            // lokalizacje

            if ($scope.manageMyLocalizations == true) {
                data.push("localizations.manage_my_localizations");
            }
            if ($scope.manageAllLocalizations == true) {
                data.push("localizations.manage_all_localizations");
            }

            if ($scope.managePageWynajem == true) {
                pageData.push("wynajem");
            }
            if ($scope.managePageAdv == true) {
                pageData.push("adv");
            }
            if ($scope.managePageBigPicture == true) {
                pageData.push("big-picture");
            }
            if ($scope.managePageManagement == true) {
                pageData.push("management");
            }
            if ($scope.managePageBigPicture == true) {
                pageData.push("historia");
            }
            if ($scope.managePageEco == true) {
                pageData.push("eco");
            }
            if ($scope.managePageContact == true) {
                pageData.push("kontakt");
            }
            if ($scope.managePageFunding == true) {
                pageData.push("dofinansowanie");
            }
            if ($scope.managePageResidentialConstruction == true) {
                pageData.push("budownictwo-mieszkaniowe");
            }

            UsersService.changePermissions(id, data).success(function() {
                $state.reload();
                toastr.success("Zmieniono uprawnienia.");
            });

            UsersService.changePagePermissions(id, pageData).success(function(
                response
            ) {
                console.log(response);
            });
        };

        $scope.setHistory = function(name) {
            UserLogsService.user = name;
            $location.path("/panel-administracyjny53335/logi");
        };

        $scope.numberOfPages = function() {
            return Math.ceil($scope.howManyPostsAre / $scope.pageSize);
        };

        $scope.howManyNewsAreDisplayed = function(howMany, id) {
            $(".display b").removeClass("active");
            $('.display b[data-id="' + id + '"]').addClass("active");
            $scope.pageSize = howMany;
            $scope.currentPage = 0;
        };

        $scope.deleteElement = function(id) {
            UsersService.delete(id).success(function(response) {
                $state.reload();
                toastr.success("Pomyślnie usunięto.");
            });
        };

        $scope.showDeletePopup = function(options, id) {
            if (options === true) {
                $scope.displayDeletePopup = true;
            } else {
                $scope.displayDeletePopup = false;
            }
            $scope.elementId = id;
        };
    }
})();

(function () {
'use strict';
	
	angular
		.module('app')
		.factory('TendersService', TendersService);

	function TendersService ($http) {
		var tender = {};

		tender.create = function (value) {
			return $http.post('/api/v1/tenders/', value);
		}

		tender.getTenders = function(params) {
			return $http.get('/api/v1/tenders/', { params: params });
		}

		tender.read = function (page, pageSiz, category, status) {
			var nextPage = page + 1,
				pageSize = pageSiz,
				pageCategory = category,
				statusNumber = status;
			
			if(pageCategory == 0 &&  statusNumber == -1) {
				return $http.get('/api/v1/tenders/?page=' + nextPage + '&page_size=' + pageSize);
			} if (pageCategory != 0 && statusNumber == -1) {
				return $http.get('/api/v1/tenders/?page=' + nextPage + '&page_size=' + pageSize + '&tender_type=' + pageCategory);
			} if (pageCategory == 0 && statusNumber != -1) {
				return $http.get('/api/v1/tenders/?page=' + nextPage + '&page_size=' + pageSize + '&status=' + statusNumber);
			} if (pageCategory != 0 && statusNumber != -1) {
				return $http.get('/api/v1/tenders/?page=' + nextPage + '&page_size=' + pageSize + '&status=' + statusNumber + '&tender_type=' + pageCategory);
			}
		}

		tender.readAll = function () {
			return $http.get('/api/v1/tenders/');
		}

		tender.readOne = function (id) {
			return $http.get('/api/v1/tenders/' + id + '/');
		}

		tender.update = function (id, value) {
			return $http.put('/api/v1/tenders/' + id + '/', value)
		}

		tender.changePosition = function (id, value) {
			return $http.put('/api/v1/tenders/' + id + '/change_position/', value);
		}

		tender.delete = function (id) {
			return $http.delete('/api/v1/tenders/' + id + '/');
		}

		return tender;
	}

})();
(function () {
'use strict';

  angular
    .module('app')
    .config(tendersRouterConfig);

  function tendersRouterConfig ($stateProvider) {
    $stateProvider
      .state('website.tenders', {
        url: '/przetargi',
        templateUrl: 'app/partials/tenders/tenders.html',
        controller: 'TendersController'
      })
      .state('preview.tenders', {
        url: '/przetargi',
        templateUrl: 'app/partials/tenders/tenders.preview.html',
        controller: 'TendersPreviewController'
      })
      .state('dashboard.tenders', {
        url: '/przetargi',
        templateUrl: 'app/partials/tenders/tenders.cms.html',
        controller: 'TendersCmsController'
      })
      .state('dashboard.addtenders', {
        url: '/dodaj_przetarg',
        templateUrl: 'app/partials/tenders/addtenders.cms.html',
        controller: 'AddTendersController'
      });
  }

})();

(function () {
'use strict';
	
	angular
		.module('app')
		.controller('TendersController', TendersController);

		function TendersController($scope, TendersService, TenderCategoryService, $window, DocumentsService) {

            $scope.currentPage = 0;
            $scope.pageSize = 10;
            $scope.pageCategory = 0;
            $scope.statusNumber = -1;
            $scope.showHideAll = "Rozwiń wszystko";
            $scope.showNoResults = false;

            $scope.$watch('[currentPage, pageSize, pageCategory, statusNumber]', function() {

                $scope.tendersFromBackend = {};
                $scope.tendersFromBackend.dataLoaded = false;

       		TendersService.read($scope.currentPage, $scope.pageSize,  $scope.pageCategory, $scope.statusNumber)
       			.success(function (response) {
       				$scope.tendersFromBackend = response.results;
       				$scope.howManyPostsAre = response.count;
                        $scope.tendersFromBackend.dataLoaded = true;

                        if(response.results.length < 1) {
                            $scope.showNoResults = true;
                        } else {
                            $scope.showNoResults = false;
                        }
       			});
            });

			TenderCategoryService.read()
				.success(function (response) {
					$scope.categoriesFromBackend = response;
				});

            $scope.openLink = function (link) {
                $window.open(link, '_blank');
            }

            $scope.checkActive = function () {
                var isSomethingOpened = $('.cont-for-list-element').hasClass('active');
                if (isSomethingOpened == true) {
                    $scope.showHideAll = "Zwiń wszystko";
                    $('#show-hide-all').addClass('active');
                } else {
                    $scope.showHideAll = "Rozwiń wszystko";
                    $('#show-hide-all').removeClass('active');
                }    
            }

            $scope.numberOfPages = function () {
                return Math.ceil($scope.howManyPostsAre / $scope.pageSize);
            }
            
            $scope.howManyNewsAreDisplayed = function (howMany, id) {
                $('.display b').removeClass('active');
                $('.display b[data-id="' + id + '"]').addClass('active');
                $scope.pageSize = howMany;
                $scope.currentPage = 0;
            }

            $scope.changeCategory = function (categoryId) {
                $scope.currentPage = 0;
                $scope.pageCategory = categoryId;
            }

            $scope.changeStatus = function (statusId) {
                $scope.currentPage = 0;
                $scope.statusNumber = statusId;
            }

            $scope.toggleBtn = function(id) {     
                $('.cont-for-list-element[data-id="' + id + '"]')
                    .toggleClass('active')
                    .find(".inner-content").click(function () {
                        return false;
                    });
            }

            $scope.showPopup = function(options, imageId) {
                if (options === true) {
                    $scope.displayPopup = true;
                    DocumentsService.readOneDocument(imageId)
                        .success(function (response) {
                            $scope.oneImage = response;
                        });
                } else {
                    $scope.displayPopup = false;
                }
            }
			
		}
})();
(function () {
'use strict';
	
	angular
		.module('app')
		.controller('TendersCmsController', TendersCmsController);

		function TendersCmsController($filter, $scope, $state, $window, TendersService, TenderCategoryService, Upload, DocumentsService, toastr) {

            $scope.currentPage = 1;
            $scope.pageSize = 10;
            $scope.documentsArray = [];
            $scope.documentsArrayTitles = [];

            $scope.publishedOptions = [
                { name: 'Opublikuj', value: true },
                { name: 'Szkic', value: false }
            ];

            $scope.publishedOptionsFilter = [
                { name: 'Opublikuj', value: 'True' },
                { name: 'Szkic', value: 'False' }
            ];

            $scope.statusesList = [
                { name: 'Aktualny', value: 0 },
                { name: 'Anulowany', value: 1 },
                { name: 'Zakończony', value: 2 }
            ];

            $scope.$watch('[currentPage, pageSize, pageCategory, statusNumber, published]', function() {           
                var params = {
                    page: $scope.currentPage,
                    page_size: $scope.pageSize,
                    tender_type: $scope.pageCategory,
                    status: $scope.statusNumber,
                    published: $scope.published
                };

       		TendersService.getTenders(params)
       			.success(function (response) {
       				$scope.tendersFromBackend = response.results;
       				$scope.howManyPostsAre = response.count;
       			});
            });

			TenderCategoryService.read()
				.success(function (response) {
					$scope.categoriesFromBackend = response;
				});

            $scope.uploadFiles = function (files) {
                if (files && files.length) {
                    for (var i = 0; i < files.length; i++) {
                        Upload.upload({
                            url: '/api/v1/documents/', 
                            data: {
                                file: files[i],
                                title: $scope.files[i].name
                            }
                        }).then(function (response) {
                            $scope.documentsArray.push(response.data.id);
                            $scope.documentsArrayTitles.push(response.data.title);
                            $('.preload-file')
                                .css('display', 'none')
                                .css('width', '0px');
                            toastr.success("Plik został poprawnie wgrany."); 
                        }, function(resp) {
                            toastr.error(resp.data.file[0]);
                        }, function (evt) {
                            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                            $('.preload-file')
                                .css('display', 'block')
                                .css('width', progressPercentage + '%');
                        });
                    }
                }
            }

            $scope.editTender = function () {
                var data = {
                    title: $scope.value.title,
                    tender_type: $scope.value.tender_type,
                    status: $scope.status.id,
                    body: $scope.value.body,
                    documents: $scope.documentsArray,
                    date: $scope.value.date,
                    published: $scope.value.published
                }

                TendersService.update($scope.tenderId, data) 
                    .success(function (response) {
                        $state.reload();
                        toastr.success('Uaktualniono.');
                    })
                    .error(function (response) {
                        for(var key in response) {
                            var value = response[key];

                            try {
                                value.forEach(function (element, index, array) {
                                    toastr.error(value[index]);
                                });
                            }

                            catch(err) {
                                toastr.error(response.detail);
                            }
                        }
                    });
            }

            $scope.changePosition = function (id, option) {
                var data = {
                    change: option
                }

                TendersService.changePosition(id, data)
                    .success(function () {
                        $state.reload();
                    });
            }

            $scope.changeFileName = function (id, documentPosition) {
                if($scope.documentsArrayTitles[documentPosition].length > 1) {
                    DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition])
                        .success(function () {
                        });
                }
            }

            $scope.deleteFromArray = function (id) {
                $scope.documentsArray.splice(id, 1);
                $scope.documentsArrayTitles.splice(id, 1);
            }

            $scope.deleteElement = function(id) {
                TendersService.delete(id)
                    .success(function() {
                        $state.reload();
                        toastr.success("Pomyślnie usunięto.");
                    });
            }

            $scope.showDeletePopup = function (options, id) {
                if (options === true) {
                    $scope.displayDeletePopup = true;
                } else {
                    $scope.displayDeletePopup = false;
                }
                $scope.elementId = id;
            }

            $scope.numberOfPages = function () {
                return Math.ceil($scope.howManyPostsAre / $scope.pageSize);
            }
            
            $scope.howManyNewsAreDisplayed = function (howMany, id) {
                $('.display b').removeClass('active');
                $('.display b[data-id="' + id + '"]').addClass('active');
                $scope.pageSize = howMany;
                $scope.currentPage = 0;
            }

            $scope.changeStatus = function(statusId) {
                $scope.currentPage = 0;
                $scope.statusNumber = statusId;
            }

             $scope.statusList = [
                {name: 'Aktualny', id: 0},
                {name: 'Anulowany', id: 1},
                {name: 'Zakończony', id: 2}
            ]

            $scope.showEditPopup = function(options, id) {
                if (options === true) {
                    $scope.displayEditPopup = true;
                    $scope.documentsArray = [];
                    $scope.documentsArrayTitles = [];
                    
                    TendersService.readOne(id)
                    .success(function(response) {

                        for(var i = 0; i < response.documents.length; i++) {
                            $scope.documentsArray.push(response.documents[i].id);
                            $scope.documentsArrayTitles.push(response.documents[i].title);
                        }

                        $scope.tenderId = response.id;
                        $scope.value.title = response.title;
                        $scope.value.tender_type = response.tender_type;
                        $scope.status = response;
                        $scope.value.body = response.body;
                        $scope.value.date = response.date;
                        $scope.status.id = response.status;
                        $scope.value.published = response.published;

                    });

                } else {
                    $scope.displayEditPopup = false;
                    $state.reload();
                }
                $scope.elementId = id;
            }

            $scope.openPreview = function (link) {
                var previewData = {
                    title: $scope.value.title,
                    body: $scope.value.body,
                    documents: $scope.documentsArrayTitles,
                    status: $scope.status.id,
                    tender_type: $scope.value.tender_type
                }   

                $window.open(link, '_blank').pastDataToNewWindow = previewData;
            }

            $scope.stripFormat = function ($html) {
                return $filter('HtmlToPlain')($html);
            }
			
		}
})();

(function () {
'use strict';

	angular
		.module('app')
		.controller('TendersPreviewController', TendersPreviewController);

	function TendersPreviewController($scope, TendersService) {

		$scope.previewData = window.pastDataToNewWindow;
        console.log($scope.previewData);

		TendersService.readAll()
			.success(function (response) {
				$scope.tendersFromBackend = response.results;
			});

        $scope.toggleBtn = function(id) {     
            $('.cont-for-list-element[data-id="' + id + '"]')
                .toggleClass('active')
                .find(".inner-content").click(function () {
                    return false;
                });
        }

        $scope.currentDate = new Date();

	}

})();

(function () {

	angular
		.module('app')
		.controller('AddTendersController', AddTendersController);

	function AddTendersController($filter, $scope, $location, $window, TenderCategoryService, TendersService, Upload, DocumentsService, toastr) {

		$scope.documentsArray = [];
        $scope.documentsArrayTitles = [];
        $scope.published = 'True';
		
		TenderCategoryService.read()
			.success(function (response) {
				$scope.categoriesFromBackend = response;
			});

        $scope.uploadFiles = function (files) {
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    Upload.upload({
                        url: '/api/v1/documents/', 
                        data: {
                            file: files[i],
                            title: $scope.files[i].name
                        }
                    }).then(function (response) {
                        $scope.documentsArray.push(response.data.id);
                        $scope.documentsArrayTitles.push(response.data.title);
                        $('.preload-file')
                            .css('display', 'none')
                            .css('width', '0px');
                        toastr.success("Plik został poprawnie wgrany."); 
                    }, function(resp) {
                        toastr.error(resp.data.file[0]);
                    }, function (evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        $('.preload-file')
                            .css('display', 'block')
                            .css('width', progressPercentage + '%');
                    });
                }
            }
        }

        $scope.changeFileName = function (id, documentPosition) {
            if($scope.documentsArrayTitles[documentPosition].length > 1) {
                DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition])
                    .success(function (response) {
                    });
            }
        }

        $scope.deleteFromArray = function (id) {
            $scope.documentsArray.splice(id, 1);
            $scope.documentsArrayTitles.splice(id, 1);
        }

        $scope.submit = function () {

			var data = {
				title: $scope.valueTitle,
				tender_type: $scope.valueTender_type.id,
				status: $scope.valueStatus,
				body: $scope.valueBody,
				documents: $scope.documentsArray,
                date: $scope.valueDate,
                published: $scope.published
			}

			TendersService.create(data)
				.success(function (response) {
					$location.path('/panel-administracyjny53335/przetargi');
                    toastr.success('Dodano.');
				})
                .error(function () {
                    toastr.error("Wypełnij wszystkie pola.");
                });   

        }

        $scope.openPreview = function (link) {
            var previewData = {
                title: $scope.valueTitle,
                body: $scope.valueBody,
                date: $scope.valueDate,
                status: $scope.valueStatus,
                tender_type: $scope.valueTender_type,
                documents: $scope.documentsArrayTitles
            }   

            $window.open(link, '_blank').pastDataToNewWindow = previewData;
        }

        $scope.stripFormat = function ($html) {
            return $filter('HtmlToPlain')($html);
        }   


	}

})();

(function() {
'use strict';

    angular
        .module('app')
        .factory('NewsCategoryService', NewsCategoryService)
        .factory('TenderCategoryService', TenderCategoryService)
        .factory('SettingsService', SettingsService)
        .factory('CultureCategoryService', CultureCategoryService)
        .factory('PressCategoryService', PressCategoryService);

	function NewsCategoryService ($http) {
		var category = {};

		category.create = function (value) {
			return $http.post('/api/v1/news_categories/', value);
		}

		category.read = function () {
			return $http.get('/api/v1/news_categories/');
		}

		category.readOne = function (id) {
			return $http.get('/api/v1/news_categories/' + id + '/');
		}

		category.update = function (id, value) {
			return $http.patch('/api/v1/news_categories/' + id + '/', value);
		}

		category.delete = function (id) {
			return $http.delete('/api/v1/news_categories/' + id + '/');
		}

		return category;
	}

	function TenderCategoryService ($http) {
		var category = {};

		category.create = function (value) {
			return $http.post('/api/v1/tender_categories/', value);
		}

		category.read = function () {
			return $http.get('/api/v1/tender_categories/');
		}

		category.readOne = function (id) {
			return $http.get('/api/v1/tender_categories/' + id + '/');
		}

		category.update = function (id, value) {
			return $http.patch('/api/v1/tender_categories/' + id + '/', value);
		}

		category.delete = function (id) {
			return $http.delete('/api/v1/tender_categories/' + id + '/');
		}

		return category;
    }

    function CultureCategoryService($http) {
        var category = {};

        category.create = function (value) {
            return $http.post('/api/v1/culture_categories/', value);
        }

        category.read = function () {
            return $http.get('/api/v1/culture_categories/');
        }

        category.readOne = function (id) {
            return $http.get('/api/v1/culture_categories/' + id + '/');
        }

        category.update = function (id, value) {
            return $http.patch('/api/v1/culture_categories/' + id + '/', value);
        }

        category.delete = function (id) {
            return $http.delete('/api/v1/culture_categories/' + id + '/');
        }

        return category;
    }

    function PressCategoryService($http) {
        var category = {};

        category.create = function (value) {
            return $http.post('/api/v1/press_categories/', value);
        }

        category.read = function () {
            return $http.get('/api/v1/press_categories/');
        }

        category.readOne = function (id) {
            return $http.get('/api/v1/press_categories/' + id + '/');
        }

        category.update = function (id, value) {
            return $http.patch('/api/v1/press_categories/' + id + '/', value);
        }

        category.delete = function (id) {
            return $http.delete('/api/v1/press_categories/' + id + '/');
        }

        return category;
    }

	function SettingsService ($http) {
		var settings = {};

		settings.emailRead = function () {
			return $http.get('/api/v1/settings/');
		}

		settings.emailUpdate = function (value) {
			return $http.patch('/api/v1/settings/', value);
		}

		settings.topicRead = function () {
			return $http.get('/api/v1/contact_topics/');
		}

		settings.topicReadOne = function (id) {
			return $http.get('/api/v1/contact_topics/' + id + '/');
		}

		settings.topicAdd = function (data) {
			return $http.post('/api/v1/contact_topics/', data);
		}

		settings.topicUpdate = function (id, value) {
			return $http.patch('/api/v1/contact_topics/' + id + '/', value);
		}

		settings.topicDelete = function (id) {
			return $http.delete('/api/v1/contact_topics/' + id + '/');
		}

		return settings;
    }

})();

(function() {
'use strict';

	angular
		.module('app')
		.config(settingsRouterConfig);

	function settingsRouterConfig($stateProvider) {
		$stateProvider
			.state('dashboard.settings', {
                url: '/ustawienia',
                templateUrl: 'app/partials/settings/settings.html',
                controller: 'SettingsController',
                controllerAs: 'SettingsCtrl'
			});
	}
})();
(function() {
	'use strict',

	angular
		.module('app')
		.controller('SettingsController', SettingsController);

    function SettingsController(
        $scope,
        $location,
        $state,
        CultureCategoryService,
        NewsCategoryService,
        TenderCategoryService,
        PressCategoryService,
        SettingsService,
        toastr) {

            var vm = this;

        NewsCategoryService.read()
            .then(function(response) {
                vm.categoriesList = response.data;
            });

        vm.addCategoryNews = function () {

            var data = {
                name: vm.newsCategoryName
            }

            NewsCategoryService.create(data)
            .success(function (response) {
                $state.reload();
            });

        }

        CultureCategoryService.read()
            .then(function (response) {
                vm.cultureCategoriesList = response.data;
            });

        vm.addCultureCategoryNews = function () {

            var data = {
                name: vm.cultureCategoryName
            }

            CultureCategoryService.create(data)
                .success(function (response) {
                    $state.reload();
                });

        }

        PressCategoryService.read()
            .then(function (response) {
                vm.pressCategoriesList = response.data;
            });

        vm.addPressCategoryNews = function () {
            var data = { name: vm.pressCategoryName };
            PressCategoryService.create(data)
                .then(function () {
                    $state.reload();
                });
        }

        TenderCategoryService.read()
            .success(function (response) {
                vm.tenderCategoryFromBackend = response;
            });

        vm.addTenderCategory = function () {

            var data = {
                name: vm.tendersCategoryName
            }

            TenderCategoryService.create(data)
            .success(function (response) {
                $state.reload();
            });
        }

        SettingsService.topicRead()
            .success(function (response) {
                vm.settingsFromBackend = response;
            });

        vm.addNewTopic = function () {

            var data = {
                name: vm.formTopicName
            }

            SettingsService.topicAdd(data)
            .success(function (response) {
                $state.reload();
            });
        }

        SettingsService.emailRead()
            .success(function (response) {

                function takeResponseBySlug(slug) {
                    for(var i = 0; i < response.placeholders.length; i++) {
                        if(response.placeholders[i].slug == slug) {
                            return i;
                        }
                    }
                }

                if(response.placeholders[takeResponseBySlug('email')]) {
                    vm.contactEmail = response.placeholders[takeResponseBySlug('email')].content;
                    vm.contactEmailId = response.placeholders[takeResponseBySlug('email')].id;
                }
            });

        vm.sendNewEmailSettings = function () {
            var data = {
                placeholders: [
                    {
                        slug: 'email',
                        type: 'pages.emailplaceholder',
                        content: vm.contactEmail,
                        id: vm.contactEmailId
                    }
                ]
            }

            SettingsService.emailUpdate(data)
            .success(function (response) {
                $state.reload();
                toastr.success("Uaktuaniono");
            })
            .error(function (response) {
                toastr.error("Błąd uaktualnienia");
            });

        }

        vm.showDeletePopup = function(options, whichOne, id) {
            if (options === true) {
                vm.displayDeletePopup = true;
            } else {
                vm.displayDeletePopup = false;
            }
            $scope.elementId = id;
            $scope.whichOne = whichOne;
        }

        vm.deleteCategory = function(id, whichOne) {
            if(whichOne == 0) {
                NewsCategoryService.delete(id)
                .success(function (response) {
                    $state.reload();
                });
            } if (whichOne == 1) {
                TenderCategoryService.delete(id)
                .success(function (response) {
                    $state.reload();
                });
            } if (whichOne == 2) {
                SettingsService.topicDelete(id)
                .success(function (response) {
                    $state.reload();
                });
            } if (whichOne == 3) {
                CultureCategoryService.delete(id)
                    .then(function () {
                        $state.reload();
                    });
            } if (whichOne == 4) {
                PressCategoryService.delete(id)
                    .then(function () {
                        $state.reload();
                    });
            }
        }

        vm.showEditPopup = function(options, whichOne, id) {
            if (options === true) {
                vm.displayEditPopup = true;
                if(whichOne == 0) {
                    NewsCategoryService.readOne(id)
                    .success(function (response) {
                        vm.nameToEdit = response.name;
                    });
                } if (whichOne == 1) {
                    TenderCategoryService.readOne(id)
                    .success(function (response) {
                        vm.nameToEdit = response.name;
                    });
                } if (whichOne == 2) {
                    SettingsService.topicReadOne(id)
                    .success(function (response) {
                        vm.nameToEdit = response.name;
                    });
                } if (whichOne == 3) {
                    CultureCategoryService.readOne(id)
                        .success(function (response) {
                            vm.nameToEdit = response.name;
                        });
                } if (whichOne == 4) {
                    PressCategoryService.readOne(id)
                        .success(function (response) {
                            vm.nameToEdit = response.name;
                        });
                }
            } else {
                vm.displayEditPopup = false;
            }
            $scope.elementId = id;
            $scope.whichOne = whichOne;
        }

        vm.editSettings = function (whichOne, id, value) {

            var data = {
                name: vm.nameToEdit
            }

            if(whichOne == 0) {
                NewsCategoryService.update(id, data)
                .success(function (response) {
                    $state.reload();
                    toastr.success("Uaktualniono");
                });
            } if(whichOne == 1) {
                TenderCategoryService.update(id, data)
                .success(function (response) {
                    $state.reload();
                    toastr.success("Uaktualniono");
                });
            } if (whichOne == 2) {
                SettingsService.topicUpdate(id, data)
                .success(function (response) {
                    $state.reload();
                    toastr.success("Uaktualniono");
                });
            } if (whichOne == 3) {
                CultureCategoryService.update(id, data)
                    .success(function (response) {
                        $state.reload();
                        toastr.success("Uaktualniono");
                    });
            } if (whichOne == 4) {
                PressCategoryService.update(id, data)
                    .success(function (response) {
                        $state.reload();
                        toastr.success("Uaktualniono");
                    });
            } 
        }
	}
})();

(function () {
'use strict';

	angular
		.module('app')
		.controller('ResidentialConstructionPreviewController', ResidentialConstructionPreviewController);

	function ResidentialConstructionPreviewController(ResidentialConstructionService, $scope) {

    $scope.previewData = window.pastDataToNewWindow;

		ResidentialConstructionService.readAll()
		.success(function(response) {
          $scope.newsFromBackend = response.results;
		});

        $scope.toggleBtn = function(id) {
            $('.cont-for-list-element[data-id="' + id + '"]')
            .toggleClass('active')
            .find(".inner-content").click(function () {
                return false;
            });
        }

	}

})();

(function(){
    'use strict';

    angular
        .module('app')
        .controller('ResidentialConstructionCmsController', ResidentialConstructionCmsController)

    function ResidentialConstructionCmsController(
        $filter,
        $scope,
        $state,
        $window,
        PagesFactory,
        ResidentialConstructionService,
        DocumentsService,
        Upload,
        toastr,
        PaginationService,
        EndpointParamGeneratorService) {

            $scope.pageCategory = 0;
            $scope.documentsArray = [];
            $scope.documentsArrayTitles = [];

            $scope.publishedOptions = [
                { name: 'Opublikuj', value: true },
                { name: 'Szkic', value: false }
            ];

            PaginationService.setter({currentPage: 1, pageSize: 10});

            $scope.$watch(function () {return PaginationService.getter(); }, function (newVal, oldVal) {
                if(newVal != null) {
                    $scope.currentPage = newVal.currentPage;
                    $scope.pageSize = newVal.pageSize;
                }
            });

            function paramList () {
                var list = [];

                list.push({title: 'page=', value: $scope.currentPage});
                list.push({title: 'page_size=', value: $scope.pageSize});
                list.push({title: 'category=', value: $scope.pageCategory});
                list.push({title: 'published=', value: $scope.published});

                return list;
            }

            $scope.$watch('[currentPage, pageSize, pageCategory, published]', function() {
                ResidentialConstructionService.read(EndpointParamGeneratorService.create(paramList()))
                .success(function(response) {
                    $scope.newsFromBackend = response.results;
                    $scope.countElements = response.count;
                });
            });

            PagesFactory.read('budownictwo-mieszkaniowe')
                .then(function (response) {
                    function takeResponseBySlug(slug) {
                        for(var i = 0; i < response.data.placeholders.length; i++) {
                            if(response.data.placeholders[i].slug == slug) {
                                return i;
                            }
                        }
                    }

                    if (response.data.placeholders[takeResponseBySlug("budownictwo-mieszkaniowe")]) {
                        $scope.advFromBackendTitle = response.data.placeholders[takeResponseBySlug("budownictwo-mieszkaniowe")].title;
                        $scope.advFromBackendContent = response.data.placeholders[takeResponseBySlug("budownictwo-mieszkaniowe")].content;
                    }
                });

            $scope.update = function () {
                var data = {
                    slug: 'budownictwo-mieszkaniowe',
                    title: 'budownictwo-mieszkaniowe',
                    placeholders: [{
                        slug: 'budownictwo-mieszkaniowe',
                        title: $scope.advFromBackendTitle,
                        content: $scope.advFromBackendContent,
                        type: 'pages.textplaceholder'
                    }
                    ]
                };
                PagesFactory.update('budownictwo-mieszkaniowe', data);
            }

            $scope.uploadFiles = function (files) {
                if (files && files.length) {
                    for (var i = 0; i < files.length; i++) {
                        Upload.upload({
                            url: '/api/v1/documents/',
                            data: {
                                file: files[i],
                                title: $scope.files[i].name
                            }
                        }).then(function (response) {
                            $scope.documentsArray.push(response.data.id);
                            $scope.documentsArrayTitles.push(response.data.title);
                            toastr.success("Plik został poprawnie wgrany.");
                            $('.preload-file')
                                .css('display', 'none')
                                .css('width', '0%');
                        }, function(resp) {
                            toastr.error(resp.data.file[0]);
                        }, function (evt) {
                            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                            $('.preload-file')
                                .css('display', 'block')
                                .css('width', progressPercentage + '%');
                        });
                    }
                }
            }

            $scope.changeFileName = function (id, documentPosition) {
                if($scope.documentsArrayTitles[documentPosition].length > 1) {
                    DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition]);
                }
            }

            $scope.deleteFromArray = function (id) {
                $scope.documentsArray.splice(id, 1);
                $scope.documentsArrayTitles.splice(id, 1);
            }

            $scope.deleteElement = function(id) {
                ResidentialConstructionService.delete(id)
                .success(function() {
                    $state.reload();
                    toastr.success("Pomyślnie usunięto.");
                });
            }

            $scope.editResidentialConstruction = function() {
                var data = {
                    title: $scope.value.title,
                    body: $scope.value.body,
                    documents: $scope.documentsArray,
                    published: $scope.value.published
                };

                ResidentialConstructionService.update($scope.newsId, data)
                .success(function() {
                    $state.reload();
                    toastr.success('Uaktualniono.');
                })
                .error(function (response) {
                    for(var key in response) {
                        var value = response[key];

                        try {
                            value.forEach(function (element, index) {
                                toastr.error(value[index]);
                            });
                        }

                        catch(err) {
                            toastr.error(response.detail);
                        }
                    }
                });
            }


            $scope.changeCategory = function(categoryId) {
                $scope.currentPage = 0;
                $scope.pageCategory = categoryId;
                PaginationService.setter({currentPage: 1, pageSize: $scope.pageSize});
            }

            $scope.changePosition = function(id, option) {
                ResidentialConstructionService.changePosition(id, { change: option })
                .success(function () {
                    $state.reload();
                });
            }

            $scope.changePublicFilter = function(publishedStatus) {
                $scope.currentPage = 0;
                $scope.published = publishedStatus;
                PaginationService.setter({currentPage: 1, pageSize: $scope.pageSize});
            }

            $scope.toggleBtn = function(id) {
                $('.cont-for-list-element[data-id="' + id + '"]')
                .toggleClass('active')
                .find(".inner-content").click(function () {
                    return false;
                });
            }

            $scope.showDeletePopup = function(options, id) {
                if (options === true) {
                    $scope.displayDeletePopup = true;
                } else {
                    $scope.displayDeletePopup = false;
                }
                $scope.elementId = id;
            }

            $scope.showEditPopup = function(options, id) {
                if (options === true) {
                    $scope.displayEditPopup = true;
                    $scope.documentsArray = [];
                    $scope.documentsArrayTitles = [];

                    ResidentialConstructionService.readOne(id)
                    .success(function(response) {
                        for(var i = 0; i < response.documents.length; i++) {
                            $scope.documentsArray.push(response.documents[i].id);
                            $scope.documentsArrayTitles.push(response.documents[i].title);
                        }

                        $scope.newsId = response.id;
                        $scope.value.title = response.title;
                        $scope.value.body = response.body;
                        $scope.value.published = response.published;
                    });

                } else {
                    $scope.displayEditPopup = false;
                    $state.reload();
                }
                $scope.elementId = id;
            }

            $scope.openLink = function (link) {
                var previewData = {
                    body: $scope.value.body,
                    title: $scope.value.title,
                    documents: $scope.documentsArrayTitles
                };
                $window.open(link, '_blank').pastDataToNewWindow = previewData;
            }

            $scope.stripFormat = function ($html) {
                return $filter('HtmlToPlain')($html);
            }
        }
})();

(function(){
	'use strict';

	angular
		.module('app')
		.controller('AddResidentialConstructionCmsController', AddResidentialConstructionCmsController);

    function AddResidentialConstructionCmsController(
        $scope,
        $location,
        $filter,
        ResidentialConstructionService,
        Upload,
        DocumentsService,
        $window,
        toastr) {

            $scope.documentsArray = [];
            $scope.documentsArrayTitles = [];
            $scope.isImportant = false;
            $scope.published = 'True';

            $scope.uploadFiles = function (files) {
                if (files && files.length) {
                    for (var i = 0; i < files.length; i++) {
                        Upload.upload({
                            url: '/api/v1/documents/',
                            data: {
                                file: files[i],
                                title: $scope.files[i].name
                            }
                        }).then(function (response) {
                            $scope.documentsArray.push(response.data.id);
                            $scope.documentsArrayTitles.push(response.data.title);
                            $('.preload-file')
                                .css('display', 'none')
                                .css('width', '0px');
                            toastr.success("Plik został poprawnie wgrany.");
                        }, function(resp) {
                            toastr.error(resp.data.file[0]);
                        }, function (evt) {
                            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                            $('.preload-file')
                                .css('display', 'block')
                                .css('width', progressPercentage + '%');
                        });
                    }
                }
            }

            $scope.changeFileName = function (id, documentPosition) {
                if($scope.documentsArrayTitles[documentPosition].length > 1) {
                    DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition]);
                }
            }

            $scope.deleteFromArray = function (id) {
                $scope.documentsArray.splice(id, 1);
                $scope.documentsArrayTitles.splice(id, 1);
            }

            $scope.submit = function () {
                var data = {
                    body: $scope.newsBody,
                    title: $scope.newsTitle,
                    documents: $scope.documentsArray,
                    published: $scope.published
                };

                ResidentialConstructionService.create(data)
                .success(function() {
                    $location.path('/panel-administracyjny53335/budownictwo-mieszkaniowe');
                    toastr.success('Dodano.');
                })
                .error(function() {
                    toastr.error("Wypełnij wszystkie pola.");
                })
            }

            $scope.openLink = function (link) {
                var previewData = {
                    body: $scope.newsBody,
                    title: $scope.newsTitle,
                    documents: $scope.documentsArrayTitles,
                };
                $window.open(link, '_blank').pastDataToNewWindow = previewData;
            }

            $scope.stripFormat = function ($html) {
                return $filter('HtmlToPlain')($html);
            }
		}
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('RentCategoriesController', RentCategoriesController);

    function RentCategoriesController($state, RentCategoriesFactory, ngDialog, toastr) {
        var vm = this;

        RentCategoriesFactory.read()
            .then(function (response) {
                vm.categoriesFromBackend = response.data;
            });

        vm.confirmDialog = function (itemId) {
            ngDialog.open({
                className: 'ngdialog-theme-default',
                template: 'app/components/delete_dialog/delete.dialog.html',
                data: {
                    item_id: itemId,
                    delete_function: RentCategoriesFactory.delete
                }
            });
        }

        vm.addNewCategory = function () {
            var data = {
                name: vm.categoryName
            }

            RentCategoriesFactory.create(data)
                .then(function () {
                    toastr.success('Dodano.');
                    $state.reload();
                }, function () {
                    toastr.error('Pole nie może być puste.');
                });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('EditRentController', EditRentController);

    function EditRentController($scope, $state, $stateParams, DocumentsService, RentFactory, RentCategoriesFactory, Upload, toastr) {
        var vm = this;
        $scope.documentsArray = [];
        $scope.documentsArrayTitles = [];

        vm.publishedOptions = [
            { name: 'Opublikuj', value: true },
            { name: 'Szkic', value: false }
        ];

        $scope.uploadFiles = function (files) {
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    Upload.upload({
                        url: '/api/v1/documents/',
                        data: {
                            file: files[i],
                            title: $scope.files[i].name
                        }
                    }).then(function (response) {
                        $scope.documentsArray.push(response.data.id);
                        $scope.documentsArrayTitles.push(response.data.title);
                        toastr.success("Plik został poprawnie wgrany.");
                        $('.preload-file')
                            .css('display', 'none')
                            .css('width', '0%');
                    }, function (resp) {
                        toastr.error(resp.data.file[0]);
                    }, function (evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        $('.preload-file')
                            .css('display', 'block')
                            .css('width', progressPercentage + '%');
                    });
                }
            }
        }

        $scope.changeFileName = function (id, documentPosition) {
            if ($scope.documentsArrayTitles[documentPosition].length > 1) {
                DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition])
                    .success(function (response) {
                    });
            }
        }

        $scope.deleteFromArray = function (id) {
            $scope.documentsArray.splice(id, 1);
            $scope.documentsArrayTitles.splice(id, 1);
        }

        RentCategoriesFactory.read()
            .then(function (response) {
                vm.categoriesFromBackend = response.data;
            });

        RentFactory.readOne($stateParams.id)
            .then(function (response) {
                vm.dataFromBackend = response.data;

                for (var i = 0; i < response.data.documents.length; i++) {
                    $scope.documentsArray.push(response.data.documents[i].id);
                    $scope.documentsArrayTitles.push(response.data.documents[i].title);
                }
            });

        vm.sendDataToBackend = function () {
            var data = {
                title: vm.dataFromBackend.title,
                body: vm.dataFromBackend.body,
                documents: $scope.documentsArray,
                rent_type: vm.dataFromBackend.rent_type,
                published: vm.dataFromBackend.published
            }

            RentFactory.update($stateParams.id, data)
                .then(function (response) {
                    toastr.success('Uaktualniono.')
                    $state.go('dashboard.rent')
                }, function (response) {
                    toastr.error('Wypełnij wszystkie pola.');
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('AddNewRentController', AddNewRentController);

    function AddNewRentController($scope, $state, DocumentsService, RentFactory, RentCategoriesFactory, Upload, toastr) {
        var vm = this;

        vm.published = 'True';
        $scope.documentsArray = [];
        $scope.documentsArrayTitles = [];

        RentCategoriesFactory.read()
            .then(function (response) {
                vm.categoriesFromBackend = response.data;
            });

        $scope.uploadFiles = function (files) {
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    Upload.upload({
                        url: '/api/v1/documents/',
                        data: {
                            file: files[i],
                            title: $scope.files[i].name
                        }
                    }).then(function (response) {
                        $scope.documentsArray.push(response.data.id);
                        $scope.documentsArrayTitles.push(response.data.title);
                        $('.preload-file')
                            .css('display', 'none')
                            .css('width', '0px');
                        toastr.success("Plik został poprawnie wgrany.");
                    }, function (resp) {
                        toastr.error(resp.data.file[0]);
                    }, function (evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        $('.preload-file')
                            .css('display', 'block')
                            .css('width', progressPercentage + '%');
                    });
                }
            }
        }

        $scope.changeFileName = function (id, documentPosition) {
            if ($scope.documentsArrayTitles[documentPosition].length > 1) {
                DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition])
                    .success(function () {
                    });
            }
        }

        $scope.deleteFromArray = function (id) {
            $scope.documentsArray.splice(id, 1);
            $scope.documentsArrayTitles.splice(id, 1);
        }

        vm.sendDataToBackend = function () {
            var data = {
                title: vm.title,
                body: vm.body,
                documents: $scope.documentsArray,
                rent_type: vm.rentType,
                published: vm.published
            }

            RentFactory.create(data)
                .then(function() {
                    toastr.success('Dodano.');
                    $state.go('dashboard.rent')
                }, function () {
                    toastr.error('Wypełnij wszystkie pola.');
                });
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('app')
        .controller('EditPressController', EditPressController)

    /** @ngInject */
    function EditPressController(
        $scope,
        $state,
        $stateParams,
        DocumentsService,
        PressCategoryService,
        PressFactory,
        Upload,
        toastr) {

        var vm = this;

        $scope.documentsArray = [];
        $scope.documentsArrayTitles = [];

        $scope.uploadFiles = function (files) {
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    Upload.upload({
                        url: '/api/v1/documents/',
                        data: {
                            file: files[i],
                            title: $scope.files[i].name
                        }
                    }).then(function (response) {
                        $scope.documentsArray.push(response.data.id);
                        $scope.documentsArrayTitles.push(response.data.title);
                        toastr.success("Plik został poprawnie wgrany.");
                        $('.preload-file')
                            .css('display', 'none')
                            .css('width', '0%');
                    }, function (resp) {
                        toastr.error(resp.data.file[0]);
                    }, function (evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        $('.preload-file')
                            .css('display', 'block')
                            .css('width', progressPercentage + '%');
                    });
                }
            }
        }

        $scope.changeFileName = function (id, documentPosition) {
            if ($scope.documentsArrayTitles[documentPosition].length > 1) {
                DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition])
                    .success(function (response) {
                    });
            }
        }

        $scope.deleteFromArray = function (id) {
            $scope.documentsArray.splice(id, 1);
            $scope.documentsArrayTitles.splice(id, 1);
        }

        PressFactory.readOne($stateParams.id)
        .then(function (response) {
            vm.dataFromBackend = response.data;

            for (var i = 0; i < response.data.documents.length; i++) {
                $scope.documentsArray.push(response.data.documents[i].id);
                $scope.documentsArrayTitles.push(response.data.documents[i].title);
            }
            });

        PressCategoryService.read()
            .then(function (response) {
                vm.categoriesFromBackend = response.data;
            });

        vm.sendDataToBackend = function () {
            var data = {
                title: vm.dataFromBackend.title,
                category: vm.dataFromBackend.category,
                body: vm.dataFromBackend.body,
                documents: $scope.documentsArray,
            }

            PressFactory.update($stateParams.id, data)
                .then(function () {
                    toastr.success('Uaktualniono.');
                    $state.go('dashboard.press');
                }, function () {
                    toastr.error('Wypełnij poprawnie formularz.');
                })
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app')
        .controller('AddPressCmsController', AddPressCmsController);

    function AddPressCmsController(
        $scope,
        $state,
        DocumentsService,
        PressFactory,
        PressCategoryService,
        Upload,
        toastr) {

        var vm = this;

        $scope.documentsArray = [];
        $scope.documentsArrayTitles = [];

        $scope.uploadFiles = function (files) {
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    Upload.upload({
                        url: '/api/v1/documents/',
                        data: {
                            file: files[i],
                            title: $scope.files[i].name
                        }
                    }).then(function (response) {
                        $scope.documentsArray.push(response.data.id);
                        $scope.documentsArrayTitles.push(response.data.title);
                        $('.preload-file')
                            .css('display', 'none')
                            .css('width', '0px');
                        toastr.success("Plik został poprawnie wgrany.");
                    }, function (resp) {
                        toastr.error(resp.data.file[0]);
                    }, function (evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        $('.preload-file')
                            .css('display', 'block')
                            .css('width', progressPercentage + '%');
                    });
                }
            }
        }

        $scope.changeFileName = function (id, documentPosition) {
            if ($scope.documentsArrayTitles[documentPosition].length > 1) {
                DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition])
                    .success(function (response) {
                    });
            }
        }

        $scope.deleteFromArray = function (id) {
            $scope.documentsArray.splice(id, 1);
            $scope.documentsArrayTitles.splice(id, 1);
        }

        PressCategoryService.read()
            .then(function (response) {
                vm.categoryList = response.data;
            });

        vm.sendDataToBackend = function () {
            var data = {
                title: vm.title,
                body: vm.body,
                category: vm.category,
                documents: $scope.documentsArray
            }

            PressFactory.create(data)
                .then(function () {
                    $state.go('dashboard.press');
                    toastr.success('Dodano.');
                }, function () {
                    toastr.error('Wypełnij cały formularz.')
                });
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('app')
        .controller('EditPerfectPlaceController', EditPerfectPlaceController)

    /** @ngInject */
    function EditPerfectPlaceController($scope, $state, $stateParams, Upload, DocumentsService, PerfectPlaceFactory, toastr){
        var vm = this;

        $scope.upload = function (file) {
	        Upload.upload({
	            url: '/api/v1/documents/',
	            data: {
	               file: file,
	               'title': $scope.file.name
	            }
	        }).then(function (response) {
                vm.documentId = response.data.id;
                vm.documentName = response.data.title;
	            $('.preload-file')
                    .css('display', 'none')
                    .css('width', '0px');
                toastr.success("Plik został poprawnie wgrany.");
	        }, function(resp) {
	           toastr.error(resp.data.file[0]);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                $('.preload-file')
                    .css('display', 'block')
                    .css('width', progressPercentage + '%');
            });
        }

        vm.deleteFile = function (id) {
            DocumentsService.delete(id);
            vm.documentId = null
            vm.documentName = null;
        }

        PerfectPlaceFactory.readOne($stateParams.id)
        .then(function (response) {
            vm.dataFromBackend = response.data;
            vm.documentOldId = response.data.documents[0].id;
        });

        vm.sendDataToBackend = function () {
            if(vm.documentId) {
                var data = {
                    title: vm.dataFromBackend.title,
                    body: vm.dataFromBackend.body,
                    documents: [ vm.documentId ],
                    image_position: vm.dataFromBackend.image_position,
                }
            } else {
                var data = {
                    title: vm.dataFromBackend.title,
                    body: vm.dataFromBackend.body,
                    image_position: vm.dataFromBackend.image_position,
                    documents: [ vm.documentOldId  ],
                }
            }

            PerfectPlaceFactory.update($stateParams.id, data)
            .then(function () {
                toastr.success('Uaktualniono.');
                $state.go('dashboard.perfect_place');
            }, function () {
                toastr.error('Wypełnij poprawnie formularz.');
            });
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app')
        .controller('AddPerfectPlaceCmsController', AddPerfectPlaceCmsController)

    /** @ngInject */
    function AddPerfectPlaceCmsController($scope, $state, PerfectPlaceFactory, DocumentsService, Upload, toastr){
        var vm = this;
        vm.imagePosition = 'top-left';

        $scope.upload = function (file) {
	        Upload.upload({
	            url: '/api/v1/documents/',
	            data: {
	               file: file,
	               'title': $scope.file.name
	            }
	        }).then(function (response) {
                vm.documentId = response.data.id;
                vm.documentName = response.data.title;
	            $('.preload-file')
                    .css('display', 'none')
                    .css('width', '0px');
                toastr.success("Plik został poprawnie wgrany.");
	        }, function(resp) {
	           toastr.error(resp.data.file[0]);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                $('.preload-file')
                    .css('display', 'block')
                    .css('width', progressPercentage + '%');
            });
        }

        vm.deleteFile = function (id) {
            DocumentsService.delete(id);
            vm.documentId = null
            vm.documentName = null;
        }

        vm.sendDataToBackend = function () {
            var data = {
                title: vm.title,
                image_position: vm.imagePosition,
                body: vm.body,
                documents: [ vm.documentId ]
            }

            PerfectPlaceFactory.create(data)
            .then(function () {
                $state.go('dashboard.perfect_place');
                toastr.success('Dodano.');
            }, function () {
                toastr.error('Wypełnij cały formularz.')
            });
        }
    }

}());
(function () {
'use strict';

	angular
		.module('app')
		.controller('NewsPreviewController', NewsPreviewController);

	function NewsPreviewController(NewsService, $scope) {

    $scope.previewData = window.pastDataToNewWindow;

		NewsService.readAll()
		.success(function (response) {
          $scope.newsFromBackend = response.results;
		});

        $scope.toggleBtn = function(id) {     
            $('.cont-for-list-element[data-id="' + id + '"]')
            .toggleClass('active')
            .find(".inner-content").click(function () {
                return false;
            });
        }
        
	}

})();

(function(){
	'use strict';

	angular
		.module('app')
		.controller('NewsCmsController', NewsCmsController)

    function NewsCmsController(
        $filter,
        $scope,
        $state,
        $window,
        NewsCategoryService,
        NewsService,
        DocumentsService,
        Upload,
        toastr,
        PaginationService,
        EndpointParamGeneratorService) {

            $scope.pageCategory = 0;
            $scope.documentsArray = [];
            $scope.documentsArrayTitles = [];

            $scope.publishedOptions = [
                { name: 'Opublikuj', value: true },
                { name: 'Szkic', value: false }
            ];

            PaginationService.setter({currentPage: 1, pageSize: 10});

            $scope.$watch(function () {return PaginationService.getter(); }, function (newVal, oldVal) {
                if(newVal != null) {
                    $scope.currentPage = newVal.currentPage;
                    $scope.pageSize = newVal.pageSize;
                }
            });

            function paramList () {
                var list = [];

                list.push({title: 'page=', value: $scope.currentPage});
                list.push({title: 'page_size=', value: $scope.pageSize});
                list.push({title: 'category=', value: $scope.pageCategory});
                list.push({title: 'published=', value: $scope.published});

                return list;
            }

            NewsCategoryService.read()
            .success(function(response) {
                $scope.categoriesFromBackend = response;
            });

            $scope.$watch('[currentPage, pageSize, pageCategory, published]', function() {

                NewsService.read(EndpointParamGeneratorService.create(paramList()))
                .success(function(response) {
                    $scope.newsFromBackend = response.results;
                    $scope.countElements = response.count;
                });    
            });

            $scope.uploadFiles = function (files) {
                if (files && files.length) {
                    for (var i = 0; i < files.length; i++) {
                        Upload.upload({
                            url: '/api/v1/documents/', 
                            data: {
                                file: files[i],
                                title: $scope.files[i].name
                            }
                        }).then(function (response) {
                            $scope.documentsArray.push(response.data.id);
                            $scope.documentsArrayTitles.push(response.data.title);
                            toastr.success("Plik został poprawnie wgrany.");
                            $('.preload-file')
                                .css('display', 'none')
                                .css('width', '0%');
                        }, function(resp) {
                            toastr.error(resp.data.file[0]);
                        }, function (evt) {
                            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                            $('.preload-file')
                                .css('display', 'block')
                                .css('width', progressPercentage + '%');
                        });
                    }
                }
            }

            $scope.changeFileName = function (id, documentPosition) {
                if($scope.documentsArrayTitles[documentPosition].length > 1) {
                    DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition])
                    .success(function (response) {
                    });
                }
            }

            $scope.deleteFromArray = function (id) {
                $scope.documentsArray.splice(id, 1);
                $scope.documentsArrayTitles.splice(id, 1);
            }

            $scope.deleteElement = function(id) {
                NewsService.delete(id)
                .success(function(response) {
                    $state.reload();
                    toastr.success("Pomyślnie usunięto.");
                });
            }

            $scope.editNews = function (id, value) {
                var data = {
                        title: $scope.value.title,
                        body: $scope.value.body,
                        category: $scope.value.category,
                        documents: $scope.documentsArray,
                        published: $scope.value.published
                    };

                NewsService.update($scope.newsId, data) 
                .success(function (response) {
                    $state.reload();
                    toastr.success('Uaktualniono.');
                })
                .error(function (response) {
                    for(var key in response) {
                        var value = response[key];

                        try {
                            value.forEach(function (element, index, array) {
                                toastr.error(value[index]);
                            });
                        }

                        catch(err) {
                            toastr.error(response.detail);
                        }
                    }
                });
            }


            $scope.changeCategory = function(categoryId) {
                $scope.currentPage = 0;
                $scope.pageCategory = categoryId;
                PaginationService.setter({currentPage: 1, pageSize: $scope.pageSize});
            }

            $scope.changePosition = function (id, option) {
                var data = {
                    change: option
                }

                NewsService.changePosition(id, data)
                    .success(function () {
                        $state.reload();
                    });
            }

            $scope.changePublicFilter = function(publishedStatus) {
                $scope.currentPage = 0;
                $scope.published = publishedStatus;
                PaginationService.setter({currentPage: 1, pageSize: $scope.pageSize});
            }
            
            $scope.toggleBtn = function(id) {     
                $('.cont-for-list-element[data-id="' + id + '"]')
                .toggleClass('active')
                .find(".inner-content").click(function () {
                    return false;
                });
            }      

            $scope.showDeletePopup = function(options, id) {
                if (options === true) {
                    $scope.displayDeletePopup = true;
                } else {
                    $scope.displayDeletePopup = false;
                }
                $scope.elementId = id;
            }

            $scope.showEditPopup = function(options, id) {
                if (options === true) {
                    $scope.displayEditPopup = true;
                    $scope.documentsArray = [];
                    $scope.documentsArrayTitles = [];
                    
                    NewsService.readOne(id)
                    .success(function(response) {

                        for(var i = 0; i < response.documents.length; i++) {
                            $scope.documentsArray.push(response.documents[i].id);
                            $scope.documentsArrayTitles.push(response.documents[i].title);
                        }

                        $scope.newsId = response.id;
                        $scope.value.title = response.title;
                        $scope.value.body = response.body;
                        $scope.value.category = response.category;
                        $scope.value.published = response.published;

                    });

                } else {
                    $scope.displayEditPopup = false;
                    $state.reload();
                }
                $scope.elementId = id;
            }

            $scope.openLink = function (link) {
                var previewData = {
                    body: $scope.value.body,
                    category: $scope.value.category,
                    title: $scope.value.title,
                    documents: $scope.documentsArrayTitles
                }   

                $window.open(link, '_blank').pastDataToNewWindow = previewData;        
            }

            $scope.stripFormat = function ($html) {
                return $filter('HtmlToPlain')($html);
            }

		}
})();

(function(){
	'use strict';

	angular
		.module('app')
		.controller('AddNewsCmsController', AddNewsCmsController);

    function AddNewsCmsController(
        $scope,
        $location,
        $filter,
        NewsService,
        NewsCategoryService,
        Upload,
        DocumentsService,
        $window,
        toastr) {

            $scope.documentsArray = [];
            $scope.documentsArrayTitles = [];
            $scope.isImportant = false;
            $scope.published = 'True';

            NewsCategoryService.read()
            .success(function(response) {
                $scope.categoriesList = response;
            });

            $scope.uploadFiles = function (files) {
                if (files && files.length) {
                    for (var i = 0; i < files.length; i++) {
                        Upload.upload({
                            url: '/api/v1/documents/', 
                            data: {
                                file: files[i],
                                title: $scope.files[i].name
                            }
                        }).then(function (response) {
                            $scope.documentsArray.push(response.data.id);
                            $scope.documentsArrayTitles.push(response.data.title);
                            $('.preload-file')
                                .css('display', 'none')
                                .css('width', '0px');
                            toastr.success("Plik został poprawnie wgrany.");     
                        }, function(resp) {
                            toastr.error(resp.data.file[0]);
                        }, function (evt) {
                            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                            $('.preload-file')
                                .css('display', 'block')
                                .css('width', progressPercentage + '%');
                        });
                    }
                }
            }

            $scope.changeFileName = function (id, documentPosition) {
                if($scope.documentsArrayTitles[documentPosition].length > 1) {
                    DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition])
                        .success(function (response) {
                        });
                }
            }

            $scope.deleteFromArray = function (id) {
                $scope.documentsArray.splice(id, 1);
                $scope.documentsArrayTitles.splice(id, 1);
            }

            $scope.submit = function () {
                var data = {
                    body: $scope.newsBody,
                    category: $scope.newsCategory,
                    title: $scope.newsTitle,
                    documents: $scope.documentsArray,
                    published: $scope.published
                };

                NewsService.create(data)
                .success(function (response) {
                    $location.path('/panel-administracyjny53335/aktualnosci');
                    toastr.success('Dodano.');
                })
                .error(function () {
                    toastr.error("Wypełnij wszystkie pola.");
                })
            }

            $scope.openLink = function (link) {
                var previewData = {
                    body: $scope.newsBody,
                    category: $scope.newsCategory,
                    title: $scope.newsTitle,
                    documents: $scope.documentsArrayTitles,

                }   

                $window.open(link, '_blank').pastDataToNewWindow = previewData;        
            }

            $scope.stripFormat = function ($html) {
                return $filter('HtmlToPlain')($html);
            }

		}
})();

(function () {
'use strict';

	angular
		.module('app')
		.factory('LogsService', LogsService)
		.service('UserLogsService', UserLogsService);

	function LogsService ($http) {
		var logs = {};

		logs.read = function (page, pageSiz, user) {
			var nextPage = page + 1,
				pageSize = pageSiz,
				whichUser = user;

			if (whichUser == 0) {	

			return $http.get('/api/v1/logs/?page=' + nextPage + '&page_size=' + pageSize);

			} else {

				return $http.get('/api/v1/logs/?page=' + nextPage + '&page_size=' + pageSize + '&user__last_name=' + whichUser);

			}
		}

		return logs;
	}

	function UserLogsService () {
		var _user = 0;

		this.user = _user;
	}

})();
(function () {
'use strict';

	angular
		.module('app')
		.config(logsRouterConfig);

	function logsRouterConfig ($stateProvider) {
		$stateProvider
	        .state('dashboard.logs', {
                url: '/logi',
                templateUrl: 'app/partials/logs/logs.cms.html',
                controller: 'LogsController'
	        });
	}

})();
(function () {
'use strict';
	
	angular
		.module('app')
		.controller('LogsController', LogsController);

	function LogsController($scope, LogsService, UsersService, UserLogsService) {

		$scope.currentPage = 0;
        $scope.pageSize = 10;
        $scope.user = UserLogsService.user;

        $scope.$watch('[currentPage, pageSize, user]', function() {
		
			LogsService.read($scope.currentPage, $scope.pageSize, $scope.user)
				.success(function (response) {
					$scope.logsFromBackend = response.results;
					$scope.howManyPostsAre = response.count;
				})
				.error(function () {
					console.warn("Błąd wczytywania logów.");
				});

		});

		UsersService.readAll()
			.success(function (response) {
				$scope.usersFromBackend = response.results;
			})
			.error(function () {
				console.warn("Błąd pobierania użytkowników.");
			})

        $scope.numberOfPages = function() {
            return Math.ceil($scope.howManyPostsAre / $scope.pageSize);
        }
        
        $scope.howManyNewsAreDisplayed = function(howMany, id) {
            $('.display b').removeClass('active');
            $('.display b[data-id="' + id + '"]').addClass('active');
            $scope.pageSize = howMany;
            $scope.currentPage = 0;
        }
	}

})();
(function () {
'use strict';

	angular
		.module('app')
		.factory('LoginService', LoginService);

	function LoginService($http) {
		var login = {};

		login.isLogged = function () {
			return $http.get('/api/v1/auth/user/');
		}

		login.logMe = function(data) {
			return $http.post('/api/v1/auth/login/', data);
		}

		return login;
	}

})();
(function() {
    "use strict";

    angular.module("app").config(loginRouterConfig);

    function loginRouterConfig($stateProvider) {
        $stateProvider
            .state("login", {
                url: "/adm53335",
                templateUrl: "app/partials/login/login.html",
                controller: "LoginController",
                controllerAs: "login"
            })
            .state("pwwd_reminder", {
                url: "/przypomnienie-hasla",
                templateUrl: "app/partials/login/password_reminder.html",
                controller: "PasswordReminderController",
                controllerAs: "PasswordReminderCtrl"
            });
    }
})();

(function() {
    'use strict',

    angular
        .module('app')
        .controller('PasswordReminderController', PasswordReminderController);


        function PasswordReminderController($location, UsersService, LoginService, toastr) {
            var vm = this;

            vm.sendNewPassword = function () {
                var data = {
                    email: vm.email
                }

                UsersService.sendNewPassword(data)
                .success(function () {
                    toastr.success("Hasło zostało zmienione.");
                    $location.path('/adm53335');
                })
                .error(function () {
                    toastr.error("E-mail nieprawidłowy.");
                });
            }
        }
})();
(function() {
	'use strict',

	angular
		.module('app')
		.controller('LoginController', LoginController);


		function LoginController($scope, $location, LoginService, toastr) {

			var isLogged = false;

			LoginService.isLogged()
				.success(function (response) {
					$location.path('/panel-administracyjny53335/');
				})
				.error(function () {
					console.warn("Zaloguj się.");
				});

			this.login = function(user) {

				var data = {
					email: $scope.user.email,
					password: $scope.user.password
				};

				LoginService.logMe(data)
					.success(function (response) {
						$location.path('/panel-administracyjny53335/');
					})
					.error(function () {
						toastr.error("Błędne email lub hasło.");
					});

			}
		}
})();
(function() {
    'use strict';
    
     angular
        .module('app')
        .controller("InfoController", InfoController);
        
        function InfoController($scope, InformationsService, $window, DocumentsService, PaginationService, EndpointParamGeneratorService) {

            $scope.showHideAll = "Rozwiń wszystko";
            $scope.showNoResults = false;

            PaginationService.setter({currentPage: 1, pageSize: 10});
            $scope.$watch(function () {return PaginationService.getter(); }, function (newVal, oldVal) {
                if(newVal != null) {
                    $scope.currentPage = newVal.currentPage;
                    $scope.pageSize = newVal.pageSize;
                }
            });

            function paramList () {
                var list = [];
                list.push({title: 'page=', value: $scope.currentPage});
                list.push({title: 'page_size=', value: $scope.pageSize});
                return list;
            }

            $scope.$watch('[currentPage, pageSize]', function() {

                $scope.newsFromBackend = {};
                $scope.newsFromBackend.dataLoaded = false;

                InformationsService.read(EndpointParamGeneratorService.create(paramList()))
                .success(function(response) {
                    $scope.newsFromBackend = response.results;
                    $scope.countElements = response.count;
                    $scope.newsFromBackend.dataLoaded = true;

                    if(response.results.length < 1) {
                        $scope.showNoResults = true;
                    } else {
                        $scope.showNoResults = false;
                    }

                });
            });

            $scope.checkActive = function () {
                var isSomethingOpened = $('.cont-for-list-element').hasClass('active');
                if (isSomethingOpened == true) {
                    $scope.showHideAll = "Zwiń wszystko";
                    $('#show-hide-all').addClass('active');
                } else {
                    $scope.showHideAll = "Rozwiń wszystko";
                    $('#show-hide-all').removeClass('active');
                }    
            }

            $scope.openLink = function (link) {
                $window.open(link, '_blank');
            }         
            
            $scope.toggleBtn = function(id) {     
                $('.cont-for-list-element[data-id="' + id + '"]')
                .toggleClass('active')
                .find(".inner-content").click(function () {
                    return false;
                });
            }

            $scope.showPopup = function(options, newsId, imageId, newsIndex) {
                if (options === true) {
                    $scope.displayPopup = true;
                    $scope._id = imageId;
                    var allImagesIds = [],
                        currentImageId = $scope._id,
                        currentImagePosition;

                    for(var i = 0; i < $scope.newsFromBackend[newsIndex].documents.length; i++) {
                        allImagesIds.push($scope.newsFromBackend[newsIndex].documents[i].id);
                    }

                    for (var i = 0; i<allImagesIds.length; i++) {
                        if(currentImageId == allImagesIds[i]) {
                            currentImageId = allImagesIds[i];
                            currentImagePosition = i;
                        }
                    }

                    $scope.imageRotate = function (rotate) {
                        if(rotate == 1) {       
                            if(currentImagePosition == allImagesIds.length-1) {
                                currentImagePosition = 0;
                            } else {
                                currentImagePosition++;
                            }
                        } if(rotate == 0) {
                            if(currentImagePosition == 0) {
                                currentImagePosition = allImagesIds.length-1;
                            } else {
                                currentImagePosition--;        
                            }       
                        }
                        $scope._id = allImagesIds[currentImagePosition];
                    }


                    $scope.$watch('_id', function() {
                        InformationsService.readOne(newsId)
                        .success(function (response) {
                            for(var i = 0; i < response.documents.length; i ++) {
                                if($scope._id == response.documents[i].id) {
                                    $scope.oneImage = response.documents[i];
                                }
                            }
                        });
                    });

                } else {
                    $scope.displayPopup = false;
                }
            }

        }

})();
(function () {
'use strict';

	angular
		.module('app')
		.controller('InfoPreviewController', InfoPreviewController);

	function InfoPreviewController(InformationsService, $scope) {

		$scope.previewData = window.pastDataToNewWindow;

		InformationsService.readAll()
		.success(function (response) {
			$scope.newsFromBackend = response.results;		
		});

        $scope.toggleBtn = function(id) {     
            $('.cont-for-list-element[data-id="' + id + '"]')
            .toggleClass('active')
            .find(".inner-content").click(function () {
                return false;
            });
        }
        
	}

})();
(function(){
	'use strict';

	angular
		.module('app')
		.controller('InfoCmsController', InfoCmsController)

		function InfoCmsController($filter, $scope, $state, $window, InformationsService, DocumentsService, Upload, toastr, PaginationService, EndpointParamGeneratorService) {

            $scope.documentsArray = [];
            $scope.documentsArrayTitles = [];

            $scope.publishedOptions = [
                { name: 'Opublikuj', value: true },
                { name: 'Szkic', value: false }
            ];

            PaginationService.setter({currentPage: 1, pageSize: 10});
            $scope.$watch(function () {return PaginationService.getter(); }, function (newVal, oldVal) {
                if(newVal != null) {
                    $scope.currentPage = newVal.currentPage;
                    $scope.pageSize = newVal.pageSize;
                }
            });
            function paramList () {
                var list = [];
                list.push({title: 'page=', value: $scope.currentPage});
                list.push({title: 'page_size=', value: $scope.pageSize});
                return list;
            }

            $scope.$watch('[currentPage, pageSize]', function() {

                InformationsService.read(EndpointParamGeneratorService.create(paramList()))
                .success(function(response) {
                    $scope.newsFromBackend = response.results;
                    $scope.countElements = response.count;
                });
            });

            $scope.uploadFiles = function (files) {
                if (files && files.length) {
                    for (var i = 0; i < files.length; i++) {
                        Upload.upload({
                            url: '/api/v1/documents/',
                            data: {
                                file: files[i],
                                title: $scope.files[i].name
                            }
                        }).then(function (response) {
                            $scope.documentsArray.push(response.data.id);
                            $scope.documentsArrayTitles.push(response.data.title);
                            toastr.success("Plik został poprawnie wgrany.");
                            $('.preload-file')
                                .css('display', 'none')
                                .css('width', '0%');
                        }, function(resp) {
                            toastr.error(resp.data.file[0]);
                        }, function (evt) {
                            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                            $('.preload-file')
                                .css('display', 'block')
                                .css('width', progressPercentage + '%');
                        });
                    }
                }
            }

            $scope.changePosition = function (id, option) {
                var data = {
                    change: option
                }

                InformationsService.changePosition(id, data)
                    .success(function () {
                        $state.reload();
                    });
            }

            $scope.changeFileName = function (id, documentPosition) {
                if($scope.documentsArrayTitles[documentPosition].length > 1) {
                    DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition])
                    .success(function () {
                    });
                }
            }

            $scope.deleteFromArray = function (id) {
                $scope.documentsArray.splice(id, 1);
                $scope.documentsArrayTitles.splice(id, 1);
            }

            $scope.deleteElement = function(id) {
                InformationsService.delete(id)
                .success(function() {
                    $state.reload();
                    toastr.success("Pomyślnie usunięto.");
                });
            }

            $scope.editNews = function (id, value) {
                var data = {
                        title: $scope.value.title,
                        body: $scope.value.body,
                        documents: $scope.documentsArray,
                        published: $scope.value.published
                    };

                InformationsService.update($scope.newsId, data)
                .success(function (response) {
                    $state.reload();
                    toastr.success('Uaktualniono.');
                })
                .error(function (response) {
                    for(var key in response) {
                        var value = response[key];

                        try {
                            value.forEach(function (element, index, array) {
                                toastr.error(value[index]);
                            });
                        }

                        catch(err) {
                            toastr.error(response.detail);
                        }
                    }
                });
            }

            $scope.toggleBtn = function(id) {
                $('.cont-for-list-element[data-id="' + id + '"]')
                .toggleClass('active')
                .find(".inner-content").click(function () {
                    return false;
                });
            }

            $scope.showDeletePopup = function(options, id) {
                if (options === true) {
                    $scope.displayDeletePopup = true;
                } else {
                    $scope.displayDeletePopup = false;
                }
                $scope.elementId = id;
            }

            $scope.showEditPopup = function(options, id) {
                if (options === true) {
                    $scope.displayEditPopup = true;
                    $scope.documentsArray = [];
                    $scope.documentsArrayTitles = [];

                    InformationsService.readOne(id)
                    .success(function(response) {

                        for(var i = 0; i < response.documents.length; i++) {
                            $scope.documentsArray.push(response.documents[i].id);
                            $scope.documentsArrayTitles.push(response.documents[i].title);
                        }

                        $scope.newsId = response.id;
                        $scope.value.title = response.title;
                        $scope.value.body = response.body;
                        $scope.value.published = response.published;

                    });

                } else {
                    $scope.displayEditPopup = false;
                    $state.reload();
                }
                $scope.elementId = id;
            }

            $scope.openLink = function (link) {
                var previewData = {
                    body: $scope.value.body,
                    title: $scope.value.title,
                    documents: $scope.documentsArrayTitles
                }

                $window.open(link, '_blank').pastDataToNewWindow = previewData;
            }

            $scope.stripFormat = function ($html) {
                return $filter('HtmlToPlain')($html);
            }

		}
})();
(function(){
	'use strict';

	angular
		.module('app')
		.controller('AddInfoCmsController', AddInfoCmsController);

		function AddInfoCmsController($scope, $location, $filter, InformationsService, Upload, DocumentsService, $window, toastr) {

            $scope.documentsArray = [];
            $scope.documentsArrayTitles = [];
            $scope.published = 'True';

            $scope.uploadFiles = function (files) {
                if (files && files.length) {
                    for (var i = 0; i < files.length; i++) {
                        Upload.upload({
                            url: '/api/v1/documents/', 
                            data: {
                                file: files[i],
                                title: $scope.files[i].name
                            }
                        }).then(function (response) {
                            $scope.documentsArray.push(response.data.id);
                            $scope.documentsArrayTitles.push(response.data.title);
                            $('.preload-file')
                                .css('display', 'none')
                                .css('width', '0px');
                            toastr.success("Plik został poprawnie wgrany.");     
                        }, function(resp) {
                            toastr.error(resp.data.file[0]);
                        }, function (evt) {
                            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                            $('.preload-file')
                                .css('display', 'block')
                                .css('width', progressPercentage + '%');
                        });
                    }
                }
            }

            $scope.changeFileName = function (id, documentPosition) {
                if($scope.documentsArrayTitles[documentPosition].length > 1) {
                    DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition])
                    .success(function (response) {
                    });
                }
            }

            $scope.deleteFromArray = function (id) {
                $scope.documentsArray.splice(id, 1);
                $scope.documentsArrayTitles.splice(id, 1);
            }

            $scope.submit = function () {

                var data = {
                    body: $scope.newsBody,
                    title: $scope.newsTitle,
                    documents: $scope.documentsArray,
                    published: $scope.published
                };

                InformationsService.create(data)
                .success(function (response) {
                    $location.path('/panel-administracyjny53335/procedury');
                    toastr.success('Dodano.');
                })
                .error(function () {
                    toastr.error("Wypełnij wszystkie pola.");
                })
            }

            $scope.openLink = function (link) {
                var previewData = {
                    body: $scope.newsBody,
                    title: $scope.newsTitle,
                    documents: $scope.documentsArrayTitles
                }   

                $window.open(link, '_blank').pastDataToNewWindow = previewData;        
            }

            $scope.stripFormat = function ($html) {
                return $filter('HtmlToPlain')($html);
            }

		}
})();
(function () {
'use strict';

	angular
		.module('app')
		.controller('FundingPreviewController', FundingPreviewController);

	function FundingPreviewController(FundingService, $scope) {

    $scope.previewData = window.pastDataToNewWindow;

		FundingService.readAll()
		.success(function(response) {
          $scope.newsFromBackend = response.results;
		});

        $scope.toggleBtn = function(id) {     
            $('.cont-for-list-element[data-id="' + id + '"]')
            .toggleClass('active')
            .find(".inner-content").click(function () {
                return false;
            });
        }
        
	}

})();

(function(){
    'use strict';

    angular
        .module('app')
        .controller('FundingCmsController', FundingCmsController)

    function FundingCmsController(
        $filter,
        $scope,
        $state,
        $window,
        PagesFactory,
        FundingService,
        DocumentsService,
        Upload,
        toastr,
        PaginationService,
        EndpointParamGeneratorService) {

            $scope.pageCategory = 0;
            $scope.documentsArray = [];
            $scope.documentsArrayTitles = [];

            $scope.publishedOptions = [
                { name: 'Opublikuj', value: true },
                { name: 'Szkic', value: false }
            ];

            PaginationService.setter({currentPage: 1, pageSize: 10});

            $scope.$watch(function () {return PaginationService.getter(); }, function (newVal, oldVal) {
                if(newVal != null) {
                    $scope.currentPage = newVal.currentPage;
                    $scope.pageSize = newVal.pageSize;
                }
            });

            function paramList () {
                var list = [];

                list.push({title: 'page=', value: $scope.currentPage});
                list.push({title: 'page_size=', value: $scope.pageSize});
                list.push({title: 'category=', value: $scope.pageCategory});
                list.push({title: 'published=', value: $scope.published});

                return list;
            }

            $scope.$watch('[currentPage, pageSize, pageCategory, published]', function() {
                FundingService.read(EndpointParamGeneratorService.create(paramList()))
                .success(function(response) {
                    $scope.newsFromBackend = response.results;
                    $scope.countElements = response.count;
                });    
            });

            PagesFactory.read('dofinansowanie')
                .then(function (response) {
                    function takeResponseBySlug(slug) {
                        for(var i = 0; i < response.data.placeholders.length; i++) {
                            if(response.data.placeholders[i].slug == slug) {
                                return i;
                            }
                        }
                    }
        
                    if (response.data.placeholders[takeResponseBySlug("dofinansowanie")]) {
                        $scope.advFromBackendTitle = response.data.placeholders[takeResponseBySlug("dofinansowanie")].title;
                        $scope.advFromBackendContent = response.data.placeholders[takeResponseBySlug("dofinansowanie")].content;
                    }

                    if (response.data.placeholders[takeResponseBySlug("dofinansowanie-obraz")]) {
                        $scope.advImage = response.data.placeholders[takeResponseBySlug("dofinansowanie-obraz")];
                    }
                });

            $scope.update = function () {
                var data = {
                    slug: 'dofinansowanie',
                    title: 'dofinansowanie',
                    placeholders: [{
                        slug: 'dofinansowanie',
                        title: $scope.advFromBackendTitle,
                        content: $scope.advFromBackendContent,
                        type: 'pages.textplaceholder'
                    },{
                        content: (function() { if ($scope.advImage.content) { return $scope.advImage.content }})(),
                        slug: 'dofinansowanie-obraz',
                        title: 'Dofinansowanie obraz',
                        type: 'images.imageplaceholder'
                    }]
                };
                PagesFactory.update('dofinansowanie', data);
            }

            $scope.uploadPhoto = function (file) {
                if (file && file.length) {
                        Upload.upload({
                            url: '/api/v1/images/', 
                            data: {
                                file: file[0],
                                title: $scope.file.name
                            }
                        }).then(function(response) {
                            $scope.advImage = {};
                            $scope.advImage.content = response.data;
                            $scope.update();
                            $('.preload-file')
                                .css('display', 'none')
                                .css('width', '0px');
                            toastr.success("Plik został poprawnie wgrany.");     
                        }, function(resp) {
                            toastr.error(resp.data.file[0]);
                        }, function (evt) {
                            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                            $('.preload-file')
                                .css('display', 'block')
                                .css('width', progressPercentage + '%');
                        });
                }
            }

            $scope.uploadFiles = function (files) {
                if (files && files.length) {
                    for (var i = 0; i < files.length; i++) {
                        Upload.upload({
                            url: '/api/v1/documents/', 
                            data: {
                                file: files[i],
                                title: $scope.files[i].name
                            }
                        }).then(function (response) {
                            $scope.documentsArray.push(response.data.id);
                            $scope.documentsArrayTitles.push(response.data.title);
                            toastr.success("Plik został poprawnie wgrany.");
                            $('.preload-file')
                                .css('display', 'none')
                                .css('width', '0%');
                        }, function(resp) {
                            toastr.error(resp.data.file[0]);
                        }, function (evt) {
                            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                            $('.preload-file')
                                .css('display', 'block')
                                .css('width', progressPercentage + '%');
                        });
                    }
                }
            }

            $scope.changeFileName = function (id, documentPosition) {
                if($scope.documentsArrayTitles[documentPosition].length > 1) {
                    DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition]);
                }
            }

            $scope.deleteFromArray = function (id) {
                $scope.documentsArray.splice(id, 1);
                $scope.documentsArrayTitles.splice(id, 1);
            }

            $scope.deleteElement = function(id) {
                FundingService.delete(id)
                .success(function() {
                    $state.reload();
                    toastr.success("Pomyślnie usunięto.");
                });
            }

            $scope.editNews = function() {
                var data = {
                    title: $scope.value.title,
                    body: $scope.value.body,
                    documents: $scope.documentsArray,
                    published: $scope.value.published
                };

                FundingService.update($scope.newsId, data) 
                .success(function() {
                    $state.reload();
                    toastr.success('Uaktualniono.');
                })
                .error(function (response) {
                    for(var key in response) {
                        var value = response[key];

                        try {
                            value.forEach(function (element, index) {
                                toastr.error(value[index]);
                            });
                        }

                        catch(err) {
                            toastr.error(response.detail);
                        }
                    }
                });
            }


            $scope.changeCategory = function(categoryId) {
                $scope.currentPage = 0;
                $scope.pageCategory = categoryId;
                PaginationService.setter({currentPage: 1, pageSize: $scope.pageSize});
            }

            $scope.changePosition = function(id, option) {
                FundingService.changePosition(id, { change: option })
                .success(function () {
                    $state.reload();
                });
            }

            $scope.changePublicFilter = function(publishedStatus) {
                $scope.currentPage = 0;
                $scope.published = publishedStatus;
                PaginationService.setter({currentPage: 1, pageSize: $scope.pageSize});
            }
            
            $scope.toggleBtn = function(id) {
                $('.cont-for-list-element[data-id="' + id + '"]')
                .toggleClass('active')
                .find(".inner-content").click(function () {
                    return false;
                });
            }

            $scope.showDeletePopup = function(options, id) {
                if (options === true) {
                    $scope.displayDeletePopup = true;
                } else {
                    $scope.displayDeletePopup = false;
                }
                $scope.elementId = id;
            }

            $scope.showEditPopup = function(options, id) {
                if (options === true) {
                    $scope.displayEditPopup = true;
                    $scope.documentsArray = [];
                    $scope.documentsArrayTitles = [];
                    
                    FundingService.readOne(id)
                    .success(function(response) {
                        for(var i = 0; i < response.documents.length; i++) {
                            $scope.documentsArray.push(response.documents[i].id);
                            $scope.documentsArrayTitles.push(response.documents[i].title);
                        }

                        $scope.newsId = response.id;
                        $scope.value.title = response.title;
                        $scope.value.body = response.body;
                        $scope.value.published = response.published;
                    });

                } else {
                    $scope.displayEditPopup = false;
                    $state.reload();
                }
                $scope.elementId = id;
            }

            $scope.openLink = function (link) {
                var previewData = {
                    body: $scope.value.body,
                    title: $scope.value.title,
                    documents: $scope.documentsArrayTitles
                };
                $window.open(link, '_blank').pastDataToNewWindow = previewData;        
            }

            $scope.stripFormat = function ($html) {
                return $filter('HtmlToPlain')($html);
            }
        }
})();

(function(){
	'use strict';

	angular
		.module('app')
		.controller('AddFundingCmsController', AddFundingCmsController);

    function AddFundingCmsController(
        $scope,
        $location,
        $filter,
        FundingService,
        Upload,
        DocumentsService,
        $window,
        toastr) {

            $scope.documentsArray = [];
            $scope.documentsArrayTitles = [];
            $scope.isImportant = false;
            $scope.published = 'True';

            $scope.uploadFiles = function (files) {
                if (files && files.length) {
                    for (var i = 0; i < files.length; i++) {
                        Upload.upload({
                            url: '/api/v1/documents/', 
                            data: {
                                file: files[i],
                                title: $scope.files[i].name
                            }
                        }).then(function (response) {
                            $scope.documentsArray.push(response.data.id);
                            $scope.documentsArrayTitles.push(response.data.title);
                            $('.preload-file')
                                .css('display', 'none')
                                .css('width', '0px');
                            toastr.success("Plik został poprawnie wgrany.");     
                        }, function(resp) {
                            toastr.error(resp.data.file[0]);
                        }, function (evt) {
                            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                            $('.preload-file')
                                .css('display', 'block')
                                .css('width', progressPercentage + '%');
                        });
                    }
                }
            }

            $scope.changeFileName = function (id, documentPosition) {
                if($scope.documentsArrayTitles[documentPosition].length > 1) {
                    DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition]);
                }
            }

            $scope.deleteFromArray = function (id) {
                $scope.documentsArray.splice(id, 1);
                $scope.documentsArrayTitles.splice(id, 1);
            }

            $scope.submit = function () {
                var data = {
                    body: $scope.newsBody,
                    title: $scope.newsTitle,
                    documents: $scope.documentsArray,
                    published: $scope.published
                };

                FundingService.create(data)
                .success(function() {
                    $location.path('/panel-administracyjny53335/dofinansowanie');
                    toastr.success('Dodano.');
                })
                .error(function() {
                    toastr.error("Wypełnij wszystkie pola.");
                })
            }

            $scope.openLink = function (link) {
                var previewData = {
                    body: $scope.newsBody,
                    title: $scope.newsTitle,
                    documents: $scope.documentsArrayTitles,
                };
                $window.open(link, '_blank').pastDataToNewWindow = previewData;
            }

            $scope.stripFormat = function ($html) {
                return $filter('HtmlToPlain')($html);
            }
		}
})();

(function(){
    'use strict';

    angular
        .module('app')
        .controller('EditCultureController', EditCultureController)

    /** @ngInject */
    function EditCultureController(
        $scope,
        $state,
        $stateParams,
        CultureCategoryService,
        CultureFactory,
        DocumentsService,
        Upload,
        toastr) {

        var vm = this;

        vm.publishedOptions = [
            { name: 'Opublikuj', value: true },
            { name: 'Szkic', value: false }
        ];

        $scope.upload = function (file) {
	        Upload.upload({
	            url: '/api/v1/documents/',
	            data: {
	               file: file,
	               'title': $scope.file.name
	            }
	        }).then(function (response) {
                vm.documentId = response.data.id;
                vm.documentName = response.data.title;
	            $('.preload-file')
                    .css('display', 'none')
                    .css('width', '0px');
                toastr.success("Plik został poprawnie wgrany.");
	        }, function(resp) {
	           toastr.error(resp.data.file[0]);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                $('.preload-file')
                    .css('display', 'block')
                    .css('width', progressPercentage + '%');
            });
        }

        vm.deleteFile = function (id) {
            DocumentsService.delete(id);
            vm.documentId = null
            vm.documentName = null;
        }

        CultureFactory.readOne($stateParams.id)
        .then(function (response) {
            vm.dataFromBackend = response.data;
            });

        CultureCategoryService.read()
            .then(function (response) {
                vm.categoriesFromBackend = response.data;
            });

        vm.sendDataToBackend = function () {
            if(vm.documentId) {
                var data = {
                    title: vm.dataFromBackend.title,
                    event_date: vm.dataFromBackend.event_date,
                    body: vm.dataFromBackend.body,
                    category: vm.dataFromBackend.category,
                    documents: [ vm.documentId ],
                    published: vm.dataFromBackend.published
                }
            } else {
                var data = {
                    title: vm.dataFromBackend.title,
                    event_date: vm.dataFromBackend.event_date,
                    category: vm.dataFromBackend.category,
                    body: vm.dataFromBackend.body,
                    published: vm.dataFromBackend.published
                }
            }

            CultureFactory.update($stateParams.id, data)
            .then(function () {
                toastr.success('Uaktualniono.');
                $state.go('dashboard.culture');
            }, function () {
                toastr.error('Wypełnij poprawnie formularz.');
            })
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app')
        .controller('AddCultureCmsController', AddCultureCmsController);

    function AddCultureCmsController(
        $scope,
        $state,
        CultureFactory,
        CultureCategoryService,
        DocumentsService,
        Upload,
        toastr) {

        var vm = this;

        vm.published = 'True';

        CultureCategoryService.read()
            .then(function (response) {
                vm.categoryList = response.data;
            });

        $scope.upload = function (file) {
	        Upload.upload({
	            url: '/api/v1/documents/',
	            data: {
	               file: file,
	               'title': $scope.file.name
	            }
	        }).then(function (response) {
                vm.documentId = response.data.id;
                vm.documentName = response.data.title;
	            $('.preload-file')
                    .css('display', 'none')
                    .css('width', '0px');
                toastr.success("Plik został poprawnie wgrany.");
	        }, function(resp) {
	           toastr.error(resp.data.file[0]);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                $('.preload-file')
                    .css('display', 'block')
                    .css('width', progressPercentage + '%');
            });
        }

        vm.deleteFile = function (id) {
            DocumentsService.delete(id);
            vm.documentId = null
            vm.documentName = null;
        }

        vm.sendDataToBackend = function () {
            if (vm.documentId) {
                var data = {
                    title: vm.title,
                    event_date: vm.event_date,
                    body: vm.body,
                    category: vm.category,
                    documents: [vm.documentId],
                    published: vm.published
                }
            } else {
                var data = {
                    title: vm.title,
                    event_date: vm.event_date,
                    category: vm.category,
                    body: vm.body,
                    published: vm.published
                }
            }

        CultureFactory.create(data)
            .then(function () {
                $state.go('dashboard.culture');
                toastr.success('Dodano.');
            }, function () {
                toastr.error('Wypełnij cały formularz.')
            });
        }
    }
})();

(function () {
'use strict';

    angular
        .module('app')
        .factory('ContactService', ContactService)
        .factory('DownDocsService', DownDocsService);

    function ContactService($http) {
        var contact = {};

        contact.read = function () {
            return $http.get('/api/v1/pages/kontakt/');
        }

        contact.update = function (value) {
            return $http.put('/api/v1/pages/kontakt/', value);
        }

        contact.sendMessage = function (value) {
            return $http.post('/api/v1/contact/', value);
        }

        return contact;
    }

    function DownDocsService($http) {
        var doc = {};

        doc.create = function (value) {
            return $http.post('/api/v1/downloadable_documents/', value);
        }

        doc.read = function (currPage, pageSiz) {
            var nextPage = currPage + 1,
                pageSize = pageSiz;

            return $http.get('/api/v1/downloadable_documents/?page=' + nextPage + '&page_size=' + pageSize);
        }

        doc.readOne = function (id) {
            return $http.get('/api/v1/downloadable_documents/' + id + '/');
        }

        doc.update = function (id, value) {
            return $http.put('/api/v1/downloadable_documents/' + id + '/', value);
        }

        doc.changePosition = function (id, value) {
            return $http.put('/api/v1/downloadable_documents/' + id + '/change_position/', value);
        }

        doc.delete = function (id) {
            return $http.delete('/api/v1/downloadable_documents/' + id + '/');
        }

        return doc;
    }

})();

(function () {
'use strict';

	angular
		.module('app')
		.config(contactRouterConfig);

	function contactRouterConfig($stateProvider) {
		$stateProvider
	        .state('dashboard.contact', {
	                url: '/kontakt',
	                templateUrl: 'app/partials/contact/contact.cms.html',
	                controller: 'ContactCmsController'
	        })
	        .state('dashboard.contactDocuments', {
	                url: '/kontakt-dokumenty',
	                templateUrl: 'app/partials/contact/contactDocuments.cms.html',
	                controller: 'ContactDocumentsController'
	        })
	        .state('dashboard.addContactDocuments', {
	                url: '/kontakt-dodaj-dokument',
	                templateUrl: 'app/partials/contact/addContactDocuments.cms.html',
	                controller: 'AddDocToContactController'
	        })
	        .state('website.contact', {
	                url: '/kontakt',
	                templateUrl: 'app/partials/contact/contact.html',
			controller: 'ContactController',
			controllerAs: 'ContactCtrl'
	        })
	}

})();
(function () {
'use strict';

  angular
    .module('app')
    .controller('ContactController', ContactController);

  function ContactController($scope, ContactService, LocalizationsFactory, $window, $log, SettingsService, toastr) {
    var vm = this;

    // set street options if exist
    vm.chosenStreet = $window.localStorage.getItem('chosenStreetName');
    vm.chosenStreetSettlement = $window.localStorage.getItem('chosenStreetSettlement');

    if(vm.chosenStreetSettlement) {
      LocalizationsFactory.readOne(vm.chosenStreetSettlement)
      .then(function (response) {
          vm.settlementFromBackend = response.data;
      });
    }

    ContactService.read()
      .success(function (response) {

        function takeResponseBySlug(slug) {
          for(var i = 0; i < response.placeholders.length; i++) {
            if(response.placeholders[i].slug == slug) {
              return i;
            }
          }
        }

        vm.contact = response.placeholders[takeResponseBySlug("contact")];
        vm.president = response.placeholders[takeResponseBySlug("prezes")];
        vm.council = response.placeholders[takeResponseBySlug("rada")];
        vm.map = response.placeholders[takeResponseBySlug("mapa")].content;

      });

    SettingsService.topicRead()
    .then(function (response) {
      $scope.topicFromBackend = response.data;
    });

    $scope.$watch(function() { return vm.chosenStreet }, function() {
        if(vm.chosenStreet) {
            if(!$window.localStorage.getItem('chosenStreetSettlement')) {
                $window.localStorage.setItem('chosenStreetName', vm.chosenStreet.originalObject.name);
                $window.localStorage.setItem('chosenStreetSettlement', vm.chosenStreet.originalObject.settlement);
                vm.chosenStreet = vm.chosenStreet.originalObject.name;
            }

            LocalizationsFactory.readOne($window.localStorage.getItem('chosenStreetSettlement'))
            .then(function (response) {
                vm.settlementFromBackend = response.data;
            });
        }
    });

    vm.removeChosenStreet = function () {
      $window.localStorage.removeItem('chosenStreetName');
      $window.localStorage.removeItem('chosenStreetSettlement');
      vm.chosenStreet = null;
      vm.chosenStreetSettlement = null;
      vm.settlementFromBackend = null;
    }

    $scope.sendMessage = function () {
      var data = {
        name: $scope.contactName,
        location: $scope.contactLocation,
        email: $scope.contactEmail,
        phone: $scope.contactTelephone,
        body: $scope.contactText
      }

      ContactService.sendMessage(data)
      .then(function () {
        toastr.success("Wiadomość wysłano.");
      }, function () {
        toastr.error('Wypełnij poprawnie formularz.')
      });
    }
  }

})();

(function () {
'use strict';

  angular
    .module('app')
    .controller('ContactCmsController', ContactCmsController);

  function ContactCmsController($filter, $scope, $state, ContactService, toastr) {
    
    ContactService.read()
      .success(function (response) {

        function takeResponseBySlug(slug) {
          for(var i = 0; i < response.placeholders.length; i++) {
            if(response.placeholders[i].slug == slug) {
              return i;
            }
          }
        }

        if(response.placeholders[takeResponseBySlug("contact")]) {
          $scope.value.contactTitle = response.placeholders[takeResponseBySlug("contact")].title;
          $scope.value.contactContent = response.placeholders[takeResponseBySlug("contact")].content;  
        }

        if(response.placeholders[takeResponseBySlug("prezes")]) {
          $scope.value.presidentTitle = response.placeholders[takeResponseBySlug("prezes")].title;
          $scope.value.presidentContent = response.placeholders[takeResponseBySlug("prezes")].content;  
        }

        if(response.placeholders[takeResponseBySlug("rada")]) {
          $scope.value.councilTitle = response.placeholders[takeResponseBySlug("rada")].title;
          $scope.value.councilContent = response.placeholders[takeResponseBySlug("rada")].content;  
        }

        if(response.placeholders[takeResponseBySlug("osiedle-anna")]) {
          $scope.value.settlementAnnaTitle = response.placeholders[takeResponseBySlug("osiedle-anna")].title;
          $scope.value.settlementAnnaContent = response.placeholders[takeResponseBySlug("osiedle-anna")].content;  
        }

        if(response.placeholders[takeResponseBySlug("osiedle-dorota-barbara")]) {
          $scope.value.settlementDorotaBarbaraTitle = response.placeholders[takeResponseBySlug("osiedle-dorota-barbara")].title;
          $scope.value.settlementDorotaBarbaraContent = response.placeholders[takeResponseBySlug("osiedle-dorota-barbara")].content;  
        }

        if(response.placeholders[takeResponseBySlug("osiedle-huby")]) {
          $scope.value.settlementHubyTitle = response.placeholders[takeResponseBySlug("osiedle-huby")].title;
          $scope.value.settlementHubyContent = response.placeholders[takeResponseBySlug("osiedle-huby")].content;  
        }

        if(response.placeholders[takeResponseBySlug("osiedle-gaj")]) {
          $scope.value.settlementGajTitle = response.placeholders[takeResponseBySlug("osiedle-gaj")].title;
          $scope.value.settlementGajContent = response.placeholders[takeResponseBySlug("osiedle-gaj")].content;  
        }

        if(response.placeholders[takeResponseBySlug("mapa")]) {
          $scope.value.map = response.placeholders[takeResponseBySlug("mapa")].content;
        }

      });


    $scope.updateContact = function (value) {

      function createDynamicallyJson() {
        var placeholders = [];

        if($scope.value.contactTitle && $scope.value.contactContent) {
          placeholders.push({slug: 'contact', type: 'pages.textplaceholder', title: $scope.value.contactTitle, content: $scope.value.contactContent});
        }

        if($scope.value.presidentTitle && $scope.value.presidentContent) {
          placeholders.push({slug: 'prezes', type: 'pages.textplaceholder', title: $scope.value.presidentTitle, content: $scope.value.presidentContent});
        }

        if($scope.value.councilTitle && $scope.value.councilContent) {
          placeholders.push({slug: 'rada', type: 'pages.textplaceholder', title: $scope.value.councilTitle, content: $scope.value.councilContent});
        }

        if($scope.value.settlementAnnaTitle && $scope.value.settlementAnnaContent) {
          placeholders.push({slug: 'osiedle-anna', type: 'pages.textplaceholder', title: $scope.value.settlementAnnaTitle, content: $scope.value.settlementAnnaContent});
        }

        if($scope.value.settlementDorotaBarbaraTitle && $scope.value.settlementDorotaBarbaraContent) {
          placeholders.push({slug: 'osiedle-dorota-barbara', type: 'pages.textplaceholder', title: $scope.value.settlementDorotaBarbaraTitle, content: $scope.value.settlementDorotaBarbaraContent});
        }

        if($scope.value.settlementHubyTitle && $scope.value.settlementHubyContent) {
          placeholders.push({slug: 'osiedle-huby', type: 'pages.textplaceholder', title: $scope.value.settlementHubyTitle, content: $scope.value.settlementHubyContent});
        }

        if($scope.value.settlementGajTitle && $scope.value.settlementGajContent) {
          placeholders.push({slug: 'osiedle-gaj', type: 'pages.textplaceholder', title: $scope.value.settlementGajTitle, content: $scope.value.settlementGajContent});
        }

        if($scope.value.map) {
          placeholders.push({slug: 'mapa', type: 'pages.textplaceholder', title: 'mapa', content: $scope.value.map});
        }

        return placeholders;
      }

      var data = {
        slug: 'kontakt',
        title: 'kontakt',
        'placeholders': createDynamicallyJson()
      };

      ContactService.update(data)
        .success(function (response) {
          $state.reload();
          toastr.success("Zapisano.");
        });
    }

    $scope.stripFormat = function ($html) {
                return $filter('HtmlToPlain')($html);
            }


  }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('EditAdvertiserController', EditAdvertiserController);

    function EditAdvertiserController($scope, $state, $stateParams, DocumentsService, AdvertisersFactory, Upload, toastr) {
        var vm = this;
        vm.publishedOptions = [
            { name: 'Opublikuj', value: true },
            { name: 'Szkic', value: false }
        ];
        $scope.documentsArray = [];
        $scope.documentsArrayTitles = [];

        $scope.uploadFiles = function (files) {
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    Upload.upload({
                        url: '/api/v1/documents/',
                        data: {
                            file: files[i],
                            title: $scope.files[i].name
                        }
                    }).then(function (response) {
                        $scope.documentsArray.push(response.data.id);
                        $scope.documentsArrayTitles.push(response.data.title);
                        toastr.success("Plik został poprawnie wgrany.");
                        $('.preload-file')
                            .css('display', 'none')
                            .css('width', '0%');
                    }, function (resp) {
                        toastr.error(resp.data.file[0]);
                    }, function (evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        $('.preload-file')
                            .css('display', 'block')
                            .css('width', progressPercentage + '%');
                    });
                }
            }
        }

        $scope.changeFileName = function (id, documentPosition) {
            if ($scope.documentsArrayTitles[documentPosition].length > 1) {
                DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition])
                    .success(function (response) {
                    });
            }
        }

        $scope.deleteFromArray = function (id) {
            $scope.documentsArray.splice(id, 1);
            $scope.documentsArrayTitles.splice(id, 1);
        }

        AdvertisersFactory.readOne($stateParams.id)
            .then(function (response) {
                vm.dataFromBackend = response.data;

                for (var i = 0; i < response.data.documents.length; i++) {
                    $scope.documentsArray.push(response.data.documents[i].id);
                    $scope.documentsArrayTitles.push(response.data.documents[i].title);
                }
            });

        vm.sendDataToBackend = function () {
            var data = {
                title: vm.dataFromBackend.title,
                body: vm.dataFromBackend.body,
                documents: $scope.documentsArray,
                published: vm.dataFromBackend.published
            }

            AdvertisersFactory.update($stateParams.id, data)
                .then(function (response) {
                    toastr.success('Uaktualniono.')
                    $state.go('dashboard.rent')
                }, function (response) {
                    toastr.error('Wypełnij wszystkie pola.');
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('AddNewAdvertisersController', AddNewAdvertisersController);

    function AddNewAdvertisersController($scope, $state, $http, DocumentsService, AdvertisersFactory, Upload, toastr) {
        var vm = this;

        vm.published = 'True';
        $scope.documentsArray = [];
        $scope.documentsArrayTitles = [];

        $scope.uploadFiles = function (files) {
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    Upload.upload({
                        url: '/api/v1/documents/',
                        data: {
                            file: files[i],
                            title: $scope.files[i].name
                        }
                    }).then(function (response) {
                        $scope.documentsArray.push(response.data.id);
                        $scope.documentsArrayTitles.push(response.data.title);
                        $('.preload-file')
                            .css('display', 'none')
                            .css('width', '0px');
                        toastr.success("Plik został poprawnie wgrany.");
                    }, function (resp) {
                        toastr.error(resp.data.file[0]);
                    }, function (evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        $('.preload-file')
                            .css('display', 'block')
                            .css('width', progressPercentage + '%');
                    });
                }
            }
        }

        $scope.changeFileName = function (id, documentPosition) {
            if ($scope.documentsArrayTitles[documentPosition].length > 1) {
                DocumentsService.updateFileTitle(id, $scope.documentsArrayTitles[documentPosition])
                    .success(function (response) {
                    });
            }
        }

        $scope.deleteFromArray = function (id) {
            $scope.documentsArray.splice(id, 1);
            $scope.documentsArrayTitles.splice(id, 1);
        }

        vm.sendDataToBackend = function () {
            var data = {
                title: vm.title,
                body: vm.body,
                documents: $scope.documentsArray,
                published: vm.published
            }

            AdvertisersFactory.create(data)
                .then(function (response) {
                    toastr.success('Dodano.');
                    $state.go('dashboard.advertisers')
                }, function () {
                    toastr.error('Wypełnij wszystkie pola.');
                });
        }
    }
})();

(function() {
'use strict';

  angular
    .module('app')
    .config(previewRouterConfig);

  function previewRouterConfig($stateProvider) {
    $stateProvider
      .state('preview', {
                url: '/podglad',
                templateUrl: 'app/partials/_preview/preview.html',
                controller: 'PreviewController'
      });
  }
})();

(function () {
'use strict';

  angular
    .module('app')
    .controller('PreviewController', PreviewController);

  function PreviewController($scope, $window, $location, DashboardService) {

    DashboardService.isLogged()
      .success(function (response) {
        $scope.userNameResp = response;
        $scope.isLoggedIn = true;

      })
      .error(function () {
        
        $scope.isLoggedIn = false;
        $location.path('/');

      });
    
    $scope.closeWindow = function () {
      $window.close();
    }

    $scope.currentYear = new Date().getFullYear();
  }

})();

(function () {
'use strict';
  
  angular
    .module('app')
    .factory('DashboardService', DashboardService);

  function DashboardService($http) {
    var login = {};

    login.isLogged = function () {
      return $http.get('/api/v1/auth/user/');
    }

    login.logoutMe = function () {
      return $http.post('/api/v1/auth/logout/');
    }

    return login;
  }

})();

(function() {
'use strict';

    angular
        .module('app')
        .config(dashboardRouterConfig);

    function dashboardRouterConfig($stateProvider) {
        $stateProvider
            .state('dashboard', {
                url: '/panel-administracyjny53335',
                templateUrl: 'app/partials/_dashboard/dashboard.html',
                controller: 'DashboardController',
                controllerAs: 'dashctrl'
            })
            .state('dashboard.home', {
                url: '/',
                templateUrl: 'app/partials/main/main.cms.html'
            });
    }
})();
(function() {
  'use strict',

  angular
    .module('app')
    .controller('DashboardController', DashboardController);

    function DashboardController($scope, $location, $locale, DashboardService, UsersService) {

      $scope.isLoggedIn = false;

      DashboardService.isLogged()
        .success(function (response) {
          $scope.userNameResp = response;
          $scope.isLoggedIn = true;

        })
        .error(function () {
          $scope.isLoggedIn = false;
          $location.path('/');

        });

      this.logout = function () {
        DashboardService.logoutMe()
          .success(function (response) {
            $location.path('/');
          });
      }

      $scope.settingsMenu = function () {
        $('.d-opened-settings').toggleClass('active');
      }

      $('*').click(function (e) {
        if(e.target.id != 'open-settings') {
          $('.d-opened-settings').removeClass('active');
        }
      });

      UsersService.readMe()
        .success(function (response) {

          $scope.currentUserId = response.id;

          function findPermission(permissionName) {
                      for(var i = 0; i < response.permissions.length; i++) {
                        if(permissionName == response.permissions[i]) {
                          return i;
                        }
                      }
                    }

                    // idealne miejsce

                    response.permissions[findPermission('perfect_place.manage_my_perfect_place')] ? $scope.displayMyPerfectPlace = true : $scope.displayMyPerfectPlace = false;
                    response.permissions[findPermission('perfect_place.manage_all_perfect_place')] ? $scope.displayAllPerfectPlace = true : $scope.displayAllPerfectPlace = false;

                    // dla mieszkańców

                    response.permissions[findPermission('news.manage_my_news')] ? $scope.displayMyNews = true : $scope.displayMyNews = false;
                    response.permissions[findPermission('news.manage_all_news')] ? $scope.displayAllNews = true : $scope.displayAllNews = false;

                    response.permissions[findPermission('culture.manage_my_culture')] ? $scope.displayMyCulture = true : $scope.displayMyCulture = false;
                    response.permissions[findPermission('culture.manage_all_culture')] ? $scope.displayAllCulture = true : $scope.displayAllCulture = false;

                    response.permissions[findPermission('informations.manage_my_information')] ? $scope.displayMyInformations = true : $scope.displayMyInformations = false;
                    response.permissions[findPermission('informations.manage_all_information')] ? $scope.displayAllInformations = true : $scope.displayAllInformations = false;

                    response.permissions[findPermission('funding.manage_my_funding')] ? $scope.displayMyFunding = true : $scope.displayMyFunding = false;
                    response.permissions[findPermission('funding.manage_all_funding')] ? $scope.displayAllFunding = true : $scope.displayAllFunding = false;

                    response.permissions[findPermission('residential_construction.manage_my_residential_construction')] ? $scope.displayMyResidentialConstruction = true : $scope.displayMyResidentialConstruction = false;
                    response.permissions[findPermission('residential_construction.manage_all_residential_construction')] ? $scope.displayAllResidentialConstruction = true : $scope.displayAllResidentialConstruction = false;

                    // współpraca

                    response.permissions[findPermission('rent.manage_my_rent')] ? $scope.displayMyRent = true : $scope.displayMyRent = false;
                    response.permissions[findPermission('rent.manage_all_rent')] ? $scope.displayAllRent = true : $scope.displayAllRent = false;

                    response.permissions[findPermission('jobs_documents.manage_my_jobdocument')] ? $scope.displayMyJobs = true : $scope.displayMyJobs = false;
                    response.permissions[findPermission('jobs_documents.manage_all_jobdocument')] ? $scope.displayAllJobs = true : $scope.displayAllJobs = false;

                    response.permissions[findPermission('tenders.manage_my_tender')] ? $scope.displayMyTenders = true : $scope.displayMyTenders = false;
                    response.permissions[findPermission('tenders.manage_all_tender')] ? $scope.displayAllTenders = true : $scope.displayAllTenders = false;

                    response.permissions[findPermission('advertisers.manage_my_advertisments')] ? $scope.displayMyAdv = true : $scope.displayMyAdv = false;
                    response.permissions[findPermission('advertisers.manage_all_advertisments')] ? $scope.displayAllAdv = true : $scope.displayAllAdv = false;

                    // o nas

                    response.permissions[findPermission('press.manage_my_press')] ? $scope.displayMyPress = true : $scope.displayMyPress = false;
                    response.permissions[findPermission('press.manage_all_press')] ? $scope.displayAllPress = true : $scope.displayAllPress = false;

                    // lokalizacje

                    response.permissions[findPermission('localizations.manage_my_localizations')] ? $scope.displayMyLocalizations = true : $scope.displayMyLocalizations = false;
                    response.permissions[findPermission('localizations.manage_all_localizations')] ? $scope.displayAllLocalizations = true : $scope.displayAllLocalizations = false;

                    // strony

                    response.permissions[findPermission('pages.manage_my_page')] ? $scope.displayMyPages = true : $scope.displayMyPages = false;
                    response.permissions[findPermission('pages.manage_all_page')] ? $scope.displayAllPages = true : $scope.displayAllPages = false;

                    response.permissions[findPermission('auth.add_permission')] ? $scope.displayUsers = true : $scope.displayUsers = false;

                    response.permissions[findPermission('news.change_newscategory')] ? $scope.changeNewsCategory = true : $scope.changeNewsCategory = false;

                    UsersService.readPagePermissions($scope.currentUserId)
                    .success(function (response) {

                      function findPermission(permissionName) {
                                    for(var i = 0; i < response.length; i++) {
                                        if(permissionName == response[i]) {
                                            return i;
                                        }
                                    }
                                }
                        response[findPermission('kontakt')] ? $scope.displayPageContact = true : $scope.displayPageContact = false;
                        response[findPermission('wynajem')] ? $scope.displayPageWynajem = true : $scope.displayPageWynajem = false;
                        response[findPermission('adv')] ? $scope.displayPageAdv = true : $scope.displayPageAdv = false;
                        response[findPermission('big-picture')] ? $scope.displayPageBigPicture = true : $scope.displayPageBigPicture = false;
                        response[findPermission('management')] ? $scope.displayPageManagement = true : $scope.displaypageManagement = false;
                        response[findPermission('historia')] ? $scope.displayHistory = true : $scope.displayHistory = false;
                        response[findPermission('eco')] ? $scope.displayEco = true : $scope.displayEco = false;
                    });
                });


        // months localization fix

        var datetime = $locale.DATETIME_FORMATS;
        var months = datetime.MONTH;

        months[0] = "Styczeń";
        months[1] = "Luty";
        months[2] = "Marzec";
        months[3] = "Kwiecień";
        months[4] = "Maj";
        months[5] = "Czerwiec";
        months[6] = "Lipiec";
        months[7] = "Sierpień";
        months[8] = "Wrzesień";
        months[9] = "Październik";
        months[10] = "Listopad";
        months[11] = "Grudzień";

    }
})();

(function () {
'use strict';

  angular
    .module('app')
    .controller('DeletePopupController', DeletePopupController);

  function DeletePopupController($scope) {
  }

})();

(function () {
    'use strict';

    angular
        .module('jw.tooltip', [])
        .directive('jwTooltip', jwTooltip);

    function jwTooltip($document, $compile) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var tooltip = $compile("<div id='jwTooltip' ng-class='tipClass' ng-bind-html='information | TrustedHtml'></div>")(scope);
                var tooltipClassName = 'jw-tooltip';
                var tooltipActiveClassName = 'jw-tooltip-show';

                scope.tipClass = [tooltipClassName];
                scope.information = attrs.jwTooltip;

                element.bind('mouseover', function (e) {
                    $document.find('body').append(tooltip);
                    tooltip.addClass(tooltipActiveClassName);

                    var bodyRect = document.body.getBoundingClientRect(),
                        pos = e.target.getBoundingClientRect(),
                        elOffset = pos.top - bodyRect.top,
                        offset = tooltip.offset(),
                        tipHeight = tooltip.outerHeight(),
                        tipWidth = tooltip.outerWidth(),
                        elWidth = pos.width || pos.right - pos.left,
                        elHeight = pos.height || pos.bottom - pos.top,
                        tipOffset = 5;

                    offset.top = elOffset + elHeight + 10;
                    offset.left = pos.left;

                    tooltip.offset(offset);
                });

                element.bind('click', function () {
                    angular.element('#jwTooltip').remove();
                    tooltip.removeClass(tooltipActiveClassName);
                });

                element.bind('mouseout', function () {
                    angular.element('#jwTooltip').remove();
                    tooltip.removeClass(tooltipActiveClassName);
                });
            }
        }
    }

})();
(function() {
    'use strict';

     angular
        .module('app')
        .controller("ResidentialConstructionController", ResidentialConstructionController);

     function ResidentialConstructionController(
        $scope,
        ResidentialConstructionService,
        $window,
        PagesFactory,
        PaginationService,
        EndpointParamGeneratorService) {

            $scope.showHideAll = "Rozwiń wszystko";
            $scope.showNoResults = false;

            PaginationService.setter({currentPage: 1, pageSize: 10});

            if($window.innerWidth > 768) {
                $('#for-users').addClass('active');
                $('.submenu').addClass('active');
                $('#sub-for-users').addClass('active');
            }

            $scope.$watch(function () {return PaginationService.getter(); }, function (newVal) {
                if(newVal != null) {
                    $scope.currentPage = newVal.currentPage;
                    $scope.pageSize = newVal.pageSize;
                }
            });

            PagesFactory.read('budownictwo-mieszkaniowe')
            .then(function(response) {
                function takeResponseBySlug(slug) {
                    for(var i = 0; i < response.data.placeholders.length; i++) {
                        if(response.data.placeholders[i].slug == slug) {
                            return i;
                        }
                    }
                }

                if(response.data.placeholders[takeResponseBySlug("budownictwo-mieszkaniowe")]) {
                    $scope.residentialConstructionTitle = response.data.placeholders[takeResponseBySlug("budownictwo-mieszkaniowe")].title;
                    $scope.residentialConstructionDescription = response.data.placeholders[takeResponseBySlug("budownictwo-mieszkaniowe")].content;
                }

                if(response.data.placeholders[takeResponseBySlug("budownictwo-mieszkaniowe-obraz")]) {
                    $scope.residentialConstructionImg = response.data.placeholders[takeResponseBySlug("budownictwo-mieszkaniowe-obraz")].content;
                }
            });

            function paramList () {
                var list = [];

                list.push({title: 'page=', value: $scope.currentPage});
                list.push({title: 'page_size=', value: $scope.pageSize});

                return list;
            }

            $scope.$watch('[currentPage, pageSize]', function() {

                $scope.newsFromBackend = {};
                $scope.newsFromBackend.dataLoaded = false;

                ResidentialConstructionService.read(EndpointParamGeneratorService.create(paramList()))
                .success(function(response) {
                    $scope.newsFromBackend = response.results;
                    $scope.countElements = response.count;
                    $scope.newsFromBackend.dataLoaded = true;

                    if(response.results.length < 1) {
                        $scope.showNoResults = true;
                    } else {
                        $scope.showNoResults = false;
                    }
                });
            });

            $scope.checkActive = function () {
                var isSomethingOpened = $('.cont-for-list-element').hasClass('active');
                if (isSomethingOpened == true) {
                    $scope.showHideAll = "Zwiń wszystko";
                    $('#show-hide-all').addClass('active');
                } else {
                    $scope.showHideAll = "Rozwiń wszystko";
                    $('#show-hide-all').removeClass('active');
                }
            }

            $scope.openLink = function (link) {
                $window.open(link, '_blank');
            }

            $scope.toggleBtn = function(id) {
                $('.cont-for-list-element[data-id="' + id + '"]')
                .toggleClass('active')
                .find(".inner-content").click(function () {
                    return false;
                });
            }

            $scope.showPopup = function(options, newsId, imageId, newsIndex) {
                if (options === true) {
                    $scope.displayPopup = true;
                    $scope._id = imageId;
                    var allImagesIds = [],
                        currentImageId = $scope._id,
                        currentImagePosition;

                    for(var i = 0; i < $scope.newsFromBackend[newsIndex].documents.length; i++) {
                        allImagesIds.push($scope.newsFromBackend[newsIndex].documents[i].id);
                    }

                    for (var i = 0; i<allImagesIds.length; i++) {
                        if(currentImageId == allImagesIds[i]) {
                            currentImageId = allImagesIds[i];
                            currentImagePosition = i;
                        }
                    }

                    $scope.imageRotate = function (rotate) {
                        if(rotate == 1) {
                            if(currentImagePosition == allImagesIds.length-1) {
                                currentImagePosition = 0;
                            } else {
                                currentImagePosition++;
                            }
                        } if(rotate == 0) {
                            if(currentImagePosition == 0) {
                                currentImagePosition = allImagesIds.length-1;
                            } else {
                                currentImagePosition--;
                            }
                        }
                        $scope._id = allImagesIds[currentImagePosition];
                    }


                    $scope.$watch('_id', function() {
                        ResidentialConstructionService.readOne(newsId)
                        .success(function (response) {
                            for(var i = 0; i < response.documents.length; i ++) {
                                if($scope._id == response.documents[i].id) {
                                    $scope.oneImage = response.documents[i];
                                }
                            }
                        });
                    });

                } else {
                    $scope.displayPopup = false;
                }
            }
        }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('RentController', RentController);

    function RentController($scope, $window, RentFactory, RentCategoriesFactory, PagesFactory, PaginationService) {
        var vm = this;

        PaginationService.setter({ currentPage: 1, pageSize: 10 });

        $scope.$watch(function () { return PaginationService.getter(); }, function (newVal, oldVal) {
            if (newVal != null) {
                $scope.currentPage = newVal.currentPage;
                $scope.pageSize = newVal.pageSize;
            }
        });

        PagesFactory.read('wynajem')
        .then(function (response) {
            function takeResponseBySlug(slug) {
                for(var i = 0; i < response.data.placeholders.length; i++) {
                    if(response.data.placeholders[i].slug == slug) {
                        return i;
                    }
                }
            }

            if(response.data.placeholders[takeResponseBySlug("wynajem")]) {
                vm.rentFromBackendTitle = response.data.placeholders[takeResponseBySlug("wynajem")].title;
                vm.rentFromBackendContent = response.data.placeholders[takeResponseBySlug("wynajem")].content;
            }
        });

        RentCategoriesFactory.read()
            .then(function (response) {
                vm.categoriesFromBackend = response.data;
            });

        $scope.$watch('[chosenCategory, pageSize, currentPage]', function () {
            var params = {
                rent_type: $scope.chosenCategory,
                page_size: $scope.pageSize,
                page: $scope.currentPage
            }

            RentFactory.read(params)
                .then(function (response) {
                    vm.dataFromBackend = response.data;
                    vm.dataFromBackend.dataLoaded = true;
                    $scope.countElements = response.data.count;

                    if (response.data.results.length < 1) {
                        vm.showNoResults = true;
                    } else {
                        vm.showNoResults = false;
                    }
                });
        });



        vm.toggleBtn = function (id) {
            $('.cont-for-list-element[data-id="' + id + '"]')
                .toggleClass('active')
                .find(".inner-content").click(function () {
                    return false;
                });
        }

        $scope.openLink = function (link) {
            $window.open(link, '_blank');
        }

        $scope.showPopup = function (options, newsId, imageId, newsIndex) {
            if (options === true) {
                $scope.displayPopup = true;
                $scope._id = imageId;

                var allImagesIds = [],
                    currentImageId = $scope._id,
                    currentImagePosition;

                for (var key in vm.dataFromBackend.results[newsIndex].documents) {
                    allImagesIds.push(vm.dataFromBackend.results[newsIndex].documents[key].id);
                }

                for (var key in allImagesIds) {
                    if (currentImageId == allImagesIds[key]) {
                        currentImageId = allImagesIds[key];
                        currentImagePosition = key;
                    }
                }

                $scope.imageRotate = function(rotate) {
                    if (rotate == 1) {
                        if (currentImagePosition == allImagesIds.length - 1) {
                            currentImagePosition = 0;
                        } else {
                            currentImagePosition++;
                        }
                    } if (rotate == 0) {
                        if (currentImagePosition == 0) {
                            currentImagePosition = allImagesIds.length - 1;
                        } else {
                            currentImagePosition--;
                        }
                    }

                    $scope._id = allImagesIds[currentImagePosition];
                }


                $scope.$watch('_id', function () {
                    RentFactory.readOne(newsId)
                        .success(function (response) {
                            for (var key in response.documents) {
                                if ($scope._id == response.documents[key].id) {
                                    $scope.oneImage = response.documents[key];
                                }
                            }
                        });
                });

            } else {
                $scope.displayPopup = false;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('RentCmsController', RentCmsController);

    function RentCmsController($scope, RentFactory, ngDialog, PagesFactory, PaginationService) {
        var vm = this;

        PaginationService.setter({ currentPage: 1, pageSize: 10 });

        $scope.$watch(function () { return PaginationService.getter(); }, function (newVal, oldVal) {
            if (newVal != null) {
                $scope.currentPage = newVal.currentPage;
                $scope.pageSize = newVal.pageSize;
            }
        });

        PagesFactory.read('wynajem')
        .then(function (response) {
            function takeResponseBySlug(slug) {
                for(var i = 0; i < response.data.placeholders.length; i++) {
                    if(response.data.placeholders[i].slug == slug) {
                        return i;
                    }
                }
            }

            if(response.data.placeholders[takeResponseBySlug("wynajem")]) {
                vm.rentFromBackendTitle = response.data.placeholders[takeResponseBySlug("wynajem")].title;
                vm.rentFromBackendContent = response.data.placeholders[takeResponseBySlug("wynajem")].content;
            }
        });

        $scope.$watch('[pageSize, page]', function () {
            var params = {
                page_size: $scope.pageSize,
                page: $scope.page
            }

            RentFactory.read(params)
                .then(function (response) {
                    vm.dataFromBackend = response.data;
                    $scope.countElements = response.data.count;
                });
        });

        vm.update = function () {
            var data = {
                slug: 'wynajem',
                title: 'Wynajem',
                placeholders: [{
                    slug: 'wynajem',
                    title: vm.rentFromBackendTitle,
                    content: vm.rentFromBackendContent,
                    type: 'pages.textplaceholder'
                }]
            }

            PagesFactory.update('wynajem', data);
        }

        vm.confirmDialog = function (itemId) {
            ngDialog.open({
                className: 'ngdialog-theme-default',
                template: 'app/components/delete_dialog/delete.dialog.html',
                data: {
                    item_id: itemId,
                    delete_function: RentFactory.delete
                }
            });
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('app')
        .controller('PressController', PressController)

    /** @ngInject */
    function PressController(
        $scope,
        PressCategoryService,
        PressFactory,
        PaginationService,
        ngDialog) {

        var vm = this;

        init();

        function init() {
            readCategoriesFromBackend();
        }

        function readCategoriesFromBackend() {
            PressCategoryService.read()
                .then(function (response) {
                    vm.categoriesFromBackend = response.data;
                });
        }

        $scope.showHideAll = "Rozwiń wszystko";
        $scope.showNoResults = false;

        PaginationService.setter({ currentPage: 1, pageSize: 10 });

        $scope.$watch(function () { return PaginationService.getter(); }, function (newVal, oldVal) {
            if (newVal != null) {
                $scope.currentPage = newVal.currentPage;
                $scope.pageSize = newVal.pageSize;
            }
        });

        $scope.$watch('[currentPage, pageSize, categoryFilter]', function () {

            var params = {
                page: $scope.currentPage,
                page_size: $scope.pageSize,
                category: $scope.categoryFilter
            }

            $scope.pressFromBackend = {};
            $scope.pressFromBackend.dataLoaded = false;

            PressFactory.read(params)
                .then(function (response) {
                    $scope.pressFromBackend = response.data.results;
                    $scope.countElements = response.data.count;
                    $scope.pressFromBackend.dataLoaded = true;

                    if (response.data.results.length < 1) {
                        $scope.showNoResults = true;
                    } else {
                        $scope.showNoResults = false;
                    }
                });
        });

        $scope.checkActive = function () {
            var isSomethingOpened = $('.cont-for-list-element').hasClass('active');
            if (isSomethingOpened == true) {
                $scope.showHideAll = "Zwiń wszystko";
                $('#show-hide-all').addClass('active');
            } else {
                $scope.showHideAll = "Rozwiń wszystko";
                $('#show-hide-all').removeClass('active');
            }
        }

        $scope.toggleBtn = function (id) {
            $('.cont-for-list-element[data-id="' + id + '"]')
                .toggleClass('active')
                .find(".inner-content").click(function () {
                    return false;
                });
        }

        $scope.showPopup = function (options, newsId, imageId, newsIndex) {
            if (options === true) {
                $scope.displayPopup = true;
                $scope._id = imageId;
                var allImagesIds = [],
                    currentImageId = $scope._id,
                    currentImagePosition;

                for (var i = 0; i < $scope.pressFromBackend[newsIndex].documents.length; i++) {
                    allImagesIds.push($scope.pressFromBackend[newsIndex].documents[i].id);
                    allImagesIds.push($scope.pressFromBackend[newsIndex].documents[i].id);
                }

                for (var i = 0; i < allImagesIds.length; i++) {
                    if (currentImageId == allImagesIds[i]) {
                        currentImageId = allImagesIds[i];
                        currentImagePosition = i;
                    }
                }

                $scope.imageRotate = function (rotate) {
                    if (rotate == 1) {
                        if (currentImagePosition == allImagesIds.length - 1) {
                            currentImagePosition = 0;
                        } else {
                            currentImagePosition++;
                        }
                    } if (rotate == 0) {
                        if (currentImagePosition == 0) {
                            currentImagePosition = allImagesIds.length - 1;
                        } else {
                            currentImagePosition--;
                        }
                    }
                    $scope._id = allImagesIds[currentImagePosition];
                }


                $scope.$watch('_id', function () {
                    PressFactory.readOne(newsId)
                        .success(function (response) {
                            for (var i = 0; i < response.documents.length; i++) {
                                if ($scope._id == response.documents[i].id) {
                                    $scope.oneImage = response.documents[i];
                                }
                            }
                        });
                });

            } else {
                $scope.displayPopup = false;
            }
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app')
        .controller('PressCmsController', PressCmsController);

    function PressCmsController($scope, PressFactory, PaginationService, ngDialog) {
        var vm = this;

        PaginationService.setter({ currentPage: 1, pageSize: 10 });
        $scope.$watch(function () { return PaginationService.getter(); }, function (newVal, oldVal) {
            if (newVal != null) {
                $scope.currentPage = newVal.currentPage;
                $scope.pageSize = newVal.pageSize;
            }
        });

        $scope.$watch('[currentPage, pageSize]', function () {
            var params = {
                page_size: $scope.pageSize,
                page: $scope.page
            }
            PressFactory.read(params)
            .then(function (response) {
                vm.dataFromBackend = response.data.results;
                $scope.countElements = response.data.count;
            });
        });


        vm.confirmDialog = function (itemId) {
            ngDialog.open({
                className: 'ngdialog-theme-default',
                template: 'app/components/delete_dialog/delete.dialog.html',
                data: {
                    item_id: itemId,
                    delete_function: PressFactory.delete
                }
            });
        }
    }

})();

(function(){
    'use strict';

    angular
        .module('app')
        .controller('PerfectPlaceController', PerfectPlaceController)
        .directive('backImg', function(){
            return function(scope, element, attrs){
                var url = attrs.backImg;
                element.css({
                    'background-image': 'url(' + url +')',
                    'background-size' : 'cover'
                });
            };
        });

    /** @ngInject */
    function PerfectPlaceController($scope, $window, PerfectPlaceFactory){
        var vm = this;
        var timer = setInterval(moveSection, 20000);
        var flagForApplyMethod = false;

        vm.fullPageOptions = {};
        vm.itemIndex;

        if($window.innerWidth < 768) {
            $('.menu-perfect-place').css('display', 'none');
        }

        PerfectPlaceFactory.read()
            .then(function(response) {
                vm.dataFromBackend = response.data;

                vm.fullPageOptions = {
                    navigation: true,
                    navigationPosition: 'right',
                    navigationTooltips: crateTooltipsList(vm.dataFromBackend),
                    loopBottom: true,
                    loopTop: true,
                    scrollingSpeed: 500,
                    scrollOverflow: true,
                    afterLoad: function (origin, destination, direction) {
                        clearInterval(timer);
                        timer = setInterval(moveSection, 20000);

                        vm.itemIndex = destination;
                        $scope.$applyAsync();
                    }
                }           
            });

        function moveSection() {
            $.fn.fullpage.moveSectionDown();
        }

        vm.showHide = function (isVisible) {
            if ($('.menu-perfect-place').css('display') == 'block') {
                $('.menu-perfect-place').css('display', 'none');
            } else {
                $('.menu-perfect-place').css('display', 'block');
            }
        }

        vm.arrowTop = function () {
            $.fn.fullpage.moveSectionUp();

            clearInterval(timer);
            timer = setInterval(moveSection, 20000);
        }

        vm.arrowBottom = function () {
            $.fn.fullpage.moveSectionDown();

            clearInterval(timer);
            timer = setInterval(moveSection, 20000);
        }

        function crateTooltipsList (arr) {
            var tooltips = [];
            for (var i = 0; i < arr.length; i++) {
                tooltips.push(arr[i].title);
            }

            return tooltips;
        }

    }

}());

(function(){
    'use strict';

    angular
        .module('app')
        .controller('PerfectPlaceCmsController', PerfectPlaceCmsController)

    /** @ngInject */
    function PerfectPlaceCmsController($scope, $state, PerfectPlaceFactory, ngDialog, toastr){
        var vm = this;

        PerfectPlaceFactory.read()
        .then(function (response) {
            vm.dataFromBackend = response.data;
        });

        vm.confirmDialog = function (itemId) {
            ngDialog.open({
                className: 'ngdialog-theme-default',
                template: 'app/components/delete_dialog/delete.dialog.html',
                data: {
                    item_id: itemId,
                    delete_function: PerfectPlaceFactory.delete
                }
            });
        }

        vm.changePosition = function (id, option) {
            var data = {
                change: option
            }

            PerfectPlaceFactory.changePosition(id, data)
                .success(function (response) {
                    $state.reload();
                });
        }
    }

}());
(function() {
    'use strict';

     angular
        .module('app')
        .controller("NewsController", NewsController);

     function NewsController(
         $scope,
         NewsCategoryService,
         NewsService,
         $window,
         DocumentsService,
         PaginationService,
         EndpointParamGeneratorService) {

            $scope.pageCategory = 0;
            $scope.showHideAll = "Rozwiń wszystko";
            $scope.showNoResults = false;

            PaginationService.setter({currentPage: 1, pageSize: 10});

            if($window.innerWidth > 768) {
                $('#for-users').addClass('active');
                $('.submenu').addClass('active');
                $('#sub-for-users').addClass('active');
            }

            $scope.$watch(function () {return PaginationService.getter(); }, function (newVal, oldVal) {
                if(newVal != null) {
                    $scope.currentPage = newVal.currentPage;
                    $scope.pageSize = newVal.pageSize;
                }
            });

            function paramList () {
                var list = [];

                list.push({title: 'page=', value: $scope.currentPage});
                list.push({title: 'page_size=', value: $scope.pageSize});
                list.push({title: 'category=', value: $scope.pageCategory});

                return list;
            }

            NewsCategoryService.read()
            .success(function(response) {
                $scope.categoriesFromBackend = response;
            });

            $scope.$watch('[currentPage, pageSize, pageCategory]', function() {

                $scope.newsFromBackend = {};
                $scope.newsFromBackend.dataLoaded = false;

                NewsService.read(EndpointParamGeneratorService.create(paramList()))
                .success(function(response) {
                    $scope.newsFromBackend = response.results;
                    $scope.countElements = response.count;
                    $scope.newsFromBackend.dataLoaded = true;

                    if(response.results.length < 1) {
                        $scope.showNoResults = true;
                    } else {
                        $scope.showNoResults = false;
                    }

                });
            });

            $scope.checkActive = function () {
                var isSomethingOpened = $('.cont-for-list-element').hasClass('active');
                if (isSomethingOpened == true) {
                    $scope.showHideAll = "Zwiń wszystko";
                    $('#show-hide-all').addClass('active');
                } else {
                    $scope.showHideAll = "Rozwiń wszystko";
                    $('#show-hide-all').removeClass('active');
                }    
            }

            $scope.openLink = function (link) {
                $window.open(link, '_blank');
            }         

            $scope.changeCategory = function(categoryId) {
                $scope.currentPage = 0;
                $scope.pageCategory = categoryId;
                PaginationService.setter({currentPage: 1, pageSize: $scope.pageSize});
            }
            
            $scope.toggleBtn = function(id) {     
                $('.cont-for-list-element[data-id="' + id + '"]')
                .toggleClass('active')
                .find(".inner-content").click(function () {
                    return false;
                });
            }

            $scope.showPopup = function(options, newsId, imageId, newsIndex) {
                if (options === true) {
                    $scope.displayPopup = true;
                    $scope._id = imageId;
                    var allImagesIds = [],
                        currentImageId = $scope._id,
                        currentImagePosition;

                    for(var i = 0; i < $scope.newsFromBackend[newsIndex].documents.length; i++) {
                        allImagesIds.push($scope.newsFromBackend[newsIndex].documents[i].id);
                    }

                    for (var i = 0; i<allImagesIds.length; i++) {
                        if(currentImageId == allImagesIds[i]) {
                            currentImageId = allImagesIds[i];
                            currentImagePosition = i;
                        }
                    }

                    $scope.imageRotate = function (rotate) {
                        if(rotate == 1) {       
                            if(currentImagePosition == allImagesIds.length-1) {
                                currentImagePosition = 0;
                            } else {
                                currentImagePosition++;
                            }
                        } if(rotate == 0) {
                            if(currentImagePosition == 0) {
                                currentImagePosition = allImagesIds.length-1;
                            } else {
                                currentImagePosition--;        
                            }       
                        }
                        $scope._id = allImagesIds[currentImagePosition];
                    }


                    $scope.$watch('_id', function() {
                        NewsService.readOne(newsId)
                        .success(function (response) {
                            for(var i = 0; i < response.documents.length; i ++) {
                                if($scope._id == response.documents[i].id) {
                                    $scope.oneImage = response.documents[i];
                                }
                            }
                        });
                    });

                } else {
                    $scope.displayPopup = false;
                }
            }

        }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ManagementWebController', ManagementWebController);

    function ManagementWebController($window, PagesFactory) {
        var vm = this;

        //if($window.innerWidth > 768) {
        //    $('#aboutus').addClass('active');
        //    $('.submenu').addClass('active');
        //    $('#sub-aboutus').addClass('active');
        //}

        PagesFactory.read('management')
        .then(function (response) {

            function takeResponseBySlug(slug) {
                for(var i = 0; i < response.data.placeholders.length; i++) {
                    if(response.data.placeholders[i].slug == slug) {
                        return i;
                    }
                }
            }

            if (response.data.placeholders[takeResponseBySlug("management")]) {
                vm.managementFromBackendTitle = response.data.placeholders[takeResponseBySlug("management")].title;
                vm.managementFromBackendBody = response.data.placeholders[takeResponseBySlug("management")].content;
            }

            if (response.data.placeholders[takeResponseBySlug("directors")]) {
                vm.directorsFromBackendTitle = response.data.placeholders[takeResponseBySlug("directors")].title;
                vm.directorsFromBackendBody = response.data.placeholders[takeResponseBySlug("directors")].content;
            }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('app')
        .controller('ManagementCmsController', ManagementCmsController)

    /** @ngInject */
    function ManagementCmsController(PagesFactory, $log){
        var vm = this;

        init();

        function init() {
            vm.update = update;

            readSiteFromServer();
        }

        function readSiteFromServer() {
            PagesFactory.read('management')
                .then(function (response) {

                    function takeResponseBySlug(slug) {
                        for (var i = 0; i < response.data.placeholders.length; i++) {
                            if (response.data.placeholders[i].slug == slug) {
                                return i;
                            }
                        }
                    }

                    if (response.data.placeholders[takeResponseBySlug("management")]) {
                        vm.managementFromBackendTitle = response.data.placeholders[takeResponseBySlug("management")].title;
                        vm.managementFromBackendBody = response.data.placeholders[takeResponseBySlug("management")].content;
                    }

                    if (response.data.placeholders[takeResponseBySlug("directors")]) {
                        vm.directorsFromBackendTitle = response.data.placeholders[takeResponseBySlug("directors")].title;
                        vm.directorsFromBackendBody = response.data.placeholders[takeResponseBySlug("directors")].content;
                    }

                }, function (response) {
                    if (response.status === 404) {
                        $log.warn('Musisz dodać stronę w dj_admin: title: management, slug: management');
                    } else {
                        $log.warn(response);
                    }
                });
        }

        function update() {
            var data = {
                slug: 'management',
                title: 'management',
                placeholders: [{
                    slug: 'management',
                    title: vm.managementFromBackendTitle,
                    content: vm.managementFromBackendBody,
                    type: 'pages.textplaceholder'
                },
                {
                    slug: 'directors',
                    title: vm.directorsFromBackendTitle,
                    content: vm.directorsFromBackendBody,
                    type: 'pages.textplaceholder'
                }]
            }

            PagesFactory.update('management', data);
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app')
        .controller('LocalizationsCmsController', LocalizationsCmsController);

    function LocalizationsCmsController($scope, $state, $http, ngDialog, LocalizationsFactory, LocalizationsStreetFactory, Upload, toastr) {
        var vm = this;

        LocalizationsFactory.read()
            .then(function (response) {
                vm.settlementsFromBackend = response.data;
            });

        LocalizationsStreetFactory.read()
            .then(function (response) {
                vm.streetsFromBackend = response.data;
            });

        vm.addNewSettlement = function () {
            ngDialog.open({
                className: 'ngdialog-theme-default',
                template: 'app/partials/localizations/cms/add_new_settlement.html',
                controller: 'LocalizationsCmsController',
                controllerAs: 'LocalizationsCmsCtrl'
            });
        }

        vm.sendNewSettlement = function () {
            var data = {
                settlement: vm.new_settlement,
                body: vm.new_body,
                body_2: vm.new_body_2,
                body_3: vm.new_body_3
            }

            LocalizationsFactory.create(data)
            .then(function () {
                toastr.success('Dodano.');
                ngDialog.close();
                $state.reload();
            }, function () {
                toastr.error('Wypełnij wszystkie pola.');
            })
        }

        vm.addNewStreet = function () {
            var data = {
                name: vm.new_street_name,
                settlement: vm.new_street_settlement
            }

            LocalizationsStreetFactory.create(data)
                .then(function (response) {
                    toastr.success('Dodano.');
                    $state.reload();
                }, function () {
                    toastr.error('Wypełnij wszystkie pola.');
                });
        }

        vm.changeSettlement = function (id, title, textBody, textBody2, textBody3) {
            var data = {
                settlement: title,
                body: textBody,
                body_2: textBody2,
                body_3: textBody3
            }
            LocalizationsFactory.update(id, data);
        }

        vm.changeStreet = function (id, title, settl) {
            var data = {
                settlement: settl,
                name: title
            }

            LocalizationsStreetFactory.update(id, data);
        }

        vm.deleteSettlement = function (itemId) {
            ngDialog.open({
                className: 'ngdialog-theme-default',
                template: 'app/components/delete_dialog/delete.dialog.html',
                data: {
                    item_id: itemId,
                    delete_function: LocalizationsFactory.delete
                }
            });
        }

        vm.deleteStreet = function (itemId) {
            ngDialog.open({
                className: 'ngdialog-theme-default',
                template: 'app/components/delete_dialog/delete.dialog.html',
                data: {
                    item_id: itemId,
                    delete_function: LocalizationsStreetFactory.delete
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('HistoryWebController', HistoryWebController);

    function HistoryWebController($window, PagesFactory) {
        var vm = this;

        //if($window.innerWidth > 768) {
        //    $('#aboutus').addClass('active');
        //    $('.submenu').addClass('active');
        //    $('#sub-aboutus').addClass('active');
        //}

        PagesFactory.read('historia')
        .then(function (response) {

            function takeResponseBySlug(slug) {
                for(var i = 0; i < response.data.placeholders.length; i++) {
                    if(response.data.placeholders[i].slug == slug) {
                        return i;
                    }
                }
            }

            if(response.data.placeholders[takeResponseBySlug("historia")]) {
                vm.dataFromBackendTitle = response.data.placeholders[takeResponseBySlug("historia")].title;
                vm.dataFromBackendBody = response.data.placeholders[takeResponseBySlug("historia")].content;
            }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('app')
        .controller('HistoryCmsController', HistoryCmsController)

    /** @ngInject */
    function HistoryCmsController(PagesFactory, $log){
        var vm = this;

        init();

        function init() {
            vm.update = update;

            readSiteFromServer();
        }

        function readSiteFromServer() {
            PagesFactory.read('historia')
                .then(function (response) {

                    function takeResponseBySlug(slug) {
                        for (var i = 0; i < response.data.placeholders.length; i++) {
                            if (response.data.placeholders[i].slug == slug) {
                                return i;
                            }
                        }
                    }

                    if (response.data.placeholders[takeResponseBySlug("historia")]) {
                        vm.coworkingFromBackendTitle = response.data.placeholders[takeResponseBySlug("historia")].title;
                        vm.coworkingFromBackendBody = response.data.placeholders[takeResponseBySlug("historia")].content;
                    }

                }, function (response) {
                    if (response.status === 404) {
                        $log.warn('Musisz dodać stronę w dj_admin: title: Historia, slug: historia');
                    } else {
                        $log.warn(response);
                    }
                });
        }

        function update() {
            var data = {
                slug: 'historia',
                title: 'Historia',
                placeholders: [{
                    slug: 'historia',
                    title: vm.coworkingFromBackendTitle,
                    content: vm.coworkingFromBackendBody,
                    type: 'pages.textplaceholder'
                }]
            }

            PagesFactory.update('historia', data);
        }
    }

}());

(function() {
    'use strict';

     angular
        .module('app')
        .controller("FundingController", FundingController);

     function FundingController(
        $scope,
        FundingService,
        $window,
        PagesFactory,
        PaginationService,
        EndpointParamGeneratorService) {

            $scope.showHideAll = "Rozwiń wszystko";
            $scope.showNoResults = false;

            PaginationService.setter({currentPage: 1, pageSize: 10});

            if($window.innerWidth > 768) {
                $('#for-users').addClass('active');
                $('.submenu').addClass('active');
                $('#sub-for-users').addClass('active');
            }

            $scope.$watch(function () {return PaginationService.getter(); }, function (newVal) {
                if(newVal != null) {
                    $scope.currentPage = newVal.currentPage;
                    $scope.pageSize = newVal.pageSize;
                }
            });

            PagesFactory.read('dofinansowanie')
            .then(function(response) {
                function takeResponseBySlug(slug) {
                    for(var i = 0; i < response.data.placeholders.length; i++) {
                        if(response.data.placeholders[i].slug == slug) {
                            return i;
                        }
                    }
                }
    
                if(response.data.placeholders[takeResponseBySlug("dofinansowanie")]) {
                    $scope.fundingTitle = response.data.placeholders[takeResponseBySlug("dofinansowanie")].title;
                    $scope.fundingDescription = response.data.placeholders[takeResponseBySlug("dofinansowanie")].content;
                }

                if(response.data.placeholders[takeResponseBySlug("dofinansowanie-obraz")]) {
                    $scope.fundingImg = response.data.placeholders[takeResponseBySlug("dofinansowanie-obraz")].content;
                }
            });

            function paramList () {
                var list = [];

                list.push({title: 'page=', value: $scope.currentPage});
                list.push({title: 'page_size=', value: $scope.pageSize});

                return list;
            }

            $scope.$watch('[currentPage, pageSize]', function() {

                $scope.newsFromBackend = {};
                $scope.newsFromBackend.dataLoaded = false;

                FundingService.read(EndpointParamGeneratorService.create(paramList()))
                .success(function(response) {
                    $scope.newsFromBackend = response.results;
                    $scope.countElements = response.count;
                    $scope.newsFromBackend.dataLoaded = true;

                    if(response.results.length < 1) {
                        $scope.showNoResults = true;
                    } else {
                        $scope.showNoResults = false;
                    }
                });
            });

            $scope.checkActive = function () {
                var isSomethingOpened = $('.cont-for-list-element').hasClass('active');
                if (isSomethingOpened == true) {
                    $scope.showHideAll = "Zwiń wszystko";
                    $('#show-hide-all').addClass('active');
                } else {
                    $scope.showHideAll = "Rozwiń wszystko";
                    $('#show-hide-all').removeClass('active');
                }    
            }

            $scope.openLink = function (link) {
                $window.open(link, '_blank');
            }         
            
            $scope.toggleBtn = function(id) {     
                $('.cont-for-list-element[data-id="' + id + '"]')
                .toggleClass('active')
                .find(".inner-content").click(function () {
                    return false;
                });
            }

            $scope.showPopup = function(options, newsId, imageId, newsIndex) {
                if (options === true) {
                    $scope.displayPopup = true;
                    $scope._id = imageId;
                    var allImagesIds = [],
                        currentImageId = $scope._id,
                        currentImagePosition;

                    for(var i = 0; i < $scope.newsFromBackend[newsIndex].documents.length; i++) {
                        allImagesIds.push($scope.newsFromBackend[newsIndex].documents[i].id);
                    }

                    for (var i = 0; i<allImagesIds.length; i++) {
                        if(currentImageId == allImagesIds[i]) {
                            currentImageId = allImagesIds[i];
                            currentImagePosition = i;
                        }
                    }

                    $scope.imageRotate = function (rotate) {
                        if(rotate == 1) {       
                            if(currentImagePosition == allImagesIds.length-1) {
                                currentImagePosition = 0;
                            } else {
                                currentImagePosition++;
                            }
                        } if(rotate == 0) {
                            if(currentImagePosition == 0) {
                                currentImagePosition = allImagesIds.length-1;
                            } else {
                                currentImagePosition--;        
                            }       
                        }
                        $scope._id = allImagesIds[currentImagePosition];
                    }


                    $scope.$watch('_id', function() {
                        FundingService.readOne(newsId)
                        .success(function (response) {
                            for(var i = 0; i < response.documents.length; i ++) {
                                if($scope._id == response.documents[i].id) {
                                    $scope.oneImage = response.documents[i];
                                }
                            }
                        });
                    });

                } else {
                    $scope.displayPopup = false;
                }
            }
        }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('EcoWebController', EcoWebController);

    function EcoWebController($window, PagesFactory) {
        var vm = this;

        //if($window.innerWidth > 768) {
        //    $('#aboutus').addClass('active');
        //    $('.submenu').addClass('active');
        //    $('#sub-aboutus').addClass('active');
        //}

        PagesFactory.read('eco')
        .then(function (response) {

            function takeResponseBySlug(slug) {
                for(var i = 0; i < response.data.placeholders.length; i++) {
                    if(response.data.placeholders[i].slug == slug) {
                        return i;
                    }
                }
            }

            if(response.data.placeholders[takeResponseBySlug("eco")]) {
                vm.dataFromBackendTitle = response.data.placeholders[takeResponseBySlug("eco")].title;
                vm.dataFromBackendBody = response.data.placeholders[takeResponseBySlug("eco")].content;
            }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('app')
        .controller('EcoCmsController', EcoCmsController)

    /** @ngInject */
    function EcoCmsController(PagesFactory, $log){
        var vm = this;

        init();

        function init() {
            vm.update = update;

            readSiteFromServer();
        }

        function readSiteFromServer() {
            PagesFactory.read('eco')
                .then(function (response) {

                    function takeResponseBySlug(slug) {
                        for (var i = 0; i < response.data.placeholders.length; i++) {
                            if (response.data.placeholders[i].slug == slug) {
                                return i;
                            }
                        }
                    }

                    if (response.data.placeholders[takeResponseBySlug("eco")]) {
                        vm.dataFromBackendTitle = response.data.placeholders[takeResponseBySlug("eco")].title;
                        vm.dataFromBackendBody = response.data.placeholders[takeResponseBySlug("eco")].content;
                    }

                }, function (response) {
                    if (response.status === 404) {
                        $log.warn('Musisz dodać stronę w dj_admin: title: eco, slug: eco');
                    } else {
                        $log.warn(response);
                    }
                });
        }

        function update() {
            var data = {
                slug: 'eco',
                title: 'eco',
                placeholders: [{
                    slug: 'eco',
                    title: vm.dataFromBackendTitle,
                    content: vm.dataFromBackendBody,
                    type: 'pages.textplaceholder'
                }]
            }

            PagesFactory.update('eco', data);
        }
    }

}());

(function(){
    'use strict';

    angular
        .module('app')
        .controller('CultureController', CultureController)

    /** @ngInject */
    function CultureController(
        $scope,
        CultureCategoryService,
        CultureFactory,
        PaginationService,
        ngDialog) {

        var vm = this;

        init();

        function init() {
            readCategoriesFromBackend();
        }

        function readCategoriesFromBackend() {
            CultureCategoryService.read()
                .then(function (response) {
                    vm.categoriesFromBackend = response.data;
                });
        }

        $scope.showHideAll = "Rozwiń wszystko";
        $scope.showNoResults = false;

        PaginationService.setter({ currentPage: 1, pageSize: 10 });

        $scope.$watch(function () { return PaginationService.getter(); }, function (newVal, oldVal) {
            if (newVal != null) {
                $scope.currentPage = newVal.currentPage;
                $scope.pageSize = newVal.pageSize;
            }
        });

        $scope.$watch('[currentPage, pageSize, categoryFilter]', function () {

            var params = {
                page: $scope.currentPage,
                page_size: $scope.pageSize,
                category: $scope.categoryFilter
            }

            $scope.cultureFromBackend = {};
            $scope.cultureFromBackend.dataLoaded = false;

            CultureFactory.read(params)
                .then(function (response) {
                    $scope.cultureFromBackend = response.data.results;
                    $scope.countElements = response.data.count;
                    $scope.cultureFromBackend.dataLoaded = true;

                    if (response.data.results.length < 1) {
                        $scope.showNoResults = true;
                    } else {
                        $scope.showNoResults = false;
                    }
                });
        });

        $scope.checkActive = function () {
            var isSomethingOpened = $('.cont-for-list-element').hasClass('active');
            if (isSomethingOpened == true) {
                $scope.showHideAll = "Zwiń wszystko";
                $('#show-hide-all').addClass('active');
            } else {
                $scope.showHideAll = "Rozwiń wszystko";
                $('#show-hide-all').removeClass('active');
            }
        }

        $scope.toggleBtn = function (id) {
            $('.cont-for-list-element[data-id="' + id + '"]')
                .toggleClass('active')
                .find(".inner-content").click(function () {
                    return false;
                });
        }

        $scope.showPopup = function (options, newsId, imageId, newsIndex) {
            if (options === true) {
                $scope.displayPopup = true;
                $scope._id = imageId;
                var allImagesIds = [],
                    currentImageId = $scope._id,
                    currentImagePosition;

                for (var i = 0; i < $scope.newsFromBackend[newsIndex].documents.length; i++) {
                    allImagesIds.push($scope.newsFromBackend[newsIndex].documents[i].id);
                }

                for (var i = 0; i < allImagesIds.length; i++) {
                    if (currentImageId == allImagesIds[i]) {
                        currentImageId = allImagesIds[i];
                        currentImagePosition = i;
                    }
                }

                $scope.imageRotate = function (rotate) {
                    if (rotate == 1) {
                        if (currentImagePosition == allImagesIds.length - 1) {
                            currentImagePosition = 0;
                        } else {
                            currentImagePosition++;
                        }
                    } if (rotate == 0) {
                        if (currentImagePosition == 0) {
                            currentImagePosition = allImagesIds.length - 1;
                        } else {
                            currentImagePosition--;
                        }
                    }
                    $scope._id = allImagesIds[currentImagePosition];
                }


                $scope.$watch('_id', function () {
                    NewsService.readOne(newsId)
                        .success(function (response) {
                            for (var i = 0; i < response.documents.length; i++) {
                                if ($scope._id == response.documents[i].id) {
                                    $scope.oneImage = response.documents[i];
                                }
                            }
                        });
                });

            } else {
                $scope.displayPopup = false;
            }
        }
    }

}());

(function(){
    'use strict';

    angular
        .module('app')
        .controller('OneEventController', OneEventController)

    /** @ngInject */
    function OneEventController($scope, CultureFactory){
        var vm = this,
            itemId = $scope.ngDialogData.item_id;

        CultureFactory.readOne(itemId)
        .then(function (response) {
            vm.dataFromBackend = response.data;
        })
    }

}());
(function () {
    'use strict';

    angular
        .module('app')
        .controller('CultureCmsController', CultureCmsController);

    function CultureCmsController($scope, CultureFactory, PaginationService, ngDialog) {
        var vm = this;
        vm.publishedOptions = [
            { name: 'Opublikowano', value: 'True' },
            { name: 'Szkic', value: 'False' }
        ];

        PaginationService.setter({ currentPage: 1, pageSize: 10 });
        $scope.$watch(function () { return PaginationService.getter(); }, function (newVal, oldVal) {
            if (newVal != null) {
                $scope.currentPage = newVal.currentPage;
                $scope.pageSize = newVal.pageSize;
            }
        });

        $scope.$watch('[currentPage, pageSize, published]', function () {
            var params = {
                page_size: $scope.pageSize,
                page: $scope.page,
                published: $scope.published
            }
            CultureFactory.read(params)
            .then(function (response) {
                vm.dataFromBackend = response.data.results;
                $scope.countElements = response.data.count;
            });
        });


        vm.confirmDialog = function (itemId) {
            ngDialog.open({
                className: 'ngdialog-theme-default',
                template: 'app/components/delete_dialog/delete.dialog.html',
                data: {
                    item_id: itemId,
                    delete_function: CultureFactory.delete
                }
            });
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('CoworkingController', CoworkingController);

    function CoworkingController($window, PagesFactory) {
        var vm = this;

        if($window.innerWidth > 768) {
            $('#cowork').addClass('active');
            $('.submenu').addClass('active');
            $('#sub-cowork').addClass('active');
        }

        PagesFactory.read('big-picture')
        .then(function (response) {

            function takeResponseBySlug(slug) {
                for(var i = 0; i < response.data.placeholders.length; i++) {
                    if(response.data.placeholders[i].slug == slug) {
                        return i;
                    }
                }
            }

            if(response.data.placeholders[takeResponseBySlug("wspolpraca")]) {
                vm.coworkingFromBackendTitle = response.data.placeholders[takeResponseBySlug("wspolpraca")].title;
                vm.coworkingFromBackendBody = response.data.placeholders[takeResponseBySlug("wspolpraca")].content;
            }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('app')
        .controller('BigPicturesController', BigPicturesController)

    /** @ngInject */
    function BigPicturesController(PagesFactory, $log){
        var vm = this;

        init();

        function init() {
            vm.update = update;

            readSiteFromServer();
        }

        function readSiteFromServer() {
            PagesFactory.read('big-picture')
                .then(function (response) {

                    function takeResponseBySlug(slug) {
                        for (var i = 0; i < response.data.placeholders.length; i++) {
                            if (response.data.placeholders[i].slug == slug) {
                                return i;
                            }
                        }
                    }

                    if (response.data.placeholders[takeResponseBySlug("wspolpraca")]) {
                        vm.coworkingFromBackendTitle = response.data.placeholders[takeResponseBySlug("wspolpraca")].title;
                        vm.coworkingFromBackendBody = response.data.placeholders[takeResponseBySlug("wspolpraca")].content;
                    }

                    if (response.data.placeholders[takeResponseBySlug("spoldzielnia")]) {
                        vm.settleFromBackendTitle = response.data.placeholders[takeResponseBySlug("spoldzielnia")].title;
                        vm.settleFromBackendBody = response.data.placeholders[takeResponseBySlug("spoldzielnia")].content;
                    }
                }, function (response) {
                    if (response.status === 404) {
                        $log.warn('Musisz dodać stronę w dj_admin: title: BigPicture, slug: big-picture');
                    } else {
                        $log.warn(response);
                    }
                });
        }

        function update() {
            var data = {
                slug: 'big-picture',
                title: 'BigPicture',
                placeholders: [{
                    slug: 'wspolpraca',
                    title: vm.coworkingFromBackendTitle,
                    content: vm.coworkingFromBackendBody,
                    type: 'pages.textplaceholder'
                },
                {
                    slug: 'spoldzielnia',
                    title: vm.settleFromBackendTitle,
                    content: vm.settleFromBackendBody,
                    type: 'pages.textplaceholder'
                }]
            }

            PagesFactory.update('big-picture', data);
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app')
        .controller('AdvertisersController', AdvertisersController);

    function AdvertisersController($scope, $window, AdvertisersFactory, PaginationService, PagesFactory) {
        var vm = this;

        PaginationService.setter({ currentPage: 1, pageSize: 10 });

        $scope.$watch(function () { return PaginationService.getter(); }, function (newVal, oldVal) {
            if (newVal != null) {
                $scope.currentPage = newVal.currentPage;
                $scope.pageSize = newVal.pageSize;
            }
        });

        PagesFactory.read('adv')
        .then(function (response) {
            function takeResponseBySlug(slug) {
                for(var i = 0; i < response.data.placeholders.length; i++) {
                    if(response.data.placeholders[i].slug == slug) {
                        return i;
                    }
                }
            }

            if(response.data.placeholders[takeResponseBySlug("adv")]) {
                vm.advFromBackendTitle = response.data.placeholders[takeResponseBySlug("adv")].title;
                vm.advFromBackendContent = response.data.placeholders[takeResponseBySlug("adv")].content;
            }
        });

        $scope.$watch('[pageSize, currentPage]', function () {
            var params = {
                page_size: $scope.pageSize,
                page: $scope.currentPage
            }

            AdvertisersFactory.read(params)
                .then(function (response) {
                    vm.dataFromBackend = response.data;
                    vm.dataFromBackend.dataLoaded = true;
                    $scope.countElements = response.data.count;

                    if (response.data.results.length < 1) {
                        vm.showNoResults = true;
                    } else {
                        vm.showNoResults = false;
                    }
                });
        });

        vm.toggleBtn = function (id) {
            $('.cont-for-list-element[data-id="' + id + '"]')
                .toggleClass('active')
                .find(".inner-content").click(function () {
                    return false;
                });
        }

        $scope.openLink = function (link) {
            $window.open(link, '_blank');
        }  

        $scope.showPopup = function (options, newsId, imageId, newsIndex) {
            if (options === true) {
                $scope.displayPopup = true;
                $scope._id = imageId;
                var allImagesIds = [],
                    currentImageId = $scope._id,
                    currentImagePosition;

                for (var i = 0; i < $scope.newsFromBackend[newsIndex].documents.length; i++) {
                    allImagesIds.push($scope.newsFromBackend[newsIndex].documents[i].id);
                }

                for (var i = 0; i < allImagesIds.length; i++) {
                    if (currentImageId == allImagesIds[i]) {
                        currentImageId = allImagesIds[i];
                        currentImagePosition = i;
                    }
                }

                $scope.imageRotate = function (rotate) {
                    if (rotate == 1) {
                        if (currentImagePosition == allImagesIds.length - 1) {
                            currentImagePosition = 0;
                        } else {
                            currentImagePosition++;
                        }
                    } if (rotate == 0) {
                        if (currentImagePosition == 0) {
                            currentImagePosition = allImagesIds.length - 1;
                        } else {
                            currentImagePosition--;
                        }
                    }
                    $scope._id = allImagesIds[currentImagePosition];
                }


                $scope.$watch('_id', function () {
                    NewsService.readOne(newsId)
                        .success(function (response) {
                            for (var i = 0; i < response.documents.length; i++) {
                                if ($scope._id == response.documents[i].id) {
                                    $scope.oneImage = response.documents[i];
                                }
                            }
                        });
                });

            } else {
                $scope.displayPopup = false;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('AdvertisersCmsController', AdvertisersCmsController);

    function AdvertisersCmsController($scope, AdvertisersFactory, ngDialog, PaginationService, PagesFactory) {
        var vm = this;

        PaginationService.setter({ currentPage: 1, pageSize: 10 });

        $scope.$watch(function () { return PaginationService.getter(); }, function (newVal, oldVal) {
            if (newVal != null) {
                $scope.currentPage = newVal.currentPage;
                $scope.pageSize = newVal.pageSize;
            }
        });

        PagesFactory.read('adv')
        .then(function (response) {
            function takeResponseBySlug(slug) {
                for(var i = 0; i < response.data.placeholders.length; i++) {
                    if(response.data.placeholders[i].slug == slug) {
                        return i;
                    }
                }
            }

            if(response.data.placeholders[takeResponseBySlug("adv")]) {
                vm.advFromBackendTitle = response.data.placeholders[takeResponseBySlug("adv")].title;
                vm.advFromBackendContent = response.data.placeholders[takeResponseBySlug("adv")].content;
            }
        });

        $scope.$watch('[pageSize, page]', function () {
            var params = {
                page_size: $scope.pageSize,
                page: $scope.page
            }

            AdvertisersFactory.read(params)
                .then(function (response) {
                    vm.dataFromBackend = response.data;
                    $scope.countElements = response.data.count;
                });
        });

        vm.update = function () {
            var data = {
                slug: 'adv',
                title: 'adv',
                placeholders: [{
                    slug: 'adv',
                    title: vm.advFromBackendTitle,
                    content: vm.advFromBackendContent,
                    type: 'pages.textplaceholder'
                }]
            }

            PagesFactory.update('adv', data);
        }

        vm.confirmDialog = function (itemId) {
            ngDialog.open({
                className: 'ngdialog-theme-default',
                template: 'app/components/delete_dialog/delete.dialog.html',
                data: {
                    item_id: itemId,
                    delete_function: AdvertisersFactory.delete
                }
            });
        }
    }
})();

(function() {
'use strict';

  angular
    .module('app')
    .config(activateRouterConfig);

  function activateRouterConfig($stateProvider) {
    $stateProvider
            .state('activate', {
                url: '/activate/:activationToken/',
                templateUrl: 'app/partials/activate/activate.html',
                controller: 'ActivateController'
          })
          .state('changePassword', {
            url: '/password-reset/confirm/:uid/:token/',
            templateUrl: 'app/partials/activate/changePassword.html',
            controller: 'ChangePasswordController'
          })
  }

})();

(function () {
'use strict';

  angular
    .module('app')
    .controller('ChangePasswordController', ChangePasswordController);

  function ChangePasswordController($stateParams, $scope, $location, UsersService, toastr) {

    var token = $stateParams.token,
      uid = $stateParams.uid;
    
    $scope.submit = function () {
      var data = {
        'uid': uid,
        'token': token,
        'new_password1': $scope.password1,
        'new_password2': $scope.password2
      }

      UsersService.changePassword(data)
      .success(function (response) {
        toastr.success("Hasło zostało zmienione.");
        $location.path('/adm53335');
      })
      .error(function () {
        toastr.error("Hasła nie są jednakowe.");
      });
    }
  }

})();

(function () {
'use strict';

  angular
    .module('app')
    .controller('ActivateController', ActivateController);

  function ActivateController($stateParams, $scope, $location, UsersService) {

    var token = $stateParams.activationToken;
    
    $scope.submit = function () {
      var data = {
        key: token,
        password1: $scope.password1,
        password2: $scope.password2
      }

      UsersService.activate(data)
        .success(function (response) {
          console.log('Konto zostało utworzone');
          $location.path('/adm53335');
        });
    }
  }

})();

/*
@license textAngular
Author : Austin Anderson
License : 2013 MIT
Version 1.5.1

See README.md or https://github.com/fraywing/textAngular/wiki for requirements and use.
*/

/*
Commonjs package manager support (eg componentjs).
*/


"use strict";
// IE version detection - http://stackoverflow.com/questions/4169160/javascript-ie-detection-why-not-use-simple-conditional-comments
// We need this as IE sometimes plays funny tricks with the contenteditable.
// ----------------------------------------------------------
// If you're not in IE (or IE version is less than 5) then:
// ie === undefined
// If you're in IE (>=5) then you can determine which version:
// ie === 7; // IE7
// Thus, to detect IE:
// if (ie) {}
// And to detect the version:
// ie === 6 // IE6
// ie > 7 // IE8, IE9, IE10 ...
// ie < 9 // Anything less than IE9
// ----------------------------------------------------------
/* istanbul ignore next: untestable browser check */
var _browserDetect = {
	ie: (function(){
		var undef,
			v = 3,
			div = document.createElement('div'),
			all = div.getElementsByTagName('i');

		while (
			div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
			all[0]
		);

		return v > 4 ? v : undef;
	}()),
	webkit: /AppleWebKit\/([\d.]+)/i.test(navigator.userAgent)
};

// fix a webkit bug, see: https://gist.github.com/shimondoodkin/1081133
// this is set true when a blur occurs as the blur of the ta-bind triggers before the click
var globalContentEditableBlur = false;
/* istanbul ignore next: Browser Un-Focus fix for webkit */
if(_browserDetect.webkit) {
	document.addEventListener("mousedown", function(_event){
		var e = _event || window.event;
		var curelement = e.target;
		if(globalContentEditableBlur && curelement !== null){
			var isEditable = false;
			var tempEl = curelement;
			while(tempEl !== null && tempEl.tagName.toLowerCase() !== 'html' && !isEditable){
				isEditable = tempEl.contentEditable === 'true';
				tempEl = tempEl.parentNode;
			}
			if(!isEditable){
				document.getElementById('textAngular-editableFix-010203040506070809').setSelectionRange(0, 0); // set caret focus to an element that handles caret focus correctly.
				curelement.focus(); // focus the wanted element.
				if (curelement.select) {
					curelement.select(); // use select to place cursor for input elements.
				}
			}
		}
		globalContentEditableBlur = false;
	}, false); // add global click handler
	angular.element(document).ready(function () {
		angular.element(document.body).append(angular.element('<input id="textAngular-editableFix-010203040506070809" class="ta-hidden-input" aria-hidden="true" unselectable="on" tabIndex="-1">'));
	});
}

// Gloabl to textAngular REGEXP vars for block and list elements.

var BLOCKELEMENTS = /^(address|article|aside|audio|blockquote|canvas|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video)$/i;
var LISTELEMENTS = /^(ul|li|ol)$/i;
var VALIDELEMENTS = /^(address|article|aside|audio|blockquote|canvas|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video|li)$/i;

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Compatibility
/* istanbul ignore next: trim shim for older browsers */
if (!String.prototype.trim) {
	String.prototype.trim = function () {
		return this.replace(/^\s+|\s+$/g, '');
	};
}

/*
	Custom stylesheet for the placeholders rules.
	Credit to: http://davidwalsh.name/add-rules-stylesheets
*/
var sheet, addCSSRule, removeCSSRule, _addCSSRule, _removeCSSRule, _getRuleIndex;
/* istanbul ignore else: IE <8 test*/
if(_browserDetect.ie > 8 || _browserDetect.ie === undefined){
	var _sheets = document.styleSheets;
	/* istanbul ignore next: preference for stylesheet loaded externally */
	for(var i = 0; i < _sheets.length; i++){
		if(_sheets[i].media.length === 0 || _sheets[i].media.mediaText.match(/(all|screen)/ig)){
			if(_sheets[i].href){
				if(_sheets[i].href.match(/textangular\.(min\.|)css/ig)){
					sheet = _sheets[i];
					break;
				}
			}
		}
	}
	/* istanbul ignore next: preference for stylesheet loaded externally */
	if(!sheet){
		// this sheet is used for the placeholders later on.
		sheet = (function() {
			// Create the <style> tag
			var style = document.createElement("style");
			/* istanbul ignore else : WebKit hack :( */
			if(_browserDetect.webkit) style.appendChild(document.createTextNode(""));

			// Add the <style> element to the page, add as first so the styles can be overridden by custom stylesheets
			document.getElementsByTagName('head')[0].appendChild(style);

			return style.sheet;
		})();
	}

	// use as: addCSSRule("header", "float: left");
	addCSSRule = function(selector, rules) {
		return _addCSSRule(sheet, selector, rules);
	};
	_addCSSRule = function(_sheet, selector, rules){
		var insertIndex;
		var insertedRule;
		// This order is important as IE 11 has both cssRules and rules but they have different lengths - cssRules is correct, rules gives an error in IE 11
		/* istanbul ignore next: browser catches */
		if(_sheet.cssRules) insertIndex = Math.max(_sheet.cssRules.length - 1, 0);
		else if(_sheet.rules) insertIndex = Math.max(_sheet.rules.length - 1, 0);

		/* istanbul ignore else: untestable IE option */
		if(_sheet.insertRule) {
			_sheet.insertRule(selector + "{" + rules + "}", insertIndex);
		}
		else {
			_sheet.addRule(selector, rules, insertIndex);
		}
		/* istanbul ignore next: browser catches */
		if(sheet.rules) insertedRule = sheet.rules[insertIndex];
		else if(sheet.cssRules) insertedRule = sheet.cssRules[insertIndex];
		// return the inserted stylesheet rule
		return insertedRule;
	};

	_getRuleIndex = function(rule, rules) {
		var i, ruleIndex;
		for (i=0; i < rules.length; i++) {
			/* istanbul ignore else: check for correct rule */
			if (rules[i].cssText === rule.cssText) {
				ruleIndex = i;
				break;
			}
		}
		return ruleIndex;
	};

	removeCSSRule = function(rule){
		_removeCSSRule(sheet, rule);
	};
	/* istanbul ignore next: tests are browser specific */
	_removeCSSRule = function(sheet, rule){
		var rules = sheet.cssRules || sheet.rules;
		if(!rules || rules.length === 0) return;
		var ruleIndex = _getRuleIndex(rule, rules);
		if(sheet.removeRule){
			sheet.removeRule(ruleIndex);
		}else{
			sheet.deleteRule(ruleIndex);
		}
	};
}

angular.module('textAngular.factories', [])
.factory('taBrowserTag', [function(){
	return function(tag){
		/* istanbul ignore next: ie specific test */
		if(!tag) return (_browserDetect.ie <= 8)? 'P' : 'p';
		else if(tag === '') return (_browserDetect.ie === undefined)? 'div' : (_browserDetect.ie <= 8)? 'P' : 'p';
		else return (_browserDetect.ie <= 8)? tag.toUpperCase() : tag;
	};
}]).factory('taApplyCustomRenderers', ['taCustomRenderers', 'taDOM', function(taCustomRenderers, taDOM){
	return function(val){
		var element = angular.element('<div></div>');
		element[0].innerHTML = val;

		angular.forEach(taCustomRenderers, function(renderer){
			var elements = [];
			// get elements based on what is defined. If both defined do secondary filter in the forEach after using selector string
			if(renderer.selector && renderer.selector !== '')
				elements = element.find(renderer.selector);
			/* istanbul ignore else: shouldn't fire, if it does we're ignoring everything */
			else if(renderer.customAttribute && renderer.customAttribute !== '')
				elements = taDOM.getByAttribute(element, renderer.customAttribute);
			// process elements if any found
			angular.forEach(elements, function(_element){
				_element = angular.element(_element);
				if(renderer.selector && renderer.selector !== '' && renderer.customAttribute && renderer.customAttribute !== ''){
					if(_element.attr(renderer.customAttribute) !== undefined) renderer.renderLogic(_element);
				} else renderer.renderLogic(_element);
			});
		});

		return element[0].innerHTML;
	};
}]).factory('taFixChrome', function(){
	// get whaterever rubbish is inserted in chrome
	// should be passed an html string, returns an html string
	var taFixChrome = function(html){
		if(!html || !angular.isString(html) || html.length <= 0) return html;
		// grab all elements with a style attibute
		var spanMatch = /<([^>\/]+?)style=("([^"]+)"|'([^']+)')([^>]*)>/ig;
		var match, styleVal, newTag, finalHtml = '', lastIndex = 0;
		while(match = spanMatch.exec(html)){
			// one of the quoted values ' or "
			/* istanbul ignore next: quotations match */
			styleVal = match[3] || match[4];
			// test for chrome inserted junk
			if(styleVal && styleVal.match(/line-height: 1.[0-9]{3,12};|color: inherit; line-height: 1.1;/i)){
				// replace original tag with new tag
				styleVal = styleVal.replace(/( |)font-family: inherit;|( |)line-height: 1.[0-9]{3,12};|( |)color: inherit;/ig, '');
				newTag = '<' + match[1].trim();
				if(styleVal.trim().length > 0) newTag += ' style=' + match[2].substring(0,1) + styleVal + match[2].substring(0,1);
				newTag += match[5].trim() + ">";
				finalHtml += html.substring(lastIndex, match.index) + newTag;
				lastIndex = match.index + match[0].length;
			}
		}
		finalHtml += html.substring(lastIndex);
		// only replace when something has changed, else we get focus problems on inserting lists
		if(lastIndex > 0){
			// replace all empty strings
			return finalHtml.replace(/<span\s?>(.*?)<\/span>(<br(\/|)>|)/ig, '$1');
		} else return html;
	};
	return taFixChrome;
}).factory('taSanitize', ['$sanitize', function taSanitizeFactory($sanitize){

	var convert_infos = [
		{
			property: 'font-weight',
			values: [ 'bold' ],
			tag: 'b'
		},
		{
			property: 'font-style',
			values: [ 'italic' ],
			tag: 'i'
		}
	];
	
	var styleMatch = [];
	for(var i = 0; i < convert_infos.length; i++){
		var _partialStyle = '(' + convert_infos[i].property + ':\\s*(';
		for(var j = 0; j < convert_infos[i].values.length; j++){
			/* istanbul ignore next: not needed to be tested yet */
			if(j > 0) _partialStyle += '|';
			_partialStyle += convert_infos[i].values[j];
		}
		_partialStyle += ');)';
		styleMatch.push(_partialStyle);
	}
	var styleRegexString = '(' + styleMatch.join('|') + ')';
	
	function wrapNested(html, wrapTag) {
		var depth = 0;
		var lastIndex = 0;
		var match;
		var tagRegex = /<[^>]*>/ig;
		while(match = tagRegex.exec(html)){
			lastIndex = match.index;
			if(match[0].substr(1, 1) === '/'){
				if(depth === 0) break;
				else depth--;
			}else depth++;
		}
		return wrapTag +
			html.substring(0, lastIndex) +
			// get the start tags reversed - this is safe as we construct the strings with no content except the tags
			angular.element(wrapTag)[0].outerHTML.substring(wrapTag.length) +
			html.substring(lastIndex);
	}
	
	function transformLegacyStyles(html){
		if(!html || !angular.isString(html) || html.length <= 0) return html;
		var i;
		var styleElementMatch = /<([^>\/]+?)style=("([^"]+)"|'([^']+)')([^>]*)>/ig;
		var match, subMatch, styleVal, newTag, lastNewTag = '', newHtml, finalHtml = '', lastIndex = 0;
		while(match = styleElementMatch.exec(html)){
			// one of the quoted values ' or "
			/* istanbul ignore next: quotations match */
			styleVal = match[3] || match[4];
			var styleRegex = new RegExp(styleRegexString, 'i');
			// test for style values to change
			if(angular.isString(styleVal) && styleRegex.test(styleVal)){
				// remove build tag list
				newTag = '';
				// init regex here for exec
				var styleRegexExec = new RegExp(styleRegexString, 'ig');
				// find relevand tags and build a string of them
				while(subMatch = styleRegexExec.exec(styleVal)){
					for(i = 0; i < convert_infos.length; i++){
						if(!!subMatch[(i*2) + 2]){
							newTag += '<' + convert_infos[i].tag + '>';
						}
					}
				}
				// recursively find more legacy styles in html before this tag and after the previous match (if any)
				newHtml = transformLegacyStyles(html.substring(lastIndex, match.index));
				// build up html
				if(lastNewTag.length > 0){
					finalHtml += wrapNested(newHtml, lastNewTag);
				}else finalHtml += newHtml;
				// grab the style val without the transformed values
				styleVal = styleVal.replace(new RegExp(styleRegexString, 'ig'), '');
				// build the html tag
				finalHtml += '<' + match[1].trim();
				if(styleVal.length > 0) finalHtml += ' style="' + styleVal + '"';
				finalHtml += match[5] + '>';
				// update the start index to after this tag
				lastIndex = match.index + match[0].length;
				lastNewTag = newTag;
			}
		}
		if(lastNewTag.length > 0){
			finalHtml += wrapNested(html.substring(lastIndex), lastNewTag);
		}
		else finalHtml += html.substring(lastIndex);
		return finalHtml;
	}
	
	function transformLegacyAttributes(html){
		if(!html || !angular.isString(html) || html.length <= 0) return html;
		// replace all align='...' tags with text-align attributes
		var attrElementMatch = /<([^>\/]+?)align=("([^"]+)"|'([^']+)')([^>]*)>/ig;
		var match, finalHtml = '', lastIndex = 0;
		// match all attr tags
		while(match = attrElementMatch.exec(html)){
			// add all html before this tag
			finalHtml += html.substring(lastIndex, match.index);
			// record last index after this tag
			lastIndex = match.index + match[0].length;
			// construct tag without the align attribute
			var newTag = '<' + match[1] + match[5];
			// add the style attribute
			if(/style=("([^"]+)"|'([^']+)')/ig.test(newTag)){
				/* istanbul ignore next: quotations match */
				newTag = newTag.replace(/style=("([^"]+)"|'([^']+)')/i, 'style="$2$3 text-align:' + (match[3] || match[4]) + ';"');
			}else{
				/* istanbul ignore next: quotations match */
				newTag += ' style="text-align:' + (match[3] || match[4]) + ';"';
			}
			newTag += '>';
			// add to html
			finalHtml += newTag;
		}
		// return with remaining html
		return finalHtml + html.substring(lastIndex);
	}
	
	return function taSanitize(unsafe, oldsafe, ignore){
		// unsafe html should NEVER built into a DOM object via angular.element. This allows XSS to be inserted and run.
		if ( !ignore ) {
			try {
				unsafe = transformLegacyStyles(unsafe);
			} catch (e) {
			}
		}

		// unsafe and oldsafe should be valid HTML strings
		// any exceptions (lets say, color for example) should be made here but with great care
		// setup unsafe element for modification
		unsafe = transformLegacyAttributes(unsafe);
		
		var safe;
		try {
			safe = $sanitize(unsafe);
			// do this afterwards, then the $sanitizer should still throw for bad markup
			if(ignore) safe = unsafe;
		} catch (e){
			safe = oldsafe || '';
		}
		
		// Do processing for <pre> tags, removing tabs and return carriages outside of them
		
		var _preTags = safe.match(/(<pre[^>]*>.*?<\/pre[^>]*>)/ig);
		var processedSafe = safe.replace(/(&#(9|10);)*/ig, '');
		var re = /<pre[^>]*>.*?<\/pre[^>]*>/ig;
		var index = 0;
		var lastIndex = 0;
		var origTag;
		safe = '';
		while((origTag = re.exec(processedSafe)) !== null && index < _preTags.length){
			safe += processedSafe.substring(lastIndex, origTag.index) + _preTags[index];
			lastIndex = origTag.index + origTag[0].length;
			index++;
		}
		return safe + processedSafe.substring(lastIndex);
	};
}]).factory('taToolExecuteAction', ['$q', '$log', function($q, $log){
	// this must be called on a toolScope or instance
	return function(editor){
		if(editor !== undefined) this.$editor = function(){ return editor; };
		var deferred = $q.defer(),
			promise = deferred.promise,
			_editor = this.$editor();
		// pass into the action the deferred function and also the function to reload the current selection if rangy available
		var result;
		try{
			result = this.action(deferred, _editor.startAction());
			// We set the .finally callback here to make sure it doesn't get executed before any other .then callback.
			promise['finally'](function(){
				_editor.endAction.call(_editor);
			});
		}catch(exc){
			$log.error(exc);
		}
		if(result || result === undefined){
			// if true or undefined is returned then the action has finished. Otherwise the deferred action will be resolved manually.
			deferred.resolve();
		}
	};
}]);
angular.module('textAngular.DOM', ['textAngular.factories'])
.factory('taExecCommand', ['taSelection', 'taBrowserTag', '$document', function(taSelection, taBrowserTag, $document){
	var listToDefault = function(listElement, defaultWrap){
		var $target, i;
		// if all selected then we should remove the list
		// grab all li elements and convert to taDefaultWrap tags
		var children = listElement.find('li');
		for(i = children.length - 1; i >= 0; i--){
			$target = angular.element('<' + defaultWrap + '>' + children[i].innerHTML + '</' + defaultWrap + '>');
			listElement.after($target);
		}
		listElement.remove();
		taSelection.setSelectionToElementEnd($target[0]);
	};
	var selectLi = function(liElement){
		if(/(<br(|\/)>)$/i.test(liElement.innerHTML.trim())) taSelection.setSelectionBeforeElement(angular.element(liElement).find("br")[0]);
		else taSelection.setSelectionToElementEnd(liElement);
	};
	var listToList = function(listElement, newListTag){
		var $target = angular.element('<' + newListTag + '>' + listElement[0].innerHTML + '</' + newListTag + '>');
		listElement.after($target);
		listElement.remove();
		selectLi($target.find('li')[0]);
	};
	var childElementsToList = function(elements, listElement, newListTag){
		var html = '';
		for(var i = 0; i < elements.length; i++){
			html += '<' + taBrowserTag('li') + '>' + elements[i].innerHTML + '</' + taBrowserTag('li') + '>';
		}
		var $target = angular.element('<' + newListTag + '>' + html + '</' + newListTag + '>');
		listElement.after($target);
		listElement.remove();
		selectLi($target.find('li')[0]);
	};
	return function(taDefaultWrap, topNode){
		taDefaultWrap = taBrowserTag(taDefaultWrap);
		return function(command, showUI, options, defaultTagAttributes){
			var i, $target, html, _nodes, next, optionsTagName, selectedElement;
			var defaultWrapper = angular.element('<' + taDefaultWrap + '>');
			try{
				selectedElement = taSelection.getSelectionElement();
			}catch(e){}
			var $selected = angular.element(selectedElement);
			if(selectedElement !== undefined){
				var tagName = selectedElement.tagName.toLowerCase();
				if(command.toLowerCase() === 'insertorderedlist' || command.toLowerCase() === 'insertunorderedlist'){
					var selfTag = taBrowserTag((command.toLowerCase() === 'insertorderedlist')? 'ol' : 'ul');
					if(tagName === selfTag){
						// if all selected then we should remove the list
						// grab all li elements and convert to taDefaultWrap tags
						return listToDefault($selected, taDefaultWrap);
					}else if(tagName === 'li' && $selected.parent()[0].tagName.toLowerCase() === selfTag && $selected.parent().children().length === 1){
						// catch for the previous statement if only one li exists
						return listToDefault($selected.parent(), taDefaultWrap);
					}else if(tagName === 'li' && $selected.parent()[0].tagName.toLowerCase() !== selfTag && $selected.parent().children().length === 1){
						// catch for the previous statement if only one li exists
						return listToList($selected.parent(), selfTag);
					}else if(tagName.match(BLOCKELEMENTS) && !$selected.hasClass('ta-bind')){
						// if it's one of those block elements we have to change the contents
						// if it's a ol/ul we are changing from one to the other
						if(tagName === 'ol' || tagName === 'ul'){
							return listToList($selected, selfTag);
						}else{
							var childBlockElements = false;
							angular.forEach($selected.children(), function(elem){
								if(elem.tagName.match(BLOCKELEMENTS)) {
									childBlockElements = true;
								}
							});
							if(childBlockElements){
								return childElementsToList($selected.children(), $selected, selfTag);
							}else{
								return childElementsToList([angular.element('<div>' + selectedElement.innerHTML + '</div>')[0]], $selected, selfTag);
							}
						}
					}else if(tagName.match(BLOCKELEMENTS)){
						// if we get here then all the contents of the ta-bind are selected
						_nodes = taSelection.getOnlySelectedElements();
						if(_nodes.length === 0){
							// here is if there is only text in ta-bind ie <div ta-bind>test content</div>
							$target = angular.element('<' + selfTag + '><li>' + selectedElement.innerHTML + '</li></' + selfTag + '>');
							$selected.html('');
							$selected.append($target);
						}else if(_nodes.length === 1 && (_nodes[0].tagName.toLowerCase() === 'ol' || _nodes[0].tagName.toLowerCase() === 'ul')){
							if(_nodes[0].tagName.toLowerCase() === selfTag){
								// remove
								return listToDefault(angular.element(_nodes[0]), taDefaultWrap);
							}else{
								return listToList(angular.element(_nodes[0]), selfTag);
							}
						}else{
							html = '';
							var $nodes = [];
							for(i = 0; i < _nodes.length; i++){
								/* istanbul ignore else: catch for real-world can't make it occur in testing */
								if(_nodes[i].nodeType !== 3){
									var $n = angular.element(_nodes[i]);
									/* istanbul ignore if: browser check only, phantomjs doesn't return children nodes but chrome at least does */
									if(_nodes[i].tagName.toLowerCase() === 'li') continue;
									else if(_nodes[i].tagName.toLowerCase() === 'ol' || _nodes[i].tagName.toLowerCase() === 'ul'){
										html += $n[0].innerHTML; // if it's a list, add all it's children
									}else if(_nodes[i].tagName.toLowerCase() === 'span' && (_nodes[i].childNodes[0].tagName.toLowerCase() === 'ol' || _nodes[i].childNodes[0].tagName.toLowerCase() === 'ul')){
										html += $n[0].childNodes[0].innerHTML; // if it's a list, add all it's children
									}else{
										html += '<' + taBrowserTag('li') + '>' + $n[0].innerHTML + '</' + taBrowserTag('li') + '>';
									}
									$nodes.unshift($n);
								}
							}
							$target = angular.element('<' + selfTag + '>' + html + '</' + selfTag + '>');
							$nodes.pop().replaceWith($target);
							angular.forEach($nodes, function($node){ $node.remove(); });
						}
						taSelection.setSelectionToElementEnd($target[0]);
						return;
					}
				}else if(command.toLowerCase() === 'formatblock'){
					optionsTagName = options.toLowerCase().replace(/[<>]/ig, '');
					if(optionsTagName.trim() === 'default') {
						optionsTagName = taDefaultWrap;
						options = '<' + taDefaultWrap + '>';
					}
					if(tagName === 'li') $target = $selected.parent();
					else $target = $selected;
					// find the first blockElement
					while(!$target[0].tagName || !$target[0].tagName.match(BLOCKELEMENTS) && !$target.parent().attr('contenteditable')){
						$target = $target.parent();
						/* istanbul ignore next */
						tagName = ($target[0].tagName || '').toLowerCase();
					}
					if(tagName === optionsTagName){
						// $target is wrap element
						_nodes = $target.children();
						var hasBlock = false;
						for(i = 0; i < _nodes.length; i++){
							hasBlock = hasBlock || _nodes[i].tagName.match(BLOCKELEMENTS);
						}
						if(hasBlock){
							$target.after(_nodes);
							next = $target.next();
							$target.remove();
							$target = next;
						}else{
							defaultWrapper.append($target[0].childNodes);
							$target.after(defaultWrapper);
							$target.remove();
							$target = defaultWrapper;
						}
					}else if($target.parent()[0].tagName.toLowerCase() === optionsTagName && !$target.parent().hasClass('ta-bind')){
						//unwrap logic for parent
						var blockElement = $target.parent();
						var contents = blockElement.contents();
						for(i = 0; i < contents.length; i ++){
							/* istanbul ignore next: can't test - some wierd thing with how phantomjs works */
							if(blockElement.parent().hasClass('ta-bind') && contents[i].nodeType === 3){
								defaultWrapper = angular.element('<' + taDefaultWrap + '>');
								defaultWrapper[0].innerHTML = contents[i].outerHTML;
								contents[i] = defaultWrapper[0];
							}
							blockElement.parent()[0].insertBefore(contents[i], blockElement[0]);
						}
						blockElement.remove();
					}else if(tagName.match(LISTELEMENTS)){
						// wrapping a list element
						$target.wrap(options);
					}else{
						// default wrap behaviour
						_nodes = taSelection.getOnlySelectedElements();
						if(_nodes.length === 0) _nodes = [$target[0]];
						// find the parent block element if any of the nodes are inline or text
						for(i = 0; i < _nodes.length; i++){
							if(_nodes[i].nodeType === 3 || !_nodes[i].tagName.match(BLOCKELEMENTS)){
								while(_nodes[i].nodeType === 3 || !_nodes[i].tagName || !_nodes[i].tagName.match(BLOCKELEMENTS)){
									_nodes[i] = _nodes[i].parentNode;
								}
							}
						}
						if(angular.element(_nodes[0]).hasClass('ta-bind')){
							$target = angular.element(options);
							$target[0].innerHTML = _nodes[0].innerHTML;
							_nodes[0].innerHTML = $target[0].outerHTML;
						}else if(optionsTagName === 'blockquote'){
							// blockquotes wrap other block elements
							html = '';
							for(i = 0; i < _nodes.length; i++){
								html += _nodes[i].outerHTML;
							}
							$target = angular.element(options);
							$target[0].innerHTML = html;
							_nodes[0].parentNode.insertBefore($target[0],_nodes[0]);
							for(i = _nodes.length - 1; i >= 0; i--){
								/* istanbul ignore else:  */
								if(_nodes[i].parentNode) _nodes[i].parentNode.removeChild(_nodes[i]);
							}
						}
						else {
							// regular block elements replace other block elements
							for(i = 0; i < _nodes.length; i++){
								$target = angular.element(options);
								$target[0].innerHTML = _nodes[i].innerHTML;
								_nodes[i].parentNode.insertBefore($target[0],_nodes[i]);
								_nodes[i].parentNode.removeChild(_nodes[i]);
							}
						}
					}
					taSelection.setSelectionToElementEnd($target[0]);
					return;
				}else if(command.toLowerCase() === 'createlink'){
					var tagBegin = '<a href="' + options + '" target="_blank"' + '>',
						tagEnd = '</a>',
						_selection = taSelection.getSelection();
					if(_selection.collapsed){
						// insert text at selection, then select then just let normal exec-command run
						taSelection.insertHtml(tagBegin + options + tagEnd, topNode);
					}else if(rangy.getSelection().getRangeAt(0).canSurroundContents()){
						var node = angular.element(tagBegin + tagEnd)[0];
						rangy.getSelection().getRangeAt(0).surroundContents(node);
					}
					return;
				}else if(command.toLowerCase() === 'inserthtml'){
					taSelection.insertHtml(options, topNode);
					return;
				}
			}
			try{
				$document[0].execCommand(command, showUI, options);
			}catch(e){}
		};
	};
}]).service('taSelection', ['$document', 'taDOM',
/* istanbul ignore next: all browser specifics and PhantomJS dosen't seem to support half of it */
function($document, taDOM){
	// need to dereference the document else the calls don't work correctly
	var _document = $document[0];
	var brException = function (element, offset) {
		/* check if selection is a BR element at the beginning of a container. If so, get
		* the parentNode instead.
		* offset should be zero in this case. Otherwise, return the original
		* element.
		*/
		if (element.tagName && element.tagName.match(/^br$/i) && offset === 0 && !element.previousSibling) {
            return {
                element: element.parentNode,
                offset: 0
            };
		} else {
			return {
				element: element,
				offset: offset
			};
		}
	};
	var api = {
		getSelection: function(){
			var range = rangy.getSelection().getRangeAt(0);
			var container = range.commonAncestorContainer;
			var selection = {
				start: brException(range.startContainer, range.startOffset),
				end: brException(range.endContainer, range.endOffset),
				collapsed: range.collapsed
			};
			// Check if the container is a text node and return its parent if so
			container = container.nodeType === 3 ? container.parentNode : container;
			if (container.parentNode === selection.start.element ||
				container.parentNode === selection.end.element) {
				selection.container = container.parentNode;
			} else {
				selection.container = container;
			}
			return selection;
		},
		getOnlySelectedElements: function(){
			var range = rangy.getSelection().getRangeAt(0);
			var container = range.commonAncestorContainer;
			// Check if the container is a text node and return its parent if so
			container = container.nodeType === 3 ? container.parentNode : container;
			return range.getNodes([1], function(node){
				return node.parentNode === container;
			});
		},
		// Some basic selection functions
		getSelectionElement: function () {
			return api.getSelection().container;
		},
		setSelection: function(el, start, end){
			var range = rangy.createRange();
			
			range.setStart(el, start);
			range.setEnd(el, end);
			
			rangy.getSelection().setSingleRange(range);
		},
		setSelectionBeforeElement: function (el){
			var range = rangy.createRange();
			
			range.selectNode(el);
			range.collapse(true);
			
			rangy.getSelection().setSingleRange(range);
		},
		setSelectionAfterElement: function (el){
			var range = rangy.createRange();
			
			range.selectNode(el);
			range.collapse(false);
			
			rangy.getSelection().setSingleRange(range);
		},
		setSelectionToElementStart: function (el){
			var range = rangy.createRange();
			
			range.selectNodeContents(el);
			range.collapse(true);
			
			rangy.getSelection().setSingleRange(range);
		},
		setSelectionToElementEnd: function (el){
			var range = rangy.createRange();
			
			range.selectNodeContents(el);
			range.collapse(false);
			if(el.childNodes && el.childNodes[el.childNodes.length - 1] && el.childNodes[el.childNodes.length - 1].nodeName === 'br'){
				range.startOffset = range.endOffset = range.startOffset - 1;
			}
			rangy.getSelection().setSingleRange(range);
		},
		// from http://stackoverflow.com/questions/6690752/insert-html-at-caret-in-a-contenteditable-div
		// topNode is the contenteditable normally, all manipulation MUST be inside this.
		insertHtml: function(html, topNode){
			var parent, secondParent, _childI, nodes, i, lastNode, _tempFrag;
			var element = angular.element("<div>" + html + "</div>");
			var range = rangy.getSelection().getRangeAt(0);
			var frag = _document.createDocumentFragment();
			var children = element[0].childNodes;
			var isInline = true;
			
			if(children.length > 0){
				// NOTE!! We need to do the following:
				// check for blockelements - if they exist then we have to split the current element in half (and all others up to the closest block element) and insert all children in-between.
				// If there are no block elements, or there is a mixture we need to create textNodes for the non wrapped text (we don't want them spans messing up the picture).
				nodes = [];
				for(_childI = 0; _childI < children.length; _childI++){
					if(!(
						(children[_childI].nodeName.toLowerCase() === 'p' && children[_childI].innerHTML.trim() === '') || // empty p element
						(children[_childI].nodeType === 3 && children[_childI].nodeValue.trim() === '') // empty text node
					)){
						isInline = isInline && !BLOCKELEMENTS.test(children[_childI].nodeName);
						nodes.push(children[_childI]);
					}
				}
				for(var _n = 0; _n < nodes.length; _n++) lastNode = frag.appendChild(nodes[_n]);
				if(!isInline && range.collapsed && /^(|<br(|\/)>)$/i.test(range.startContainer.innerHTML)) range.selectNode(range.startContainer);
			}else{
				isInline = true;
				// paste text of some sort
				lastNode = frag = _document.createTextNode(html);
			}
			
			// Other Edge case - selected data spans multiple blocks.
			if(isInline){
				range.deleteContents();
			}else{ // not inline insert
				if(range.collapsed && range.startContainer !== topNode){
					if(range.startContainer.innerHTML && range.startContainer.innerHTML.match(/^<[^>]*>$/i)){
						// this log is to catch when innerHTML is something like `<img ...>`
						parent = range.startContainer;
						if(range.startOffset === 1){
							// before single tag
							range.setStartAfter(parent);
							range.setEndAfter(parent);
						}else{
							// after single tag
							range.setStartBefore(parent);
							range.setEndBefore(parent);
						}
					}else{
						// split element into 2 and insert block element in middle
						if(range.startContainer.nodeType === 3 && range.startContainer.parentNode !== topNode){ // if text node
							parent = range.startContainer.parentNode;
							secondParent = parent.cloneNode();
							// split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
							taDOM.splitNodes(parent.childNodes, parent, secondParent, range.startContainer, range.startOffset);
							
							// Escape out of the inline tags like b
							while(!VALIDELEMENTS.test(parent.nodeName)){
								angular.element(parent).after(secondParent);
								parent = parent.parentNode;
								var _lastSecondParent = secondParent;
								secondParent = parent.cloneNode();
								// split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
								taDOM.splitNodes(parent.childNodes, parent, secondParent, _lastSecondParent);
							}
						}else{
							parent = range.startContainer;
							secondParent = parent.cloneNode();
							taDOM.splitNodes(parent.childNodes, parent, secondParent, undefined, undefined, range.startOffset);
						}
						
						angular.element(parent).after(secondParent);
						// put cursor to end of inserted content
						range.setStartAfter(parent);
						range.setEndAfter(parent);
						
						if(/^(|<br(|\/)>)$/i.test(parent.innerHTML.trim())){
							range.setStartBefore(parent);
							range.setEndBefore(parent);
							angular.element(parent).remove();
						}
						if(/^(|<br(|\/)>)$/i.test(secondParent.innerHTML.trim())) angular.element(secondParent).remove();
						if(parent.nodeName.toLowerCase() === 'li'){
							_tempFrag = _document.createDocumentFragment();
							for(i = 0; i < frag.childNodes.length; i++){
								element = angular.element('<li>');
								taDOM.transferChildNodes(frag.childNodes[i], element[0]);
								taDOM.transferNodeAttributes(frag.childNodes[i], element[0]);
								_tempFrag.appendChild(element[0]);
							}
							frag = _tempFrag;
							if(lastNode){
								lastNode = frag.childNodes[frag.childNodes.length - 1];
								lastNode = lastNode.childNodes[lastNode.childNodes.length - 1];
							}
						}
					}
				}else{
					range.deleteContents();
				}
			}
			
			range.insertNode(frag);
			if(lastNode){
				api.setSelectionToElementEnd(lastNode);
			}
		}
	};
	return api;
}]).service('taDOM', function(){
	var taDOM = {
		// recursive function that returns an array of angular.elements that have the passed attribute set on them
		getByAttribute: function(element, attribute){
			var resultingElements = [];
			var childNodes = element.children();
			if(childNodes.length){
				angular.forEach(childNodes, function(child){
					resultingElements = resultingElements.concat(taDOM.getByAttribute(angular.element(child), attribute));
				});
			}
			if(element.attr(attribute) !== undefined) resultingElements.push(element);
			return resultingElements;
		},
		
		transferChildNodes: function(source, target){
			// clear out target
			target.innerHTML = '';
			while(source.childNodes.length > 0) target.appendChild(source.childNodes[0]);
			return target;
		},
		
		splitNodes: function(nodes, target1, target2, splitNode, subSplitIndex, splitIndex){
			if(!splitNode && isNaN(splitIndex)) throw new Error('taDOM.splitNodes requires a splitNode or splitIndex');
			var startNodes = document.createDocumentFragment();
			var endNodes = document.createDocumentFragment();
			var index = 0;
			
			while(nodes.length > 0 && (isNaN(splitIndex) || splitIndex !== index) && nodes[0] !== splitNode){
				startNodes.appendChild(nodes[0]); // this removes from the nodes array (if proper childNodes object.
				index++;
			}
			
			if(!isNaN(subSplitIndex) && subSplitIndex >= 0 && nodes[0]){
				startNodes.appendChild(document.createTextNode(nodes[0].nodeValue.substring(0, subSplitIndex)));
				nodes[0].nodeValue = nodes[0].nodeValue.substring(subSplitIndex);
			}
			while(nodes.length > 0) endNodes.appendChild(nodes[0]);
			
			taDOM.transferChildNodes(startNodes, target1);
			taDOM.transferChildNodes(endNodes, target2);
		},
		
		transferNodeAttributes: function(source, target){
			for(var i = 0; i < source.attributes.length; i++) target.setAttribute(source.attributes[i].name, source.attributes[i].value);
			return target;
		}
	};
	return taDOM;
});
angular.module('textAngular.validators', [])
.directive('taMaxText', function(){
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, elem, attrs, ctrl){
			var max = parseInt(scope.$eval(attrs.taMaxText));
			if (isNaN(max)){
				throw('Max text must be an integer');
			}
			attrs.$observe('taMaxText', function(value){
				max = parseInt(value);
				if (isNaN(max)){
					throw('Max text must be an integer');
				}
				if (ctrl.$dirty){
					ctrl.$validate();
				}
			});
			ctrl.$validators.taMaxText = function(viewValue){
				var source = angular.element('<div/>');
				source.html(viewValue);
				return source.text().length <= max;
			};
		}
	};
}).directive('taMinText', function(){
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, elem, attrs, ctrl){
			var min = parseInt(scope.$eval(attrs.taMinText));
			if (isNaN(min)){
				throw('Min text must be an integer');
			}
			attrs.$observe('taMinText', function(value){
				min = parseInt(value);
				if (isNaN(min)){
					throw('Min text must be an integer');
				}
				if (ctrl.$dirty){
					ctrl.$validate();
				}
			});
			ctrl.$validators.taMinText = function(viewValue){
				var source = angular.element('<div/>');
				source.html(viewValue);
				return !source.text().length || source.text().length >= min;
			};
		}
	};
});
angular.module('textAngular.taBind', ['textAngular.factories', 'textAngular.DOM'])
.service('_taBlankTest', [function(){
	var INLINETAGS_NONBLANK = /<(a|abbr|acronym|bdi|bdo|big|cite|code|del|dfn|img|ins|kbd|label|map|mark|q|ruby|rp|rt|s|samp|time|tt|var)[^>]*(>|$)/i;
	return function(_defaultTest){
		return function(_blankVal){
			if(!_blankVal) return true;
			// find first non-tag match - ie start of string or after tag that is not whitespace
			var _firstMatch = /(^[^<]|>)[^<]/i.exec(_blankVal);
			var _firstTagIndex;
			if(!_firstMatch){
				// find the end of the first tag removing all the
				// Don't do a global replace as that would be waaayy too long, just replace the first 4 occurences should be enough
				_blankVal = _blankVal.toString().replace(/="[^"]*"/i, '').replace(/="[^"]*"/i, '').replace(/="[^"]*"/i, '').replace(/="[^"]*"/i, '');
				_firstTagIndex = _blankVal.indexOf('>');
			}else{
				_firstTagIndex = _firstMatch.index;
			}
			_blankVal = _blankVal.trim().substring(_firstTagIndex, _firstTagIndex + 100);
			// check for no tags entry
			if(/^[^<>]+$/i.test(_blankVal)) return false;
			// this regex is to match any number of whitespace only between two tags
			if (_blankVal.length === 0 || _blankVal === _defaultTest || /^>(\s|&nbsp;)*<\/[^>]+>$/ig.test(_blankVal)) return true;
			// this regex tests if there is a tag followed by some optional whitespace and some text after that
			else if (/>\s*[^\s<]/i.test(_blankVal) || INLINETAGS_NONBLANK.test(_blankVal)) return false;
			else return true;
		};
	};
}])
.directive('taButton', [function(){
	return {
		link: function(scope, element, attrs){
			element.attr('unselectable', 'on');
			element.on('mousedown', function(e, eventData){
				/* istanbul ignore else: this is for catching the jqLite testing*/
				if(eventData) angular.extend(e, eventData);
				// this prevents focusout from firing on the editor when clicking toolbar buttons
				e.preventDefault();
				return false;
			});
		}
	};
}])
.directive('taBind', [
		'taSanitize', '$timeout', '$document', 'taFixChrome', 'taBrowserTag',
		'taSelection', 'taSelectableElements', 'taApplyCustomRenderers', 'taOptions',
		'_taBlankTest', '$parse', 'taDOM', 'textAngularManager',
		function(
			taSanitize, $timeout, $document, taFixChrome, taBrowserTag,
			taSelection, taSelectableElements, taApplyCustomRenderers, taOptions,
			_taBlankTest, $parse, taDOM, textAngularManager){
	// Uses for this are textarea or input with ng-model and ta-bind='text'
	// OR any non-form element with contenteditable="contenteditable" ta-bind="html|text" ng-model
	return {
		priority: 2, // So we override validators correctly
		require: ['ngModel','?ngModelOptions'],
		link: function(scope, element, attrs, controller){
			var ngModel = controller[0];
			var ngModelOptions = controller[1] || {};
			// the option to use taBind on an input or textarea is required as it will sanitize all input into it correctly.
			var _isContentEditable = element.attr('contenteditable') !== undefined && element.attr('contenteditable');
			var _isInputFriendly = _isContentEditable || element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input';
			var _isReadonly = false;
			var _focussed = false;
			var _skipRender = false;
			var _disableSanitizer = attrs.taUnsafeSanitizer || taOptions.disableSanitizer;
			var _lastKey;
			// see http://www.javascripter.net/faq/keycodes.htm for good information
			// NOTE Mute On|Off 173 (Opera MSIE Safari Chrome) 181 (Firefox)
			// BLOCKED_KEYS are special keys...
			// Tab, pause/break, CapsLock, Esc, Page Up, End, Home,
			// Left arrow, Up arrow, Right arrow, Down arrow, Insert, Delete,
			// f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12
			// NumLock, ScrollLock
			var BLOCKED_KEYS = /^(9|19|20|27|33|34|35|36|37|38|39|40|45|112|113|114|115|116|117|118|119|120|121|122|123|144|145)$/i;
			// UNDO_TRIGGER_KEYS - spaces, enter, delete, backspace, all punctuation
			// Backspace, Enter, Space, Delete, (; :) (Firefox), (= +) (Firefox),
			// Numpad +, Numpad -, (; :), (= +),
			// (, <), (- _), (. >), (/ ?), (` ~), ([ {), (\ |), (] }), (' ")
			// NOTE - Firefox: 173 = (- _) -- adding this to UNDO_TRIGGER_KEYS
			var UNDO_TRIGGER_KEYS = /^(8|13|32|46|59|61|107|109|173|186|187|188|189|190|191|192|219|220|221|222)$/i;
			var _pasteHandler;

			// defaults to the paragraph element, but we need the line-break or it doesn't allow you to type into the empty element
			// non IE is '<p><br/></p>', ie is '<p></p>' as for once IE gets it correct...
			var _defaultVal, _defaultTest;

			var _CTRL_KEY = 0x0001;
			var _META_KEY = 0x0002;
			var _ALT_KEY = 0x0004;
			var _SHIFT_KEY = 0x0008;
			// map events to special keys...
			// mappings is an array of maps from events to specialKeys as declared in textAngularSetup
			var _keyMappings = [
				//		ctrl/command + z
				{
					specialKey: 'UndoKey',
					forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
					mustHaveModifiers: [_META_KEY + _CTRL_KEY],
					keyCode: 90
				},
				//		ctrl/command + shift + z
				{
					specialKey: 'RedoKey',
					forbiddenModifiers: _ALT_KEY,
					mustHaveModifiers: [_META_KEY + _CTRL_KEY, _SHIFT_KEY],
					keyCode: 90
				},
				//		ctrl/command + y
				{
					specialKey: 'RedoKey',
					forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
					mustHaveModifiers: [_META_KEY + _CTRL_KEY],
					keyCode: 89
				},
				//		TabKey
				{
					specialKey: 'TabKey',
					forbiddenModifiers: _META_KEY + _SHIFT_KEY + _ALT_KEY + _CTRL_KEY,
					mustHaveModifiers: [],
					keyCode: 9
				},
				//		shift + TabKey
				{
					specialKey: 'ShiftTabKey',
					forbiddenModifiers: _META_KEY + _ALT_KEY + _CTRL_KEY,
					mustHaveModifiers: [_SHIFT_KEY],
					keyCode: 9
				}
			];
			function _mapKeys(event) {
				var specialKey;
				_keyMappings.forEach(function (map){
					if (map.keyCode === event.keyCode) {
						var netModifiers = (event.metaKey ? _META_KEY: 0) +
							(event.ctrlKey ? _CTRL_KEY: 0) +
							(event.shiftKey ? _SHIFT_KEY: 0) +
							(event.altKey ? _ALT_KEY: 0);
						if (map.forbiddenModifiers & netModifiers) return;
						if (map.mustHaveModifiers.every(function (modifier) { return netModifiers & modifier; })){
							specialKey = map.specialKey;
						}
					}
				});
				return specialKey;
			}

			// set the default to be a paragraph value
			if(attrs.taDefaultWrap === undefined) attrs.taDefaultWrap = 'p';
			/* istanbul ignore next: ie specific test */
			if(attrs.taDefaultWrap === ''){
				_defaultVal = '';
				_defaultTest = (_browserDetect.ie === undefined)? '<div><br></div>' : (_browserDetect.ie >= 11)? '<p><br></p>' : (_browserDetect.ie <= 8)? '<P>&nbsp;</P>' : '<p>&nbsp;</p>';
			}else{
				_defaultVal = (_browserDetect.ie === undefined || _browserDetect.ie >= 11)?
					'<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>' :
					(_browserDetect.ie <= 8)?
						'<' + attrs.taDefaultWrap.toUpperCase() + '></' + attrs.taDefaultWrap.toUpperCase() + '>' :
						'<' + attrs.taDefaultWrap + '></' + attrs.taDefaultWrap + '>';
				_defaultTest = (_browserDetect.ie === undefined || _browserDetect.ie >= 11)?
					'<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>' :
					(_browserDetect.ie <= 8)?
						'<' + attrs.taDefaultWrap.toUpperCase() + '>&nbsp;</' + attrs.taDefaultWrap.toUpperCase() + '>' :
						'<' + attrs.taDefaultWrap + '>&nbsp;</' + attrs.taDefaultWrap + '>';
			}

			/* istanbul ignore else */
			if(!ngModelOptions.$options) ngModelOptions.$options = {}; // ng-model-options support

			var _blankTest = _taBlankTest(_defaultTest);

			var _ensureContentWrapped = function(value) {
				if (_blankTest(value)) return value;
				var domTest = angular.element("<div>" + value + "</div>");
				//console.log('domTest.children().length():', domTest.children().length);
				if (domTest.children().length === 0) {
					value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
				} else {
					var _children = domTest[0].childNodes;
					var i;
					var _foundBlockElement = false;
					for (i = 0; i < _children.length; i++) {
						if (_foundBlockElement = _children[i].nodeName.toLowerCase().match(BLOCKELEMENTS)) break;
					}
					if (!_foundBlockElement) {
						value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
					}
					else{
						value = "";
						for(i = 0; i < _children.length; i++){
							var node = _children[i];
							var nodeName = node.nodeName.toLowerCase();
							//console.log(nodeName);
							if(nodeName === '#comment') {
								value += '<!--' + node.nodeValue + '-->';
							} else if(nodeName === '#text') {
								// determine if this is all whitespace, if so, we will leave it as it is.
								// otherwise, we will wrap it as it is
								var text = node.textContent;
								if (!text.trim()) {
									// just whitespace
									value += text;
								} else {
									// not pure white space so wrap in <p>...</p> or whatever attrs.taDefaultWrap is set to.
									value += "<" + attrs.taDefaultWrap + ">" + text + "</" + attrs.taDefaultWrap + ">";
								}
							} else if(!nodeName.match(BLOCKELEMENTS)){
								/* istanbul ignore  next: Doesn't seem to trigger on tests */
								var _subVal = (node.outerHTML || node.nodeValue);
								/* istanbul ignore else: Doesn't seem to trigger on tests, is tested though */
								if(_subVal.trim() !== '')
									value += "<" + attrs.taDefaultWrap + ">" + _subVal + "</" + attrs.taDefaultWrap + ">";
								else value += _subVal;
							} else {
								value += node.outerHTML;
							}
						}
					}
				}
				//console.log(value);
				return value;
			};

			if(attrs.taPaste) _pasteHandler = $parse(attrs.taPaste);

			element.addClass('ta-bind');

			var _undoKeyupTimeout;

			scope['$undoManager' + (attrs.id || '')] = ngModel.$undoManager = {
				_stack: [],
				_index: 0,
				_max: 1000,
				push: function(value){
					if((typeof value === "undefined" || value === null) ||
						((typeof this.current() !== "undefined" && this.current() !== null) && value === this.current())) return value;
					if(this._index < this._stack.length - 1){
						this._stack = this._stack.slice(0,this._index+1);
					}
					this._stack.push(value);
					if(_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
					if(this._stack.length > this._max) this._stack.shift();
					this._index = this._stack.length - 1;
					return value;
				},
				undo: function(){
					return this.setToIndex(this._index-1);
				},
				redo: function(){
					return this.setToIndex(this._index+1);
				},
				setToIndex: function(index){
					if(index < 0 || index > this._stack.length - 1){
						return undefined;
					}
					this._index = index;
					return this.current();
				},
				current: function(){
					return this._stack[this._index];
				}
			};

			var _redoUndoTimeout;
			var _undo = scope['$undoTaBind' + (attrs.id || '')] = function(){
				/* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
				if(!_isReadonly && _isContentEditable){
					var content = ngModel.$undoManager.undo();
					if(typeof content !== "undefined" && content !== null){
						_setInnerHTML(content);
						_setViewValue(content, false);
						if(_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
						_redoUndoTimeout = $timeout(function(){
							element[0].focus();
							taSelection.setSelectionToElementEnd(element[0]);
						}, 1);
					}
				}
			};

			var _redo = scope['$redoTaBind' + (attrs.id || '')] = function(){
				/* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
				if(!_isReadonly && _isContentEditable){
					var content = ngModel.$undoManager.redo();
					if(typeof content !== "undefined" && content !== null){
						_setInnerHTML(content);
						_setViewValue(content, false);
						/* istanbul ignore next */
						if(_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
						_redoUndoTimeout = $timeout(function(){
							element[0].focus();
							taSelection.setSelectionToElementEnd(element[0]);
						}, 1);
					}
				}
			};

			// in here we are undoing the converts used elsewhere to prevent the < > and & being displayed when they shouldn't in the code.
			var _compileHtml = function(){
				if(_isContentEditable) return element[0].innerHTML;
				if(_isInputFriendly) return element.val();
				throw ('textAngular Error: attempting to update non-editable taBind');
			};

			var _setViewValue = function(_val, triggerUndo, skipRender){
				_skipRender = skipRender || false;
				if(typeof triggerUndo === "undefined" || triggerUndo === null) triggerUndo = true && _isContentEditable; // if not contentEditable then the native undo/redo is fine
				if(typeof _val === "undefined" || _val === null) _val = _compileHtml();
				if(_blankTest(_val)){
					// this avoids us from tripping the ng-pristine flag if we click in and out with out typing
					if(ngModel.$viewValue !== '') ngModel.$setViewValue('');
					if(triggerUndo && ngModel.$undoManager.current() !== '') ngModel.$undoManager.push('');
				}else{
					_reApplyOnSelectorHandlers();
					if(ngModel.$viewValue !== _val){
						ngModel.$setViewValue(_val);
						if(triggerUndo) ngModel.$undoManager.push(_val);
					}
				}
				ngModel.$render();
			};

			//used for updating when inserting wrapped elements
			scope['updateTaBind' + (attrs.id || '')] = function(){
				if(!_isReadonly) _setViewValue(undefined, undefined, true);
			};

			// catch DOM XSS via taSanitize
			// Sanitizing both ways is identical
			var _sanitize = function(unsafe){
				return (ngModel.$oldViewValue = taSanitize(taFixChrome(unsafe), ngModel.$oldViewValue, _disableSanitizer));
			};

			// trigger the validation calls
			if(element.attr('required')) ngModel.$validators.required = function(modelValue, viewValue) {
				return !_blankTest(modelValue || viewValue);
			};
			// parsers trigger from the above keyup function or any other time that the viewValue is updated and parses it for storage in the ngModel
			ngModel.$parsers.push(_sanitize);
			ngModel.$parsers.unshift(_ensureContentWrapped);
			// because textAngular is bi-directional (which is awesome) we need to also sanitize values going in from the server
			ngModel.$formatters.push(_sanitize);
			ngModel.$formatters.unshift(_ensureContentWrapped);
			ngModel.$formatters.unshift(function(value){
				return ngModel.$undoManager.push(value || '');
			});

			//this code is used to update the models when data is entered/deleted
			if(_isInputFriendly){
				scope.events = {};
				if(!_isContentEditable){
					// if a textarea or input just add in change and blur handlers, everything else is done by angulars input directive
					element.on('change blur', scope.events.change = scope.events.blur = function(){
						if(!_isReadonly) ngModel.$setViewValue(_compileHtml());
					});

					element.on('keydown', scope.events.keydown = function(event, eventData){
						/* istanbul ignore else: this is for catching the jqLite testing*/
						if(eventData) angular.extend(event, eventData);
						// Reference to http://stackoverflow.com/questions/6140632/how-to-handle-tab-in-textarea
						/* istanbul ignore else: otherwise normal functionality */
						if(event.keyCode === 9){ // tab was pressed
							// get caret position/selection
							var start = this.selectionStart;
							var end = this.selectionEnd;

							var value = element.val();
							if(event.shiftKey){
								// find \t
								var _linebreak = value.lastIndexOf('\n', start), _tab = value.lastIndexOf('\t', start);
								if(_tab !== -1 && _tab >= _linebreak){
									// set textarea value to: text before caret + tab + text after caret
									element.val(value.substring(0, _tab) + value.substring(_tab + 1));

									// put caret at right position again (add one for the tab)
									this.selectionStart = this.selectionEnd = start - 1;
								}
							}else{
								// set textarea value to: text before caret + tab + text after caret
								element.val(value.substring(0, start) + "\t" + value.substring(end));

								// put caret at right position again (add one for the tab)
								this.selectionStart = this.selectionEnd = start + 1;
							}
							// prevent the focus lose
							event.preventDefault();
						}
					});

					var _repeat = function(string, n){
						var result = '';
						for(var _n = 0; _n < n; _n++) result += string;
						return result;
					};

					// add a forEach function that will work on a NodeList, etc..
					var forEach = function (array, callback, scope) {
						for (var i= 0; i<array.length; i++) {
							callback.call(scope, i, array[i]);
						}
					};

					// handle <ul> or <ol> nodes
					var recursiveListFormat = function(listNode, tablevel){
						var _html = '';
						var _subnodes = listNode.childNodes;
						tablevel++;
						// tab out and add the <ul> or <ol> html piece
						_html += _repeat('\t', tablevel-1) + listNode.outerHTML.substring(0, 4);
						forEach(_subnodes, function (index, node) {
							/* istanbul ignore next: browser catch */
							var nodeName = node.nodeName.toLowerCase();
							if (nodeName === '#comment') {
								_html += '<!--' + node.nodeValue + '-->';
								return;
							}
							if (nodeName === '#text') {
								_html += node.textContent;
								return;
							}
							/* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
							if(!node.outerHTML) {
								// no html to add
								return;
							}
							if(nodeName === 'ul' || nodeName === 'ol') {
								_html += '\n' + recursiveListFormat(node, tablevel);
							}
							else {
								// no reformatting within this subnode, so just do the tabing...
								_html += '\n' + _repeat('\t', tablevel) + node.outerHTML;
							}
						});
						// now add on the </ol> or </ul> piece
						_html += '\n' + _repeat('\t', tablevel-1) + listNode.outerHTML.substring(listNode.outerHTML.lastIndexOf('<'));
						return _html;
					};
					// handle formating of something like:
					// <ol><!--First comment-->
					//  <li>Test Line 1<!--comment test list 1--></li>
					//    <ul><!--comment ul-->
					//      <li>Nested Line 1</li>
					//        <!--comment between nested lines--><li>Nested Line 2</li>
					//    </ul>
					//  <li>Test Line 3</li>
					// </ol>
					ngModel.$formatters.unshift(function(htmlValue){
						// tabulate the HTML so it looks nicer
						//
						// first get a list of the nodes...
						// we do this by using the element parser...
						//
						// doing this -- which is simpiler -- breaks our tests...
						//var _nodes=angular.element(htmlValue);
						var _nodes = angular.element('<div>' + htmlValue + '</div>')[0].childNodes;
						if(_nodes.length > 0){
							// do the reformatting of the layout...
							htmlValue = '';
							forEach(_nodes, function (index, node) {
								var nodeName = node.nodeName.toLowerCase();
								if (nodeName === '#comment') {
									htmlValue += '<!--' + node.nodeValue + '-->';
									return;
								}
								if (nodeName === '#text') {
									htmlValue += node.textContent;
									return;
								}
								/* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
								if(!node.outerHTML)
								{
									// nothing to format!
									return;
								}
								if(htmlValue.length > 0) {
									// we aready have some content, so drop to a new line
									htmlValue += '\n';
								}
								if(nodeName === 'ul' || nodeName === 'ol') {
									// okay a set of list stuff we want to reformat in a nested way
									htmlValue += '' + recursiveListFormat(node, 0);
								}
								else {
									// just use the original without any additional formating
									htmlValue += '' + node.outerHTML;
								}
							});
						}
						return htmlValue;
					});
				}else{
					// all the code specific to contenteditable divs
					var _processingPaste = false;
					/* istanbul ignore next: phantom js cannot test this for some reason */
					var processpaste = function(text) {
                        var _isOneNote = text.match(/content=["']*OneNote.File/i);
						/* istanbul ignore else: don't care if nothing pasted */
                        //console.log(text);
						if(text && text.trim().length){
							// test paste from word/microsoft product
							if(text.match(/class=["']*Mso(Normal|List)/i) || text.match(/content=["']*Word.Document/i) || text.match(/content=["']*OneNote.File/i)){
								var textFragment = text.match(/<!--StartFragment-->([\s\S]*?)<!--EndFragment-->/i);
								if(!textFragment) textFragment = text;
								else textFragment = textFragment[1];
								textFragment = textFragment.replace(/<o:p>[\s\S]*?<\/o:p>/ig, '').replace(/class=(["']|)MsoNormal(["']|)/ig, '');
								var dom = angular.element("<div>" + textFragment + "</div>");
								var targetDom = angular.element("<div></div>");
								var _list = {
									element: null,
									lastIndent: [],
									lastLi: null,
									isUl: false
								};
								_list.lastIndent.peek = function(){
									var n = this.length;
									if (n>0) return this[n-1];
								};
								var _resetList = function(isUl){
									_list.isUl = isUl;
									_list.element = angular.element(isUl ? "<ul>" : "<ol>");
									_list.lastIndent = [];
									_list.lastIndent.peek = function(){
										var n = this.length;
										if (n>0) return this[n-1];
									};
									_list.lastLevelMatch = null;
								};
								for(var i = 0; i <= dom[0].childNodes.length; i++){
									if(!dom[0].childNodes[i] || dom[0].childNodes[i].nodeName === "#text"){
										continue;
									} else {
										var tagName = dom[0].childNodes[i].tagName.toLowerCase();
										if(tagName !== "p" && tagName !== "h1" && tagName !== "h2" && tagName !== "h3" && tagName !== "h4" && tagName !== "h5" && tagName !== "h6"){
											continue;
										}
									}
									var el = angular.element(dom[0].childNodes[i]);
									var _listMatch = (el.attr('class') || '').match(/MsoList(Bullet|Number|Paragraph)(CxSp(First|Middle|Last)|)/i);

									if(_listMatch){
										if(el[0].childNodes.length < 2 || el[0].childNodes[1].childNodes.length < 1){
											continue;
										}
										var isUl = _listMatch[1].toLowerCase() === "bullet" || (_listMatch[1].toLowerCase() !== "number" && !(/^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].innerHTML) || /^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].childNodes[0].innerHTML)));
										var _indentMatch = (el.attr('style') || '').match(/margin-left:([\-\.0-9]*)/i);
										var indent = parseFloat((_indentMatch)?_indentMatch[1]:0);
										var _levelMatch = (el.attr('style') || '').match(/mso-list:l([0-9]+) level([0-9]+) lfo[0-9+]($|;)/i);
										// prefers the mso-list syntax

										if(_levelMatch && _levelMatch[2]) indent = parseInt(_levelMatch[2]);

										if ((_levelMatch && (!_list.lastLevelMatch || _levelMatch[1] !== _list.lastLevelMatch[1])) || !_listMatch[3] || _listMatch[3].toLowerCase() === "first" || (_list.lastIndent.peek() === null) || (_list.isUl !== isUl && _list.lastIndent.peek() === indent)) {
											_resetList(isUl);
											targetDom.append(_list.element);
										} else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() < indent){
											_list.element = angular.element(isUl ? "<ul>" : "<ol>");
											_list.lastLi.append(_list.element);
										} else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent){
											while(_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent){
												if(_list.element.parent()[0].tagName.toLowerCase() === 'li'){
													_list.element = _list.element.parent();
													continue;
												}else if(/[uo]l/i.test(_list.element.parent()[0].tagName.toLowerCase())){
													_list.element = _list.element.parent();
												}else{ // else it's it should be a sibling
													break;
												}
												_list.lastIndent.pop();
											}
											_list.isUl = _list.element[0].tagName.toLowerCase() === "ul";
											if (isUl !== _list.isUl) {
												_resetList(isUl);
												targetDom.append(_list.element);
											}
										}

										_list.lastLevelMatch = _levelMatch;
										if(indent !== _list.lastIndent.peek()) _list.lastIndent.push(indent);
										_list.lastLi = angular.element("<li>");
										_list.element.append(_list.lastLi);
										_list.lastLi.html(el.html().replace(/<!(--|)\[if !supportLists\](--|)>[\s\S]*?<!(--|)\[endif\](--|)>/ig, ''));
										el.remove();
									}else{
										_resetList(false);
										targetDom.append(el);
									}
								}
								var _unwrapElement = function(node){
									node = angular.element(node);
									for(var _n = node[0].childNodes.length - 1; _n >= 0; _n--) node.after(node[0].childNodes[_n]);
									node.remove();
								};

								angular.forEach(targetDom.find('span'), function(node){
									node.removeAttribute('lang');
									if(node.attributes.length <= 0) _unwrapElement(node);
								});
								angular.forEach(targetDom.find('font'), _unwrapElement);

                                text = targetDom.html();
                                if(_isOneNote){
                                    text = targetDom.html() || dom.html();
                                }
							}else{
								// remove unnecessary chrome insert
								text = text.replace(/<(|\/)meta[^>]*?>/ig, '');
								if(text.match(/<[^>]*?(ta-bind)[^>]*?>/)){
									// entire text-angular or ta-bind has been pasted, REMOVE AT ONCE!!
									if(text.match(/<[^>]*?(text-angular)[^>]*?>/)){
										var _el = angular.element("<div>" + text + "</div>");
										_el.find('textarea').remove();
										var binds = taDOM.getByAttribute(_el, 'ta-bind');
										for(var _b = 0; _b < binds.length; _b++){
											var _target = binds[_b][0].parentNode.parentNode;
											for(var _c = 0; _c < binds[_b][0].childNodes.length; _c++){
												_target.parentNode.insertBefore(binds[_b][0].childNodes[_c], _target);
											}
											_target.parentNode.removeChild(_target);
										}
										text = _el.html().replace('<br class="Apple-interchange-newline">', '');
									}
								}else if(text.match(/^<span/)){
									// in case of pasting only a span - chrome paste, remove them. THis is just some wierd formatting
									// if we remove the '<span class="Apple-converted-space"> </span>' here we destroy the spacing
									// on paste from even ourselves!
									if (!text.match(/<span class=(\"Apple-converted-space\"|\'Apple-converted-space\')>.<\/span>/ig)) {
										text = text.replace(/<(|\/)span[^>]*?>/ig, '');
									}
								}
								// Webkit on Apple tags
								text = text.replace(/<br class="Apple-interchange-newline"[^>]*?>/ig, '').replace(/<span class="Apple-converted-space">( |&nbsp;)<\/span>/ig, '&nbsp;');
							}

							if (/<li(\s.*)?>/i.test(text) && /(<ul(\s.*)?>|<ol(\s.*)?>).*<li(\s.*)?>/i.test(text) === false) {
								// insert missing parent of li element
								text = text.replace(/<li(\s.*)?>.*<\/li(\s.*)?>/i, '<ul>$&</ul>');
							}

							// parse whitespace from plaintext input, starting with preceding spaces that get stripped on paste
							text = text.replace(/^[ |\u00A0]+/gm, function (match) {
								var result = '';
								for (var i = 0; i < match.length; i++) {
									result += '&nbsp;';
								}
								return result;
							}).replace(/\n|\r\n|\r/g, '<p>').replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');

							if(_pasteHandler) text = _pasteHandler(scope, {$html: text}) || text;

							text = taSanitize(text, '', _disableSanitizer);

							taSelection.insertHtml(text, element[0]);
							$timeout(function(){
								ngModel.$setViewValue(_compileHtml());
								_processingPaste = false;
								element.removeClass('processing-paste');
							}, 0);
						}else{
							_processingPaste = false;
							element.removeClass('processing-paste');
						}
					};

					element.on('paste', scope.events.paste = function(e, eventData){
						/* istanbul ignore else: this is for catching the jqLite testing*/
						if(eventData) angular.extend(e, eventData);
						if(_isReadonly || _processingPaste){
							e.stopPropagation();
							e.preventDefault();
							return false;
						}

						// Code adapted from http://stackoverflow.com/questions/2176861/javascript-get-clipboard-data-on-paste-event-cross-browser/6804718#6804718
						_processingPaste = true;
						element.addClass('processing-paste');
						var pastedContent;
						var clipboardData = (e.originalEvent || e).clipboardData;
						if (clipboardData && clipboardData.getData && clipboardData.types.length > 0) {// Webkit - get data from clipboard, put into editdiv, cleanup, then cancel event
							var _types = "";
							for(var _t = 0; _t < clipboardData.types.length; _t++){
								_types += " " + clipboardData.types[_t];
							}
							/* istanbul ignore next: browser tests */
							if (/text\/html/i.test(_types)) {
								pastedContent = clipboardData.getData('text/html');
							} else if (/text\/plain/i.test(_types)) {
								pastedContent = clipboardData.getData('text/plain');
							}

							processpaste(pastedContent);
							e.stopPropagation();
							e.preventDefault();
							return false;
						} else {// Everything else - empty editdiv and allow browser to paste content into it, then cleanup
							var _savedSelection = rangy.saveSelection(),
								_tempDiv = angular.element('<div class="ta-hidden-input" contenteditable="true"></div>');
							$document.find('body').append(_tempDiv);
							_tempDiv[0].focus();
							$timeout(function(){
								// restore selection
								rangy.restoreSelection(_savedSelection);
								processpaste(_tempDiv[0].innerHTML);
								element[0].focus();
								_tempDiv.remove();
							}, 0);
						}
					});
					element.on('cut', scope.events.cut = function(e){
						// timeout to next is needed as otherwise the paste/cut event has not finished actually changing the display
						if(!_isReadonly) $timeout(function(){
							ngModel.$setViewValue(_compileHtml());
						}, 0);
						else e.preventDefault();
					});

					element.on('keydown', scope.events.keydown = function(event, eventData){
						/* istanbul ignore else: this is for catching the jqLite testing*/
						if(eventData) angular.extend(event, eventData);
						event.specialKey = _mapKeys(event);
						var userSpecialKey;
						/* istanbul ignore next: difficult to test */
						taOptions.keyMappings.forEach(function (mapping) {
							if (event.specialKey === mapping.commandKeyCode) {
								// taOptions has remapped this binding... so
								// we disable our own
								event.specialKey = undefined;
							}
							if (mapping.testForKey(event)) {
								userSpecialKey = mapping.commandKeyCode;
							}
							if ((mapping.commandKeyCode === 'UndoKey') || (mapping.commandKeyCode === 'RedoKey')) {
								// this is necessary to fully stop the propagation.
								if (!mapping.enablePropagation) {
									event.preventDefault();
								}
							}
						});
						/* istanbul ignore next: difficult to test */
						if (typeof userSpecialKey !== 'undefined') {
							event.specialKey = userSpecialKey;
						}
						/* istanbul ignore next: difficult to test as can't seem to select */
						if ((typeof event.specialKey !== 'undefined') && (
								event.specialKey !== 'UndoKey' || event.specialKey !== 'RedoKey'
							)) {
							event.preventDefault();
							textAngularManager.sendKeyCommand(scope, event);
						}
						/* istanbul ignore else: readonly check */
						if(!_isReadonly){
							if (event.specialKey==='UndoKey') {
								_undo();
								event.preventDefault();
							}
							if (event.specialKey==='RedoKey') {
								_redo();
								event.preventDefault();
							}
							/* istanbul ignore next: difficult to test as can't seem to select */
							if(event.keyCode === 13 && !event.shiftKey){
								var contains = function(a, obj) {
									for (var i = 0; i < a.length; i++) {
										if (a[i] === obj) {
											return true;
										}
									}
									return false;
								};
								var $selection;
								var selection = taSelection.getSelectionElement();
								if(!selection.tagName.match(VALIDELEMENTS)) return;
								var _new = angular.element(_defaultVal);
								// if we are in the last element of a blockquote, or ul or ol and the element is blank
								// we need to pull the element outside of the said type
								var moveOutsideElements = ['blockquote', 'ul', 'ol'];
								if (contains(moveOutsideElements, selection.parentNode.tagName.toLowerCase())) {
									if (/^<br(|\/)>$/i.test(selection.innerHTML.trim()) && !selection.nextSibling) {
										// if last element is blank, pull element outside.
										$selection = angular.element(selection);
										var _parent = $selection.parent();
										_parent.after(_new);
										$selection.remove();
										if (_parent.children().length === 0) _parent.remove();
										taSelection.setSelectionToElementStart(_new[0]);
										event.preventDefault();
									}
									if (/^<[^>]+><br(|\/)><\/[^>]+>$/i.test(selection.innerHTML.trim())) {
										$selection = angular.element(selection);
										$selection.after(_new);
										$selection.remove();
										taSelection.setSelectionToElementStart(_new[0]);
										event.preventDefault();
									}
								}
							}
						}
					});
					var _keyupTimeout;
					element.on('keyup', scope.events.keyup = function(event, eventData){
						/* istanbul ignore else: this is for catching the jqLite testing*/
						if(eventData) angular.extend(event, eventData);
						/* istanbul ignore next: FF specific bug fix */
						if (event.keyCode === 9) {
							var _selection = taSelection.getSelection();
							if(_selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
							return;
						}
						if(_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
						if(!_isReadonly && !BLOCKED_KEYS.test(event.keyCode)){
							// if enter - insert new taDefaultWrap, if shift+enter insert <br/>
							if(_defaultVal !== '' && event.keyCode === 13){
								if(!event.shiftKey){
									// new paragraph, br should be caught correctly
									var selection = taSelection.getSelectionElement();
									while(!selection.tagName.match(VALIDELEMENTS) && selection !== element[0]){
										selection = selection.parentNode;
									}

									if(selection.tagName.toLowerCase() !== attrs.taDefaultWrap && selection.tagName.toLowerCase() !== 'li' && (selection.innerHTML.trim() === '' || selection.innerHTML.trim() === '<br>')){
										var _new = angular.element(_defaultVal);
										angular.element(selection).replaceWith(_new);
										taSelection.setSelectionToElementStart(_new[0]);
									}
								}
							}
							var val = _compileHtml();
							if(_defaultVal !== '' && val.trim() === ''){
								_setInnerHTML(_defaultVal);
								taSelection.setSelectionToElementStart(element.children()[0]);
							}else if(val.substring(0, 1) !== '<' && attrs.taDefaultWrap !== ''){
								/* we no longer do this, since there can be comments here and white space
								var _savedSelection = rangy.saveSelection();
								val = _compileHtml();
								val = "<" + attrs.taDefaultWrap + ">" + val + "</" + attrs.taDefaultWrap + ">";
								_setInnerHTML(val);
								rangy.restoreSelection(_savedSelection);
								*/
							}
							var triggerUndo = _lastKey !== event.keyCode && UNDO_TRIGGER_KEYS.test(event.keyCode);
							if(_keyupTimeout) $timeout.cancel(_keyupTimeout);
							_keyupTimeout = $timeout(function() {
								_setViewValue(val, triggerUndo, true);
							}, ngModelOptions.$options.debounce || 400);
							if(!triggerUndo) _undoKeyupTimeout = $timeout(function(){ ngModel.$undoManager.push(val); }, 250);
							_lastKey = event.keyCode;
						}
					});

					element.on('blur', scope.events.blur = function(){
						_focussed = false;
						/* istanbul ignore else: if readonly don't update model */
						if(!_isReadonly){
							_setViewValue(undefined, undefined, true);
						}else{
							_skipRender = true; // don't redo the whole thing, just check the placeholder logic
							ngModel.$render();
						}
					});

					// Placeholders not supported on ie 8 and below
					if(attrs.placeholder && (_browserDetect.ie > 8 || _browserDetect.ie === undefined)){
						var rule;
						if(attrs.id) rule = addCSSRule('#' + attrs.id + '.placeholder-text:before', 'content: "' + attrs.placeholder + '"');
						else throw('textAngular Error: An unique ID is required for placeholders to work');

						scope.$on('$destroy', function(){
							removeCSSRule(rule);
						});
					}

					element.on('focus', scope.events.focus = function(){
						_focussed = true;
						element.removeClass('placeholder-text');
						_reApplyOnSelectorHandlers();
					});

					element.on('mouseup', scope.events.mouseup = function(){
						var _selection = taSelection.getSelection();
						if(_selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
					});

					// prevent propagation on mousedown in editor, see #206
					element.on('mousedown', scope.events.mousedown = function(event, eventData){
						/* istanbul ignore else: this is for catching the jqLite testing*/
						if(eventData) angular.extend(event, eventData);
						event.stopPropagation();
					});
				}
			}

			var selectorClickHandler = function(event){
				// emit the element-select event, pass the element
				scope.$emit('ta-element-select', this);
				event.preventDefault();
				return false;
			};
			var fileDropHandler = function(event, eventData){
				/* istanbul ignore else: this is for catching the jqLite testing*/
				if(eventData) angular.extend(event, eventData);
				// emit the drop event, pass the element, preventing should be done elsewhere
				if(!dropFired && !_isReadonly){
					dropFired = true;
					var dataTransfer;
					if(event.originalEvent) dataTransfer = event.originalEvent.dataTransfer;
					else dataTransfer = event.dataTransfer;
					scope.$emit('ta-drop-event', this, event, dataTransfer);
					$timeout(function(){
						dropFired = false;
						_setViewValue(undefined, undefined, true);
					}, 100);
				}
			};

			//used for updating when inserting wrapped elements
			var _reApplyOnSelectorHandlers = scope['reApplyOnSelectorHandlers' + (attrs.id || '')] = function(){
				/* istanbul ignore else */
				if(!_isReadonly) angular.forEach(taSelectableElements, function(selector){
						// check we don't apply the handler twice
						element.find(selector)
							.off('click', selectorClickHandler)
							.on('click', selectorClickHandler);
					});
			};

			var _setInnerHTML = function(newval){
				element[0].innerHTML = newval;
			};
			var _renderTimeout;
			var _renderInProgress = false;
			// changes to the model variable from outside the html/text inputs
			ngModel.$render = function(){
				/* istanbul ignore if: Catches rogue renders, hard to replicate in tests */
				if(_renderInProgress) return;
				else _renderInProgress = true;
				// catch model being null or undefined
				var val = ngModel.$viewValue || '';
				// if the editor isn't focused it needs to be updated, otherwise it's receiving user input
				if(!_skipRender){
					/* istanbul ignore else: in other cases we don't care */
					if(_isContentEditable && _focussed){
						// update while focussed
						element.removeClass('placeholder-text');
						if(_renderTimeout) $timeout.cancel(_renderTimeout);
						_renderTimeout = $timeout(function(){
							/* istanbul ignore if: Can't be bothered testing this... */
							if(!_focussed){
								element[0].focus();
								taSelection.setSelectionToElementEnd(element.children()[element.children().length - 1]);
							}
							_renderTimeout = undefined;
						}, 1);
					}
					if(_isContentEditable){
						// WYSIWYG Mode
						if(attrs.placeholder){
							if(val === ''){
								// blank
								_setInnerHTML(_defaultVal);
							}else{
								// not-blank
								_setInnerHTML(val);
							}
						}else{
							_setInnerHTML((val === '') ? _defaultVal : val);
						}
						// if in WYSIWYG and readOnly we kill the use of links by clicking
						if(!_isReadonly){
							_reApplyOnSelectorHandlers();
							element.on('drop', fileDropHandler);
						}else{
							element.off('drop', fileDropHandler);
						}
					}else if(element[0].tagName.toLowerCase() !== 'textarea' && element[0].tagName.toLowerCase() !== 'input'){
						// make sure the end user can SEE the html code as a display. This is a read-only display element
						_setInnerHTML(taApplyCustomRenderers(val));
					}else{
						// only for input and textarea inputs
						element.val(val);
					}
				}
				if(_isContentEditable && attrs.placeholder){
					if(val === ''){
						if(_focussed) element.removeClass('placeholder-text');
						else element.addClass('placeholder-text');
					}else{
						element.removeClass('placeholder-text');
					}
				}
				_renderInProgress = _skipRender = false;
			};

			if(attrs.taReadonly){
				//set initial value
				_isReadonly = scope.$eval(attrs.taReadonly);
				if(_isReadonly){
					element.addClass('ta-readonly');
					// we changed to readOnly mode (taReadonly='true')
					if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
						element.attr('disabled', 'disabled');
					}
					if(element.attr('contenteditable') !== undefined && element.attr('contenteditable')){
						element.removeAttr('contenteditable');
					}
				}else{
					element.removeClass('ta-readonly');
					// we changed to NOT readOnly mode (taReadonly='false')
					if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
						element.removeAttr('disabled');
					}else if(_isContentEditable){
						element.attr('contenteditable', 'true');
					}
				}
				// taReadonly only has an effect if the taBind element is an input or textarea or has contenteditable='true' on it.
				// Otherwise it is readonly by default
				scope.$watch(attrs.taReadonly, function(newVal, oldVal){
					if(oldVal === newVal) return;
					if(newVal){
						element.addClass('ta-readonly');
						// we changed to readOnly mode (taReadonly='true')
						if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
							element.attr('disabled', 'disabled');
						}
						if(element.attr('contenteditable') !== undefined && element.attr('contenteditable')){
							element.removeAttr('contenteditable');
						}
						// turn ON selector click handlers
						angular.forEach(taSelectableElements, function(selector){
							element.find(selector).on('click', selectorClickHandler);
						});
						element.off('drop', fileDropHandler);
					}else{
						element.removeClass('ta-readonly');
						// we changed to NOT readOnly mode (taReadonly='false')
						if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
							element.removeAttr('disabled');
						}else if(_isContentEditable){
							element.attr('contenteditable', 'true');
						}
						// remove the selector click handlers
						angular.forEach(taSelectableElements, function(selector){
							element.find(selector).off('click', selectorClickHandler);
						});
						element.on('drop', fileDropHandler);
					}
					_isReadonly = newVal;
				});
			}

			// Initialise the selectableElements
			// if in WYSIWYG and readOnly we kill the use of links by clicking
			if(_isContentEditable && !_isReadonly){
				angular.forEach(taSelectableElements, function(selector){
					element.find(selector).on('click', selectorClickHandler);
				});
				element.on('drop', fileDropHandler);
				element.on('blur', function(){
					/* istanbul ignore next: webkit fix */
					if(_browserDetect.webkit) { // detect webkit
						globalContentEditableBlur = true;
					}
				});
			}
		}
	};
}]);

// this global var is used to prevent multiple fires of the drop event. Needs to be global to the textAngular file.
var dropFired = false;
var textAngular = angular.module("textAngular", ['ngSanitize', 'textAngularSetup', 'textAngular.factories', 'textAngular.DOM', 'textAngular.validators', 'textAngular.taBind']); //This makes ngSanitize required

textAngular.config([function(){
	// clear taTools variable. Just catches testing and any other time that this config may run multiple times...
	angular.forEach(taTools, function(value, key){ delete taTools[key];	});
}]);

textAngular.directive("textAngular", [
	'$compile', '$timeout', 'taOptions', 'taSelection', 'taExecCommand',
	'textAngularManager', '$document', '$animate', '$log', '$q', '$parse',
	function($compile, $timeout, taOptions, taSelection, taExecCommand,
		textAngularManager, $document, $animate, $log, $q, $parse){
		return {
			require: '?ngModel',
			scope: {},
			restrict: "EA",
			priority: 2, // So we override validators correctly
			link: function(scope, element, attrs, ngModel){
				// all these vars should not be accessable outside this directive
				var _keydown, _keyup, _keypress, _mouseup, _focusin, _focusout,
					_originalContents, _toolbars,
					_serial = (attrs.serial) ? attrs.serial : Math.floor(Math.random() * 10000000000000000),
					_taExecCommand, _resizeMouseDown, _updateSelectedStylesTimeout;

				scope._name = (attrs.name) ? attrs.name : 'textAngularEditor' + _serial;

				var oneEvent = function(_element, event, action){
					$timeout(function(){
						// shim the .one till fixed
						var _func = function(){
							_element.off(event, _func);
							action.apply(this, arguments);
						};
						_element.on(event, _func);
					}, 100);
				};
				_taExecCommand = taExecCommand(attrs.taDefaultWrap);
				// get the settings from the defaults and add our specific functions that need to be on the scope
				angular.extend(scope, angular.copy(taOptions), {
					// wraps the selection in the provided tag / execCommand function. Should only be called in WYSIWYG mode.
					wrapSelection: function(command, opt, isSelectableElementTool){
						if(command.toLowerCase() === "undo"){
							scope['$undoTaBindtaTextElement' + _serial]();
						}else if(command.toLowerCase() === "redo"){
							scope['$redoTaBindtaTextElement' + _serial]();
						}else{
							// catch errors like FF erroring when you try to force an undo with nothing done
							_taExecCommand(command, false, opt, scope.defaultTagAttributes);
							if(isSelectableElementTool){
								// re-apply the selectable tool events
								scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
							}
							// refocus on the shown display element, this fixes a display bug when using :focus styles to outline the box.
							// You still have focus on the text/html input it just doesn't show up
							scope.displayElements.text[0].focus();
						}
					},
					showHtml: scope.$eval(attrs.taShowHtml) || false
				});
				// setup the options from the optional attributes
				if(attrs.taFocussedClass)			scope.classes.focussed = attrs.taFocussedClass;
				if(attrs.taTextEditorClass)			scope.classes.textEditor = attrs.taTextEditorClass;
				if(attrs.taHtmlEditorClass)			scope.classes.htmlEditor = attrs.taHtmlEditorClass;
				if(attrs.taDefaultTagAttributes){
					try	{
						//	TODO: This should use angular.merge to enhance functionality once angular 1.4 is required
						angular.extend(scope.defaultTagAttributes, angular.fromJson(attrs.taDefaultTagAttributes));
					} catch (error) {
						$log.error(error);
					}
				}
				// optional setup functions
				if(attrs.taTextEditorSetup)			scope.setup.textEditorSetup = scope.$parent.$eval(attrs.taTextEditorSetup);
				if(attrs.taHtmlEditorSetup)			scope.setup.htmlEditorSetup = scope.$parent.$eval(attrs.taHtmlEditorSetup);
				// optional fileDropHandler function
				if(attrs.taFileDrop)				scope.fileDropHandler = scope.$parent.$eval(attrs.taFileDrop);
				else								scope.fileDropHandler = scope.defaultFileDropHandler;

				_originalContents = element[0].innerHTML;
				// clear the original content
				element[0].innerHTML = '';

				// Setup the HTML elements as variable references for use later
				scope.displayElements = {
					// we still need the hidden input even with a textarea as the textarea may have invalid/old input in it,
					// wheras the input will ALLWAYS have the correct value.
					forminput: angular.element("<input type='hidden' tabindex='-1' style='display: none;'>"),
					html: angular.element("<textarea></textarea>"),
					text: angular.element("<div></div>"),
					// other toolbased elements
					scrollWindow: angular.element("<div class='ta-scroll-window'></div>"),
					popover: angular.element('<div class="popover fade bottom" style="max-width: none; width: 305px;"></div>'),
					popoverArrow: angular.element('<div class="arrow"></div>'),
					popoverContainer: angular.element('<div class="popover-content"></div>'),
					resize: {
						overlay: angular.element('<div class="ta-resizer-handle-overlay"></div>'),
						background: angular.element('<div class="ta-resizer-handle-background"></div>'),
						anchors: [
							angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tl"></div>'),
							angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tr"></div>'),
							angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-bl"></div>'),
							angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-br"></div>')
						],
						info: angular.element('<div class="ta-resizer-handle-info"></div>')
					}
				};

				// Setup the popover
				scope.displayElements.popover.append(scope.displayElements.popoverArrow);
				scope.displayElements.popover.append(scope.displayElements.popoverContainer);
				scope.displayElements.scrollWindow.append(scope.displayElements.popover);

				scope.displayElements.popover.on('mousedown', function(e, eventData){
					/* istanbul ignore else: this is for catching the jqLite testing*/
					if(eventData) angular.extend(e, eventData);
					// this prevents focusout from firing on the editor when clicking anything in the popover
					e.preventDefault();
					return false;
				});

				// define the popover show and hide functions
				scope.showPopover = function(_el){
					scope.displayElements.popover.css('display', 'block');
					scope.reflowPopover(_el);
					$animate.addClass(scope.displayElements.popover, 'in');
					oneEvent($document.find('body'), 'click keyup', function(){scope.hidePopover();});
				};
				scope.reflowPopover = function(_el){
					/* istanbul ignore if: catches only if near bottom of editor */
					if(scope.displayElements.text[0].offsetHeight - 51 > _el[0].offsetTop){
						scope.displayElements.popover.css('top', _el[0].offsetTop + _el[0].offsetHeight + scope.displayElements.scrollWindow[0].scrollTop + 'px');
						scope.displayElements.popover.removeClass('top').addClass('bottom');
					}else{
						scope.displayElements.popover.css('top', _el[0].offsetTop - 54 + scope.displayElements.scrollWindow[0].scrollTop + 'px');
						scope.displayElements.popover.removeClass('bottom').addClass('top');
					}
					var _maxLeft = scope.displayElements.text[0].offsetWidth - scope.displayElements.popover[0].offsetWidth;
					var _targetLeft = _el[0].offsetLeft + (_el[0].offsetWidth / 2.0) - (scope.displayElements.popover[0].offsetWidth / 2.0);
					scope.displayElements.popover.css('left', Math.max(0, Math.min(_maxLeft, _targetLeft)) + 'px');
					scope.displayElements.popoverArrow.css('margin-left', (Math.min(_targetLeft, (Math.max(0, _targetLeft - _maxLeft))) - 11) + 'px');
				};
				scope.hidePopover = function(){
					scope.displayElements.popover.css('display', '');
					scope.displayElements.popoverContainer.attr('style', '');
					scope.displayElements.popoverContainer.attr('class', 'popover-content');
					scope.displayElements.popover.removeClass('in');
				};

				// setup the resize overlay
				scope.displayElements.resize.overlay.append(scope.displayElements.resize.background);
				angular.forEach(scope.displayElements.resize.anchors, function(anchor){ scope.displayElements.resize.overlay.append(anchor);});
				scope.displayElements.resize.overlay.append(scope.displayElements.resize.info);
				scope.displayElements.scrollWindow.append(scope.displayElements.resize.overlay);

				// define the show and hide events
				scope.reflowResizeOverlay = function(_el){
					_el = angular.element(_el)[0];
					scope.displayElements.resize.overlay.css({
						'display': 'block',
						'left': _el.offsetLeft - 5 + 'px',
						'top': _el.offsetTop - 5 + 'px',
						'width': _el.offsetWidth + 10 + 'px',
						'height': _el.offsetHeight + 10 + 'px'
					});
					scope.displayElements.resize.info.text(_el.offsetWidth + ' x ' + _el.offsetHeight);
				};
				/* istanbul ignore next: pretty sure phantomjs won't test this */
				scope.showResizeOverlay = function(_el){
					var _body = $document.find('body');
					_resizeMouseDown = function(event){
						var startPosition = {
							width: parseInt(_el.attr('width')),
							height: parseInt(_el.attr('height')),
							x: event.clientX,
							y: event.clientY
						};
						if(startPosition.width === undefined || isNaN(startPosition.width)) startPosition.width = _el[0].offsetWidth;
						if(startPosition.height === undefined || isNaN(startPosition.height)) startPosition.height = _el[0].offsetHeight;
						scope.hidePopover();
						var ratio = startPosition.height / startPosition.width;
						var mousemove = function(event){
							// calculate new size
							var pos = {
								x: Math.max(0, startPosition.width + (event.clientX - startPosition.x)),
								y: Math.max(0, startPosition.height + (event.clientY - startPosition.y))
							};

							// DEFAULT: the aspect ratio is not locked unless the Shift key is pressed.
							//
							// attribute: ta-resize-force-aspect-ratio -- locks resize into maintaing the aspect ratio
							var bForceAspectRatio = (attrs.taResizeForceAspectRatio !== undefined);
							// attribute: ta-resize-maintain-aspect-ratio=true causes the space ratio to remain locked
							// unless the Shift key is pressed
							var bFlipKeyBinding = attrs.taResizeMaintainAspectRatio;
							var bKeepRatio =  bForceAspectRatio || (bFlipKeyBinding && !event.shiftKey);
							if(bKeepRatio) {
								var newRatio = pos.y / pos.x;
								pos.x = ratio > newRatio ? pos.x : pos.y / ratio;
								pos.y = ratio > newRatio ? pos.x * ratio : pos.y;
							}
							var el = angular.element(_el);
							function roundedMaxVal(val) {
								return Math.round(Math.max(0, val));
							}
							el.css('height', roundedMaxVal(pos.y) + 'px');
							el.css('width', roundedMaxVal(pos.x) + 'px');

							// reflow the popover tooltip
							scope.reflowResizeOverlay(_el);
						};
						_body.on('mousemove', mousemove);
						oneEvent(_body, 'mouseup', function(event){
							event.preventDefault();
							event.stopPropagation();
							_body.off('mousemove', mousemove);
							// at this point, we need to force the model to update! since the css has changed!
							// this fixes bug: #862 - we now hide the popover -- as this seems more consitent.
							// there are still issues under firefox, the window does not repaint. -- not sure
							// how best to resolve this, but clicking anywhere works.
							scope.$apply(function (){
								scope.hidePopover();
								scope.updateTaBindtaTextElement();
							}, 100);
						});
						event.stopPropagation();
						event.preventDefault();
					};

					scope.displayElements.resize.anchors[3].off('mousedown');
					scope.displayElements.resize.anchors[3].on('mousedown', _resizeMouseDown);

					scope.reflowResizeOverlay(_el);
					oneEvent(_body, 'click', function(){scope.hideResizeOverlay();});
				};
				/* istanbul ignore next: pretty sure phantomjs won't test this */
				scope.hideResizeOverlay = function(){
					scope.displayElements.resize.anchors[3].off('mousedown', _resizeMouseDown);
					scope.displayElements.resize.overlay.css('display', '');
				};

				// allow for insertion of custom directives on the textarea and div
				scope.setup.htmlEditorSetup(scope.displayElements.html);
				scope.setup.textEditorSetup(scope.displayElements.text);
				scope.displayElements.html.attr({
					'id': 'taHtmlElement' + _serial,
					'ng-show': 'showHtml',
					'ta-bind': 'ta-bind',
					'ng-model': 'html',
					'ng-model-options': element.attr('ng-model-options')
				});
				scope.displayElements.text.attr({
					'id': 'taTextElement' + _serial,
					'contentEditable': 'true',
					'ta-bind': 'ta-bind',
					'ng-model': 'html',
					'ng-model-options': element.attr('ng-model-options')
				});
				scope.displayElements.scrollWindow.attr({'ng-hide': 'showHtml'});
				if(attrs.taDefaultWrap) scope.displayElements.text.attr('ta-default-wrap', attrs.taDefaultWrap);

				if(attrs.taUnsafeSanitizer){
					scope.displayElements.text.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
					scope.displayElements.html.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
				}

				// add the main elements to the origional element
				scope.displayElements.scrollWindow.append(scope.displayElements.text);
				element.append(scope.displayElements.scrollWindow);
				element.append(scope.displayElements.html);

				scope.displayElements.forminput.attr('name', scope._name);
				element.append(scope.displayElements.forminput);

				if(attrs.tabindex){
					element.removeAttr('tabindex');
					scope.displayElements.text.attr('tabindex', attrs.tabindex);
					scope.displayElements.html.attr('tabindex', attrs.tabindex);
				}

				if (attrs.placeholder) {
					scope.displayElements.text.attr('placeholder', attrs.placeholder);
					scope.displayElements.html.attr('placeholder', attrs.placeholder);
				}

				if(attrs.taDisabled){
					scope.displayElements.text.attr('ta-readonly', 'disabled');
					scope.displayElements.html.attr('ta-readonly', 'disabled');
					scope.disabled = scope.$parent.$eval(attrs.taDisabled);
					scope.$parent.$watch(attrs.taDisabled, function(newVal){
						scope.disabled = newVal;
						if(scope.disabled){
							element.addClass(scope.classes.disabled);
						}else{
							element.removeClass(scope.classes.disabled);
						}
					});
				}

				if(attrs.taPaste){
					scope._pasteHandler = function(_html){
						return $parse(attrs.taPaste)(scope.$parent, {$html: _html});
					};
					scope.displayElements.text.attr('ta-paste', '_pasteHandler($html)');
				}

				// compile the scope with the text and html elements only - if we do this with the main element it causes a compile loop
				$compile(scope.displayElements.scrollWindow)(scope);
				$compile(scope.displayElements.html)(scope);

				scope.updateTaBindtaTextElement = scope['updateTaBindtaTextElement' + _serial];
				scope.updateTaBindtaHtmlElement = scope['updateTaBindtaHtmlElement' + _serial];

				// add the classes manually last
				element.addClass("ta-root");
				scope.displayElements.scrollWindow.addClass("ta-text ta-editor " + scope.classes.textEditor);
				scope.displayElements.html.addClass("ta-html ta-editor " + scope.classes.htmlEditor);

				// used in the toolbar actions
				scope._actionRunning = false;
				var _savedSelection = false;
				scope.startAction = function(){
					scope._actionRunning = true;
					// if rangy library is loaded return a function to reload the current selection
					_savedSelection = rangy.saveSelection();
					return function(){
						if(_savedSelection) rangy.restoreSelection(_savedSelection);
					};
				};
				scope.endAction = function(){
					scope._actionRunning = false;
					if(_savedSelection){
						if(scope.showHtml){
							scope.displayElements.html[0].focus();
						}else{
							scope.displayElements.text[0].focus();
						}
						// rangy.restoreSelection(_savedSelection);
						rangy.removeMarkers(_savedSelection);
					}
					_savedSelection = false;
					scope.updateSelectedStyles();
					// only update if in text or WYSIWYG mode
					if(!scope.showHtml) scope['updateTaBindtaTextElement' + _serial]();
				};

				// note that focusout > focusin is called everytime we click a button - except bad support: http://www.quirksmode.org/dom/events/blurfocus.html
				// cascades to displayElements.text and displayElements.html automatically.
				_focusin = function(){
					scope.focussed = true;
					element.addClass(scope.classes.focussed);
					_toolbars.focus();
					element.triggerHandler('focus');
				};
				scope.displayElements.html.on('focus', _focusin);
				scope.displayElements.text.on('focus', _focusin);
				_focusout = function(e){
					// if we are NOT runnig an action and have NOT focussed again on the text etc then fire the blur events
					if(!scope._actionRunning && $document[0].activeElement !== scope.displayElements.html[0] && $document[0].activeElement !== scope.displayElements.text[0]){
						element.removeClass(scope.classes.focussed);
						_toolbars.unfocus();
						// to prevent multiple apply error defer to next seems to work.
						$timeout(function(){
							scope._bUpdateSelectedStyles = false;
							element.triggerHandler('blur');
							scope.focussed = false;
						}, 0);
					}
					e.preventDefault();
					return false;
				};
				scope.displayElements.html.on('blur', _focusout);
				scope.displayElements.text.on('blur', _focusout);

				scope.displayElements.text.on('paste', function(event){
					element.triggerHandler('paste', event);
				});

				// Setup the default toolbar tools, this way allows the user to add new tools like plugins.
				// This is on the editor for future proofing if we find a better way to do this.
				scope.queryFormatBlockState = function(command){
					// $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
					return !scope.showHtml && command.toLowerCase() === $document[0].queryCommandValue('formatBlock').toLowerCase();
				};
				scope.queryCommandState = function(command){
					// $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
					return (!scope.showHtml) ? $document[0].queryCommandState(command) : '';
				};
				scope.switchView = function(){
					scope.showHtml = !scope.showHtml;
					$animate.enabled(false, scope.displayElements.html);
					$animate.enabled(false, scope.displayElements.text);
					//Show the HTML view
					if(scope.showHtml){
						//defer until the element is visible
						$timeout(function(){
							$animate.enabled(true, scope.displayElements.html);
							$animate.enabled(true, scope.displayElements.text);
							// [0] dereferences the DOM object from the angular.element
							return scope.displayElements.html[0].focus();
						}, 100);
					}else{
						//Show the WYSIWYG view
						//defer until the element is visible
						$timeout(function(){
							$animate.enabled(true, scope.displayElements.html);
							$animate.enabled(true, scope.displayElements.text);
							// [0] dereferences the DOM object from the angular.element
							return scope.displayElements.text[0].focus();
						}, 100);
					}
				};

				// changes to the model variable from outside the html/text inputs
				// if no ngModel, then the only input is from inside text-angular
				if(attrs.ngModel){
					var _firstRun = true;
					ngModel.$render = function(){
						if(_firstRun){
							// we need this firstRun to set the originalContents otherwise it gets overrided by the setting of ngModel to undefined from NaN
							_firstRun = false;
							// if view value is null or undefined initially and there was original content, set to the original content
							var _initialValue = scope.$parent.$eval(attrs.ngModel);
							if((_initialValue === undefined || _initialValue === null) && (_originalContents && _originalContents !== '')){
								// on passing through to taBind it will be sanitised
								ngModel.$setViewValue(_originalContents);
							}
						}
						scope.displayElements.forminput.val(ngModel.$viewValue);
						// if the editors aren't focused they need to be updated, otherwise they are doing the updating
						scope.html = ngModel.$viewValue || '';
					};
					// trigger the validation calls
					if(element.attr('required')) ngModel.$validators.required = function(modelValue, viewValue) {
						var value = modelValue || viewValue;
						return !(!value || value.trim() === '');
					};
				}else{
					// if no ngModel then update from the contents of the origional html.
					scope.displayElements.forminput.val(_originalContents);
					scope.html = _originalContents;
				}

				// changes from taBind back up to here
				scope.$watch('html', function(newValue, oldValue){
					if(newValue !== oldValue){
						if(attrs.ngModel && ngModel.$viewValue !== newValue) ngModel.$setViewValue(newValue);
						scope.displayElements.forminput.val(newValue);
					}
				});

				if(attrs.taTargetToolbars) _toolbars = textAngularManager.registerEditor(scope._name, scope, attrs.taTargetToolbars.split(','));
				else{
					var _toolbar = angular.element('<div text-angular-toolbar name="textAngularToolbar' + _serial + '">');
					// passthrough init of toolbar options
					if(attrs.taToolbar)						_toolbar.attr('ta-toolbar', attrs.taToolbar);
					if(attrs.taToolbarClass)				_toolbar.attr('ta-toolbar-class', attrs.taToolbarClass);
					if(attrs.taToolbarGroupClass)			_toolbar.attr('ta-toolbar-group-class', attrs.taToolbarGroupClass);
					if(attrs.taToolbarButtonClass)			_toolbar.attr('ta-toolbar-button-class', attrs.taToolbarButtonClass);
					if(attrs.taToolbarActiveButtonClass)	_toolbar.attr('ta-toolbar-active-button-class', attrs.taToolbarActiveButtonClass);
					if(attrs.taFocussedClass)				_toolbar.attr('ta-focussed-class', attrs.taFocussedClass);

					element.prepend(_toolbar);
					$compile(_toolbar)(scope.$parent);
					_toolbars = textAngularManager.registerEditor(scope._name, scope, ['textAngularToolbar' + _serial]);
				}

				scope.$on('$destroy', function(){
					textAngularManager.unregisterEditor(scope._name);
					angular.element(window).off('blur');
				});

				// catch element select event and pass to toolbar tools
				scope.$on('ta-element-select', function(event, element){
					if(_toolbars.triggerElementSelect(event, element)){
						scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
					}
				});

				scope.$on('ta-drop-event', function(event, element, dropEvent, dataTransfer){
					scope.displayElements.text[0].focus();
					if(dataTransfer && dataTransfer.files && dataTransfer.files.length > 0){
						angular.forEach(dataTransfer.files, function(file){
							// taking advantage of boolean execution, if the fileDropHandler returns true, nothing else after it is executed
							// If it is false then execute the defaultFileDropHandler if the fileDropHandler is NOT the default one
							// Once one of these has been executed wrap the result as a promise, if undefined or variable update the taBind, else we should wait for the promise
							try{
								$q.when(scope.fileDropHandler(file, scope.wrapSelection) ||
									(scope.fileDropHandler !== scope.defaultFileDropHandler &&
									$q.when(scope.defaultFileDropHandler(file, scope.wrapSelection)))).then(function(){
										scope['updateTaBindtaTextElement' + _serial]();
									});
							}catch(error){
								$log.error(error);
							}
						});
						dropEvent.preventDefault();
						dropEvent.stopPropagation();
					/* istanbul ignore else, the updates if moved text */
					}else{
						$timeout(function(){
							scope['updateTaBindtaTextElement' + _serial]();
						}, 0);
					}
				});

				// the following is for applying the active states to the tools that support it
				scope._bUpdateSelectedStyles = false;
				/* istanbul ignore next: browser window/tab leave check */
				angular.element(window).on('blur', function(){
					scope._bUpdateSelectedStyles = false;
					scope.focussed = false;
				});
				// loop through all the tools polling their activeState function if it exists
				scope.updateSelectedStyles = function(){
					var _selection;
					/* istanbul ignore next: This check is to ensure multiple timeouts don't exist */
					if(_updateSelectedStylesTimeout) $timeout.cancel(_updateSelectedStylesTimeout);
					// test if the common element ISN'T the root ta-text node
					if((_selection = taSelection.getSelectionElement()) !== undefined && _selection.parentNode !== scope.displayElements.text[0]){
						_toolbars.updateSelectedStyles(angular.element(_selection));
					}else _toolbars.updateSelectedStyles();
					// used to update the active state when a key is held down, ie the left arrow
					/* istanbul ignore else: browser only check */
					if(scope._bUpdateSelectedStyles) _updateSelectedStylesTimeout = $timeout(scope.updateSelectedStyles, 200);
				};
				// start updating on keydown
				_keydown = function(){
					/* istanbul ignore next: ie catch */
					if(!scope.focussed){
						scope._bUpdateSelectedStyles = false;
						return;
					}
					/* istanbul ignore else: don't run if already running */
					if(!scope._bUpdateSelectedStyles){
						scope._bUpdateSelectedStyles = true;
						scope.$apply(function(){
							scope.updateSelectedStyles();
						});
					}
				};
				scope.displayElements.html.on('keydown', _keydown);
				scope.displayElements.text.on('keydown', _keydown);
				// stop updating on key up and update the display/model
				_keyup = function(){
					scope._bUpdateSelectedStyles = false;
				};
				scope.displayElements.html.on('keyup', _keyup);
				scope.displayElements.text.on('keyup', _keyup);
				// stop updating on key up and update the display/model
				_keypress = function(event, eventData){
					/* istanbul ignore else: this is for catching the jqLite testing*/
					if(eventData) angular.extend(event, eventData);
					scope.$apply(function(){
						if(_toolbars.sendKeyCommand(event)){
							/* istanbul ignore else: don't run if already running */
							if(!scope._bUpdateSelectedStyles){
								scope.updateSelectedStyles();
							}
							event.preventDefault();
							return false;
						}
					});
				};
				scope.displayElements.html.on('keypress', _keypress);
				scope.displayElements.text.on('keypress', _keypress);
				// update the toolbar active states when we click somewhere in the text/html boxed
				_mouseup = function(){
					// ensure only one execution of updateSelectedStyles()
					scope._bUpdateSelectedStyles = false;
					scope.$apply(function(){
						scope.updateSelectedStyles();
					});
				};
				scope.displayElements.html.on('mouseup', _mouseup);
				scope.displayElements.text.on('mouseup', _mouseup);
			}
		};
	}
]);
textAngular.service('textAngularManager', ['taToolExecuteAction', 'taTools', 'taRegisterTool', function(taToolExecuteAction, taTools, taRegisterTool){
	// this service is used to manage all textAngular editors and toolbars.
	// All publicly published functions that modify/need to access the toolbar or editor scopes should be in here
	// these contain references to all the editors and toolbars that have been initialised in this app
	var toolbars = {}, editors = {};
	// when we focus into a toolbar, we need to set the TOOLBAR's $parent to be the toolbars it's linked to.
	// We also need to set the tools to be updated to be the toolbars...
	return {
		// register an editor and the toolbars that it is affected by
		registerEditor: function(name, scope, targetToolbars){
			// targetToolbars are optional, we don't require a toolbar to function
			if(!name || name === '') throw('textAngular Error: An editor requires a name');
			if(!scope) throw('textAngular Error: An editor requires a scope');
			if(editors[name]) throw('textAngular Error: An Editor with name "' + name + '" already exists');
			// _toolbars is an ARRAY of toolbar scopes
			var _toolbars = [];
			angular.forEach(targetToolbars, function(_name){
				if(toolbars[_name]) _toolbars.push(toolbars[_name]);
				// if it doesn't exist it may not have been compiled yet and it will be added later
			});
			editors[name] = {
				scope: scope,
				toolbars: targetToolbars,
				_registerToolbar: function(toolbarScope){
					// add to the list late
					if(this.toolbars.indexOf(toolbarScope.name) >= 0) _toolbars.push(toolbarScope);
				},
				// this is a suite of functions the editor should use to update all it's linked toolbars
				editorFunctions: {
					disable: function(){
						// disable all linked toolbars
						angular.forEach(_toolbars, function(toolbarScope){ toolbarScope.disabled = true; });
					},
					enable: function(){
						// enable all linked toolbars
						angular.forEach(_toolbars, function(toolbarScope){ toolbarScope.disabled = false; });
					},
					focus: function(){
						// this should be called when the editor is focussed
						angular.forEach(_toolbars, function(toolbarScope){
							toolbarScope._parent = scope;
							toolbarScope.disabled = false;
							toolbarScope.focussed = true;
							scope.focussed = true;
						});
					},
					unfocus: function(){
						// this should be called when the editor becomes unfocussed
						angular.forEach(_toolbars, function(toolbarScope){
							toolbarScope.disabled = true;
							toolbarScope.focussed = false;
						});
						scope.focussed = false;
					},
					updateSelectedStyles: function(selectedElement){
						// update the active state of all buttons on liked toolbars
						angular.forEach(_toolbars, function(toolbarScope){
							angular.forEach(toolbarScope.tools, function(toolScope){
								if(toolScope.activeState){
									toolbarScope._parent = scope;
									toolScope.active = toolScope.activeState(selectedElement);
								}
							});
						});
					},
					sendKeyCommand: function(event){
						// we return true if we applied an action, false otherwise
						var result = false;
						if(event.ctrlKey || event.metaKey || event.specialKey) angular.forEach(taTools, function(tool, name){
							if(tool.commandKeyCode && (tool.commandKeyCode === event.which || tool.commandKeyCode === event.specialKey)){
								for(var _t = 0; _t < _toolbars.length; _t++){
									if(_toolbars[_t].tools[name] !== undefined){
										taToolExecuteAction.call(_toolbars[_t].tools[name], scope);
										result = true;
										break;
									}
								}
							}
						});
						return result;
					},
					triggerElementSelect: function(event, element){
						// search through the taTools to see if a match for the tag is made.
						// if there is, see if the tool is on a registered toolbar and not disabled.
						// NOTE: This can trigger on MULTIPLE tools simultaneously.
						var elementHasAttrs = function(_element, attrs){
							var result = true;
							for(var i = 0; i < attrs.length; i++) result = result && _element.attr(attrs[i]);
							return result;
						};
						var workerTools = [];
						var unfilteredTools = {};
						var result = false;
						element = angular.element(element);
						// get all valid tools by element name, keep track if one matches the
						var onlyWithAttrsFilter = false;
						angular.forEach(taTools, function(tool, name){
							if(
								tool.onElementSelect &&
								tool.onElementSelect.element &&
								tool.onElementSelect.element.toLowerCase() === element[0].tagName.toLowerCase() &&
								(!tool.onElementSelect.filter || tool.onElementSelect.filter(element))
							){
								// this should only end up true if the element matches the only attributes
								onlyWithAttrsFilter = onlyWithAttrsFilter ||
									(angular.isArray(tool.onElementSelect.onlyWithAttrs) && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs));
								if(!tool.onElementSelect.onlyWithAttrs || elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) unfilteredTools[name] = tool;
							}
						});
						// if we matched attributes to filter on, then filter, else continue
						if(onlyWithAttrsFilter){
							angular.forEach(unfilteredTools, function(tool, name){
								if(tool.onElementSelect.onlyWithAttrs && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) workerTools.push({'name': name, 'tool': tool});
							});
							// sort most specific (most attrs to find) first
							workerTools.sort(function(a,b){
								return b.tool.onElementSelect.onlyWithAttrs.length - a.tool.onElementSelect.onlyWithAttrs.length;
							});
						}else{
							angular.forEach(unfilteredTools, function(tool, name){
								workerTools.push({'name': name, 'tool': tool});
							});
						}
						// Run the actions on the first visible filtered tool only
						if(workerTools.length > 0){
							for(var _i = 0; _i < workerTools.length; _i++){
								var tool = workerTools[_i].tool;
								var name = workerTools[_i].name;
								for(var _t = 0; _t < _toolbars.length; _t++){
									if(_toolbars[_t].tools[name] !== undefined){
										tool.onElementSelect.action.call(_toolbars[_t].tools[name], event, element, scope);
										result = true;
										break;
									}
								}
								if(result) break;
							}
						}
						return result;
					}
				}
			};
			return editors[name].editorFunctions;
		},
		// retrieve editor by name, largely used by testing suites only
		retrieveEditor: function(name){
			return editors[name];
		},
		unregisterEditor: function(name){
			delete editors[name];
		},
		// registers a toolbar such that it can be linked to editors
		registerToolbar: function(scope){
			if(!scope) throw('textAngular Error: A toolbar requires a scope');
			if(!scope.name || scope.name === '') throw('textAngular Error: A toolbar requires a name');
			if(toolbars[scope.name]) throw('textAngular Error: A toolbar with name "' + scope.name + '" already exists');
			toolbars[scope.name] = scope;
			angular.forEach(editors, function(_editor){
				_editor._registerToolbar(scope);
			});
		},
		// retrieve toolbar by name, largely used by testing suites only
		retrieveToolbar: function(name){
			return toolbars[name];
		},
		// retrieve toolbars by editor name, largely used by testing suites only
		retrieveToolbarsViaEditor: function(name){
			var result = [], _this = this;
			angular.forEach(this.retrieveEditor(name).toolbars, function(name){
				result.push(_this.retrieveToolbar(name));
			});
			return result;
		},
		unregisterToolbar: function(name){
			delete toolbars[name];
		},
		// functions for updating the toolbar buttons display
		updateToolsDisplay: function(newTaTools){
			// pass a partial struct of the taTools, this allows us to update the tools on the fly, will not change the defaults.
			var _this = this;
			angular.forEach(newTaTools, function(_newTool, key){
				_this.updateToolDisplay(key, _newTool);
			});
		},
		// this function resets all toolbars to their default tool definitions
		resetToolsDisplay: function(){
			var _this = this;
			angular.forEach(taTools, function(_newTool, key){
				_this.resetToolDisplay(key);
			});
		},
		// update a tool on all toolbars
		updateToolDisplay: function(toolKey, _newTool){
			var _this = this;
			angular.forEach(toolbars, function(toolbarScope, toolbarKey){
				_this.updateToolbarToolDisplay(toolbarKey, toolKey, _newTool);
			});
		},
		// resets a tool to the default/starting state on all toolbars
		resetToolDisplay: function(toolKey){
			var _this = this;
			angular.forEach(toolbars, function(toolbarScope, toolbarKey){
				_this.resetToolbarToolDisplay(toolbarKey, toolKey);
			});
		},
		// update a tool on a specific toolbar
		updateToolbarToolDisplay: function(toolbarKey, toolKey, _newTool){
			if(toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, _newTool);
			else throw('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
		},
		// reset a tool on a specific toolbar to it's default starting value
		resetToolbarToolDisplay: function(toolbarKey, toolKey){
			if(toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, taTools[toolKey], true);
			else throw('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
		},
		// removes a tool from all toolbars and it's definition
		removeTool: function(toolKey){
			delete taTools[toolKey];
			angular.forEach(toolbars, function(toolbarScope){
				delete toolbarScope.tools[toolKey];
				for(var i = 0; i < toolbarScope.toolbar.length; i++){
					var toolbarIndex;
					for(var j = 0; j < toolbarScope.toolbar[i].length; j++){
						if(toolbarScope.toolbar[i][j] === toolKey){
							toolbarIndex = {
								group: i,
								index: j
							};
							break;
						}
						if(toolbarIndex !== undefined) break;
					}
					if(toolbarIndex !== undefined){
						toolbarScope.toolbar[toolbarIndex.group].slice(toolbarIndex.index, 1);
						toolbarScope._$element.children().eq(toolbarIndex.group).children().eq(toolbarIndex.index).remove();
					}
				}
			});
		},
		// toolkey, toolDefinition are required. If group is not specified will pick the last group, if index isnt defined will append to group
		addTool: function(toolKey, toolDefinition, group, index){
			taRegisterTool(toolKey, toolDefinition);
			angular.forEach(toolbars, function(toolbarScope){
				toolbarScope.addTool(toolKey, toolDefinition, group, index);
			});
		},
		// adds a Tool but only to one toolbar not all
		addToolToToolbar: function(toolKey, toolDefinition, toolbarKey, group, index){
			taRegisterTool(toolKey, toolDefinition);
			toolbars[toolbarKey].addTool(toolKey, toolDefinition, group, index);
		},
		// this is used when externally the html of an editor has been changed and textAngular needs to be notified to update the model.
		// this will call a $digest if not already happening
		refreshEditor: function(name){
			if(editors[name]){
				editors[name].scope.updateTaBindtaTextElement();
				/* istanbul ignore else: phase catch */
				if(!editors[name].scope.$$phase) editors[name].scope.$digest();
			}else throw('textAngular Error: No Editor with name "' + name + '" exists');
		},
		// this is used by taBind to send a key command in response to a special key event
		sendKeyCommand: function(scope, event){
			var _editor = editors[scope._name];
			/* istanbul ignore else: if nothing to do, do nothing */
			if (_editor && _editor.editorFunctions.sendKeyCommand(event)) {
				/* istanbul ignore else: don't run if already running */
				if(!scope._bUpdateSelectedStyles){
					scope.updateSelectedStyles();
				}
				event.preventDefault();
				return false;
			}
		}
	};
}]);
textAngular.directive('textAngularToolbar', [
	'$compile', 'textAngularManager', 'taOptions', 'taTools', 'taToolExecuteAction', '$window',
	function($compile, textAngularManager, taOptions, taTools, taToolExecuteAction, $window){
		return {
			scope: {
				name: '@' // a name IS required
			},
			restrict: "EA",
			link: function(scope, element, attrs){
				if(!scope.name || scope.name === '') throw('textAngular Error: A toolbar requires a name');
				angular.extend(scope, angular.copy(taOptions));
				if(attrs.taToolbar)						scope.toolbar = scope.$parent.$eval(attrs.taToolbar);
				if(attrs.taToolbarClass)				scope.classes.toolbar = attrs.taToolbarClass;
				if(attrs.taToolbarGroupClass)			scope.classes.toolbarGroup = attrs.taToolbarGroupClass;
				if(attrs.taToolbarButtonClass)			scope.classes.toolbarButton = attrs.taToolbarButtonClass;
				if(attrs.taToolbarActiveButtonClass)	scope.classes.toolbarButtonActive = attrs.taToolbarActiveButtonClass;
				if(attrs.taFocussedClass)				scope.classes.focussed = attrs.taFocussedClass;

				scope.disabled = true;
				scope.focussed = false;
				scope._$element = element;
				element[0].innerHTML = '';
				element.addClass("ta-toolbar " + scope.classes.toolbar);

				scope.$watch('focussed', function(){
					if(scope.focussed) element.addClass(scope.classes.focussed);
					else element.removeClass(scope.classes.focussed);
				});

				var setupToolElement = function(toolDefinition, toolScope){
					var toolElement;
					if(toolDefinition && toolDefinition.display){
						toolElement = angular.element(toolDefinition.display);
					}
					else toolElement = angular.element("<button type='button'>");

					if(toolDefinition && toolDefinition["class"]) toolElement.addClass(toolDefinition["class"]);
					else toolElement.addClass(scope.classes.toolbarButton);

					toolElement.attr('name', toolScope.name);
					// important to not take focus from the main text/html entry
					toolElement.attr('ta-button', 'ta-button');
					toolElement.attr('ng-disabled', 'isDisabled()');
					toolElement.attr('tabindex', '-1');
					toolElement.attr('ng-click', 'executeAction()');
					toolElement.attr('ng-class', 'displayActiveToolClass(active)');

					if (toolDefinition && toolDefinition.tooltiptext) {
						toolElement.attr('title', toolDefinition.tooltiptext);
					}
					if(toolDefinition && !toolDefinition.display && !toolScope._display){
						// first clear out the current contents if any
						toolElement[0].innerHTML = '';
						// add the buttonText
						if(toolDefinition.buttontext) toolElement[0].innerHTML = toolDefinition.buttontext;
						// add the icon to the front of the button if there is content
						if(toolDefinition.iconclass){
							var icon = angular.element('<i>'), content = toolElement[0].innerHTML;
							icon.addClass(toolDefinition.iconclass);
							toolElement[0].innerHTML = '';
							toolElement.append(icon);
							if(content && content !== '') toolElement.append('&nbsp;' + content);
						}
					}

					toolScope._lastToolDefinition = angular.copy(toolDefinition);

					return $compile(toolElement)(toolScope);
				};

				// Keep a reference for updating the active states later
				scope.tools = {};
				// create the tools in the toolbar
				// default functions and values to prevent errors in testing and on init
				scope._parent = {
					disabled: true,
					showHtml: false,
					queryFormatBlockState: function(){ return false; },
					queryCommandState: function(){ return false; }
				};
				var defaultChildScope = {
					$window: $window,
					$editor: function(){
						// dynamically gets the editor as it is set
						return scope._parent;
					},
					isDisabled: function(){
						// to set your own disabled logic set a function or boolean on the tool called 'disabled'
						return ( // this bracket is important as without it it just returns the first bracket and ignores the rest
							// when the button's disabled function/value evaluates to true
							(typeof this.$eval('disabled') !== 'function' && this.$eval('disabled')) || this.$eval('disabled()') ||
							// all buttons except the HTML Switch button should be disabled in the showHtml (RAW html) mode
							(this.name !== 'html' && this.$editor().showHtml) ||
							// if the toolbar is disabled
							this.$parent.disabled ||
							// if the current editor is disabled
							this.$editor().disabled
						);
					},
					displayActiveToolClass: function(active){
						return (active)? scope.classes.toolbarButtonActive : '';
					},
					executeAction: taToolExecuteAction
				};

				angular.forEach(scope.toolbar, function(group){
					// setup the toolbar group
					var groupElement = angular.element("<div>");
					groupElement.addClass(scope.classes.toolbarGroup);
					angular.forEach(group, function(tool){
						// init and add the tools to the group
						// a tool name (key name from taTools struct)
						//creates a child scope of the main angularText scope and then extends the childScope with the functions of this particular tool
						// reference to the scope and element kept
						scope.tools[tool] = angular.extend(scope.$new(true), taTools[tool], defaultChildScope, {name: tool});
						scope.tools[tool].$element = setupToolElement(taTools[tool], scope.tools[tool]);
						// append the tool compiled with the childScope to the group element
						groupElement.append(scope.tools[tool].$element);
					});
					// append the group to the toolbar
					element.append(groupElement);
				});

				// update a tool
				// if a value is set to null, remove from the display
				// when forceNew is set to true it will ignore all previous settings, used to reset to taTools definition
				// to reset to defaults pass in taTools[key] as _newTool and forceNew as true, ie `updateToolDisplay(key, taTools[key], true);`
				scope.updateToolDisplay = function(key, _newTool, forceNew){
					var toolInstance = scope.tools[key];
					if(toolInstance){
						// get the last toolDefinition, then override with the new definition
						if(toolInstance._lastToolDefinition && !forceNew) _newTool = angular.extend({}, toolInstance._lastToolDefinition, _newTool);
						if(_newTool.buttontext === null && _newTool.iconclass === null && _newTool.display === null)
							throw('textAngular Error: Tool Definition for updating "' + key + '" does not have a valid display/iconclass/buttontext value');

						// if tool is defined on this toolbar, update/redo the tool
						if(_newTool.buttontext === null){
							delete _newTool.buttontext;
						}
						if(_newTool.iconclass === null){
							delete _newTool.iconclass;
						}
						if(_newTool.display === null){
							delete _newTool.display;
						}

						var toolElement = setupToolElement(_newTool, toolInstance);
						toolInstance.$element.replaceWith(toolElement);
						toolInstance.$element = toolElement;
					}
				};

				// we assume here that all values passed are valid and correct
				scope.addTool = function(key, _newTool, groupIndex, index){
					scope.tools[key] = angular.extend(scope.$new(true), taTools[key], defaultChildScope, {name: key});
					scope.tools[key].$element = setupToolElement(taTools[key], scope.tools[key]);
					var group;
					if(groupIndex === undefined) groupIndex = scope.toolbar.length - 1;
					group = angular.element(element.children()[groupIndex]);

					if(index === undefined){
						group.append(scope.tools[key].$element);
						scope.toolbar[groupIndex][scope.toolbar[groupIndex].length - 1] = key;
					}else{
						group.children().eq(index).after(scope.tools[key].$element);
						scope.toolbar[groupIndex][index] = key;
					}
				};

				textAngularManager.registerToolbar(scope);

				scope.$on('$destroy', function(){
					textAngularManager.unregisterToolbar(scope.name);
				});
			}
		};
	}
]);

(function () {
'use strict';

	angular
		.module('app')
		.service('ToDictService', ToDictService);

	function ToDictService () {
		this.placeholdersToDict = function (placeholders) {
			var dict = {};

			for (var i = 0; i < placeholders.length; i++) {
				dict[placeholders[i].slug] = placeholders[i];
			}

			return dict;
		}
	}
})();
(function(){
    'use strict';

    angular
        .module('app')
        .factory('PagesFactory', PagesFactory)

    /** @ngInject */
    function PagesFactory($http){

        var item = {};

        item.read = function (page) {
            return $http.get('/api/v1/pages/' + page + '/');
        }

        item.update = function (page, value) {
            return $http.put('/api/v1/pages/' + page + '/', value);
        }

        item.create = function (value) {
            return $http.post('/api/v1/pages/', value)
        }

        return item;
    }

}());

(function () {
'use strict';

	angular
		.module('app')
		.factory('ImagesService', ImagesService);

	function ImagesService($http) {
		var image = {};

		image.readOneImage = function (id) {
			return $http.get('/api/v1/images/' + id + '/');
		}

		image.updateFileTitle = function (id, value) {
			var data = {
				title: value
			}

			return $http.patch('/api/v1/images/' + id + '/', data);
		}

		return image;
	}

})();
(function () {
'use strict';

	angular
		.module('app')
		.factory('EndpointParamGeneratorService', EndpointParamGeneratorService);

	function EndpointParamGeneratorService () {
		var params = {};

		params.create = function (value) {
			var paramList = '';

			function checkIsFirst () {
				if(paramList.length == 0) {
					paramList += '?';
				} else {
					paramList += '&';
				}
			}

			value.forEach(function (element, index, array) {
				if(value[index].value != 0) {
					checkIsFirst();
					paramList += value[index].title;
					paramList += value[index].value;
				}
			});

			return paramList;
		}

		return params;
	}

})();
(function () {
'use strict';

	angular
		.module('app')
		.factory('DocumentsService', DocumentsService);

	function DocumentsService($http) {
		var doc = {};

		doc.readOneDocument = function (id) {
			return $http.get('/api/v1/documents/' + id + '/');
		}

		doc.updateFileTitle = function (id, value) {
			var data = {
				title: value
			}

			return $http.patch('/api/v1/documents/' + id + '/', data);
		}

		doc.delete = function (id) {
			return $http.delete('/api/v1/documents/' + id + '/');
		}

		return doc;
	}

})();
(function() {
	'use strict';

	angular
		.module('app')
		.filter('TrustedHtml', TrustedHtml)
		.filter('TrustedSrc', TrustedSrc);

	function TrustedHtml ($sce) {
		return function (content) {
			return $sce.trustAsHtml(content);
		}
	}

	function TrustedSrc ($sce) {
		return function (content) {
			return $sce.trustAsResourceUrl(content);
		}
	}

})();

(function() {
	'use strict';

	angular
		.module('app')
		.filter('HtmlToPlain', HtmlToPlain);

	function HtmlToPlain () {
		return function (content) {
			return String(content).replace(/<[^>]+>/gm, function (x) {
				if(!x.match(/<(\/?|p+ ?|span+ ?|h1+ ?|h2+ ?|h3+ ?|b+ ?|br+ ?|ul+ ?|li+ ?\/?)+>/)) {
					if(x.match(/<(\/?|p+ +[^>]+|span+ +[^>]+|h1+ +[^>]+|h2+ +[^>]+|h3+ +[^>]+|b+ +[^>]+|br+ +[^>]+|ul+ +[^>]+|li+ +[^>]+)+>/gm)) {
						return x.replace(/ +.*/gm,">");
					} else {
						return '';
					}
				} else {
					return x;
				};
			});
		}
	}


})();

(function(){
    'use strict';

    angular
        .module('app')
        .controller('SettlementController', SettlementController)

    /** @ngInject */
    function SettlementController(PagesFactory, $window){
        var vm = this;

        if ($window.innerWidth > 768) {
            $('#aboutus').addClass('active');
            $('.submenu').addClass('active');
            $('#sub-aboutus').addClass('active');
        }

        PagesFactory.read('big-picture')
        .then(function (response) {

            function takeResponseBySlug(slug) {
                for(var i = 0; i < response.data.placeholders.length; i++) {
                    if(response.data.placeholders[i].slug == slug) {
                        return i;
                    }
                }
            }

            if(response.data.placeholders[takeResponseBySlug("wspolpraca")]) {
                vm.dataFromBackendTitle = response.data.placeholders[takeResponseBySlug("spoldzielnia")].title;
                vm.dataFromBackendBody = response.data.placeholders[takeResponseBySlug("spoldzielnia")].content;
            }
        });

    }

}());

(function () {
    'use strict';

    angular
        .module('app')
        .config(coworkingRouteConfig);

    function coworkingRouteConfig($stateProvider) {
        $stateProvider
            .state('website.settlement', {
                url: '/spoldzielnia',
                templateUrl: 'app/partials/settlement/web.html',
                controller: 'SettlementController',
                controllerAs: 'SettlementCtrl'
            });
    };
})();

(function() {
'use strict';

	angular
		.module('app')
		.factory('ResidentialConstructionService', ResidentialConstructionService);

	function ResidentialConstructionService($http) {
		var item = {};

		item.create = function (value) {
			return $http.post('/api/v1/residential_construction/', value);
		}

		item.read = function (params) {
			return $http.get('/api/v1/residential_construction/' + params);
		}

		item.readAll = function () {
			return $http.get('/api/v1/residential_construction/');
		}

		item.readOne = function (id) {
			return $http.get('/api/v1/residential_construction/' + id + '/');
		}

		item.update = function (id, value) {
			return $http.put('/api/v1/residential_construction/' + id + '/', value);
		}

		item.changePosition = function (id, value) {
			return $http.put('/api/v1/residential_construction/' + id + '/change_position/', value);
		}

		item.delete = function (id) {
			return $http.delete('/api/v1/residential_construction/' + id + '/');
		}

		return item;
	}

})();

(function () {
'use strict';

	angular
		.module('app')
		.config(ResidentialConstructionRouterConfig);

	function ResidentialConstructionRouterConfig ($stateProvider) {
		$stateProvider
			.state('website.residential_construction', {
                url: '/budownictwo-mieszkaniowe',
                templateUrl: 'app/partials/residential_construction/web/residential_construction.html',
				controller: 'ResidentialConstructionController',
				controllerAs: 'ResidentialConstructionCtrl'
			})
			.state('preview.residential_construction', {
				url: '/budownictwo-mieszkaniowe',
				templateUrl: 'app/partials/residential_construction/cms/residential_construction.preview.html',
				controller: 'ResidentialConstructionPreviewController',
				controllerAs: 'ResidentialConstructionPreviewCtrl'
			})
			.state('dashboard.residential_construction', {
                url: '/budownictwo-mieszkaniowe',
                templateUrl: 'app/partials/residential_construction/cms/residential_construction.cms.html',
				controller: 'ResidentialConstructionCmsController',
				controllerAs: 'ResidentialConstructionCmsCtrl'
			})
			.state('dashboard.add-residential_construction', {
				url: '/dodaj-budownictwo-mieszkaniowe',
				templateUrl: 'app/partials/residential_construction/cms/add-residential_construction.cms.html',
				controller: 'AddResidentialConstructionCmsController',
				controllerAs: 'AddResidentialConstructionCmsCtrl'
			});
	}
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(rentRouterConfig);

    function rentRouterConfig($stateProvider) {
        $stateProvider
            .state('dashboard.rent_categories', {
                url: '/kategorie-wynajmu',
                templateUrl: 'app/partials/rent/cms/rent_categories/rent_categories.html',
                controller: 'RentCategoriesController',
                controllerAs: 'RentCategoriesCtrl'
            })
            .state('website.rent', {
                url: '/wynajem',
                templateUrl: 'app/partials/rent/web/rent.html',
                controller: 'RentController',
                controllerAs: 'RentCtrl'
            })
            .state('dashboard.rent', {
                url: '/wynajem',
                templateUrl: 'app/partials/rent/cms/rent.html',
                controller: 'RentCmsController',
                controllerAs: 'RentCmsCtrl'
            })
            .state('dashboard.add_rent', {
                url: '/dodaj-wynajem',
                templateUrl: 'app/partials/rent/cms/add_new/add_new.html',
                controller: 'AddNewRentController',
                controllerAs: 'AddNewRentCtrl'
            })
            .state('dashboard.edit_rent', {
                url: '/edytuj-wynajem/:id',
                templateUrl: 'app/partials/rent/cms/edit/edit.html',
                controller: 'EditRentController',
                controllerAs: 'EditRentCtrl'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('RentFactory', RentFactory)
        .factory('RentCategoriesFactory', RentCategoriesFactory);

    function RentFactory($http) {
        var apiAddress = '/api/v1/rents/',
            item = {};

        item.create = function (data) {
            return $http.post(apiAddress, data);
        }

        item.read = function (params) {
            return $http.get(apiAddress, { params: params });
        }

        item.readOne = function (id) {
            return $http.get(apiAddress + id + '/');
        }

        item.update = function (id, data) {
            return $http.patch(apiAddress + id + '/', data);
        }

        item.delete = function (id) {
            return $http.delete(apiAddress + id + '/');
        }

        return item;
    }

    function RentCategoriesFactory($http) {
        var apiAddress = '/api/v1/rent_categories/',
            item = {};

        item.create = function (data) {
            return $http.post(apiAddress, data);
        }

        item.read = function (params) {
            return $http.get(apiAddress, { params: params });
        }

        item.readOne = function (id) {
            return $http.get(apiAddress + id + '/');
        }

        item.update = function (id, data) {
            return $http.patch(apiAddress + id + '/', data);
        }

        item.delete = function (id) {
            return $http.delete(apiAddress + id + '/');
        }

        return item;
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(pressRouterConfig);

    function pressRouterConfig($stateProvider) {
        $stateProvider
            .state('website.press', {
                url: '/media',
                templateUrl: 'app/partials/press/web/web.html',
                controller: 'PressController',
                controllerAs: 'PressCtrl'
            })
            .state('dashboard.press', {
                url: '/media',
                templateUrl: 'app/partials/press/cms/press.html',
                controller: 'PressCmsController',
                controllerAs: 'PressCmsCtrl'
            })
            .state('dashboard.add_press', {
                url: '/dodaj-media',
                templateUrl: 'app/partials/press/cms/add_new/add_new.html',
                controller: 'AddPressCmsController',
                controllerAs: 'AddPressCmsCtrl'
            })
            .state('dashboard.edit_press', {
                url: '/edytuj-media/:id',
                templateUrl: 'app/partials/press/cms/edit/edit.html',
                controller: 'EditPressController',
                controllerAs: 'EditPressCtrl'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('PressFactory', PressFactory);

    function PressFactory($http) {
            var apiAddress = '/api/v1/press/',
                item = {};

            item.create = function (data) {
                return $http.post(apiAddress, data);
            }

            item.read = function (params) {
                return $http.get(apiAddress, { params: params });
            }

            item.readOne = function (id) {
                return $http.get(apiAddress + id + '/');
            }

            item.update = function (id, data) {
                return $http.patch(apiAddress + id + '/', data);
            }

            item.delete = function (id) {
                return $http.delete(apiAddress + id + '/');
            }

            return item;
        }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(perfectPlaceRouterConfig);

    function perfectPlaceRouterConfig($stateProvider) {
        $stateProvider
            .state('perfect_place', {
                url: '/idealne-miejsce',
                templateUrl: 'app/partials/perfect_place/web/web.html',
                controller: 'PerfectPlaceController',
                controllerAs: 'PerfectPlaceCtrl'
            })
            .state('dashboard.perfect_place', {
                url: '/idealne-miejsce',
                templateUrl: 'app/partials/perfect_place/cms/cms.html',
                controller: 'PerfectPlaceCmsController',
                controllerAs: 'PerfectPlaceCmsCtrl'
            })
            .state('dashboard.add_perfect_place', {
                url: '/dodaj-miejsce',
                templateUrl: 'app/partials/perfect_place/cms/add_new/add_new.html',
                controller: 'AddPerfectPlaceCmsController',
                controllerAs: 'AddPerfectPlaceCmsCtrl'
            })
            .state('dashboard.edit_perfect_place', {
                url: '/edytuj-miejsce/:id',
                templateUrl: 'app/partials/perfect_place/cms/edit/edit.html',
                controller: 'EditPerfectPlaceController',
                controllerAs: 'EditPerfectPlaceCtrl'
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('PerfectPlaceFactory', PerfectPlaceFactory);

        function PerfectPlaceFactory($http) {
            var apiAddress = '/api/v1/perfect_place/',
                item = {};

            item.create = function (data) {
                return $http.post(apiAddress, data);
            }

            item.read = function (params) {
                return $http.get(apiAddress, { params: params });
            }

            item.readOne = function (id) {
                return $http.get(apiAddress + id + '/');
            }

            item.update = function (id, data) {
                return $http.patch(apiAddress + id + '/', data);
            }

            item.delete = function (id) {
                return $http.delete(apiAddress + id + '/');
            }

            item.changePosition = function (id, value) {
                return $http.put(apiAddress + id + '/change_position/', value);
            }

            return item;
        }
})();
(function() {
'use strict';

	angular
		.module('app')
		.factory('NewsService', NewsService);

	function NewsService($http) {
		var news = {};

		news.create = function (value) {
			return $http.post('/api/v1/news/', value);
		}

		news.read = function (params) {
			return $http.get('/api/v1/news/' + params);		
		}

		news.readAll = function () {
			return $http.get('/api/v1/news/');
		}

		news.readOne = function (id) {
			return $http.get('/api/v1/news/' + id + '/');
		}

		news.update = function (id, value) {
			return $http.put('/api/v1/news/' + id + '/', value);
		}

		news.changePosition = function (id, value) {
			return $http.put('/api/v1/news/' + id + '/change_position/', value);
		}

		news.delete = function (id) {
			return $http.delete('/api/v1/news/' + id + '/');
		}

		return news;
	}

})();
(function () {
'use strict';

	angular
		.module('app')
		.config(newsRouterConfig);

	function newsRouterConfig ($stateProvider) {
		$stateProvider
			.state('website.news', {
                url: '/aktualnosci',
                templateUrl: 'app/partials/news/web/news.html',
                controller: 'NewsController'
			})
			.state('preview.news', {
				url: '/aktualnosci',
				templateUrl: 'app/partials/news/cms/news.preview.html',
				controller: 'NewsPreviewController'
			})
			.state('dashboard.news', {
                url: '/aktualnosci',
                templateUrl: 'app/partials/news/cms/news.cms.html',
                controller: 'NewsCmsController',
			})
			.state('dashboard.addNews', {
				url: '/dodaj-aktualnosc',
				templateUrl: 'app/partials/news/cms/addnews.cms.html',
				controller: 'AddNewsCmsController'
			});
	}
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(managementRouteConfig);

    function managementRouteConfig($stateProvider) {
        $stateProvider
            .state('website.management', {
                url: '/zarzad',
                templateUrl: 'app/partials/management/web/management.html',
                controller: 'ManagementWebController',
                controllerAs: 'ManagementWebCtrl'
            })
            .state('dashboard.management', {
                url: '/zarzad',
                templateUrl: 'app/partials/management/cms/cms.html',
                controller: 'ManagementCmsController',
                controllerAs: 'ManagementCmsCtrl'
            });
    };
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(advertisersRouterConfig);

    function advertisersRouterConfig($stateProvider) {
        $stateProvider
            .state('dashboard.localizations', {
                url: '/lokalizacje',
                templateUrl: 'app/partials/localizations/cms/cms.html',
                controller: 'LocalizationsCmsController',
                controllerAs: 'LocalizationsCmsCtrl'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('LocalizationsFactory', LocalizationsFactory)
        .factory('LocalizationsStreetFactory', LocalizationsStreetFactory);

    function LocalizationsFactory($http) {
        var apiAddress = '/api/v1/localizations/',
            item = {};

        item.create = function (data) {
            return $http.post(apiAddress, data);
        }

        item.read = function (params) {
            return $http.get(apiAddress, { params: params });
        }

        item.readOne = function (id) {
            return $http.get(apiAddress + id + '/');
        }

        item.update = function (id, data) {
            return $http.patch(apiAddress + id + '/', data);
        }

        item.delete = function (id) {
            return $http.delete(apiAddress + id + '/');
        }

        return item;
    }

    function LocalizationsStreetFactory($http) {
        var apiAddress = '/api/v1/streets/',
            item = {};

        item.create = function (data) {
            return $http.post(apiAddress, data);
        }

        item.read = function (params) {
            return $http.get(apiAddress, { params: params });
        }

        item.readOne = function (id) {
            return $http.get(apiAddress + id + '/');
        }

        item.update = function (id, data) {
            return $http.patch(apiAddress + id + '/', data);
        }

        item.delete = function (id) {
            return $http.delete(apiAddress + id + '/');
        }

        return item;
    }

})();

(function() {
'use strict';

	angular
		.module('app')
		.factory('InformationsService', InformationsService);

	function InformationsService($http) {
		var info = {};

		info.create = function (value) {
			return $http.post('/api/v1/informations/', value);
		}

		info.read = function (params) {
			return $http.get('/api/v1/informations/' + params);
		}

		info.readAll = function () {
			return $http.get('/api/v1/informations/');
		}

		info.readOne = function (id) {
			return $http.get('/api/v1/informations/' + id + '/');
		}

		info.update = function (id, value) {
			return $http.put('/api/v1/informations/' + id + '/', value);
		}

		info.changePosition = function (id, value) {
			return $http.put('/api/v1/informations/' + id + '/change_position/', value);
		}

		info.delete = function (id) {
			return $http.delete('/api/v1/informations/' + id + '/');
		}

		return info;
	}

})();
/*
    Aplikacja do zarządzania procedurami.
*/

(function () {
'use strict';

  angular
    .module('app')
    .config(infoRouterConfig);

  function infoRouterConfig ($stateProvider) {
    $stateProvider
      .state('website.info', {
        url: '/procedury',
        templateUrl: 'app/partials/informations/web/info.html',
        controller: 'InfoController'
      })
      .state('preview.info', {
        url: '/procedury',
        templateUrl: 'app/partials/informations/cms/info.preview.html',
        controller: 'InfoPreviewController'
      })
      .state('dashboard.info', {
        url: '/procedury',
        templateUrl: 'app/partials/informations/cms/info.cms.html',
        controller: 'InfoCmsController',
      })
      .state('dashboard.addInfo', {
        url: '/dodaj-procedury',
        templateUrl: 'app/partials/informations/cms/addinfo.cms.html',
        controller: 'AddInfoCmsController'
      });
  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(historyRouteConfig);

    function historyRouteConfig($stateProvider) {
        $stateProvider
            .state('website.history', {
                url: '/historia',
                templateUrl: 'app/partials/history/web/history.html',
                controller: 'HistoryWebController',
                controllerAs: 'HistoryWebCtrl'
            })
            .state('dashboard.history', {
                url: '/historia',
                templateUrl: 'app/partials/history/cms/cms.html',
                controller: 'HistoryCmsController',
                controllerAs: 'HistoryCmsCtrl'
            });
    };
})();

(function() {
'use strict';

	angular
		.module('app')
		.factory('FundingService', FundingService);

	function FundingService($http) {
		var item = {};

		item.create = function (value) {
			return $http.post('/api/v1/funding/', value);
		}

		item.read = function (params) {
			return $http.get('/api/v1/funding/' + params);
		}

		item.readAll = function () {
			return $http.get('/api/v1/funding/');
		}

		item.readOne = function (id) {
			return $http.get('/api/v1/funding/' + id + '/');
		}

		item.update = function (id, value) {
			return $http.put('/api/v1/funding/' + id + '/', value);
		}

		item.changePosition = function (id, value) {
			return $http.put('/api/v1/funding/' + id + '/change_position/', value);
		}

		item.delete = function (id) {
			return $http.delete('/api/v1/funding/' + id + '/');
		}

		return item;
	}

})();
(function () {
'use strict';

	angular
		.module('app')
		.config(FundingRouterConfig);

	function FundingRouterConfig ($stateProvider) {
		$stateProvider
			.state('website.funding', {
                url: '/dofinansowanie',
                templateUrl: 'app/partials/funding/web/funding.html',
				controller: 'FundingController',
				controllerAs: 'FundingCtrl'
			})
			.state('preview.funding', {
				url: '/dofinansowanie',
				templateUrl: 'app/partials/funding/cms/funding.preview.html',
				controller: 'FundingPreviewController',
				controllerAs: 'FundingPreviewCtrl'
			})
			.state('dashboard.funding', {
                url: '/dofinansowanie',
                templateUrl: 'app/partials/funding/cms/funding.cms.html',
				controller: 'FundingCmsController',
				controllerAs: 'FundingCmsCtrl'
			})
			.state('dashboard.add-funding', {
				url: '/dodaj-dofinansowanie',
				templateUrl: 'app/partials/funding/cms/add-funding.cms.html',
				controller: 'AddFundingCmsController',
				controllerAs: 'AddFundingCmsCtrl'
			});
	}
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(historyRouteConfig);

    function historyRouteConfig($stateProvider) {
        $stateProvider
            .state('website.eco', {
                url: '/ekologia',
                templateUrl: 'app/partials/eco/web/eco.html',
                controller: 'EcoWebController',
                controllerAs: 'EcoWebCtrl'
            })
            .state('dashboard.eco', {
                url: '/ekologia',
                templateUrl: 'app/partials/eco/cms/cms.html',
                controller: 'EcoCmsController',
                controllerAs: 'EcoCmsCtrl'
            });
    };
})();

// (function () {
//     'use strict';

//     angular
//         .module('app')
//         .config(cultureRouterConfig);

//     function cultureRouterConfig($stateProvider) {
//         $stateProvider
//             .state('website.culture', {
//                 url: '/wydarzenia',
//                 templateUrl: 'app/partials/culture/web/web.html',
//                 controller: 'CultureController',
//                 controllerAs: 'CultureCtrl'
//             })
//             .state('dashboard.culture', {
//                 url: '/wydarzenia-kulturalne',
//                 templateUrl: 'app/partials/culture/cms/culture.html',
//                 controller: 'CultureCmsController',
//                 controllerAs: 'CultureCmsCtrl'
//             })
//             .state('dashboard.add_culture', {
//                 url: '/dodaj-wydarzenie',
//                 templateUrl: 'app/partials/culture/cms/add_new/add_new.html',
//                 controller: 'AddCultureCmsController',
//                 controllerAs: 'AddCultureCmsCtrl'
//             })
//             .state('dashboard.edit_culture', {
//                 url: '/edytuj-wydarzenie/:id',
//                 templateUrl: 'app/partials/culture/cms/edit/edit.html',
//                 controller: 'EditCultureController',
//                 controllerAs: 'EditCultureCtrl'
//             });
//     }
// })();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('CultureFactory', CultureFactory);

        function CultureFactory($http) {
            var apiAddress = '/api/v1/culture/',
                item = {};

            item.create = function (data) {
                return $http.post(apiAddress, data);
            }

            item.read = function (params) {
                return $http.get(apiAddress, { params: params });
            }

            item.readOne = function (id) {
                return $http.get(apiAddress + id + '/');
            }

            item.update = function (id, data) {
                return $http.patch(apiAddress + id + '/', data);
            }

            item.delete = function (id) {
                return $http.delete(apiAddress + id + '/');
            }

            return item;
        }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(coworkingRouteConfig);

    function coworkingRouteConfig($stateProvider) {
        $stateProvider
            .state('website.coworking', {
                url: '/wspolpraca',
                templateUrl: 'app/partials/coworking/web/coworking.html',
                controller: 'CoworkingController',
                controllerAs: 'CoworkingCtrl'
            })
            .state('dashboard.coworking', {
                url: '/wspolpraca',
                templateUrl: 'app/partials/coworking/cms/cms.html',
                controller: 'BigPicturesController',
                controllerAs: 'BigPicturesCtrl'
            });
    };
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(advertisersRouterConfig);

    function advertisersRouterConfig($stateProvider) {
        $stateProvider
            .state('website.advertisers', {
                url: '/reklamodawcy',
                templateUrl: 'app/partials/adv/web/web.html',
                controller: 'AdvertisersController',
                controllerAs: 'AdvertisersCtrl'
            })
            .state('dashboard.advertisers', {
                url: '/reklamodawcy',
                templateUrl: 'app/partials/adv/cms/cms.html',
                controller: 'AdvertisersCmsController',
                controllerAs: 'AdvertisersCmsCtrl'
            })
            .state('dashboard.add_advertiser', {
                url: '/dodaj-reklamodawce',
                templateUrl: 'app/partials/adv/cms/add_new/add_new.html',
                controller: 'AddNewAdvertisersController',
                controllerAs: 'AddNewAdvertisersCtrl'
            })
            .state('dashboard.edit_advertiser', {
                url: '/edytuj-reklamodawce/:id',
                templateUrl: 'app/partials/adv/cms/edit/edit.html',
                controller: 'EditAdvertiserController',
                controllerAs: 'EditAdvertiserCtrl'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('AdvertisersFactory', AdvertisersFactory);

    function AdvertisersFactory($http) {
        var apiAddress = '/api/v1/adv/',
            item = {};

        item.create = function (data) {
            return $http.post(apiAddress, data);
        }

        item.read = function (params) {
            return $http.get(apiAddress, { params: params });
        }

        item.readOne = function (id) {
            return $http.get(apiAddress + id + '/');
        }

        item.update = function (id, data) {
            return $http.patch(apiAddress + id + '/', data);
        }

        item.delete = function (id) {
            return $http.delete(apiAddress + id + '/');
        }

        return item;
    }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('WebsiteController', WebsiteController);

    function WebsiteController() {
        $(document).on('click', '.navbar-collapse.in', function (e) {
            if ($(e.target).is('a')) {
                $(this).collapse('hide');
            }
        });
    }

})();

(function() {
  'use strict';

  angular
      .module('app')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

/*

How to use:

        vm.showDeletePopup = function (itemId) {
            ngDialog.open({
                template: 'app/components/delete_dialog/delete.dialog.html',
                className: 'dialog-theme',
                data: {
                    item_id: itemId,
                    delete_function: LocationsBuildingsFactory.delete
                }
            });
        }

item_id - the id of item which u want to delete,
delete_function - function (factory item) which is used to deleting this item

*/

(function () {
    'use strict';

    angular
        .module('app')
        .controller('DeleteDialogController', DeleteDialogController);

    function DeleteDialogController($scope, $state, ngDialog, toastr) {
        var vm = this,
            deleteFunction = $scope.ngDialogData.delete_function,
            itemId = $scope.ngDialogData.item_id,
            additionalId = $scope.ngDialogData.additional_id;

        vm.sendDataToBackend = function () {
            deleteFunction(itemId, additionalId)
                .then(function () {
                    toastr.success('Pomyślnie usunięto.');
                    ngDialog.close();
                    $state.reload();
                });
        }
    }

})();
(function () {
'use strict';

	angular
		.module('textAngularSetup')
		.value('taTranslations', {
// moved to sub-elements
	//toggleHTML: "Toggle HTML",
	//insertImage: "Please enter a image URL to insert",
	//insertLink: "Please enter a URL to insert",
	//insertVideo: "Please enter a youtube URL to embed",
	html: {
		tooltip: 'Widok HTML'
	},
	// tooltip for heading - might be worth splitting
	heading: {
		tooltip: 'Nagłówek '
	},
	p: {
		tooltip: 'Paragraf'
	},
	pre: {
		tooltip: 'Preformatted text'
	},
	ul: {
		tooltip: 'Lista wypunktowana'
	},
	ol: {
		tooltip: 'Lista numerowana'
	},
	quote: {
		tooltip: 'Quote/unquote selection or paragraph'
	},
	undo: {
		tooltip: 'Undo'
	},
	redo: {
		tooltip: 'Redo'
	},
	bold: {
		tooltip: 'Pogrubienie'
	},
	italic: {
		tooltip: 'Pochylenie'
	},
	underline: {
		tooltip: 'Podkreślenie'
	},
	strikeThrough:{
		tooltip: 'Strikethrough'
	},
	justifyLeft: {
		tooltip: 'Wyrównaj do lewej'
	},
	justifyRight: {
		tooltip: 'Wyrównaj do prawej'
	},
	justifyFull: {
		tooltip: 'Wyjustuj'
	},
	justifyCenter: {
		tooltip: 'Wycenteruj'
	},
	indent: {
		tooltip: 'Increase indent'
	},
	outdent: {
		tooltip: 'Decrease indent'
	},
	clear: {
		tooltip: 'Wyczyść formatowanie'
	},
	insertImage: {
		dialogPrompt: 'Wstaw adres URL obrazu',
		tooltip: 'Wstaw obraz z linku',
		hotkey: 'the - possibly language dependent hotkey ... for some future implementation'
	},
	insertVideo: {
		tooltip: 'Insert video',
		dialogPrompt: 'Please enter a youtube URL to embed'
	},
	insertLink: {
		tooltip: 'Wstaw / edytuj link',
		dialogPrompt: "Wstaw adres URL"
	},
	editLink: {
		reLinkButton: {
			tooltip: "Popraw link"
		},
		unLinkButton: {
			tooltip: "Usuń link"
		},
		targetToggle: {
			buttontext: "Otwórz w nowym oknie"
		}
	},
	wordcount: {
		tooltip: 'Display words Count'
	},
		charcount: {
		tooltip: 'Display characters Count'
	}
		});
})();

// active-scripts.js
//

var ActiveItem = function (activeElement) {
    'use strict';
    this.activeElement = activeElement;
};

ActiveItem.prototype.changeState = function (itemName, exception) {
    'use strict';

    var item = $(itemName)
        .click(function (e) {
            e.preventDefault;
            $(this).toggleClass('active');
        })
        .find(exception).click(function () {
            return false;
        });
};

ActiveItem.prototype.collapseAndExpandAll = function (buttonName, itemsNames) {
    'use strict';

    var item = $(buttonName).click(function (e) {
        var isSomethingOpened;
        e.preventDefault;

        isSomethingOpened = $(itemsNames).hasClass('active');

        if (isSomethingOpened == true) {
            $(itemsNames).removeClass('active');
            $(buttonName).removeClass('active');
        } else {
            $(itemsNames).addClass('active');
            $(buttonName).addClass('active');
        }
    });
};

(function() {
  'use strict';

  angular
    .module('app')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $location, $window) {
    $window.ga('create', 'UA-88254358-1', 'auto');

    $rootScope.$on('$stateChangeSuccess', function (event) {
      $window.ga('send', 'pageview', $location.path());
    });

    $rootScope.$on('$stateChangeSuccess', function () {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
        .state('website', {
            templateUrl: 'app/partials/_web/website.html',
            controller: 'WebsiteController',
            controllerAs: 'website'
        });

    $urlRouterProvider.otherwise('/idealne-miejsce');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('app')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $locationProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    
    // HTML5 mode in urls e.g. /kontakt instead of /#/kontakt
    $locationProvider.html5Mode(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-center';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
    toastrConfig.closeButton = true;

  }
  
})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/delete_dialog/delete.dialog.html","<div class=\"dialog-inside\" ng-controller=\"DeleteDialogController as DeleteDialogCtrl\"><h1 class=\"formTitle\">Usuwanie</h1><p class=\"formSubTitle\">Czy chcesz usunąć wybrany element?</p><div class=\"row spaceTop\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><a class=\"btn-dialog-red\" ng-click=\"DeleteDialogCtrl.sendDataToBackend()\">Usuń</a></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><a class=\"btn-dialog-blue\" ng-click=\"closeThisDialog()\">Anuluj</a></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar\"><a href=\"https://github.com/Swiip/generator-gulp-angular\">Gulp Angular</a><ul><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></nav>");
$templateCache.put("app/scripts/pagination/pagination.html","<div class=\"row pagination\" ng-controller=\"PaginationController\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"pagination-div\"><ul><li><p>Strona:</p></li><li><button type=\"button\" ng-if=\"currentPage > 1\" ng-click=\"nextOrPrevPage(\'prev\')\" class=\"page-left\"></button></li><li><div class=\"page-numbers\"><a>{{ currentPage }}</a> z <a ng-click=\"pageNumber(howManyPages())\">{{ howManyPages() }}</a></div></li><li><button type=\"button\" ng-if=\"currentPage < howManyPages()\" ng-click=\"nextOrPrevPage(\'next\')\" class=\"page-right\"></button></li></ul></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><p class=\"display\">Wyświetlaj: <span><b class=\"active\" data-id=\"1\" ng-click=\"changeHowManyElements(1, 10)\">10</b> | <b data-id=\"2\" ng-click=\"changeHowManyElements(2, 20)\">20</b> | <b data-id=\"3\" ng-click=\"changeHowManyElements(3, 50)\">50</b></span></p></div></div>");
$templateCache.put("app/templates/deletePopup/deletePopup.cms.html","<div class=\"d-delete-confirm d-alert\" data-ng-show=\"displayDeletePopup\"><div class=\"d-sub-title\"><span>Usuwanie elementu</span></div><p>Czy chcesz usunąć ten element?</p><div class=\"form-controls-alert\"><a href=\"\" class=\"btn\" data-ng-click=\"showDeletePopup(false)\">anuluj</a> <a href=\"\" class=\"btn-delete\" data-ng-click=\"deleteElement(elementId)\">usuń</a></div></div>");
$templateCache.put("app/partials/_dashboard/dashboard.html","<div ng-if=\"isLoggedIn == true\" class=\"dashboard\"><div class=\"container-fluid\"><div class=\"row reorder\"><div class=\"col-md-2 nopaddings d-big-menu\"><div class=\"logo\"><img src=\"../assets/images/logo-cms.png\"></div><ul class=\"d-menu-left\"><li class=\"d-menu-title\" ng-if=\"displayMyPerfectPlace || displayAllPerfectPlace\">Zamieszkaj na Południu</li><ul ng-if=\"displayMyPerfectPlace || displayAllPerfectPlace\"><li><a ui-sref=\"dashboard.perfect_place\">Zamieszkaj na Południu</a></li></ul><li class=\"d-menu-title\" ng-if=\"displayMyNews || displayAllNews || displayMyCulture || displayAllCulture || displayMyInformations || displayAllInformations\">Dla mieszkańców</li><ul><li><a ui-sref=\"dashboard.news\" ng-if=\"displayAllNews || displayMyNews\">Aktualności</a></li><li><a ui-sref=\"dashboard.info\" ng-if=\"displayAllInformations || displayMyInformations\">Informacje praktyczne</a></li><li><a ui-sref=\"dashboard.funding\" ng-if=\"displayAllFunding || displayMyFunding\">Dofinansowanie</a></li><li><a ui-sref=\"dashboard.residential_construction\" ng-if=\"displayAllResidentialConstruction || displayMyResidentialConstruction\">Budownictwo mieszkaniowe</a></li></ul><li class=\"d-menu-title\">Współpraca</li><ul ng-if=\"displayMyRent || displayAllRent || displayMyTenders || displayAllTenders || displayMyAdv || displayAllAdv || displayMyJobs || displayAllJobs\"><li><a ui-sref=\"dashboard.rent_categories\" ng-if=\"displayMyRent || displayAllRent\">Kategorie lokali</a></li><li><a ui-sref=\"dashboard.rent\" ng-if=\"displayMyRent || displayAllRent\">Lokale</a></li><li><a ui-sref=\"dashboard.tenders\" ng-if=\"displayAllTenders || displayMyTenders\">Przetargi</a></li><li><a ui-sref=\"dashboard.advertisers\" ng-if=\"displayMyAdv || displayAllAdv\">Reklamodawcy</a></li><li><a ui-sref=\"dashboard.workoffers\" ng-if=\"displayAllJobs || displayMyJobs\">Oferty pracy</a></li></ul><li class=\"d-menu-title\" ng-if=\"displayPageBigPicture || displayPageManagement || displayHistory || displayEco || displayMyPress || displayAllPress\">O nas</li><ul ng-if=\"displayPageBigPicture || displayEco\"><li><a ui-sref=\"dashboard.coworking\" ng-if=\"displayPageBigPicture\">Spółdzielnia</a></li><li><a ui-sref=\"dashboard.management\" ng-if=\"displayPageManagement\">Zarząd i Rada</a></li><li><a ui-sref=\"dashboard.history\" ng-if=\"displayHistory\">Historia</a></li><li><a ui-sref=\"dashboard.eco\" ng-if=\"displayEco\">Ekologia</a></li><li><a ui-sref=\"dashboard.press\" ng-if=\"displayAllPress || displayMyPress\">Media o nas</a></li></ul><li class=\"d-menu-title\" ng-if=\"displayPageContact\">Kontakt</li><ul ng-if=\"displayPageContact\"><li><a ui-sref=\"dashboard.contact\">Kontakt</a></li></ul><li class=\"d-menu-title\" ng-if=\"displayMyLocalizations || displayAllLocalizations\">Lokalizacje</li><ul ng-if=\"displayMyLocalizations || displayAllLocalizations\"><li><a ui-sref=\"dashboard.localizations\">Lokalizacje</a></li></ul></ul></div><div class=\"col-md-10 nopaddings\"><div class=\"d-big-content\"><header class=\"d-header\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"d-user-name\"><span>Witaj,</span> {{ userNameResp.email }}<div class=\"d-settings\"><img src=\"../assets/images/settings-ico.png\" alt=\"ustawienia\" id=\"open-settings\" ng-click=\"settingsMenu()\"></div></div><div class=\"d-opened-settings\" ng-click=\"settingsMenu()\"><ul><li><a ui-sref=\"dashboard.users\" ng-if=\"displayUsers == true\">Użytkownicy</a></li><li><a ui-sref=\"dashboard.logs\" ng-if=\"displayUsers == true\">Historia zmian</a></li><li><a ui-sref=\"dashboard.settings\" ng-if=\"changeNewsCategory == true\">Ustawienia</a></li><li class=\"logout\" ng-click=\"dashctrl.logout()\">Wyloguj</li><li><a ui-sref=\"perfect_place\">Przejdź do strony</a></li></ul></div></div></div></header><div class=\"d-content-view\" ui-view=\"\"></div></div></div></div><div class=\"row reorder-xs\"><div class=\"col-md-12 nopaddings\"><div class=\"d-big-content\"><div class=\"d-header\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"d-user-name\"><span>Witaj,</span> {{ userNameResp.email }}<div class=\"d-settings\"><img src=\"../assets/images/settings-ico.png\" alt=\"ustawienia\" id=\"open-settings\" ng-click=\"settingsMenu()\"></div></div><div class=\"d-opened-settings\" ng-click=\"settingsMenu()\"><ul><li><a ui-sref=\"dashboard.users\" ng-if=\"displayUsers == true\">Użytkownicy</a></li><li><a ui-sref=\"dashboard.logs\" ng-if=\"displayUsers == true\">Historia zmian</a></li><li><a ui-sref=\"dashboard.settings\" ng-if=\"changeNewsCategory == true\">Ustawienia</a></li><li class=\"logout\" ng-click=\"dashctrl.logout()\">Wyloguj</li><li><a ui-sref=\"website.home\">Przejdź do strony</a></li></ul></div></div></div></div></div></div><div class=\"col-md-12 d-big-menu\"><div class=\"logo\"><img src=\"../assets/images/logo-cms.png\"></div><ul class=\"d-menu-left\"><li class=\"d-menu-title\" ng-if=\"displayAllNews == true || displayAllJobs == true || displayMyNews == true || displayMyJobs == true\">Aktualności</li><ul><li><a ui-sref=\"dashboard.news\" ng-if=\"displayAllNews == true || displayMyNews == true\">Aktualności</a></li><li><a ui-sref=\"dashboard.tenders\" ng-if=\"displayAllTenders == true || displayMyTenders == true\">Przetargi</a></li><li><a ui-sref=\"dashboard.workoffers\" ng-if=\"displayAllJobs == true || displayMyJobs == true\">Oferty pracy</a></li><li><a ui-sref=\"dashboard.funding\" ng-if=\"displayAllFunding || displayMyFunding\">Dofinansowanie</a></li><li><a ui-sref=\"dashboard.residential_construction\" ng-if=\"displayAllResidentialConstruction || displayMyResidentialConstruction\">Budownictwo mieszkaniowe</a></li></ul><li class=\"d-menu-title\" ng-if=\"readPageStrengths == true || displayAllGalleries == true || displayAllRules == true || readPageStrengths == true || displayMyGalleries == true || displayMyRules == true\">Nasza spółdzielnia</li><ul><li><a ui-sref=\"dashboard.aboutus\" ng-if=\"readPageAboutUs == true\">O nas</a></li><li><a ui-sref=\"dashboard.strengths\" ng-if=\"readPageStrengths == true\">Silne strony</a></li><li><a ui-sref=\"dashboard.info\" ng-if=\"displayAllPages == true || displayMyPages == true\">Informacje praktyczne</a></li><li><a ui-sref=\"dashboard.regulations\" ng-if=\"displayAllRules == true || displayMyRules == true\">Regulaminy</a></li><li><a ui-sref=\"dashboard.history\" ng-if=\"displayAllHistory == true || displayMyHistory == true\">Historia spółdzielni</a></li><li><a ui-sref=\"dashboard.gallery\" ng-if=\"displayAllGalleries == true || displayMyGalleries == true\">Galeria</a></li><li><a ui-sref=\"dashboard.invests\" ng-if=\"displayAllGalleries == true || displayMyGalleries == true\">Zrealizowane inwestycje</a></li></ul><li class=\"d-menu-title\" ng-if=\"readPageAnna == true || readPageDorota == true || readPageHuby == true || readPageGaj == true\">Osiedla</li><ul><li><a ui-sref=\"dashboard.osiedle-anna\" ng-if=\"readPageAnna == true\">Osiedle Anna</a></li><li><a ui-sref=\"dashboard.osiedle-dorota-barbara\" ng-if=\"readPageDorota == true\">Osiedle Dorota-Barbara</a></li><li><a ui-sref=\"dashboard.osiedle-huby\" ng-if=\"readPageHuby == true\">Osiedle Huby</a></li><li><a ui-sref=\"dashboard.osiedle-gaj\" ng-if=\"readPageGaj == true\">Osiedle Gaj</a></li></ul><li><a ui-sref=\"dashboard.solar-energy\" ng-if=\"readPageSolar == true\">Energia Słoneczna</a></li><li class=\"d-menu-title\" ng-if=\"displayMyDownloadableDocuments == true || displayAllPages == true || displayMyPages == true || displayAllDownloadableDocuments == true\">Kontakt</li><ul><li><a ui-sref=\"dashboard.contact\" ng-if=\"readPageContact == true\">Kontakt</a></li><li><a ui-sref=\"dashboard.contactDocuments\" ng-if=\"displayMyDownloadableDocuments == true || displayAllDownloadableDocuments == true\">Druki</a></li></ul></ul></div><div class=\"col-md-12\"><div class=\"d-big-content\"><div class=\"d-content-view\" ui-view=\"\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12 nopaddings\"><footer><div class=\"container\"><div class=\"row\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><img src=\"assets/images/smwplogo-footer.png\" alt=\"SMWP Logo Footer\"></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><img src=\"assets/images/mitlogo-footer.png\" class=\"mit\" alt=\"MIT Logo Footer\"></div></div></div></footer></div></div></div></div>");
$templateCache.put("app/partials/_preview/preview.html","<div ng-if=\"isLoggedIn == true\"><header class=\"preview\"><h3>Tryb podglądu. <span ng-click=\"closeWindow()\">Zamknij.</span></h3></header><div ui-view=\"\"></div><footer><div class=\"container\"><div class=\"row\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><img src=\"assets/images/smwplogo-footer.png\" alt=\"SMWP Logo Footer\"> <span>© {{ currentYear }}</span></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><a href=\"http://www.mitprojects.pl\" target=\"_blank\"><img src=\"assets/images/mitlogo-footer.png\" class=\"mit\" alt=\"MIT Logo Footer\"> <span class=\"realization\">Realizacja:</span></a></div></div></div></footer></div>");
$templateCache.put("app/partials/_web/website.html","<nav class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container-fluid max-width\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-1\" aria-expanded=\"false\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" ui-sref=\"perfect_place\"><img src=\"assets/images/smwp-logo.png\" alt=\"SM Wrocław-Południe Logo\" class=\"nav-logo\"></a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-1\"><ul class=\"nav navbar-nav\"><li><a ui-sref=\"perfect_place\" ui-sref-active=\"active\">Zamieszkaj na Południu</a></li><li class=\"dropdown\"><a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">Dla mieszkańców <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a ui-sref=\"website.news\" ui-sref-active=\"active\">Aktualności</a></li><li><a ui-sref=\"website.info\" ui-sref-active=\"active\">Informacje praktyczne</a></li><li><a ui-sref=\"website.funding\" ui-sref-active=\"active\">Dofinansowanie projektów</a></li><li><a ui-sref=\"website.residential_construction\" ui-sref-active=\"active\">Budownictwo mieszkaniowe</a></li><li><a href=\"https://gabaryty.ekosystem.wroc.pl/\" target=\"_blank\">Wywóz gabarytów</a></li></ul></li><li class=\"dropdown\"><a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">Współpraca <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a ui-sref=\"website.tenders\" ui-sref-active=\"active\">Przetargi</a></li><li><a ui-sref=\"website.rent\" ui-sref-active=\"active\">Lokale użytkowe</a></li><li><a ui-sref=\"website.advertisers\" ui-sref-active=\"active\">Reklamodawcy</a></li><li><a ui-sref=\"website.workoffers\" ui-sref-active=\"active\">Oferty pracy</a></li></ul></li><li class=\"dropdown\"><a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">O nas <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a ui-sref=\"website.settlement\" ui-sref-active=\"active\">Spółdzielnia</a></li><li><a ui-sref=\"website.management\" ui-sref-active=\"active\">Rada i Zarząd</a></li><li><a ui-sref=\"website.history\" ui-sref-active=\"active\">Historia</a></li><li><a ui-sref=\"website.eco\" ui-sref-active=\"active\">Ekologia</a></li><li><a ui-sref=\"website.press\" ui-sref-active=\"active\">Media o nas</a></li></ul></li><li><a href=\"http://nasze-poludnie.pl/\" target=\"_blank\">Blog</a></li><li><a ui-sref=\"website.contact\" ui-sref-active=\"active\">Kontakt</a></li></ul><ul class=\"nav navbar-nav navbar-right\"><li style=\"display: flex; align-items: center; height: 72px\"><a style=\"padding: 0\" ui-sref=\"website.funding\"><img src=\"assets/images/ue.png\" style=\"max-width: 80px;\"></a></li><li><a class=\"im\" href=\"https://smwp.imieszkaniec.pl\">iMieszkaniec.pl</a></li><li><a class=\"ebok\" href=\"http://ebok.wroclaw-poludnie.pl/\">E-BOK</a></li></ul></div></div></nav><div ui-view=\"\" class=\"footer-fix slide\"></div><footer><div class=\"container\"><div class=\"row footer-space-bottom\"><div class=\"col-md-4 col-xs-12\"><a href=\"/\"><img src=\"assets/images/smwplogo-footer.png\" alt=\"SMWP\"></a> <a href=\"https://wizytowka.rzetelnafirma.pl/GQ050W34\" target=\"_blank\"><img src=\"assets/images/rzetelna-firma-logo.png\" class=\"rzetelna-firma\"></a></div><div class=\"col-md-4 col-xs-12\"><h1>Dla mieszkańca</h1><ul><li><a href=\"http://ebok.wroclaw-poludnie.pl\" target=\"_blank\" alt=\"EBOK\">E-BOK</a></li><li><a href=\"https://smwp.imieszkaniec.pl\" target=\"_blank\" alt=\"iMieszkaniec\">iMieszkaniec.pl</a></li></ul></div><div class=\"col-md-4 col-xs-12\"><h1>Media społecznościowe</h1><ul><li><a>Facebook</a></li><li><a>YouTube</a></li></ul></div></div></div></footer><div class=\"goUp\" ng-click=\"goUp()\">do góry</div><cookie-law-banner message=\"Strona wykorzystuje pliki cookies (ciasteczka). Więcej informacji w Polityce Plików Cookies.\" accept-text=\"Rozumiem\" policy-button=\"true\" policy-text=\"Polityka Cookies\" policy-url=\"../assets/docs/cookiespolicy.pdf\" policy-blank=\"true\"></cookie-law-banner>");
$templateCache.put("app/partials/activate/activate.html","<div class=\"d-login-wrapper\"><h3>Wpisz dwukrotnie hasło, aby dodać konto. Następnie zapisz, aby przenieść się na stronę logowania.</h3><form name=\"loginForm\"><input type=\"password\" id=\"email\" ng-model=\"password1\" placeholder=\"wpisz hasło\"> <input type=\"password\" id=\"password\" ng-model=\"password2\" placeholder=\"powtórz hasło\"> <button ng-click=\"submit()\">zapisz</button></form></div>");
$templateCache.put("app/partials/activate/changePassword.html","<div class=\"d-login-wrapper\"><h3>Wpisz dwukrotnie hasło, aby dokonać zmiany. Następnie wyślij, aby przejść na stronę logowania.</h3><form name=\"loginForm\"><input type=\"password\" id=\"email\" ng-model=\"password1\" placeholder=\"wpisz hasło\"> <input type=\"password\" id=\"password\" ng-model=\"password2\" placeholder=\"powtórz hasło\"> <button ng-click=\"submit()\">zapisz</button></form></div>");
$templateCache.put("app/partials/contact/contact.cms.html","<form class=\"d-form spaceBottom spaceTop\"><div class=\"d-sub-title\"><span>Dodatkowe dane kontaktowe</span></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"value.contactTitle\" ng-init=\"value.contactTitle=\'\'\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"value.contactContent\" ta-paste=\"stripFormat($html)\" ng-init=\"value.contactContent=\'\'\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"value.presidentTitle\" ng-init=\"value.presidentTitle=\'\'\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"value.presidentContent\" ta-paste=\"stripFormat($html)\" ng-init=\"value.presidentContent=\'\'\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div><div class=\"d-sub-title\"><span>Mapa</span></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><textarea ng-model=\"value.map\" ng-init=\"value.map=\'\'\"></textarea></div></div><button class=\"d-btn-add-content\" ng-click=\"updateContact(value)\">zapisz kontakt</button></form>");
$templateCache.put("app/partials/contact/contact.html","<div class=\"container\"><div class=\"row choose-street\" ng-if=\"!ContactCtrl.settlementFromBackend\"><div class=\"col-md-12\"><span>Wpisz swoją ulicę</span><angucomplete-alt pause=\"400\" placeholder=\"Ulica...\" selected-object=\"ContactCtrl.chosenStreet\" remote-url=\"/api/v1/streets/?search=\" title-field=\"name\" input-class=\"form-control form-control-small\" text-searching=\"Szukanie...\" text-no-results=\"Brak wyników\"></angucomplete-alt><span>Wpisz ulicę, aby wyświetlić dane kontaktowe swojego osiedla.</span></div></div><div class=\"row choosen-street\" ng-if=\"ContactCtrl.settlementFromBackend\"><div class=\"col-md-4 contactInformations\"><div>Wybrana ulica: <b>{{ ContactCtrl.chosenStreet }}</b>&nbsp;&nbsp;&nbsp;&nbsp;<a ng-click=\"ContactCtrl.removeChosenStreet()\">zmień</a></div><div ng-bind-html=\"ContactCtrl.settlementFromBackend.body | TrustedHtml\"></div></div><div class=\"col-md-4\"><div ng-bind-html=\"ContactCtrl.settlementFromBackend.body_2 | TrustedHtml\"></div></div><div class=\"col-md-4\"><div ng-bind-html=\"ContactCtrl.settlementFromBackend.body_3 | TrustedHtml\"></div></div></div><div class=\"row\"><div class=\"col-md-4 contactInformations\"><ul class=\"contactBlocks\"><li class=\"contact-info-head blockOne\">{{ ContactCtrl.contact.title }}</li><li ng-bind-html=\"ContactCtrl.contact.content | TrustedHtml\"></li></ul><a href=\"https://mieszkania.uniqa24.pl/uniqa-pgi-web/landingPage.html?sm=3695e40f-5ed1-4007-a543-6ac51dd056a1\"><img src=\"/assets/images/baner-mieszkanie-300x66-05-2025.gif\" alt=\"Oferta UNIQA\"></a></div><div class=\"col-md-4 contactInformations\"><ul class=\"contactBlocks\"><li class=\"contact-info-head blockTwo\">{{ ContactCtrl.president.title }}</li><li ng-bind-html=\"ContactCtrl.president.content | TrustedHtml\"></li></ul></div><div class=\"col-md-4\"><form class=\"contact-form\"><input placeholder=\"imię i nazwisko\" ng-model=\"contactName\"> <input placeholder=\"adres lokalu\" ng-model=\"contactLocation\"> <input placeholder=\"nr telefonu\" ng-model=\"contactTelephone\"> <input placeholder=\"e-mail\" ng-model=\"contactEmail\"> <textarea placeholder=\"treść wiadomości\" ng-model=\"contactText\"></textarea><br><a class=\"d-btn-add\" ng-click=\"sendMessage()\">wyślij wiadomość</a></form></div></div><div class=\"row standard-page\"><div class=\"col-xs-12\"><img src=\"assets/images/mapa.jpg\"></div></div></div>");
$templateCache.put("app/partials/login/login.html","<div class=\"d-login-wrapper\"><img src=\"../assets/images/logo-cms.png\"><form name=\"loginForm\"><input type=\"text\" id=\"email\" ng-model=\"user.email\" placeholder=\"adres e-mail\"> <input type=\"password\" id=\"password\" ng-model=\"user.password\" placeholder=\"hasło\"> <button ng-click=\"login.login(user)\">zaloguj</button></form><a class=\"login-wrapper-forget-password spaceTop\" ui-sref=\"pwwd_reminder\">Zapomniałem hasła</a></div>");
$templateCache.put("app/partials/login/password_reminder.html","<div class=\"d-login-wrapper\"><img src=\"../assets/images/logo-cms.png\"><form name=\"loginForm\"><input type=\"text\" id=\"email\" ng-model=\"PasswordReminderCtrl.email\" placeholder=\"adres e-mail\"> <button ng-click=\"PasswordReminderCtrl.sendNewPassword()\">wyślij hasło</button></form></div>");
$templateCache.put("app/partials/logs/logs.cms.html","<div class=\"d-sub-title spaceTop\"><span>Historia zmian</span></div><form class=\"d-form spaceBottomXS\"><select ng-model=\"user\" ng-init=\"user == 0 ? user=\'0\' : user\"><option value=\"0\" selected=\"\">Pokaż wszystkich</option><option ng-repeat=\"user in usersFromBackend\" value=\"{{ user.last_name }}\">{{ user.first_name }} {{ user.last_name }}</option></select></form><table class=\"d-table\"><thead><tr><td>Aktywność</td><td>Kategoria</td><td>Użytkownik</td><td>Data</td></tr></thead><tbody><tr ng-repeat=\"log in logsFromBackend\"><td>{{ log.activity }}</td><td>{{ log.object_repr }}</td><td>{{ log.user_name }}</td><td>{{ log.created_at | date: \'shortDate\' }}</td></tr></tbody></table><div class=\"row pagination\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"pagination-div\" ng-show=\"logsFromBackend.length\"><ul><li><p>Strona:</p></li><li><button type=\"button\" ng-disabled=\"currentPage == 0\" ng-click=\"currentPage=currentPage-1\" class=\"page-left\"></button></li><li><div class=\"page-numbers\"><a>{{currentPage + 1}}</a> z <a>{{ numberOfPages() }}</a></div></li><li><button type=\"button\" ng-disabled=\"currentPage >= numberOfPages() - 1\" ng-click=\"currentPage = currentPage+1\" class=\"page-right\"></button></li></ul></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><p class=\"display\">Wyświetlaj: <span><b class=\"active\" data-id=\"1\" ng-click=\"howManyNewsAreDisplayed(10, 1)\">10</b> | <b data-id=\"2\" ng-click=\"howManyNewsAreDisplayed(20, 2)\">20</b> | <b data-id=\"3\" ng-click=\"howManyNewsAreDisplayed(50, 3)\">50</b></span></p></div></div>");
$templateCache.put("app/partials/main/main.cms.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-7\"><h1>Witaj,</h1><h4>Znajdujesz się w panelu administracyjnym strony internetowej Spółdzielni Wrocław-Południe. Masz dostęp do odpowiednich działów strony w zależności od nadanych uprawnień.</h4><p>W razie jakichkolwiek problemów skontaktuj się z działem informatycznym Spółdzielni lub Wykonawcą MITprojects sp.j. na adres <a href=\"mailto:info@mitprojects.pl\">info@mitprojects.pl</a>.</p><p>Zapraszamy do aktywnego korzystania!</p><p class=\"last-update\">Ostatnia aktualizacja: 01.02.2017</p></div></div></div>");
$templateCache.put("app/partials/settings/settings.html","<div class=\"d-sub-title spaceTop\"><span>Kategorie aktualności</span></div><form name=\"categoryForm\" class=\"d-form\"><label>Tytuł kategorii</label> <input type=\"text\" id=\"name\" ng-model=\"SettingsCtrl.newsCategoryName\"> <button type=\"submit\" class=\"d-btn-add-content\" ng-click=\"SettingsCtrl.addCategoryNews()\">dodaj</button></form><ul class=\"d-lists-in-settings spaceBottom\"><li ng-repeat=\"category in SettingsCtrl.categoriesList\">{{ category.name }} <img data-ng-click=\"SettingsCtrl.showEditPopup(true, 0, category.id)\" src=\"../assets/images/edit-ico.jpg\" alt=\"edytowanie\" class=\"d-settings-edit-ico\"> <img data-ng-click=\"SettingsCtrl.showDeletePopup(true, 0, category.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></li></ul><div class=\"d-sub-title spaceTop\"><span>Rodzaje przetargów</span></div><form name=\"categoryForm\" class=\"d-form\"><label>Tytuł kategorii</label> <input type=\"text\" id=\"name\" ng-model=\"SettingsCtrl.tendersCategoryName\"> <button type=\"submit\" class=\"d-btn-add-content\" ng-click=\"SettingsCtrl.addTenderCategory()\">dodaj</button></form><ul class=\"d-lists-in-settings spaceBottom\"><li ng-repeat=\"category in SettingsCtrl.tenderCategoryFromBackend\">{{ category.name }} <img data-ng-click=\"SettingsCtrl.showEditPopup(true, 1, category.id)\" src=\"../assets/images/edit-ico.jpg\" alt=\"edytowanie\" class=\"d-settings-edit-ico\"> <img data-ng-click=\"SettingsCtrl.showDeletePopup(true, 1, category.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></li></ul><div class=\"d-sub-title spaceTop\"><span>Kategorie wydarzeń kulturalnych</span></div><form name=\"categoryForm\" class=\"d-form\"><label>Tytuł kategorii</label> <input type=\"text\" id=\"name\" ng-model=\"SettingsCtrl.cultureCategoryName\"> <button type=\"submit\" class=\"d-btn-add-content\" ng-click=\"SettingsCtrl.addCultureCategoryNews()\">dodaj</button></form><ul class=\"d-lists-in-settings spaceBottom\"><li ng-repeat=\"item in SettingsCtrl.cultureCategoriesList\">{{ item.name }} <img data-ng-click=\"SettingsCtrl.showEditPopup(true, 3, item.id)\" src=\"../assets/images/edit-ico.jpg\" alt=\"edytowanie\" class=\"d-settings-edit-ico\"> <img data-ng-click=\"SettingsCtrl.showDeletePopup(true, 3, item.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></li></ul><div class=\"d-sub-title spaceTop\"><span>Kategorie mediów</span></div><form name=\"categoryForm\" class=\"d-form\"><label>Tytuł kategorii</label> <input type=\"text\" id=\"name\" ng-model=\"SettingsCtrl.pressCategoryName\"> <button type=\"submit\" class=\"d-btn-add-content\" ng-click=\"SettingsCtrl.addPressCategoryNews()\">dodaj</button></form><ul class=\"d-lists-in-settings spaceBottom\"><li ng-repeat=\"item in SettingsCtrl.pressCategoriesList\">{{ item.name }} <img data-ng-click=\"SettingsCtrl.showEditPopup(true, 4, item.id)\" src=\"../assets/images/edit-ico.jpg\" alt=\"edytowanie\" class=\"d-settings-edit-ico\"> <img data-ng-click=\"SettingsCtrl.showDeletePopup(true, 4, item.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></li></ul><div class=\"d-sub-title spaceTop\"><span>Tematy w formularzach</span></div><form name=\"categoryForm\" class=\"d-form\"><label>Tytuł tematu</label> <input type=\"text\" id=\"name\" ng-model=\"SettingsCtrl.formTopicName\"> <button type=\"submit\" class=\"d-btn-add-content\" ng-click=\"SettingsCtrl.addNewTopic()\">dodaj</button></form><ul class=\"d-lists-in-settings spaceBottom\"><li ng-repeat=\"topic in SettingsCtrl.settingsFromBackend\">{{ topic.name }} <img data-ng-click=\"SettingsCtrl.showEditPopup(true, 2, topic.id)\" src=\"../assets/images/edit-ico.jpg\" alt=\"edytowanie\" class=\"d-settings-edit-ico\"> <img data-ng-click=\"SettingsCtrl.showDeletePopup(true, 2, topic.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></li></ul><div class=\"d-sub-title spaceTop\"><span>Wysyłanie formularzy</span></div><form name=\"categoryForm\" class=\"d-form spaceBottom\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Kontakt</label></div><div class=\"col-md-10\"><input type=\"text\" id=\"name\" ng-model=\"SettingsCtrl.contactEmail\"></div></div></div></div><button type=\"submit\" class=\"d-btn-add-content\" ng-click=\"SettingsCtrl.sendNewEmailSettings()\">aktualizuj</button></form><div class=\"d-delete-confirm d-alert\" data-ng-show=\"SettingsCtrl.displayDeletePopup\"><p>Czy chcesz usunąć ten element?</p><div class=\"form-controls-alert\"><a href=\"\" class=\"btn\" data-ng-click=\"SettingsCtrl.showDeletePopup(false)\">anuluj</a> <a href=\"\" class=\"btn-delete\" data-ng-click=\"SettingsCtrl.deleteCategory(elementId, whichOne)\">usuń</a></div></div><div class=\"d-edit-popup\" data-ng-show=\"SettingsCtrl.displayEditPopup\"><div class=\"d-sub-title\"><span>Edytujesz ustawienia</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"SettingsCtrl.nameToEdit\"></div></div><a href=\"\" class=\"btn-abort\" data-ng-click=\"SettingsCtrl.showEditPopup(false)\">anuluj</a> <a class=\"btn-accept\" type=\"submit\" ng-click=\"SettingsCtrl.editSettings(whichOne, elementId, value)\">aktualizuj</a></form></div>");
$templateCache.put("app/partials/settlement/web.html","<div class=\"container standard-page\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><h1>{{ SettlementCtrl.dataFromBackendTitle }}</h1><p ng-bind-html=\"SettlementCtrl.dataFromBackendBody | TrustedHtml\"></p></div><div class=\"col-md-6 col-xs-12\"><img src=\"../assets/images/spoldzielnia-photo.jpg\" alt=\"współpraca\"></div></div></div>");
$templateCache.put("app/partials/tenders/addtenders.cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodajesz nowy przetarg</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł przetargu</label></div><div class=\"col-md-10\"><input class=\"longInput\" type=\"text\" ng-model=\"valueTitle\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Wybierz kategorię</label></div><div class=\"col-md-10\"><select ng-model=\"valueTender_type\" ng-options=\"item as item.name for item in categoriesFromBackend\"></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Wybierz status</label></div><div class=\"col-md-10\"><select ng-model=\"valueStatus\"><option value=\"0\">Aktualny</option><option value=\"1\">Anulowany</option><option value=\"2\">Zakończony</option></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Data przetargu</label></div><div class=\"col-md-10\"><datepicker date-format=\"yyyy-M-d\"><input type=\"text\" placeholder=\"wzór: 2010-12-29\" ng-model=\"valueDate\"></datepicker></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść przetargu</label></div><div class=\"col-md-10\"><text-angular ng-model=\"valueBody\" ta-paste=\"stripFormat($html)\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"published\"><option value=\"True\">Opublikuj</option><option value=\"False\">Szkic</option></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><button class=\"d-btn-add-content\" ng-click=\"openPreview(\'/podglad/przetargi\')\">podgląd</button> <button class=\"d-btn-add-content\" ng-click=\"submit()\">dodaj przetarg</button></form>");
$templateCache.put("app/partials/tenders/edittenders.cms.html","<div class=\"d-edit-popup\" data-ng-show=\"displayEditPopup\"><div class=\"d-sub-title\"><span>Edytujesz przetarg</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł aktualności</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"$parent.value.title\" ng-init=\"$parent.value.title=\'\'\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Wybierz kategorię</label></div><div class=\"col-md-10\"><select ng-model=\"$parent.value.tender_type\" ng-options=\"item.name for item in categoriesFromBackend track by item.id\"></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Wybierz status</label></div><div class=\"col-md-10\"><select ng-model=\"$parent.status\" ng-options=\"item.name for item in statusList track by item.id\"></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Data przetargu</label></div><div class=\"col-md-10\"><datepicker date-format=\"yyyy-M-d\"><input type=\"text\" placeholder=\"wzór: 2010-12-29\" ng-model=\"$parent.value.date\" ng-init=\"$parent.value.date=\'\'\"></datepicker></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść przetargu</label></div><div class=\"col-md-10\"><text-angular ng-model=\"$parent.value.body\" ta-paste=\"stripFormat($html)\" ng-init=\"$parent.value.body=\'\'\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"$parent.value.published\" ng-options=\"item.value as item.name for item in publishedOptions\"></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottom\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"$parent.files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><a href=\"\" class=\"btn-abort\" data-ng-click=\"showEditPopup(false)\">anuluj</a> <a href=\"\" class=\"btn-preview\" ng-click=\"openPreview(\'/podglad/przetargi\')\">podgląd</a> <a class=\"btn-accept\" type=\"submit\" ng-click=\"editTender()\">aktualizuj</a></form></div>");
$templateCache.put("app/partials/tenders/tenders.cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodaj przetarg</span></div><a class=\"d-btn-add spaceBottom\" ui-sref=\"dashboard.addtenders\">Dodaj przetarg</a><div class=\"d-sub-title spaceTop\"><span>Przetargi</span></div><div class=\"d-form spaceBottom\"><label>Kategoria:</label><select ng-model=\"pageCategory\" ng-options=\"item.id as item.name for item in categoriesFromBackend\"><option value=\"\">Wybierz kategorię</option></select><label>Status:</label><select ng-model=\"statusNumber\" ng-options=\"item.value as item.name for item in statusesList\"><option value=\"\">Wybierz status</option></select><label>Publikacja:</label><select ng-model=\"published\" ng-options=\"item.value as item.name for item in publishedOptionsFilter\"><option value=\"\">Pokaż wszystkie</option></select></div><table class=\"d-table\"><thead><tr><td>Tytuł</td><td>Data</td><td>Aktualizacja</td><td>Publikacja</td><td>Status</td><td>Rodzaj</td><td>Dodał</td><td></td><td></td><td>Pozycja</td></tr></thead><tbody><tr ng-repeat=\"tender in tendersFromBackend\"><td>{{ tender.title }}</td><td>{{ tender.created_at | date: \'shortDate\' }}</td><td>{{ tender.updated_at | date: \'shortDate\' }}</td><td ng-if=\"tender.published\">Opublikowano</td><td ng-if=\"!tender.published\">Szkic</td><td>{{ tender.status_name }}</td><td>{{ tender.tender_type.name }}</td><td>{{ tender.created_by_name }}</td><td><a href=\"\" data-ng-click=\"showEditPopup(true, tender.id)\">Edytuj</a></td><td><img class=\"d-settings-thrash\" data-ng-click=\"showDeletePopup(true, tender.id)\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></td><td><div class=\"col-md-12 d-position-arrows-container\"><img src=\"../assets/images/posUp-ico.png\" class=\"d-btn-position-arrows\" ng-click=\"changePosition(tender.id, \'up\')\"></div><div class=\"col-md-12 d-position-arrows-container\"><img src=\"../assets/images/posDown-ico.png\" class=\"d-btn-position-arrows\" ng-click=\"changePosition(tender.id, \'down\')\"></div></td></tr></tbody></table><div class=\"row pagination\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"pagination-div\" ng-show=\"tendersFromBackend.length\"><ul><li><p>Strona:</p></li><li><button type=\"button\" ng-disabled=\"currentPage == 0\" ng-click=\"currentPage=currentPage-1\" class=\"page-left\"></button></li><li><div class=\"page-numbers\"><a>{{currentPage + 1}}</a> z <a>{{ numberOfPages() }}</a></div></li><li><button type=\"button\" ng-disabled=\"currentPage >= numberOfPages() - 1\" ng-click=\"currentPage = currentPage+1\" class=\"page-right\"></button></li></ul></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><p class=\"display\">Wyświetlaj: <span><b class=\"active\" data-id=\"1\" ng-click=\"howManyNewsAreDisplayed(10, 1)\">10</b> | <b data-id=\"2\" ng-click=\"howManyNewsAreDisplayed(20, 2)\">20</b> | <b data-id=\"3\" ng-click=\"howManyNewsAreDisplayed(50, 3)\">50</b></span></p></div></div><div ng-include=\"\'app/templates/deletePopup/deletePopup.cms.html\'\"></div><div ng-include=\"\'app/partials/tenders/edittenders.cms.html\'\"></div>");
$templateCache.put("app/partials/tenders/tenders.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row head-of-lists\"><div class=\"col-md-3 col-sm-12 col-xs-12\"><select ng-model=\"categoryFilter\" ng-init=\"categoryFilter = \'0\'\" ng-change=\"changeCategory(categoryFilter)\"><option value=\"0\" ng-selected=\"true\">Wybierz kategorię</option><option ng-repeat=\"category in categoriesFromBackend\" value=\"{{ category.id }}\">{{ category.name }}</option></select></div><div class=\"col-md-3 col-sm-12 col-xs-12\"><select ng-model=\"statusFilter\" ng-init=\"statusFilter = \'-1\'\" ng-change=\"changeStatus(statusFilter)\"><option value=\"-1\" ng-selected=\"true\">Wybierz status</option><option value=\"0\">Aktualny</option><option value=\"1\">Anulowany</option><option value=\"2\">Zakończony</option></select></div><div class=\"col-md-6 col-sm-12 col-xs-12 spaceTopOnMobile\"><p class=\"show-hide-all\" id=\"show-hide-all\">{{ showHideAll }}<img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 1\"></p></div></div><img src=\"../assets/images/preloader.gif\" class=\"preloader\" ng-hide=\"tendersFromBackend.dataLoaded\"><div ng-show=\"tendersFromBackend.dataLoaded\"><div class=\"row cont-for-list-element\" ng-repeat=\"tender in tendersFromBackend\" data-id=\"{{ tender.id }}\" ng-click=\"toggleBtn(tender.id)\"><article class=\"expand-text\"><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-7\"><h1>{{ tender.title }}<span class=\"dateSpan\">dodano: {{ tender.created_at | date: \'shortDate\' }}, data przetargu: {{ tender.date | date: \'shortDate\' }}</span></h1></div><div class=\"col-md-3\"><h1><span>kategoria: {{ tender.tender_type.name }}</span></h1></div><div class=\"col-md-2\"><h1><span>status: <span ng-if=\"tender.status_name == \'aktualny\'\" class=\"tender-status-aktualny\">{{ tender.status_name }}</span> <span ng-if=\"tender.status_name == \'anulowany\'\" class=\"tender-status-anulowany\">{{ tender.status_name }}</span> <span ng-if=\"tender.status_name == \'zakończony\'\" class=\"tender-status-zakonczony\">{{ tender.status_name }}</span></span></h1></div></div><div class=\"inner-content\"><div class=\"inner-box\" ng-click=\"$event.stopPropagation()\"><p ng-bind-html=\"tender.body | TrustedHtml\">{{ tender.body }}</p><div class=\"row spaceLeftInArticle\"><img ng-repeat=\"doc in tender.documents\" class=\"backEndPhotoInArticle\" ng-if=\"doc.file_path.indexOf(\'.png\') > -1 || doc.file_path.indexOf(\'.jpg\') > -1\" src=\"{{ doc.file_path }}\" data-ng-click=\"showPopup(true, doc.id)\"></div><div class=\"row spaceLeftInArticle\"><a ng-if=\"tender.documents[0]\" ng-repeat=\"doc in tender.documents\" ng-click=\"openLink(doc.file_path)\"><span ng-if=\"doc.file_path.indexOf(\'.pdf\') > -1\">{{ doc.title }}<br></span><br></a></div></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\"><span></span><img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div><div class=\"row cont-for-list-element\" ng-show=\"showNoResults\"><article><h1>Brak wyników</h1></article></div><div class=\"row pagination\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"pagination-div\" ng-show=\"tendersFromBackend.length\"><ul><li><p>Strona:</p></li><li><button type=\"button\" ng-disabled=\"currentPage == 0\" ng-click=\"currentPage=currentPage-1\" class=\"page-left\"></button></li><li><div class=\"page-numbers\"><a>{{currentPage + 1}}</a> z <a ng-click=\"currentPage = numberOfPages() - 1\">{{ numberOfPages() }}</a></div></li><li><button type=\"button\" ng-disabled=\"currentPage >= numberOfPages() - 1\" ng-click=\"currentPage = currentPage+1\" class=\"page-right\"></button></li></ul></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><p class=\"display\">Wyświetlaj: <span><b class=\"active\" data-id=\"1\" ng-click=\"howManyNewsAreDisplayed(10, 1)\">10</b> | <b data-id=\"2\" ng-click=\"howManyNewsAreDisplayed(20, 2)\">20</b> | <b data-id=\"3\" ng-click=\"howManyNewsAreDisplayed(50, 3)\">50</b></span></p></div></div></div></div><script>\n    $(document).ready(function() {\n        var activeItem = new ActiveItem();\n        activeItem.changeState(\".cont-for-list-element\", \".inner-content\");\n        activeItem.collapseAndExpandAll(\"#show-hide-all\", \".cont-for-list-element\");\n    });\n</script><div class=\"gallery-background\" data-ng-show=\"displayPopup\" ng-click=\"showPopup(false)\"></div><div class=\"gallery-popup\" data-ng-show=\"displayPopup\"><img src=\"../assets/images/exit-ico.png\" class=\"exit-ico\" data-ng-click=\"showPopup(false)\"> <img src=\"{{ oneImage.file_path }}\" class=\"popup-image\"><p>{{ oneImage.title }}</p></div>");
$templateCache.put("app/partials/tenders/tenders.preview.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row cont-for-list-element active\"><article class=\"expand-text\"><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-6\"><h1>{{ previewData.title }}<span class=\"dateSpan\">dodano: {{ currentDate | date: \'shortDate\' }}, data przetargu: {{ previewData.date }}</span></h1></div><div class=\"col-md-3\"><h1><span>kategoria: {{ previewData.tender_type.name }}</span></h1></div><div class=\"col-md-3\"><h1><span>status: <span ng-if=\"previewData.status == \'0\'\" class=\"tender-status-aktualny\">aktualny</span> <span ng-if=\"previewData.status == \'1\'\" class=\"tender-status-anulowany\">anulowany</span> <span ng-if=\"previewData.status == \'2\'\" class=\"tender-status-zakonczony\">zakończony</span></span></h1></div></div><div class=\"inner-content\"><div class=\"inner-box\"><p ng-bind-html=\"previewData.body | TrustedHtml\">{{ previewData.body }}</p><a ng-repeat=\"doc in previewData.documents\"><span>{{ doc }}<br></span></a></div></div></div><div class=\"col-md-2\"></div></article></div><div class=\"row cont-for-list-element\" ng-repeat=\"tender in tendersFromBackend | limitTo: 5\" data-id=\"{{ tender.id }}\" ng-click=\"toggleBtn(tender.id)\"><article class=\"expand-text\"><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-6\"><h1>{{ tender.title }}<span class=\"dateSpan\">dodano: {{ tender.created_at | date: \'shortDate\' }}, data przetargu: {{ tender.date }}</span></h1></div><div class=\"col-md-3\"><h1><span>kategoria: {{ tender.tender_type.name }}</span></h1></div><div class=\"col-md-3\"><h1><span>status: <span ng-if=\"tender.status_name == \'aktualny\'\" class=\"tender-status-aktualny\">{{ tender.status_name }}</span> <span ng-if=\"tender.status_name == \'anulowany\'\" class=\"tender-status-anulowany\">{{ tender.status_name }}</span> <span ng-if=\"tender.status_name == \'zakończony\'\" class=\"tender-status-zakonczony\">{{ tender.status_name }}</span></span></h1></div></div><div class=\"inner-content\"><div class=\"inner-box\"><p ng-bind-html=\"tender.body | TrustedHtml\">{{ tender.body }}</p><a ng-if=\"tender.documents[0]\" ng-repeat=\"doc in tender.documents\" ng-click=\"openLink(doc.file_path)\"><img ng-if=\"doc.file_path.indexOf(\'.png\') > -1 || doc.file_path.indexOf(\'.jpg\') > -1\" src=\"{{ doc.file_path }}\"> <span ng-if=\"doc.file_path.indexOf(\'.pdf\') > -1\">{{ doc.title }}<br></span></a></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\">Rozwiń<img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div></div>");
$templateCache.put("app/partials/users/permissions.html","<div class=\"d-edit-popup\" data-ng-show=\"displayPermissionsPopup\"><div class=\"d-sub-title\"><span>Zmiana uprawnień użytkownika</span></div><div class=\"row\"><form class=\"d-form-permissions spaceBottom\"><div class=\"col-md-4 col-sm-12 col-xs-12 spaceBottom\"><h2 class=\"d-permissions-subtitle\">Zamieszkaj na Południu</h2><input type=\"checkbox\" ng-model=\"$parent.manageMyPerfectPlace\">Zamieszkaj na Południu<br><input type=\"checkbox\" class=\"d-checkbox-margin\" ng-model=\"$parent.manageAllPerfectPlace\">Edytuj wszystkie<br><br><h2 class=\"d-permissions-subtitle\">Dla mieszkańców</h2><input type=\"checkbox\" ng-model=\"$parent.manageMyNews\">Aktualności<br><input type=\"checkbox\" class=\"d-checkbox-margin\" ng-model=\"$parent.manageAllNews\">Edytuj wszystkie<br><br><input type=\"checkbox\" ng-model=\"$parent.manageMyCulture\">Wydarzenia<br><input type=\"checkbox\" class=\"d-checkbox-margin\" ng-model=\"$parent.manageAllCulture\">Edytuj wszystkie<br><br><input type=\"checkbox\" ng-model=\"$parent.manageMyInformations\">Procedury<br><input type=\"checkbox\" class=\"d-checkbox-margin\" ng-model=\"$parent.manageAllInformations\">Edytuj wszystkie<br><br><input type=\"checkbox\" ng-model=\"$parent.manageMyFunding\">Dofinansowanie<br><input type=\"checkbox\" class=\"d-checkbox-margin\" ng-model=\"$parent.manageAllFunding\">Edytuj wszystkie<br><br><input type=\"checkbox\" ng-model=\"$parent.manageMyResidentialConstruction\">Budownictwo mieszkaniowe<br><input type=\"checkbox\" class=\"d-checkbox-margin\" ng-model=\"$parent.manageAllResidentialConstruction\">Edytuj wszystkie<br><br></div><div class=\"col-md-4 col-sm-12 col-xs-12 spaceBottom\"><h5 class=\"d-permissions-subtitle\">Współpraca</h5><input type=\"checkbox\" ng-model=\"$parent.manageMyRent\">Lokale<br><input type=\"checkbox\" class=\"d-checkbox-margin\" ng-model=\"$parent.manageAllRent\">Edytuj wszystkie<br><br><input type=\"checkbox\" ng-model=\"$parent.manageMyTenders\">Przetargi<br><input type=\"checkbox\" class=\"d-checkbox-margin\" ng-model=\"$parent.manageAllTenders\">Edytuj wszystkie<br><br><input type=\"checkbox\" ng-model=\"$parent.manageMyAdv\">Reklamodawcy<br><input type=\"checkbox\" class=\"d-checkbox-margin\" ng-model=\"$parent.manageAllAdv\">Edytuj wszystkie<br><br><input type=\"checkbox\" ng-model=\"$parent.manageMyJobs\">Oferty pracy<br><input type=\"checkbox\" class=\"d-checkbox-margin\" ng-model=\"$parent.manageAllJobs\">Edytuj wszystkie<br><br></div><div class=\"col-md-4 col-sm-12 col-xs-12 spaceBottom\"><h5 class=\"d-permissions-subtitle\">O nas</h5><input type=\"checkbox\" ng-model=\"$parent.manageMyPress\">Media o nas<br><input type=\"checkbox\" class=\"d-checkbox-margin\" ng-model=\"$parent.manageAllPress\">Edytuj wszystkie<br><br><h5 class=\"d-permissions-subtitle\">Lokalizacje</h5><input type=\"checkbox\" ng-model=\"$parent.manageMyLocalizations\">Lokalizacje<br><input type=\"checkbox\" class=\"d-checkbox-margin\" ng-model=\"$parent.manageAllLocalizations\">Edytuj wszystkie<br><br><h5 class=\"d-permissions-subtitle\">Podstrony</h5><input type=\"checkbox\" ng-model=\"$parent.managePageWynajem\">Wynajem<br><input type=\"checkbox\" ng-model=\"$parent.managePageAdv\">Reklamodawcy<br><input type=\"checkbox\" ng-model=\"$parent.managePageBigPicture\">Spółdzielnia i Współpraca<br><input type=\"checkbox\" ng-model=\"$parent.managePageFunding\">Dofinansowanie<br><input type=\"checkbox\" ng-model=\"$parent.managePageResidentialConstruction\">Budownictwo mieszkaniowe<br><input type=\"checkbox\" ng-model=\"$parent.managePageManagement\">Rada i Zarząd<br><input type=\"checkbox\" ng-model=\"$parent.managePageHistory\">Historia<br><input type=\"checkbox\" ng-model=\"$parent.managePageEco\">Ekologia<br><input type=\"checkbox\" ng-model=\"$parent.managePageContact\">Kontakt<br></div><div class=\"row\"><div class=\"col-md-12\"><a href=\"\" class=\"btn-abort\" data-ng-click=\"showPermissionWindow(false)\">anuluj</a> <a class=\"btn-accept\" type=\"submit\" ng-click=\"sendNewPermissions(elementId)\">aktualizuj</a></div></div></form></div></div>");
$templateCache.put("app/partials/users/users.cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodaj użytkownika</span></div><form class=\"d-form\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Adres e-mail</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"value.email\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Imię</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"value.first_name\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Nazwisko</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"value.last_name\"></div></div><button class=\"d-btn-add-content spaceBottom\" ng-click=\"addUser(value)\">dodaj</button></form><div class=\"d-sub-title spaceTop\"><span>Użytkownicy</span></div><table class=\"d-table\"><thead><tr><td>Imię i nazwisko</td><td>E-mail</td><td></td><td></td><td></td><td></td></tr></thead><tbody><tr ng-repeat=\"user in usersFromBackend\"><td>{{ user.first_name }} {{ user.last_name }}</td><td>{{ user.email }}</td><td><a ng-click=\"showPermissionWindow(true, user.id)\">Uprawnienia</a></td><td><a ng-click=\"setHistory(user.last_name)\">Historia zmian</a></td><td><a ng-click=\"sendNewPassword(user.email)\">Nowe hasło</a></td><td><img data-ng-click=\"showDeletePopup(true, user.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></td></tr></tbody></table><div class=\"row pagination\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"pagination-div\" ng-show=\"usersFromBackend.length\"><ul><li><p>Strona:</p></li><li><button type=\"button\" ng-disabled=\"currentPage == 0\" ng-click=\"currentPage=currentPage-1\" class=\"page-left\"></button></li><li><div class=\"page-numbers\"><a>{{currentPage + 1}}</a> z <a>{{ numberOfPages() }}</a></div></li><li><button type=\"button\" ng-disabled=\"currentPage >= numberOfPages() - 1\" ng-click=\"currentPage = currentPage+1\" class=\"page-right\"></button></li></ul></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><p class=\"display\">Wyświetlaj: <span><b class=\"active\" data-id=\"1\" ng-click=\"howManyNewsAreDisplayed(10, 1)\">10</b> | <b data-id=\"2\" ng-click=\"howManyNewsAreDisplayed(20, 2)\">20</b> | <b data-id=\"3\" ng-click=\"howManyNewsAreDisplayed(50, 3)\">50</b></span></p></div></div><div ng-include=\"\'app/partials/users/permissions.html\'\"></div><div ng-include=\"\'app/templates/deletePopup/deletePopup.cms.html\'\"></div>");
$templateCache.put("app/partials/workoffers/addworkoffer.cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodajesz nową ofertę pracy</span></div><form class=\"d-form\" name=\"form\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input class=\"longInput\" type=\"text\" ng-model=\"offerTitle\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"published\"><option value=\"True\">Opublikuj</option><option value=\"False\">Szkic</option></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Dodaj plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"upload($file)\" ng-model=\"file\" ngf-max-size=\"20MB\"><span class=\"d-add-file\">Dodaj nowy</span><br>{{file.name}}</div></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"></div><div class=\"col-md-10\"><input type=\"checkbox\" class=\"checkbox checkBoxNormal\" ng-model=\"addToNews\"> Dodaj do aktualności</div></div><button class=\"d-btn-add-content\" ng-click=\"openPreview(\'/podglad/oferty-pracy\')\">podgląd</button> <button class=\"d-btn-add-content spaceBottom\" type=\"submit\" ng-click=\"addWorkOffer(offer)\">dodaj ofertę pracy</button></form>");
$templateCache.put("app/partials/workoffers/editworkoffer.cms.html","<div class=\"d-edit-popup\" data-ng-show=\"displayEditPopup\"><div class=\"preload-file\"></div><div class=\"d-sub-title\"><span>Edytujesz ofertę pracy</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł oferty</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"$parent.value.title\" ng-init=\"$parent.value.title=\'\'\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"$parent.value.published\" ng-options=\"item.value as item.name for item in publishedOptions\"></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Aktualny plik</label></div><div class=\"col-md-10\">{{ actualFile }} <span ng-if=\"!actualFile\">Brak pliku</span></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Załącz nowy plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"upload($file)\" ng-model=\"$parent.file\" ngf-max-size=\"20MB\"><span class=\"d-add-file\">Dodaj nowy</span><br>{{ file.name }}</div></div></div><div class=\"row spaceBottom\"><div class=\"col-md-2\"></div><div class=\"col-md-10\"><input type=\"checkbox\" class=\"checkbox checkBoxNormal\" ng-model=\"$parent.value.addToNews\"> Dodaj do aktualności</div></div><a href=\"\" class=\"btn-abort\" data-ng-click=\"showEditPopup(false)\">anuluj</a> <a href=\"\" class=\"btn-preview\" ng-click=\"openPreview(\'/podglad/oferty-pracy\')\">podgląd</a> <a class=\"btn-accept\" type=\"submit\" ng-click=\"editOffer()\">aktualizuj</a></form></div>");
$templateCache.put("app/partials/workoffers/workoffers.cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodaj ofertę pracy</span></div><a class=\"d-btn-add spaceBottom\" ui-sref=\"dashboard.addworkoffers\">Dodaj ofertę pracy</a><div class=\"d-sub-title spaceTop\"><span>Oferty pracy</span></div><table class=\"d-table\"><thead><tr><td>Tytuł</td><td>Data</td><td>Aktualizacja</td><td>Publikacja</td><td>Dodał</td><td></td><td></td></tr></thead><tbody><tr ng-repeat=\"job in jobsFromBackend\"><td>{{ job.title }}</td><td>{{ job.created_at | date: \'shortDate\' }}</td><td>{{ job.updated_at | date: \'shortDate\' }}</td><td ng-if=\"job.published\">Opublikowano</td><td ng-if=\"!job.published\">Szkic</td><td>{{ job.created_by_name }}</td><td><a href=\"\" data-ng-click=\"showEditPopup(true, job.id)\">Edytuj</a></td><td><img data-ng-click=\"showDeletePopup(true, job.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></td></tr></tbody></table><div class=\"row pagination\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"pagination-div\" ng-show=\"jobsFromBackend.length\"><ul><li><p>Strona:</p></li><li><button type=\"button\" ng-disabled=\"currentPage == 0\" ng-click=\"currentPage=currentPage-1\" class=\"page-left\"></button></li><li><div class=\"page-numbers\"><a>{{currentPage + 1}}</a> z <a>{{ numberOfPages() }}</a></div></li><li><button type=\"button\" ng-disabled=\"currentPage >= numberOfPages() - 1\" ng-click=\"currentPage = currentPage+1\" class=\"page-right\"></button></li></ul></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><p class=\"display\">Wyświetlaj: <span><b class=\"active\" data-id=\"1\" ng-click=\"howManyNewsAreDisplayed(10, 1)\">10</b> | <b data-id=\"2\" ng-click=\"howManyNewsAreDisplayed(20, 2)\">20</b> | <b data-id=\"3\" ng-click=\"howManyNewsAreDisplayed(50, 3)\">50</b></span></p></div></div><div ng-include=\"\'app/templates/deletePopup/deletePopup.cms.html\'\"></div><div ng-include=\"\'app/partials/workoffers/editworkoffer.cms.html\'\"></div>");
$templateCache.put("app/partials/workoffers/workoffers.html","<div class=\"container\"><div class=\"cont-for-content\"><img src=\"../assets/images/preloader.gif\" class=\"preloader\" ng-hide=\"jobsFromBackend.dataLoaded\"><div ng-show=\"jobsFromBackend.dataLoaded\"><div class=\"row cont-for-list-element\" ng-repeat=\"job in jobsFromBackend\"><article><div class=\"col-md-10\"><h1>{{ job.title }}<span class=\"dateSpan\">dodano: {{ job.created_at | date: \'shortDate\' }}</span></h1></div><div class=\"col-md-2\"><p class=\"download-document\"><a ng-click=\"openLink(job.documents[0].file_path)\">Dokument</a></p></div></article></div></div><div class=\"row cont-for-list-element\" ng-show=\"showNoResults\"><article><h1>Brak wyników</h1></article></div><div class=\"row pagination\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"pagination-div\" ng-show=\"jobsFromBackend.length\"><ul><li><p>Strona:</p></li><li><button type=\"button\" ng-disabled=\"currentPage == 0\" ng-click=\"currentPage=currentPage-1\" class=\"page-left\"></button></li><li><div class=\"page-numbers\"><a>{{currentPage + 1}}</a> z <a ng-click=\"currentPage = numberOfPages() - 1\">{{ numberOfPages() }}</a></div></li><li><button type=\"button\" ng-disabled=\"currentPage >= numberOfPages() - 1\" ng-click=\"currentPage = currentPage+1\" class=\"page-right\"></button></li></ul></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><p class=\"display\">Wyświetlaj: <span><b class=\"active\" data-id=\"1\" ng-click=\"howManyNewsAreDisplayed(10, 1)\">10</b> | <b data-id=\"2\" ng-click=\"howManyNewsAreDisplayed(20, 2)\">20</b> | <b data-id=\"3\" ng-click=\"howManyNewsAreDisplayed(50, 3)\">50</b></span></p></div></div></div></div>");
$templateCache.put("app/partials/workoffers/workoffers.preview.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row cont-for-list-element\"><article><div class=\"col-md-10\"><h1>{{ previewData.title }}<span class=\"dateSpan\">dodano: {{ date | date: \'shortDate\' }}</span></h1></div><div class=\"col-md-2\"><p class=\"download-document\"><a>Dokument</a></p></div></article></div><div class=\"row cont-for-list-element\" ng-repeat=\"job in jobsFromBackend | limitTo: 5\"><article><div class=\"col-md-10\"><h1>{{ job.title }}<span class=\"dateSpan\">dodano: {{ job.created_at | date: \'shortDate\' }}</span></h1></div><div class=\"col-md-2\"><p class=\"download-document\"><a ng-click=\"openLink(job.documents[0].file_path)\">Dokument</a></p></div></article></div></div></div>");
$templateCache.put("app/partials/adv/cms/cms.html","<div class=\"d-sub-title spaceTop\"><span>Opis</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"AdvertisersCmsCtrl.advFromBackendTitle\" ng-change=\"AdvertisersCmsCtrl.update()\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"AdvertisersCmsCtrl.advFromBackendContent\" ng-change=\"AdvertisersCmsCtrl.update()\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div></form><div class=\"d-sub-title spaceTop\"><span>Dodaj</span></div><a class=\"d-btn-add spaceBottom\" ui-sref=\"dashboard.add_advertiser\">Dodaj</a><div class=\"d-sub-title spaceTop\"><span>Reklamodawcy</span></div><table class=\"d-table\"><thead><tr><td>Tytuł</td><td>Data</td><td>Aktualizacja</td><td>Publikacja</td><td>Dodał</td><td></td><td></td></tr></thead><tbody><tr ng-repeat=\"item in AdvertisersCmsCtrl.dataFromBackend.results\"><td>{{ item.title }}</td><td>{{ item.created_at | date: \'shortDate\' }}</td><td>{{ item.updated_at | date: \'shortDate\' }}</td><td ng-if=\"item.published\">Opublikowano</td><td ng-if=\"!item.published\">Szkic</td><td>{{ item.created_by_name }}</td><td><a ui-sref=\"dashboard.edit_advertiser({id: item.id})\">Edytuj</a></td><td><img data-ng-click=\"AdvertisersCmsCtrl.confirmDialog(item.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></td></tr></tbody></table><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div>");
$templateCache.put("app/partials/adv/web/web.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row cont-for-list-element\"><article class=\"expand-text\"><div class=\"col-md-12\"><h1>{{ AdvertisersCtrl.advFromBackendTitle }}</h1><div class=\"inner-content\"><div class=\"inner-box\"><p ng-bind-html=\"AdvertisersCtrl.advFromBackendContent | TrustedHtml\"></p></div></div></div></article></div><img src=\"../assets/images/preloader.gif\" class=\"preloader\" ng-hide=\"AdvertisersCtrl.dataFromBackend.dataLoaded\"><div ng-show=\"AdvertisersCtrl.dataFromBackend.dataLoaded\"><div class=\"row cont-for-list-element\" data-id=\"{{ item.id }}\" ng-repeat=\"item in AdvertisersCtrl.dataFromBackend.results | limitTo: displayedPosts\" ng-click=\"AdvertisersCtrl.toggleBtn(item.id); checkActive();\" ng-init=\"sectionIndex = $index\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ item.title }}<span class=\"dateSpan\">dodano: {{ item.created_at | date: \'shortDate\' }}</span></h1><div class=\"inner-content\"><div class=\"inner-box\" ng-click=\"$event.stopPropagation()\"><p ng-bind-html=\"item.body | TrustedHtml\">{{ item.body }}</p><div class=\"row spaceLeftInArticle\"><img ng-repeat=\"doc in item.documents\" class=\"backEndPhotoInArticle\" ng-if=\"doc.file_path.indexOf(\'.png\') > -1 || doc.file_path.indexOf(\'.jpg\') > -1\" ng-src=\"{{ doc.file_path }}\" data-ng-click=\"showPopup(true, item.id, doc.id, sectionIndex)\"></div><div class=\"row spaceLeftInArticle\"><a ng-repeat=\"doc in item.documents\" ng-if=\"item.documents[0]\" ng-click=\"openLink(doc.file_path)\"><span ng-if=\"doc.file_path.indexOf(\'.pdf\') > -1 || doc.file_path.indexOf(\'.doc\') > -1 || doc.file_path.indexOf(\'.docx\') > -1 || doc.file_path.indexOf(\'.txt\') > -1\">{{ doc.title }}<br></span><br></a></div></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\"><span></span><img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div><div class=\"row cont-for-list-element\" ng-show=\"AdvertisersCtrl.showNoResults\"><article><h1>Brak wyników</h1></article></div><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div></div></div><div class=\"gallery-background\" data-ng-show=\"displayPopup\" ng-click=\"showPopup(false)\"></div><div class=\"gallery-popup\" data-ng-show=\"displayPopup\"><img src=\"../assets/images/exit-ico.png\" class=\"exit-ico\" data-ng-click=\"showPopup(false)\"> <img src=\"{{ oneImage.file_path }}\" class=\"popup-image\"><div class=\"settlement-arrow prev\" ng-click=\"imageRotate(0)\"></div><div class=\"settlement-arrow next\" ng-click=\"imageRotate(1)\"></div><p>{{ oneImage.title }}</p></div><script>\r\n    $(document).ready(function() {\r\n        var activeItem = new ActiveItem();\r\n        activeItem.collapseAndExpandAll(\"#show-hide-all\", \".cont-for-list-element\");\r\n    });\r\n</script>");
$templateCache.put("app/partials/coworking/cms/cms.html","<div class=\"d-sub-title spaceTop\"><span>Spółdzielnia</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS spaceTop\"><div class=\"col-md-12\"><input type=\"text\" class=\"longInput\" ng-change=\"BigPicturesCtrl.update()\" ng-model=\"BigPicturesCtrl.settleFromBackendTitle\"></div><div class=\"col-md-12\"><text-angular ng-model=\"BigPicturesCtrl.settleFromBackendBody\" ng-change=\"BigPicturesCtrl.update()\" ta-paste=\"stripFormat($html)\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div></form>");
$templateCache.put("app/partials/coworking/web/coworking.html","<div class=\"container standard-page\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><h1>{{ CoworkingCtrl.coworkingFromBackendTitle }}</h1><p ng-bind-html=\"CoworkingCtrl.coworkingFromBackendBody | TrustedHtml\"></p></div><div class=\"col-md-6 col-xs-12\"><img src=\"../assets/images/coworking_bg.jpg\" alt=\"współpraca\"></div></div></div>");
$templateCache.put("app/partials/culture/cms/culture.html","<div class=\"d-sub-title spaceTop\"><span>Dodaj</span></div><a class=\"d-btn-add spaceBottom\" ui-sref=\"dashboard.add_culture\">Dodaj</a><div class=\"d-sub-title spaceTop\"><span>Wydarzenia</span></div><div class=\"d-form spaceBottom\"><label>Publikacja:</label><select ng-model=\"published\" ng-options=\"item.value as item.name for item in CultureCmsCtrl.publishedOptions\"><option value=\"\">Pokaż wszystkie</option></select></div><table class=\"d-table\"><thead><tr><td>Tytuł</td><td>Data wydarzenia</td><td>Kategoria</td><td>Data dodania</td><td>Aktualizacja</td><td>Publikacja</td><td>Dodał</td><td></td><td></td></tr></thead><tbody><tr ng-repeat=\"item in CultureCmsCtrl.dataFromBackend\"><td>{{ item.title }}</td><td>{{ item.event_date }}</td><td>{{ item.category.name }}</td><td>{{ item.created_at | date: \'yyyy-MM-dd\' }}</td><td>{{ item.updated_at | date: \'yyyy-MM-dd\' }}</td><td ng-if=\"item.published\">Opublikowano</td><td ng-if=\"!item.published\">Szkic</td><td>{{ item.created_by_name }}</td><td><a ui-sref=\"dashboard.edit_culture({id: item.id})\">Edytuj</a></td><td><img data-ng-click=\"CultureCmsCtrl.confirmDialog(item.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></td></tr></tbody></table><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div>");
$templateCache.put("app/partials/culture/web/event.html","<div class=\"dialog-inside\" ng-controller=\"DeleteDialogController as DeleteDialogCtrl\"><h1 class=\"formTitle\">{{ OneEventCtrl.dataFromBackend.title }}</h1><img ng-src=\"{{ OneEventCtrl.dataFromBackend.documents[0].file_path }}\"><p class=\"formSubTitle\" ng-bind-html=\"OneEventCtrl.dataFromBackend.body | TrustedHtml\">Czy chcesz usunąć wybrany element?</p></div>");
$templateCache.put("app/partials/culture/web/web.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row head-of-lists\"><div class=\"col-xs-6\"><label>Kategoria:</label><select ng-model=\"categoryFilter\" ng-change=\"changeCategory(categoryFilter)\" ng-options=\"category.id as category.name for category in CultureCtrl.categoriesFromBackend\"><option value=\"\">Pokaż wszystkie</option></select></div><div class=\"col-xs-6\"><p class=\"show-hide-all\" id=\"show-hide-all\" ng-click=\"checkActive()\">{{ showHideAll }} <img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 1\"></p></div></div><img src=\"../assets/images/preloader.gif\" class=\"preloader\" ng-hide=\"cultureFromBackend.dataLoaded\"><div ng-show=\"cultureFromBackend.dataLoaded\"><div class=\"row cont-for-list-element\" data-id=\"{{ news.id }}\" ng-repeat=\"news in cultureFromBackend | limitTo: displayedPosts\" ng-click=\"toggleBtn(news.id); checkActive();\" value=\"{{ news.category.name }}\" ng-init=\"sectionIndex = $index\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ news.title }}, {{ news.event_date | date: \'shortDate\' }}<span class=\"dateSpan\">kategoria: {{ news.category.name }}</span></h1><div class=\"inner-content\"><div class=\"inner-box\" ng-click=\"$event.stopPropagation()\"><p ng-bind-html=\"news.body | TrustedHtml\">{{ news.body }}</p><div class=\"row spaceLeftInArticle\"><img ng-repeat=\"doc in news.documents\" class=\"backEndPhotoInArticle\" ng-if=\"doc.file_path.indexOf(\'.png\') > -1 || doc.file_path.indexOf(\'.jpg\') > -1\" ng-src=\"{{ doc.file_path }}\" data-ng-click=\"showPopup(true, news.id, doc.id, sectionIndex)\"></div><div class=\"row spaceLeftInArticle\"><a ng-repeat=\"doc in news.documents\" ng-if=\"news.documents[0]\" ng-click=\"openLink(doc.file_path)\"><span ng-if=\"doc.file_path.indexOf(\'.pdf\') > -1 || doc.file_path.indexOf(\'.doc\') > -1 || doc.file_path.indexOf(\'.docx\') > -1 || doc.file_path.indexOf(\'.txt\') > -1\">{{ doc.title }}<br></span><br></a></div></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\"><span></span><img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div><div class=\"row cont-for-list-element\" ng-show=\"showNoResults\"><article><h1>Brak wyników</h1></article></div><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div></div></div><div class=\"gallery-background\" data-ng-show=\"displayPopup\" ng-click=\"showPopup(false)\"></div><div class=\"gallery-popup\" data-ng-show=\"displayPopup\"><img src=\"../assets/images/exit-ico.png\" class=\"exit-ico\" data-ng-click=\"showPopup(false)\"> <img src=\"{{ oneImage.file_path }}\" class=\"popup-image\"><div class=\"settlement-arrow prev\" ng-click=\"imageRotate(0)\"></div><div class=\"settlement-arrow next\" ng-click=\"imageRotate(1)\"></div><p>{{ oneImage.title }}</p></div><script>\r\n    $(document).ready(function() {\r\n        var activeItem = new ActiveItem();\r\n        activeItem.collapseAndExpandAll(\"#show-hide-all\", \".cont-for-list-element\");\r\n    });\r\n</script>");
$templateCache.put("app/partials/eco/cms/cms.html","<div class=\"d-sub-title spaceTop\"><span>Ekologia</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS spaceTop\"><div class=\"col-md-12\"><input type=\"text\" class=\"longInput\" ng-change=\"EcoCmsCtrl.update()\" ng-model=\"EcoCmsCtrl.dataFromBackendTitle\"></div><div class=\"col-md-12\"><text-angular ng-model=\"EcoCmsCtrl.dataFromBackendBody\" ng-change=\"EcoCmsCtrl.update()\" ta-paste=\"stripFormat($html)\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div></form>");
$templateCache.put("app/partials/eco/web/eco.html","<div class=\"container standard-page\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><h1>{{ EcoWebCtrl.dataFromBackendTitle }}</h1><p ng-bind-html=\"EcoWebCtrl.dataFromBackendBody | TrustedHtml\"></p></div><div class=\"col-md-6 col-xs-12\"><img src=\"../assets/images/ekologia.jpg\" alt=\"ekologia\"></div></div></div>");
$templateCache.put("app/partials/funding/cms/add-funding.cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodajesz nowe dofinansowanie</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"newsTitle\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"newsBody\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"published\"><option value=\"True\">Opublikuj</option><option value=\"False\">Szkic</option></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><button class=\"d-btn-add-content\" ng-click=\"openLink(\'/podglad/dofinansowanie\')\">podgląd</button> <button class=\"d-btn-add-content\" ng-click=\"submit()\">dodaj</button></form>");
$templateCache.put("app/partials/funding/cms/edit-funding.cms.html","<div class=\"d-edit-popup\" data-ng-show=\"displayEditPopup\"><div class=\"d-sub-title\"><span>Edytujesz aktualność</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł aktualności</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"$parent.value.title\" ng-init=\"$parent.value.title=\'\'\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść aktualności</label></div><div class=\"col-md-10\"><text-angular ng-model=\"$parent.value.body\" ta-paste=\"stripFormat($html)\" ng-init=\"$parent.value.body=\'\'\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"$parent.value.published\" ng-options=\"item.value as item.name for item in publishedOptions\"></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottom\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"$parent.files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><a href=\"\" class=\"btn-abort\" data-ng-click=\"showEditPopup(false)\">anuluj</a> <a href=\"\" class=\"btn-preview\" ng-click=\"openLink(\'/podglad/aktualnosci\')\">podgląd</a> <a class=\"btn-accept\" type=\"submit\" ng-click=\"editNews()\">aktualizuj</a></form></div>");
$templateCache.put("app/partials/funding/cms/funding.cms.html","<form class=\"d-form spaceBottom spaceTop\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"advFromBackendTitle\" ng-change=\"update()\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"advFromBackendContent\" ng-change=\"update()\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-xs-12\"><label>{{ advImage.content.title }}</label></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadPhoto($files)\" ng-model=\"file\"><span class=\"d-add-file\">Zdjęcie</span></div></div></div></form><div class=\"d-sub-title spaceTop\"><span>Dodaj Dofinansowanie</span></div><a class=\"d-btn-add spaceBottom\" ui-sref=\"dashboard.add-funding\">Dodaj dofinansowanie</a><div class=\"d-sub-title spaceTop\"><span>Dofinansowanie</span></div><div class=\"d-form spaceBottom\"><label>Publikacja:</label><select ng-model=\"publicFilter\" ng-init=\"publicFilter = \'0\'\" ng-change=\"changePublicFilter(publicFilter)\"><option value=\"0\" ng-selected=\"true\">Pokaż wszystkie</option><option value=\"True\">Opublikowano</option><option value=\"False\">Szkic</option></select></div><table class=\"d-table\"><thead><tr><td>Tytuł</td><td>Data</td><td>Aktualizacja</td><td>Publikacja</td><td>Dodał</td><td></td><td></td><td>Pozycja</td></tr></thead><tbody><tr ng-repeat=\"new in newsFromBackend | limitTo: displayedPosts\"><td>{{ new.title }}</td><td>{{ new.created_at | date: \'shortDate\' }}</td><td>{{ new.updated_at | date: \'shortDate\' }}</td><td ng-if=\"new.published\">Opublikowano</td><td ng-if=\"!new.published\">Szkic</td><td>{{ new.created_by_name }}</td><td><a href=\"\" data-ng-click=\"showEditPopup(true, new.id)\">Edytuj</a></td><td><img data-ng-click=\"showDeletePopup(true, new.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></td><td><div class=\"col-md-12 d-position-arrows-container\"><img src=\"../assets/images/posUp-ico.png\" class=\"d-btn-position-arrows\" ng-click=\"changePosition(new.id, \'up\')\"></div><div class=\"col-md-12 d-position-arrows-container\"><img src=\"../assets/images/posDown-ico.png\" class=\"d-btn-position-arrows\" ng-click=\"changePosition(new.id, \'down\')\"></div></td></tr></tbody></table><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div><div ng-include=\"\'app/templates/deletePopup/deletePopup.cms.html\'\"></div><div ng-include=\"\'app/partials/funding/cms/edit-funding.cms.html\'\"></div>");
$templateCache.put("app/partials/funding/cms/funding.preview.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row cont-for-list-element active\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ previewData.title }}</h1><div class=\"inner-content\"><div class=\"inner-box\"><p ng-bind-html=\"previewData.body | TrustedHtml\">{{ previewData.body }}</p><a ng-repeat=\"doc in previewData.documents\"><span>{{ doc }}</span><br></a></div></div></div><div class=\"col-md-2\"></div></article></div><div class=\"row cont-for-list-element\" data-id=\"{{ news.id }}\" ng-repeat=\"news in newsFromBackend | limitTo: 5\" ng-click=\"toggleBtn(news.id)\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ news.title }}<span class=\"dateSpan\">dodano: {{ news.created_at | date: \'shortDate\' }}, kategoria: {{ news.category.name }}</span></h1><div class=\"inner-content\"><div class=\"inner-box\"><p ng-bind-html=\"news.body | TrustedHtml\">{{ news.body }}</p><a ng-if=\"news.documents[0]\" ng-repeat=\"doc in news.documents\" ng-click=\"openLink(doc.file_path)\">{{ doc.title }}<br></a></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\">Rozwiń<img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div></div>");
$templateCache.put("app/partials/funding/web/funding.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row cont-for-list-element\"><article class=\"expand-text\"><div class=\"col-md-12\"><img src=\"{{ fundingImg.file_path }}\" alt=\"{{ fundingImg.title }}\" class=\"img-responsive img-funding spaceBottom\"><h1 class=\"spaceBottomXS\">{{ fundingTitle }}</h1><div class=\"inner-content\"><div class=\"inner-box\"><p ng-bind-html=\"fundingDescription | TrustedHtml\"></p></div></div></div></article></div><div class=\"row head-of-lists\"><div class=\"col-sm-12\"><p class=\"show-hide-all\" id=\"show-hide-all\" ng-click=\"checkActive()\">{{ showHideAll }}<img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 1\"></p></div></div><img src=\"../assets/images/preloader.gif\" class=\"preloader\" ng-hide=\"newsFromBackend.dataLoaded\"><div ng-show=\"newsFromBackend.dataLoaded\"><div class=\"row cont-for-list-element\" data-id=\"{{ news.id }}\" ng-repeat=\"news in newsFromBackend | limitTo: displayedPosts\" ng-click=\"toggleBtn(news.id); checkActive();\" value=\"{{ news.category.name }}\" ng-init=\"sectionIndex = $index\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ news.title }}<span class=\"dateSpan\">dodano: {{ news.created_at | date: \'shortDate\' }}</span></h1><div class=\"inner-content\"><div class=\"inner-box\" ng-click=\"$event.stopPropagation()\"><p ng-bind-html=\"news.body | TrustedHtml\">{{ news.body }}</p><div class=\"row spaceLeftInArticle\"><img ng-repeat=\"doc in news.documents\" class=\"backEndPhotoInArticle\" ng-if=\"doc.file_path.indexOf(\'.png\') > -1 || doc.file_path.indexOf(\'.jpg\') > -1 || doc.file_path.indexOf(\'.jpeg\') > -1 || doc.file_path.indexOf(\'.JPG\') > -1 || doc.file_path.indexOf(\'.JPEG\') > -1 || doc.file_path.indexOf(\'.PNG\') > -1\" ng-src=\"{{ doc.file_path }}\" data-ng-click=\"showPopup(true, news.id, doc.id, sectionIndex)\"></div><div class=\"row spaceLeftInArticle\"><a ng-repeat=\"doc in news.documents\" ng-if=\"news.documents[0]\" ng-click=\"openLink(doc.file_path)\"><span ng-if=\"doc.file_path.indexOf(\'.pdf\') > -1 || doc.file_path.indexOf(\'.doc\') > -1 || doc.file_path.indexOf(\'.docx\') > -1 || doc.file_path.indexOf(\'.txt\') > -1\">{{ doc.title }}<br></span><br></a></div></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\"><span></span><img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div><div class=\"row cont-for-list-element\" ng-show=\"showNoResults\"><article><h1>Brak wyników</h1></article></div><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div></div></div><div class=\"gallery-background\" data-ng-show=\"displayPopup\" ng-click=\"showPopup(false)\"></div><div class=\"gallery-popup\" data-ng-show=\"displayPopup\"><img src=\"../assets/images/exit-ico.png\" class=\"exit-ico\" data-ng-click=\"showPopup(false)\"> <img src=\"{{ oneImage.file_path }}\" class=\"popup-image\"><div class=\"settlement-arrow prev\" ng-click=\"imageRotate(0)\"></div><div class=\"settlement-arrow next\" ng-click=\"imageRotate(1)\"></div><p>{{ oneImage.title }}</p></div><script>\n    $(document).ready(function() {\n        var activeItem = new ActiveItem();\n        activeItem.collapseAndExpandAll(\"#show-hide-all\", \".cont-for-list-element\");\n    });\n</script>");
$templateCache.put("app/partials/history/cms/cms.html","<div class=\"d-sub-title spaceTop\"><span>Historia</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS spaceTop\"><div class=\"col-md-12\"><input type=\"text\" class=\"longInput\" ng-change=\"HistoryCmsCtrl.update()\" ng-model=\"HistoryCmsCtrl.coworkingFromBackendTitle\"></div><div class=\"col-md-12\"><text-angular ng-model=\"HistoryCmsCtrl.coworkingFromBackendBody\" ng-change=\"HistoryCmsCtrl.update()\" ta-paste=\"stripFormat($html)\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div></form>");
$templateCache.put("app/partials/history/web/history.html","<div class=\"container standard-page\"><div class=\"row history\"><div class=\"col-xs-12\"><h1>{{ HistoryWebCtrl.dataFromBackendTitle }}</h1><p ng-bind-html=\"HistoryWebCtrl.dataFromBackendBody | TrustedHtml\"></p></div></div></div>");
$templateCache.put("app/partials/informations/cms/addinfo.cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodaj</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"newsTitle\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"newsBody\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"published\"><option value=\"True\">Opublikuj</option><option value=\"False\">Szkic</option></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><button class=\"d-btn-add-content\" ng-click=\"openLink(\'/podglad/procedury\')\">podgląd</button> <button class=\"d-btn-add-content\" ng-click=\"submit()\">dodaj</button></form>");
$templateCache.put("app/partials/informations/cms/editinfo.cms.html","<div class=\"d-edit-popup\" data-ng-show=\"displayEditPopup\"><div class=\"d-sub-title\"><span>Edytuj</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"$parent.value.title\" ng-init=\"$parent.value.title=\'\'\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"$parent.value.body\" ta-paste=\"stripFormat($html)\" ng-init=\"$parent.value.body=\'\'\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"$parent.value.published\" ng-options=\"item.value as item.name for item in publishedOptions\"></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottom\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"$parent.files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><a href=\"\" class=\"btn-abort\" data-ng-click=\"showEditPopup(false)\">anuluj</a> <a href=\"\" class=\"btn-preview\" ng-click=\"openLink(\'/podglad/procedury\')\">podgląd</a> <a class=\"btn-accept\" type=\"submit\" ng-click=\"editNews(regToEdit.id, value)\">aktualizuj</a></form></div>");
$templateCache.put("app/partials/informations/cms/info.cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodaj</span></div><a class=\"d-btn-add spaceBottom\" ui-sref=\"dashboard.addInfo\">Dodaj</a><div class=\"d-sub-title spaceTop\"><span>Procedury</span></div><table class=\"d-table\"><thead><tr><td>Tytuł</td><td>Data</td><td>Aktualizacja</td><td>Publikacja</td><td>Dodał</td><td></td><td></td><td>Pozycja</td></tr></thead><tbody><tr ng-repeat=\"new in newsFromBackend | limitTo: displayedPosts\"><td>{{ new.title }}</td><td>{{ new.created_at | date: \'shortDate\' }}</td><td>{{ new.updated_at | date: \'shortDate\' }}</td><td ng-if=\"new.published\">Opublikowano</td><td ng-if=\"!new.published\">Szkic</td><td>{{ new.created_by_name }}</td><td><a href=\"\" data-ng-click=\"showEditPopup(true, new.id)\">Edytuj</a></td><td><img data-ng-click=\"showDeletePopup(true, new.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></td><td><div class=\"col-md-12 d-position-arrows-container\"><img src=\"../assets/images/posUp-ico.png\" class=\"d-btn-position-arrows\" ng-click=\"changePosition(new.id, \'up\')\"></div><div class=\"col-md-12 d-position-arrows-container\"><img src=\"../assets/images/posDown-ico.png\" class=\"d-btn-position-arrows\" ng-click=\"changePosition(new.id, \'down\')\"></div></td></tr></tbody></table><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div><div ng-include=\"\'app/templates/deletePopup/deletePopup.cms.html\'\"></div><div ng-include=\"\'app/partials/informations/cms/editinfo.cms.html\'\"></div>");
$templateCache.put("app/partials/informations/cms/info.preview.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row cont-for-list-element active\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ previewData.title }}</h1><div class=\"inner-content\"><div class=\"inner-box\"><p ng-bind-html=\"previewData.body | TrustedHtml\">{{ previewData.body }}</p><a ng-repeat=\"doc in previewData.documents\"><span>{{ doc }}</span><br></a></div></div></div><div class=\"col-md-2\"></div></article></div><div class=\"row cont-for-list-element\" data-id=\"{{ news.id }}\" ng-repeat=\"news in newsFromBackend | limitTo: 5\" ng-click=\"toggleBtn(news.id)\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ news.title }}</h1><div class=\"inner-content\"><div class=\"inner-box\"><p ng-bind-html=\"news.body | TrustedHtml\">{{ news.body }}</p><a ng-if=\"news.documents[0]\" ng-repeat=\"doc in news.documents\" ng-click=\"openLink(doc.file_path)\">{{ doc.title }}<br></a></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\">Rozwiń<img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div></div>");
$templateCache.put("app/partials/informations/web/info.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row head-of-lists\"><div class=\"col-md-6 col-sm-6 col-xs-7\"></div><div class=\"col-md-6 col-sm-6 col-xs-5\"><p class=\"show-hide-all\" id=\"show-hide-all\" ng-click=\"checkActive()\">{{ showHideAll }}<img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 1\"></p></div></div><img src=\"../assets/images/preloader.gif\" class=\"preloader\" ng-hide=\"newsFromBackend.dataLoaded\"><div ng-show=\"newsFromBackend.dataLoaded\"><div class=\"row cont-for-list-element\" data-id=\"{{ news.id }}\" ng-repeat=\"news in newsFromBackend | limitTo: displayedPosts\" ng-click=\"toggleBtn(news.id); checkActive();\" value=\"{{ news.category.name }}\" ng-init=\"sectionIndex = $index\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ news.title }}</h1><div class=\"inner-content\"><div class=\"inner-box\" ng-click=\"$event.stopPropagation()\"><p ng-bind-html=\"news.body | TrustedHtml\">{{ news.body }}</p><div class=\"row spaceLeftInArticle\"><img ng-repeat=\"doc in news.documents\" class=\"backEndPhotoInArticle\" ng-if=\"doc.file_path.indexOf(\'.png\') > -1 || doc.file_path.indexOf(\'.jpg\') > -1\" src=\"{{ doc.file_path }}\" data-ng-click=\"showPopup(true, news.id, doc.id, sectionIndex)\"></div><div class=\"row spaceLeftInArticle\"><a ng-repeat=\"doc in news.documents\" ng-if=\"news.documents[0]\" ng-click=\"openLink(doc.file_path)\"><span ng-if=\"doc.file_path.indexOf(\'.pdf\') > -1 || doc.file_path.indexOf(\'.doc\') > -1 || doc.file_path.indexOf(\'.docx\') > -1 || doc.file_path.indexOf(\'.txt\') > -1\">{{ doc.title }}<br></span><br></a></div></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\"><span></span><img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div><div class=\"row cont-for-list-element\" ng-show=\"showNoResults\"><article><h1>Brak wyników</h1></article></div><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div></div></div><div class=\"gallery-background\" data-ng-show=\"displayPopup\" ng-click=\"showPopup(false)\"></div><div class=\"gallery-popup\" data-ng-show=\"displayPopup\"><img src=\"../assets/images/exit-ico.png\" class=\"exit-ico\" data-ng-click=\"showPopup(false)\"> <img src=\"{{ oneImage.file_path }}\" class=\"popup-image\"><div class=\"settlement-arrow prev\" ng-click=\"imageRotate(0)\"></div><div class=\"settlement-arrow next\" ng-click=\"imageRotate(1)\"></div><p>{{ oneImage.title }}</p></div><script>\r\n    $(document).ready(function() {\r\n        var activeItem = new ActiveItem();\r\n        activeItem.collapseAndExpandAll(\"#show-hide-all\", \".cont-for-list-element\");\r\n    });\r\n</script>");
$templateCache.put("app/partials/localizations/cms/add_new_settlement.html","<div class=\"dialog-inside\"><h1 class=\"formTitle\">Dodawanie osiedla</h1><div class=\"row spaceTop\"><form class=\"d-form\"><div class=\"col-md-12\"><input type=\"text\" class=\"longInput\" ng-model=\"LocalizationsCmsCtrl.new_settlement\" placeholder=\"Nazwa osiedla\"></div><div class=\"col-md-12\"><text-angular ng-model=\"LocalizationsCmsCtrl.new_body\" ta-paste=\"stripFormat($html)\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div><div class=\"col-md-12\"><text-angular ng-model=\"LocalizationsCmsCtrl.new_body_2\" ta-paste=\"stripFormat($html)\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div><div class=\"col-md-12\"><text-angular ng-model=\"LocalizationsCmsCtrl.new_body_3\" ta-paste=\"stripFormat($html)\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></form></div><div class=\"row spaceTop\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><a class=\"btn-dialog-blue\" ng-click=\"LocalizationsCmsCtrl.sendNewSettlement()\">Dodaj</a></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><a class=\"btn-red-close-quit-delete\" ng-click=\"closeThisDialog()\">Anuluj</a></div></div></div>");
$templateCache.put("app/partials/localizations/cms/cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodaj osiedle</span></div><form class=\"d-form spaceBottom\"><button class=\"d-btn-add-content\" ng-click=\"LocalizationsCmsCtrl.addNewSettlement()\">dodaj osiedle</button><div class=\"row spaceBottomXS spaceTop\" ng-repeat=\"item in LocalizationsCmsCtrl.settlementsFromBackend\"><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" value=\"{{ item.settlement }}\" ng-model=\"item.settlement\" ng-change=\"LocalizationsCmsCtrl.changeSettlement(item.id, item.settlement, item.body)\"></div><div class=\"col-md-2\"><a ng-click=\"LocalizationsCmsCtrl.deleteSettlement(item.id)\" class=\"btn-red-close-quit-delete\">Usuń</a></div><div class=\"col-md-12\"><text-angular ng-model=\"item.body\" ng-change=\"LocalizationsCmsCtrl.changeSettlement(item.id, item.settlement, item.body, item.body_2, item.body_3)\" ta-paste=\"stripFormat($html)\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div><div class=\"col-md-12\"><text-angular ng-model=\"item.body_2\" ng-change=\"LocalizationsCmsCtrl.changeSettlement(item.id, item.settlement, item.body, item.body_2, item.body_3)\" ta-paste=\"stripFormat($html)\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div><div class=\"col-md-12\"><text-angular ng-model=\"item.body_3\" ng-change=\"LocalizationsCmsCtrl.changeSettlement(item.id, item.settlement, item.body, item.body_2, item.body_3)\" ta-paste=\"stripFormat($html)\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div></form><div class=\"d-sub-title spaceTop\"><span>Dodaj ulicę</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS spaceTop\"><div class=\"col-md-6\"><input type=\"text\" class=\"longInput\" ng-model=\"LocalizationsCmsCtrl.new_street_name\"></div><div class=\"col-md-4\"><select type=\"text\" class=\"longInput\" ng-model=\"LocalizationsCmsCtrl.new_street_settlement\" ng-options=\"setl.id as setl.settlement for setl in LocalizationsCmsCtrl.settlementsFromBackend\"><option value=\"\">Wybierz osiedle</option></select></div><div class=\"col-md-2\"><button class=\"d-btn-add-content\" ng-click=\"LocalizationsCmsCtrl.addNewStreet()\">dodaj ulicę</button></div></div></form><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS spaceTop\" ng-repeat=\"item in LocalizationsCmsCtrl.streetsFromBackend\"><div class=\"col-md-6\"><input type=\"text\" class=\"longInput\" ng-model=\"item.name\" ng-change=\"LocalizationsCmsCtrl.changeStreet(item.id, item.name, item.settlement)\"></div><div class=\"col-md-4\"><select type=\"text\" class=\"longInput\" ng-model=\"item.settlement\" ng-change=\"LocalizationsCmsCtrl.changeStreet(item.id, item.name, item.settlement)\" ng-options=\"setl.id as setl.settlement for setl in LocalizationsCmsCtrl.settlementsFromBackend\"><option value=\"\">Wybierz osiedle</option></select></div><div class=\"col-md-2\"><a ng-click=\"LocalizationsCmsCtrl.deleteStreet(item.id)\" class=\"btn-red-close-quit-delete\">Usuń</a></div></div></form>");
$templateCache.put("app/partials/management/cms/cms.html","<div class=\"d-sub-title spaceTop\"><span>Zarząd</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS spaceTop\"><div class=\"col-md-12\"><input type=\"text\" class=\"longInput\" ng-change=\"ManagementCmsCtrl.update()\" ng-model=\"ManagementCmsCtrl.managementFromBackendTitle\"></div><div class=\"col-md-12\"><text-angular ng-model=\"ManagementCmsCtrl.managementFromBackendBody\" ng-change=\"ManagementCmsCtrl.update()\" ta-paste=\"stripFormat($html)\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div></form><div class=\"d-sub-title spaceTop\"><span>Rada</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS spaceTop\"><div class=\"col-md-12\"><input type=\"text\" class=\"longInput\" ng-change=\"ManagementCmsCtrl.update()\" ng-model=\"ManagementCmsCtrl.directorsFromBackendTitle\"></div><div class=\"col-md-12\"><text-angular ng-model=\"ManagementCmsCtrl.directorsFromBackendBody\" ng-change=\"ManagementCmsCtrl.update()\" ta-paste=\"stripFormat($html)\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div></form>");
$templateCache.put("app/partials/management/web/management.html","<div class=\"container standard-page\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><h1>{{ ManagementWebCtrl.managementFromBackendTitle }}</h1><p ng-bind-html=\"ManagementWebCtrl.managementFromBackendBody | TrustedHtml\"></p></div><div class=\"col-md-6 col-xs-12\"><h1>{{ ManagementWebCtrl.directorsFromBackendTitle }}</h1><p ng-bind-html=\"ManagementWebCtrl.directorsFromBackendBody | TrustedHtml\"></p></div></div></div>");
$templateCache.put("app/partials/news/cms/addnews.cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodajesz nową aktualność</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł aktualności</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"newsTitle\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Wybierz kategorię</label></div><div class=\"col-md-10\"><select ng-model=\"newsCategory\" ng-options=\"categories.name for categories in categoriesList track by categories.id\"><option value=\"\">Wybierz kategorię</option></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść aktualności</label></div><div class=\"col-md-10\"><text-angular ng-model=\"newsBody\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"published\"><option value=\"True\">Opublikuj</option><option value=\"False\">Szkic</option></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><button class=\"d-btn-add-content\" ng-click=\"openLink(\'/podglad/aktualnosci\')\">podgląd</button> <button class=\"d-btn-add-content\" ng-click=\"submit()\">dodaj aktualność</button></form>");
$templateCache.put("app/partials/news/cms/editnews.cms.html","<div class=\"d-edit-popup\" data-ng-show=\"displayEditPopup\"><div class=\"d-sub-title\"><span>Edytujesz aktualność</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł aktualności</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"$parent.value.title\" ng-init=\"$parent.value.title=\'\'\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Wybierz kategorię</label></div><div class=\"col-md-10\"><select ng-model=\"$parent.value.category\" ng-options=\"categories.name for categories in categoriesFromBackend track by categories.id\"></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść aktualności</label></div><div class=\"col-md-10\"><text-angular ng-model=\"$parent.value.body\" ta-paste=\"stripFormat($html)\" ng-init=\"$parent.value.body=\'\'\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"$parent.value.published\" ng-options=\"item.value as item.name for item in publishedOptions\"></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottom\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"$parent.files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><a href=\"\" class=\"btn-abort\" data-ng-click=\"showEditPopup(false)\">anuluj</a> <a href=\"\" class=\"btn-preview\" ng-click=\"openLink(\'/podglad/aktualnosci\')\">podgląd</a> <a class=\"btn-accept\" type=\"submit\" ng-click=\"editNews(regToEdit.id, value)\">aktualizuj</a></form></div>");
$templateCache.put("app/partials/news/cms/news.cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodaj aktualność</span></div><a class=\"d-btn-add spaceBottom\" ui-sref=\"dashboard.addNews\">Dodaj aktualność</a><div class=\"d-sub-title spaceTop\"><span>Aktualności</span></div><div class=\"d-form spaceBottom\"><label>Kategoria:</label><select ng-model=\"categoryFilter\" ng-init=\"categoryFilter = \'0\'\" ng-change=\"changeCategory(categoryFilter)\"><option value=\"0\" ng-selected=\"true\">Pokaż wszystkie</option><option ng-repeat=\"element in categoriesFromBackend\" value=\"{{ element.id }}\">{{ element.name }}</option></select><label>Publikacja:</label><select ng-model=\"publicFilter\" ng-init=\"publicFilter = \'0\'\" ng-change=\"changePublicFilter(publicFilter)\"><option value=\"0\" ng-selected=\"true\">Pokaż wszystkie</option><option value=\"True\">Opublikowano</option><option value=\"False\">Szkic</option></select></div><table class=\"d-table\"><thead><tr><td>Tytuł</td><td>Data</td><td>Aktualizacja</td><td>Publikacja</td><td>Dodał</td><td></td><td></td><td>Pozycja</td></tr></thead><tbody><tr ng-repeat=\"new in newsFromBackend | limitTo: displayedPosts\"><td>{{ new.title }}</td><td>{{ new.created_at | date: \'shortDate\' }}</td><td>{{ new.updated_at | date: \'shortDate\' }}</td><td ng-if=\"new.published\">Opublikowano</td><td ng-if=\"!new.published\">Szkic</td><td>{{ new.created_by_name }}</td><td><a href=\"\" data-ng-click=\"showEditPopup(true, new.id)\">Edytuj</a></td><td><img data-ng-click=\"showDeletePopup(true, new.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></td><td><div class=\"col-md-12 d-position-arrows-container\"><img src=\"../assets/images/posUp-ico.png\" class=\"d-btn-position-arrows\" ng-click=\"changePosition(new.id, \'up\')\"></div><div class=\"col-md-12 d-position-arrows-container\"><img src=\"../assets/images/posDown-ico.png\" class=\"d-btn-position-arrows\" ng-click=\"changePosition(new.id, \'down\')\"></div></td></tr></tbody></table><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div><div ng-include=\"\'app/templates/deletePopup/deletePopup.cms.html\'\"></div><div ng-include=\"\'app/partials/news/cms/editnews.cms.html\'\"></div>");
$templateCache.put("app/partials/news/cms/news.preview.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row cont-for-list-element active\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ previewData.title }}<span class=\"dateSpan\">kategoria: {{ previewData.category.name }}</span></h1><div class=\"inner-content\"><div class=\"inner-box\"><p ng-bind-html=\"previewData.body | TrustedHtml\">{{ previewData.body }}</p><a ng-repeat=\"doc in previewData.documents\"><span>{{ doc }}</span><br></a></div></div></div><div class=\"col-md-2\"></div></article></div><div class=\"row cont-for-list-element\" data-id=\"{{ news.id }}\" ng-repeat=\"news in newsFromBackend | limitTo: 5\" ng-click=\"toggleBtn(news.id)\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ news.title }}<span class=\"dateSpan\">dodano: {{ news.created_at | date: \'shortDate\' }}, kategoria: {{ news.category.name }}</span></h1><div class=\"inner-content\"><div class=\"inner-box\"><p ng-bind-html=\"news.body | TrustedHtml\">{{ news.body }}</p><a ng-if=\"news.documents[0]\" ng-repeat=\"doc in news.documents\" ng-click=\"openLink(doc.file_path)\">{{ doc.title }}<br></a></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\">Rozwiń<img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div></div>");
$templateCache.put("app/partials/news/web/news.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row head-of-lists\"><div class=\"col-md-6 col-sm-6 col-xs-7\"><label>Kategoria:</label><select ng-model=\"categoryFilter\" ng-init=\"categoryFilter = \'0\'\" ng-change=\"changeCategory(categoryFilter)\"><option value=\"0\" ng-selected=\"true\">Pokaż wszystkie</option><option ng-repeat=\"element in categoriesFromBackend\" value=\"{{ element.id }}\">{{ element.name }}</option></select></div><div class=\"col-md-6 col-sm-6 col-xs-5\"><p class=\"show-hide-all\" id=\"show-hide-all\" ng-click=\"checkActive()\">{{ showHideAll }}<img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 1\"></p></div></div><img src=\"../assets/images/preloader.gif\" class=\"preloader\" ng-hide=\"newsFromBackend.dataLoaded\"><div ng-show=\"newsFromBackend.dataLoaded\"><div class=\"row cont-for-list-element\" data-id=\"{{ news.id }}\" ng-repeat=\"news in newsFromBackend | limitTo: displayedPosts\" ng-click=\"toggleBtn(news.id); checkActive();\" value=\"{{ news.category.name }}\" ng-init=\"sectionIndex = $index\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ news.title }}<span class=\"dateSpan\">dodano: {{ news.created_at | date: \'shortDate\' }}, kategoria: {{ news.category.name }}</span></h1><div class=\"inner-content\"><div class=\"inner-box\" ng-click=\"$event.stopPropagation()\"><p ng-bind-html=\"news.body | TrustedHtml\">{{ news.body }}</p><div class=\"row spaceLeftInArticle\"><img ng-repeat=\"doc in news.documents\" class=\"backEndPhotoInArticle\" ng-if=\"doc.file_path.indexOf(\'.png\') > -1 || doc.file_path.indexOf(\'.jpg\') > -1 || doc.file_path.indexOf(\'.jpeg\') > -1 || doc.file_path.indexOf(\'.JPG\') > -1 || doc.file_path.indexOf(\'.JPEG\') > -1 || doc.file_path.indexOf(\'.PNG\') > -1\" ng-src=\"{{ doc.file_path }}\" data-ng-click=\"showPopup(true, news.id, doc.id, sectionIndex)\"></div><div class=\"row spaceLeftInArticle\"><a ng-repeat=\"doc in news.documents\" ng-if=\"news.documents[0]\" ng-click=\"openLink(doc.file_path)\"><span ng-if=\"doc.file_path.indexOf(\'.pdf\') > -1 || doc.file_path.indexOf(\'.doc\') > -1 || doc.file_path.indexOf(\'.docx\') > -1 || doc.file_path.indexOf(\'.txt\') > -1\">{{ doc.title }}<br></span><br></a></div></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\"><span></span><img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div><div class=\"row cont-for-list-element\" ng-show=\"showNoResults\"><article><h1>Brak wyników</h1></article></div><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div></div></div><div class=\"gallery-background\" data-ng-show=\"displayPopup\" ng-click=\"showPopup(false)\"></div><div class=\"gallery-popup\" data-ng-show=\"displayPopup\"><img src=\"../assets/images/exit-ico.png\" class=\"exit-ico\" data-ng-click=\"showPopup(false)\"> <img src=\"{{ oneImage.file_path }}\" class=\"popup-image\"><div class=\"settlement-arrow prev\" ng-click=\"imageRotate(0)\"></div><div class=\"settlement-arrow next\" ng-click=\"imageRotate(1)\"></div><p>{{ oneImage.title }}</p></div><script>\r\n    $(document).ready(function() {\r\n        var activeItem = new ActiveItem();\r\n        activeItem.collapseAndExpandAll(\"#show-hide-all\", \".cont-for-list-element\");\r\n    });\r\n</script>");
$templateCache.put("app/partials/perfect_place/cms/cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodaj idealne miejsce</span></div><a class=\"d-btn-add spaceBottom\" ui-sref=\"dashboard.add_perfect_place\">Dodaj</a><div class=\"d-sub-title spaceTop\"><span>Idealne miejsce</span></div><table class=\"d-table\"><thead><tr><td>Tytuł</td><td>Data</td><td>Dodał</td><td></td><td></td><td>Pozycja</td></tr></thead><tbody><tr ng-repeat=\"item in PerfectPlaceCmsCtrl.dataFromBackend\"><td>{{ item.title }}</td><td>{{ item.created_at | date: \'shortDate\' }}</td><td>{{ item.created_by_name }}</td><td><a ui-sref=\"dashboard.edit_perfect_place({id: item.id})\">Edytuj</a></td><td><img ng-click=\"PerfectPlaceCmsCtrl.confirmDialog(item.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></td><td><div class=\"col-md-12 d-position-arrows-container\"><img src=\"../assets/images/posUp-ico.png\" class=\"d-btn-position-arrows\" ng-click=\"PerfectPlaceCmsCtrl.changePosition(item.id, \'up\')\"></div><div class=\"col-md-12 d-position-arrows-container\"><img src=\"../assets/images/posDown-ico.png\" class=\"d-btn-position-arrows\" ng-click=\"PerfectPlaceCmsCtrl.changePosition(item.id, \'down\')\"></div></td></tr></tbody></table>");
$templateCache.put("app/partials/perfect_place/web/web.html","<nav class=\"navbar navbar-default navbar-fixed-top navbar-prefect-place\"><div class=\"container-fluid max-width\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-1\" aria-expanded=\"false\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" ui-sref=\"perfect_place\"><img src=\"assets/images/smwp-logo.png\" alt=\"SM Wrocław-Południe Logo\" class=\"nav-logo\"></a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-1\"><ul class=\"nav navbar-nav\"><li><a ui-sref=\"perfect_place\" ui-sref-active=\"active\">Zamieszkaj na Południu</a></li><li class=\"dropdown\"><a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">Dla mieszkańców <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a ui-sref=\"website.news\" ui-sref-active=\"active\">Aktualności</a></li><li><a ui-sref=\"website.info\" ui-sref-active=\"active\">Informacje praktyczne</a></li><li><a ui-sref=\"website.funding\" ui-sref-active=\"active\">Dofinansowanie projektów</a></li><li><a ui-sref=\"website.residential_construction\" ui-sref-active=\"active\">Budownictwo mieszkaniowe</a></li><li><a href=\"https://gabaryty.ekosystem.wroc.pl/\" target=\"_blank\">Wywóz gabarytów</a></li></ul></li><li class=\"dropdown\"><a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">Współpraca <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a ui-sref=\"website.tenders\" ui-sref-active=\"active\">Przetargi</a></li><li><a ui-sref=\"website.rent\" ui-sref-active=\"active\">Lokale użytkowe</a></li><li><a ui-sref=\"website.advertisers\" ui-sref-active=\"active\">Reklamodawcy</a></li><li><a ui-sref=\"website.workoffers\" ui-sref-active=\"active\">Oferty pracy</a></li></ul></li><li class=\"dropdown\"><a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">O nas <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a ui-sref=\"website.settlement\" ui-sref-active=\"active\">Spółdzielnia</a></li><li><a ui-sref=\"website.management\" ui-sref-active=\"active\">Rada i Zarząd</a></li><li><a ui-sref=\"website.history\" ui-sref-active=\"active\">Historia</a></li><li><a ui-sref=\"website.eco\" ui-sref-active=\"active\">Ekologia</a></li><li><a ui-sref=\"website.press\" ui-sref-active=\"active\">Media o nas</a></li></ul></li><li><a href=\"http://nasze-poludnie.pl/\" target=\"_blank\">Blog</a></li><li><a ui-sref=\"website.contact\" ui-sref-active=\"active\">Kontakt</a></li></ul><ul class=\"nav navbar-nav navbar-right\"><li style=\"display: flex; align-items: center; height: 72px\"><a style=\"padding: 0\" ui-sref=\"website.funding\"><img src=\"assets/images/ue.png\" style=\"max-width: 80px;\"></a></li><li><a class=\"im\" href=\"https://smwp.imieszkaniec.pl/\">iMieszkaniec.pl</a></li><li><a class=\"ebok\" href=\"http://ebok.wroclaw-poludnie.pl/\">E-BOK</a></li></ul></div></div></nav><div ng-hide=\"PerfectPlaceCtrl.itemIndex == 1\" class=\"arrow-top\" ng-click=\"PerfectPlaceCtrl.arrowTop()\"></div><div full-page=\"\" options=\"PerfectPlaceCtrl.fullPageOptions\"><div class=\"section\" ng-repeat=\"item in PerfectPlaceCtrl.dataFromBackend\"><div class=\"big-picture-perfect-place percect-place-bg\" back-img=\"{{ item.documents[0].file_path }}\"><div class=\"center-left\" ng-class=\"item.image_position\"><h1>{{ item.title }}</h1><p ng-bind-html=\"item.body | TrustedHtml\"></p></div></div><div ng-class=\"item.image_position\" class=\"big-picture-txt\"><img class=\"big-picture-img\" src=\"{{ item.documents[0].file_path }}\"><div><h1>{{ item.title }}</h1><p ng-bind-html=\"item.body | TrustedHtml\"></p></div></div></div></div><div ng-hide=\"PerfectPlaceCtrl.itemIndex == PerfectPlaceCtrl.dataFromBackend.length\" class=\"arrow-bottom\" ng-click=\"PerfectPlaceCtrl.arrowBottom()\"></div>");
$templateCache.put("app/partials/press/cms/press.html","<div class=\"d-sub-title spaceTop\"><span>Dodaj</span></div><a class=\"d-btn-add spaceBottom\" ui-sref=\"dashboard.add_press\">Dodaj</a><div class=\"d-sub-title spaceTop\"><span>Media</span></div><table class=\"d-table\"><thead><tr><td>Tytuł</td><td>Kategoria</td><td>Data dodania</td><td>Dodał</td><td></td><td></td></tr></thead><tbody><tr ng-repeat=\"item in PressCmsCtrl.dataFromBackend\"><td>{{ item.title }}</td><td>{{ item.category.name }}</td><td>{{ item.created_at | date: \'yyyy-MM-dd\' }}</td><td>{{ item.created_by_name }}</td><td><a ui-sref=\"dashboard.edit_press({id: item.id})\">Edytuj</a></td><td><img data-ng-click=\"PressCmsCtrl.confirmDialog(item.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></td></tr></tbody></table><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div>");
$templateCache.put("app/partials/press/web/web.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row head-of-lists\"><div class=\"col-xs-6\"><label>Kategoria:</label><select ng-model=\"categoryFilter\" ng-change=\"changeCategory(categoryFilter)\" ng-options=\"item.id as item.name for item in PressCtrl.categoriesFromBackend\"><option value=\"\">Pokaż wszystkie</option></select></div><div class=\"col-xs-6\"><p class=\"show-hide-all\" id=\"show-hide-all\" ng-click=\"checkActive()\">{{ showHideAll }} <img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 1\"></p></div></div><img src=\"../assets/images/preloader.gif\" class=\"preloader\" ng-hide=\"pressFromBackend.dataLoaded\"><div ng-show=\"pressFromBackend.dataLoaded\"><div class=\"row cont-for-list-element\" data-id=\"{{ item.id }}\" ng-repeat=\"item in pressFromBackend | limitTo: displayedPosts\" ng-click=\"toggleBtn(item.id); checkActive();\" value=\"{{ item.category.name }}\" ng-init=\"sectionIndex = $index\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ item.title }}<span class=\"dateSpan\">kategoria: {{ item.category.name }}</span></h1><div class=\"inner-content\"><div class=\"inner-box\" ng-click=\"$event.stopPropagation()\"><p ng-bind-html=\"item.body | TrustedHtml\">{{ item.body }}</p><div class=\"row spaceLeftInArticle\"><img ng-repeat=\"doc in item.documents\" class=\"backEndPhotoInArticle\" ng-if=\"doc.file_path.indexOf(\'.png\') > -1 || doc.file_path.indexOf(\'.jpg\') > -1 || doc.file_path.indexOf(\'.jpeg\') > -1 || doc.file_path.indexOf(\'.JPG\') > -1 || doc.file_path.indexOf(\'.JPEG\') > -1 || doc.file_path.indexOf(\'.PNG\') > -1\" ng-src=\"{{ doc.file_path }}\" data-ng-click=\"showPopup(true, item.id, doc.id, sectionIndex)\"></div><div class=\"row spaceLeftInArticle\"><a ng-repeat=\"doc in item.documents\" ng-if=\"item.documents[0]\" ng-click=\"openLink(doc.file_path)\"><span ng-if=\"doc.file_path.indexOf(\'.pdf\') > -1 || doc.file_path.indexOf(\'.doc\') > -1 || doc.file_path.indexOf(\'.docx\') > -1 || doc.file_path.indexOf(\'.txt\') > -1\">{{ doc.title }}<br></span><br></a></div></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\"><span></span><img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div><div class=\"row cont-for-list-element\" ng-show=\"showNoResults\"><article><h1>Brak wyników</h1></article></div><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div></div></div><div class=\"gallery-background\" data-ng-show=\"displayPopup\" ng-click=\"showPopup(false)\"></div><div class=\"gallery-popup\" data-ng-show=\"displayPopup\"><img src=\"../assets/images/exit-ico.png\" class=\"exit-ico\" data-ng-click=\"showPopup(false)\"> <img src=\"{{ oneImage.file_path }}\" class=\"popup-image\"><div class=\"settlement-arrow prev\" ng-click=\"imageRotate(0)\"></div><div class=\"settlement-arrow next\" ng-click=\"imageRotate(1)\"></div><p>{{ oneImage.title }}</p></div><script>\n    $(document).ready(function() {\n        var activeItem = new ActiveItem();\n        activeItem.collapseAndExpandAll(\"#show-hide-all\", \".cont-for-list-element\");\n    });\n</script>");
$templateCache.put("app/partials/rent/cms/rent.html","<div class=\"d-sub-title spaceTop\"><span>Dodaj</span></div><a class=\"d-btn-add spaceBottom\" ui-sref=\"dashboard.add_rent\">Dodaj</a><div class=\"d-sub-title spaceTop\"><span>Lokale</span></div><table class=\"d-table\"><thead><tr><td>Tytuł</td><td>Kategoria</td><td>Data</td><td>Aktualizacja</td><td>Publikacja</td><td>Dodał</td><td></td><td></td></tr></thead><tbody><tr ng-repeat=\"item in RentCmsCtrl.dataFromBackend.results\"><td>{{ item.title }}</td><td>{{ item.rent_type.name }}</td><td>{{ item.created_at | date: \'shortDate\' }}</td><td>{{ item.updated_at | date: \'shortDate\' }}</td><td ng-if=\"item.published\">Opublikowano</td><td ng-if=\"!item.published\">Szkic</td><td>{{ item.created_by_name }}</td><td><a ui-sref=\"dashboard.edit_rent({id: item.id})\">Edytuj</a></td><td><img data-ng-click=\"RentCmsCtrl.confirmDialog(item.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></td></tr></tbody></table><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div>");
$templateCache.put("app/partials/rent/web/rent.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row head-of-lists\"><div class=\"col-md-6 col-sm-6 col-xs-7\"><label>Kategoria:</label><select ng-model=\"chosenCategory\" ng-options=\"item.id as item.name for item in RentCtrl.categoriesFromBackend track by item.id\"><option value=\"\">Wybierz kategorię</option></select></div><div class=\"col-md-6 col-sm-6 col-xs-5\"><p class=\"show-hide-all\" id=\"show-hide-all\" ng-click=\"checkActive()\">{{ showHideAll }}<img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 1\"></p></div></div><img src=\"../assets/images/preloader.gif\" class=\"preloader\" ng-hide=\"RentCtrl.dataFromBackend.dataLoaded\"><div ng-show=\"RentCtrl.dataFromBackend.dataLoaded\"><div class=\"row cont-for-list-element\" data-id=\"{{ item.id }}\" ng-repeat=\"item in RentCtrl.dataFromBackend.results | limitTo: displayedPosts\" ng-click=\"RentCtrl.toggleBtn(item.id); checkActive();\" value=\"{{ item.rent_type.name }}\" ng-init=\"sectionIndex = $index\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ item.title }}<span class=\"dateSpan\">dodano: {{ item.created_at | date: \'shortDate\' }}, kategoria: {{ item.rent_type.name }}</span></h1><div class=\"inner-content\"><div class=\"inner-box\" ng-click=\"$event.stopPropagation()\"><p ng-bind-html=\"item.body | TrustedHtml\">{{ item.body }}</p><div class=\"row spaceLeftInArticle\"><img ng-repeat=\"doc in item.documents\" class=\"backEndPhotoInArticle\" ng-if=\"doc.file_path.indexOf(\'.png\') > -1 || doc.file_path.indexOf(\'.jpg\') > -1 || doc.file_path.indexOf(\'.JPG\') > -1 || doc.file_path.indexOf(\'.PNG\') > -1\" ng-src=\"{{ doc.file_path }}\" ng-click=\"showPopup(true, item.id, doc.id, sectionIndex)\"></div><div class=\"row spaceLeftInArticle\"><a ng-repeat=\"doc in item.documents\" ng-if=\"item.documents[0]\" ng-click=\"openLink(doc.file_path)\"><span ng-if=\"doc.file_path.indexOf(\'.pdf\') > -1 || doc.file_path.indexOf(\'.doc\') > -1 || doc.file_path.indexOf(\'.docx\') > -1 || doc.file_path.indexOf(\'.txt\') > -1\">{{ doc.title }}<br></span><br></a></div></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\"><span></span><img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div><div class=\"row cont-for-list-element\" ng-show=\"RentCtrl.showNoResults\"><article><h1>Brak wyników</h1></article></div><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div></div></div><div class=\"gallery-background\" data-ng-show=\"displayPopup\" ng-click=\"showPopup(false)\"></div><div class=\"gallery-popup\" data-ng-show=\"displayPopup\"><img src=\"../assets/images/exit-ico.png\" class=\"exit-ico\" data-ng-click=\"showPopup(false)\"> <img src=\"{{ oneImage.file_path }}\" class=\"popup-image\"><div class=\"settlement-arrow prev\" ng-click=\"imageRotate(0)\"></div><div class=\"settlement-arrow next\" ng-click=\"imageRotate(1)\"></div><p>{{ oneImage.title }}</p></div><script>\r\n    $(document).ready(function() {\r\n        var activeItem = new ActiveItem();\r\n        activeItem.collapseAndExpandAll(\"#show-hide-all\", \".cont-for-list-element\");\r\n    });\r\n</script>");
$templateCache.put("app/partials/residential_construction/cms/add-residential_construction.cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodajesz nowe budownictwo mieszkaniowe</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"newsTitle\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"newsBody\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"published\"><option value=\"True\">Opublikuj</option><option value=\"False\">Szkic</option></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><button class=\"d-btn-add-content\" ng-click=\"openLink(\'/podglad/budownictwo-mieszaniowe\')\">podgląd</button> <button class=\"d-btn-add-content\" ng-click=\"submit()\">dodaj</button></form>");
$templateCache.put("app/partials/residential_construction/cms/edit-residential_construction.cms.html","<div class=\"d-edit-popup\" data-ng-show=\"displayEditPopup\"><div class=\"d-sub-title\"><span>Edytujesz budownictwo mieszkaniowe</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"$parent.value.title\" ng-init=\"$parent.value.title=\'\'\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"$parent.value.body\" ta-paste=\"stripFormat($html)\" ng-init=\"$parent.value.body=\'\'\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"$parent.value.published\" ng-options=\"item.value as item.name for item in publishedOptions\"></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottom\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"$parent.files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><a href=\"\" class=\"btn-abort\" data-ng-click=\"showEditPopup(false)\">anuluj</a> <a href=\"\" class=\"btn-preview\" ng-click=\"openLink(\'/podglad/budownictwo-mieszkaniowe\')\">podgląd</a> <a class=\"btn-accept\" type=\"submit\" ng-click=\"editResidentialConstruction()\">aktualizuj</a></form></div>");
$templateCache.put("app/partials/residential_construction/cms/residential_construction.cms.html","<div class=\"d-sub-title spaceTop\"><span>Dodaj Budownictwo mieszkaniowe</span></div><a class=\"d-btn-add spaceBottom\" ui-sref=\"dashboard.add-residential_construction\">Dodaj budownictwo mieszkaniowe</a><div class=\"d-sub-title spaceTop\"><span>Budownictwo mieszkaniowe</span></div><div class=\"d-form spaceBottom\"><label>Publikacja:</label><select ng-model=\"publicFilter\" ng-init=\"publicFilter = \'0\'\" ng-change=\"changePublicFilter(publicFilter)\"><option value=\"0\" ng-selected=\"true\">Pokaż wszystkie</option><option value=\"True\">Opublikowano</option><option value=\"False\">Szkic</option></select></div><table class=\"d-table\"><thead><tr><td>Tytuł</td><td>Data</td><td>Aktualizacja</td><td>Publikacja</td><td>Dodał</td><td></td><td></td><td>Pozycja</td></tr></thead><tbody><tr ng-repeat=\"new in newsFromBackend | limitTo: displayedPosts\"><td>{{ new.title }}</td><td>{{ new.created_at | date: \'shortDate\' }}</td><td>{{ new.updated_at | date: \'shortDate\' }}</td><td ng-if=\"new.published\">Opublikowano</td><td ng-if=\"!new.published\">Szkic</td><td>{{ new.created_by_name }}</td><td><a href=\"\" data-ng-click=\"showEditPopup(true, new.id)\">Edytuj</a></td><td><img data-ng-click=\"showDeletePopup(true, new.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></td><td><div class=\"col-md-12 d-position-arrows-container\"><img src=\"../assets/images/posUp-ico.png\" class=\"d-btn-position-arrows\" ng-click=\"changePosition(new.id, \'up\')\"></div><div class=\"col-md-12 d-position-arrows-container\"><img src=\"../assets/images/posDown-ico.png\" class=\"d-btn-position-arrows\" ng-click=\"changePosition(new.id, \'down\')\"></div></td></tr></tbody></table><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div><div ng-include=\"\'app/templates/deletePopup/deletePopup.cms.html\'\"></div><div ng-include=\"\'app/partials/residential_construction/cms/edit-residential_construction.cms.html\'\"></div>");
$templateCache.put("app/partials/residential_construction/cms/residential_construction.preview.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row cont-for-list-element active\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ previewData.title }}</h1><div class=\"inner-content\"><div class=\"inner-box\"><p ng-bind-html=\"previewData.body | TrustedHtml\">{{ previewData.body }}</p><a ng-repeat=\"doc in previewData.documents\"><span>{{ doc }}</span><br></a></div></div></div><div class=\"col-md-2\"></div></article></div><div class=\"row cont-for-list-element\" data-id=\"{{ news.id }}\" ng-repeat=\"news in newsFromBackend | limitTo: 5\" ng-click=\"toggleBtn(news.id)\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ news.title }}<span class=\"dateSpan\">dodano: {{ news.created_at | date: \'shortDate\' }}, kategoria: {{ news.category.name }}</span></h1><div class=\"inner-content\"><div class=\"inner-box\"><p ng-bind-html=\"news.body | TrustedHtml\">{{ news.body }}</p><a ng-if=\"news.documents[0]\" ng-repeat=\"doc in news.documents\" ng-click=\"openLink(doc.file_path)\">{{ doc.title }}<br></a></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\">Rozwiń<img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div></div>");
$templateCache.put("app/partials/residential_construction/web/residential_construction.html","<div class=\"container\"><div class=\"cont-for-content\"><div class=\"row cont-for-list-element\"><article class=\"expand-text\"><div class=\"col-md-12\"><img src=\"{{ residentialConstructionImg.file_path }}\" alt=\"{{ residentialConstructionImg.title }}\" class=\"img-responsive img-funding spaceBottom\"><h1 class=\"spaceBottomXS\">{{ residentialConstructionTitle }}</h1><div class=\"inner-content\"><div class=\"inner-box\"><p ng-bind-html=\"residentialConstructionDescription | TrustedHtml\"></p></div></div></div></article></div><div class=\"row head-of-lists\"><div class=\"col-sm-12\"><p class=\"show-hide-all\" id=\"show-hide-all\" ng-click=\"checkActive()\">{{ showHideAll }}<img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 1\"></p></div></div><img src=\"../assets/images/preloader.gif\" class=\"preloader\" ng-hide=\"newsFromBackend.dataLoaded\"><div ng-show=\"newsFromBackend.dataLoaded\"><div class=\"row cont-for-list-element\" data-id=\"{{ news.id }}\" ng-repeat=\"news in newsFromBackend | limitTo: displayedPosts\" ng-click=\"toggleBtn(news.id); checkActive();\" value=\"{{ news.category.name }}\" ng-init=\"sectionIndex = $index\"><article class=\"expand-text\"><div class=\"col-md-10\"><h1>{{ news.title }}<span class=\"dateSpan\">dodano: {{ news.created_at | date: \'shortDate\' }}</span></h1><div class=\"inner-content\"><div class=\"inner-box\" ng-click=\"$event.stopPropagation()\"><p ng-bind-html=\"news.body | TrustedHtml\">{{ news.body }}</p><div class=\"row spaceLeftInArticle\"><img ng-repeat=\"doc in news.documents\" class=\"backEndPhotoInArticle\" ng-if=\"doc.file_path.indexOf(\'.png\') > -1 || doc.file_path.indexOf(\'.jpg\') > -1 || doc.file_path.indexOf(\'.jpeg\') > -1 || doc.file_path.indexOf(\'.JPG\') > -1 || doc.file_path.indexOf(\'.JPEG\') > -1 || doc.file_path.indexOf(\'.PNG\') > -1\" ng-src=\"{{ doc.file_path }}\" data-ng-click=\"showPopup(true, news.id, doc.id, sectionIndex)\"></div><div class=\"row spaceLeftInArticle\"><a ng-repeat=\"doc in news.documents\" ng-if=\"news.documents[0]\" ng-click=\"openLink(doc.file_path)\"><span ng-if=\"doc.file_path.indexOf(\'.pdf\') > -1 || doc.file_path.indexOf(\'.doc\') > -1 || doc.file_path.indexOf(\'.docx\') > -1 || doc.file_path.indexOf(\'.txt\') > -1\">{{ doc.title }}<br></span><br></a></div></div></div></div><div class=\"col-md-2\"><p class=\"show-hide-all\"><span></span><img src=\"/assets/images/expand-ico.png\" class=\"show-hide-all-ico 2\"></p></div></article></div></div><div class=\"row cont-for-list-element\" ng-show=\"showNoResults\"><article><h1>Brak wyników</h1></article></div><div ng-include=\"\'app/scripts/pagination/pagination.html\'\"></div></div></div><div class=\"gallery-background\" data-ng-show=\"displayPopup\" ng-click=\"showPopup(false)\"></div><div class=\"gallery-popup\" data-ng-show=\"displayPopup\"><img src=\"../assets/images/exit-ico.png\" class=\"exit-ico\" data-ng-click=\"showPopup(false)\"> <img src=\"{{ oneImage.file_path }}\" class=\"popup-image\"><div class=\"settlement-arrow prev\" ng-click=\"imageRotate(0)\"></div><div class=\"settlement-arrow next\" ng-click=\"imageRotate(1)\"></div><p>{{ oneImage.title }}</p></div><script>\n    $(document).ready(function() {\n        var activeItem = new ActiveItem();\n        activeItem.collapseAndExpandAll(\"#show-hide-all\", \".cont-for-list-element\");\n    });\n</script>");
$templateCache.put("app/partials/adv/cms/add_new/add_new.html","<div class=\"d-sub-title spaceTop\"><span>Dodajesz nowy wynajem</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"AddNewAdvertisersCtrl.title\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"AddNewAdvertisersCtrl.body\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"AddNewAdvertisersCtrl.published\"><option value=\"True\">Opublikuj</option><option value=\"False\">Szkic</option></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><button class=\"d-btn-add-content\" ng-click=\"AddNewAdvertisersCtrl.sendDataToBackend()\">dodaj</button></form>");
$templateCache.put("app/partials/adv/cms/edit/edit.html","<div class=\"d-sub-title spaceTop\"><span>Dodajesz nowy wynajem</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"EditAdvertiserCtrl.dataFromBackend.title\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"EditAdvertiserCtrl.dataFromBackend.body\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"EditAdvertiserCtrl.dataFromBackend.published\" ng-options=\"item.value as item.name for item in EditAdvertiserCtrl.publishedOptions\"></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><button class=\"d-btn-add-content\" ng-click=\"EditAdvertiserCtrl.sendDataToBackend()\">zapisz</button></form>");
$templateCache.put("app/partials/culture/cms/add_new/add_new.html","<div class=\"d-sub-title spaceTop\"><span>Dodajesz wydarzenie</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"AddCultureCmsCtrl.title\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Dada wydarzenia</label></div><div class=\"col-md-10\"><datepicker date-format=\"yyyy-M-d\"><input type=\"text\" placeholder=\"wzór: 06-10-2010\" ng-model=\"AddCultureCmsCtrl.event_date\"></datepicker></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Wybierz kategorię</label></div><div class=\"col-md-10\"><select ng-model=\"AddCultureCmsCtrl.category\" ng-options=\"categories.name for categories in AddCultureCmsCtrl.categoryList track by categories.id\"><option value=\"\">Wybierz kategorię</option></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"AddCultureCmsCtrl.body\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"AddCultureCmsCtrl.published\"><option value=\"True\">Opublikuj</option><option value=\"False\">Szkic</option></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Dodaj plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"upload($file)\" ng-model=\"file\" ngf-max-size=\"20MB\"><span class=\"d-add-file\">Dodaj nowy</span><br></div><br>{{ AddCultureCmsCtrl.documentName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a ng-if=\"AddCultureCmsCtrl.documentId\" class=\"btn-red-close-quit-delete\" ng-click=\"AddCultureCmsCtrl.deleteFile(AddCultureCmsCtrl.documentId)\">Usuń</a></div></div><button class=\"d-btn-add-content\" ng-click=\"AddCultureCmsCtrl.sendDataToBackend()\">dodaj</button></form>");
$templateCache.put("app/partials/culture/cms/edit/edit.html","<div class=\"d-sub-title spaceTop\"><span>Dodajesz wydarzenie</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"EditCultureCtrl.dataFromBackend.title\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Dada wydarzenia</label></div><div class=\"col-md-10\"><datepicker date-format=\"yyyy-M-d\"><input type=\"text\" placeholder=\"wzór: 2010-12-29\" ng-model=\"EditCultureCtrl.dataFromBackend.event_date\"></datepicker></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Wybierz kategorię</label></div><div class=\"col-md-10\"><select ng-model=\"EditCultureCtrl.dataFromBackend.category\" ng-options=\"category.name for category in EditCultureCtrl.categoriesFromBackend track by category.id\"></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"EditCultureCtrl.dataFromBackend.body\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"EditCultureCtrl.dataFromBackend.published\" ng-options=\"item.value as item.name for item in EditCultureCtrl.publishedOptions\"></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Aktualny plik</label></div><div class=\"col-md-10\"><a href=\"{{ EditCultureCtrl.dataFromBackend.documents[0].file_path }}\" target=\"_blank\">{{ EditCultureCtrl.dataFromBackend.documents[0].title }}</a></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Dodaj plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"upload($file)\" ng-model=\"file\" ngf-max-size=\"20MB\"><span class=\"d-add-file\">Dodaj nowy</span><br></div><br>{{ EditCultureCtrl.documentName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a ng-if=\"EditCultureCtrl.documentId\" class=\"btn-red-close-quit-delete\" ng-click=\"EditCultureCtrl.deleteFile(EditCultureCtrl.documentId)\">Usuń</a></div></div><button class=\"d-btn-add-content\" ng-click=\"EditCultureCtrl.sendDataToBackend()\">zapisz</button></form>");
$templateCache.put("app/partials/perfect_place/cms/add_new/add_new.html","<div class=\"d-sub-title spaceTop\"><span>Dodajesz wydarzenie</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"AddPerfectPlaceCmsCtrl.title\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Pozycja tekstu</label></div><div class=\"col-md-10\"><select ng-model=\"AddPerfectPlaceCmsCtrl.imagePosition\"><option value=\"top-left\">góra-lewo</option><option value=\"top-right\">góra-prawo</option></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"AddPerfectPlaceCmsCtrl.body\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Dodaj plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"upload($file)\" ng-model=\"file\" ngf-max-size=\"20MB\"><span class=\"d-add-file\">Dodaj nowy</span><br></div><br>{{ AddPerfectPlaceCmsCtrl.documentName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a ng-if=\"AddPerfectPlaceCmsCtrl.documentId\" class=\"btn-red-close-quit-delete\" ng-click=\"AddPerfectPlaceCmsCtrl.deleteFile(AddPerfectPlaceCmsCtrl.documentId)\">Usuń</a></div></div><button class=\"d-btn-add-content\" ng-click=\"AddPerfectPlaceCmsCtrl.sendDataToBackend()\">dodaj</button></form>");
$templateCache.put("app/partials/perfect_place/cms/edit/edit.html","<div class=\"d-sub-title spaceTop\"><span>Edytujesz miejsce</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"EditPerfectPlaceCtrl.dataFromBackend.title\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Pozycja tekstu</label></div><div class=\"col-md-10\"><select ng-model=\"EditPerfectPlaceCtrl.dataFromBackend.image_position\"><option value=\"top-left\">góra-lewo</option><option value=\"top-right\">góra-prawo</option></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"EditPerfectPlaceCtrl.dataFromBackend.body\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Aktualny plik</label></div><div class=\"col-md-10\"><a href=\"{{ EditPerfectPlaceCtrl.dataFromBackend.documents[0].file_path }}\" target=\"_blank\">{{ EditPerfectPlaceCtrl.dataFromBackend.documents[0].title }}</a></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Dodaj plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"upload($file)\" ng-model=\"file\" ngf-max-size=\"20MB\"><span class=\"d-add-file\">Dodaj nowy</span><br></div><br>{{ EditPerfectPlaceCtrl.documentName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a ng-if=\"EditPerfectPlaceCtrl.documentId\" class=\"btn-red-close-quit-delete\" ng-click=\"EditPerfectPlaceCtrl.deleteFile(EditPerfectPlaceCtrl.documentId)\">Usuń</a></div></div><button class=\"d-btn-add-content\" ng-click=\"EditPerfectPlaceCtrl.sendDataToBackend()\">dodaj</button></form>");
$templateCache.put("app/partials/press/cms/add_new/add_new.html","<div class=\"d-sub-title spaceTop\"><span>Dodajesz media</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"AddPressCmsCtrl.title\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Wybierz kategorię</label></div><div class=\"col-md-10\"><select ng-model=\"AddPressCmsCtrl.category\" ng-options=\"categories.name for categories in AddPressCmsCtrl.categoryList track by categories.id\"><option value=\"\">Wybierz kategorię</option></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"AddPressCmsCtrl.body\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><button class=\"d-btn-add-content\" ng-click=\"AddPressCmsCtrl.sendDataToBackend()\">dodaj</button></form>");
$templateCache.put("app/partials/press/cms/edit/edit.html","<div class=\"d-sub-title spaceTop\"><span>Dodajesz wydarzenie</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"EditPressCtrl.dataFromBackend.title\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Wybierz kategorię</label></div><div class=\"col-md-10\"><select ng-model=\"EditPressCtrl.dataFromBackend.category\" ng-options=\"category.name for category in EditPressCtrl.categoriesFromBackend track by category.id\"></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"EditPressCtrl.dataFromBackend.body\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottom\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"$parent.files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><button class=\"d-btn-add-content\" ng-click=\"EditPressCtrl.sendDataToBackend()\">zapisz</button></form>");
$templateCache.put("app/partials/rent/cms/add_new/add_new.html","<div class=\"d-sub-title spaceTop\"><span>Dodajesz nowy lokal</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"AddNewRentCtrl.title\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Wybierz kategorię</label></div><div class=\"col-md-10\"><select ng-model=\"AddNewRentCtrl.rentType\" ng-options=\"item.id as item.name for item in AddNewRentCtrl.categoriesFromBackend track by item.id\"><option value=\"\">Wybierz kategorię</option></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"AddNewRentCtrl.body\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"AddNewRentCtrl.published\"><option value=\"True\">Opublikuj</option><option value=\"False\">Szkic</option></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><button class=\"d-btn-add-content\" ng-click=\"AddNewRentCtrl.sendDataToBackend()\">dodaj</button></form>");
$templateCache.put("app/partials/rent/cms/edit/edit.html","<div class=\"d-sub-title spaceTop\"><span>Edytujesz lokal</span></div><form class=\"d-form spaceBottom\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Tytuł</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"longInput\" ng-model=\"EditRentCtrl.dataFromBackend.title\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Wybierz kategorię</label></div><div class=\"col-md-10\"><select ng-model=\"EditRentCtrl.dataFromBackend.rent_type\" ng-options=\"item.name for item in EditRentCtrl.categoriesFromBackend track by item.id\"><option value=\"\">Wybierz kategorię</option></select></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Treść</label></div><div class=\"col-md-10\"><text-angular ng-model=\"EditRentCtrl.dataFromBackend.body\" ta-toolbar=\"[[\'h1\', \'h2\', \'h3\', \'p\', \'bold\', \'italics\', \'underline\', \'insertLink\', \'ul\', \'ol\', \'html\']]\" ta-paste=\"stripFormat($html)\"></text-angular></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Publikacja</label></div><div class=\"col-md-10\"><select ng-model=\"EditRentCtrl.dataFromBackend.published\" ng-options=\"item.value as item.name for item in EditRentCtrl.publishedOptions\"></select></div></div><div class=\"row spaceBottomXS\" ng-if=\"documentsArray[0]\" ng-repeat=\"files in documentsArray\"><div class=\"col-md-2\"><label>Nazwa pliku</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"documentsArrayTitles[$index]\" ng-change=\"changeFileName(documentsArray[$index], $index)\"> <img ng-click=\"deleteFromArray($index)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></div></div><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Załącz plik</label></div><div class=\"col-md-10\"><div class=\"preload-file\"></div><div ngf-select=\"uploadFiles($files)\" multiple=\"multiple\" ng-model=\"files\"><span class=\"d-add-file\">Dodaj nowy</span></div></div></div><button class=\"d-btn-add-content\" ng-click=\"EditRentCtrl.sendDataToBackend()\">zapisz</button></form>");
$templateCache.put("app/partials/rent/cms/rent_categories/rent_categories.html","<div class=\"d-sub-title spaceTop\"><span>Dodaj</span></div><form class=\"d-form\"><div class=\"row spaceBottomXS\"><div class=\"col-md-2\"><label>Nazwa kategorii</label></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"RentCategoriesCtrl.categoryName\"></div></div><button class=\"d-btn-add-content spaceBottom\" ng-click=\"RentCategoriesCtrl.addNewCategory()\">dodaj</button></form><div class=\"d-sub-title spaceTop\"><span>Kategorie</span></div><table class=\"d-table\"><thead><tr><td>Tytuł</td><td></td><td></td></tr></thead><tbody><tr ng-repeat=\"item in RentCategoriesCtrl.categoriesFromBackend\"><td>{{ item.name }}</td><td><img data-ng-click=\"RentCategoriesCtrl.confirmDialog(item.id)\" class=\"d-settings-thrash\" src=\"../assets/images/thrash-ico.png\" alt=\"usuwanie\"></td></tr></tbody></table>");}]);